function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e307) { throw _e307; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e308) { didErr = true; err = _e308; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).THREE = {});
}(this, function (t) {
  "use strict";

  var e = "138",
      n = 100,
      i = 300,
      r = 301,
      s = 302,
      a = 303,
      o = 304,
      l = 306,
      c = 307,
      h = 1e3,
      u = 1001,
      d = 1002,
      p = 1003,
      m = 1004,
      f = 1005,
      g = 1006,
      v = 1007,
      y = 1008,
      x = 1009,
      _ = 1012,
      M = 1014,
      b = 1015,
      w = 1016,
      S = 1020,
      T = 1023,
      E = 1026,
      A = 1027,
      R = 33776,
      C = 33777,
      L = 33778,
      P = 33779,
      D = 35840,
      I = 35841,
      N = 35842,
      B = 35843,
      z = 37492,
      O = 37496,
      U = 37808,
      F = 37809,
      H = 37810,
      G = 37811,
      V = 37812,
      k = 37813,
      W = 37814,
      j = 37815,
      q = 37816,
      X = 37817,
      J = 37818,
      Y = 37819,
      Z = 37820,
      K = 37821,
      Q = 36492,
      $ = 2300,
      tt = 2301,
      et = 2302,
      nt = 2400,
      it = 2401,
      rt = 2402,
      st = 2500,
      at = 2501,
      ot = 3e3,
      lt = 3001,
      ct = 7680,
      ht = 35044,
      ut = 35048,
      dt = "300 es",
      pt = 1035;

  var mt = /*#__PURE__*/function () {
    function mt() {
      _classCallCheck(this, mt);
    }

    _createClass(mt, [{
      key: "addEventListener",
      value: function addEventListener(t, e) {
        void 0 === this._listeners && (this._listeners = {});
        var n = this._listeners;
        void 0 === n[t] && (n[t] = []), -1 === n[t].indexOf(e) && n[t].push(e);
      }
    }, {
      key: "hasEventListener",
      value: function hasEventListener(t, e) {
        if (void 0 === this._listeners) return !1;
        var n = this._listeners;
        return void 0 !== n[t] && -1 !== n[t].indexOf(e);
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(t, e) {
        if (void 0 === this._listeners) return;
        var n = this._listeners[t];

        if (void 0 !== n) {
          var _t2 = n.indexOf(e);

          -1 !== _t2 && n.splice(_t2, 1);
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(t) {
        if (void 0 === this._listeners) return;
        var e = this._listeners[t.type];

        if (void 0 !== e) {
          t.target = this;

          var _n2 = e.slice(0);

          for (var _e2 = 0, _i2 = _n2.length; _e2 < _i2; _e2++) {
            _n2[_e2].call(this, t);
          }

          t.target = null;
        }
      }
    }]);

    return mt;
  }();

  var ft = [];

  for (var _t3 = 0; _t3 < 256; _t3++) {
    ft[_t3] = (_t3 < 16 ? "0" : "") + _t3.toString(16);
  }

  var gt = 1234567;
  var vt = Math.PI / 180,
      yt = 180 / Math.PI;

  function xt() {
    var t = 4294967295 * Math.random() | 0,
        e = 4294967295 * Math.random() | 0,
        n = 4294967295 * Math.random() | 0,
        i = 4294967295 * Math.random() | 0;
    return (ft[255 & t] + ft[t >> 8 & 255] + ft[t >> 16 & 255] + ft[t >> 24 & 255] + "-" + ft[255 & e] + ft[e >> 8 & 255] + "-" + ft[e >> 16 & 15 | 64] + ft[e >> 24 & 255] + "-" + ft[63 & n | 128] + ft[n >> 8 & 255] + "-" + ft[n >> 16 & 255] + ft[n >> 24 & 255] + ft[255 & i] + ft[i >> 8 & 255] + ft[i >> 16 & 255] + ft[i >> 24 & 255]).toUpperCase();
  }

  function _t(t, e, n) {
    return Math.max(e, Math.min(n, t));
  }

  function Mt(t, e) {
    return (t % e + e) % e;
  }

  function bt(t, e, n) {
    return (1 - n) * t + n * e;
  }

  function wt(t) {
    return 0 == (t & t - 1) && 0 !== t;
  }

  function St(t) {
    return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
  }

  function Tt(t) {
    return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
  }

  var Et = Object.freeze({
    __proto__: null,
    DEG2RAD: vt,
    RAD2DEG: yt,
    generateUUID: xt,
    clamp: _t,
    euclideanModulo: Mt,
    mapLinear: function mapLinear(t, e, n, i, r) {
      return i + (t - e) * (r - i) / (n - e);
    },
    inverseLerp: function inverseLerp(t, e, n) {
      return t !== e ? (n - t) / (e - t) : 0;
    },
    lerp: bt,
    damp: function damp(t, e, n, i) {
      return bt(t, e, 1 - Math.exp(-n * i));
    },
    pingpong: function pingpong(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return e - Math.abs(Mt(t, 2 * e) - e);
    },
    smoothstep: function smoothstep(t, e, n) {
      return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e)) * t * (3 - 2 * t);
    },
    smootherstep: function smootherstep(t, e, n) {
      return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e)) * t * t * (t * (6 * t - 15) + 10);
    },
    randInt: function randInt(t, e) {
      return t + Math.floor(Math.random() * (e - t + 1));
    },
    randFloat: function randFloat(t, e) {
      return t + Math.random() * (e - t);
    },
    randFloatSpread: function randFloatSpread(t) {
      return t * (.5 - Math.random());
    },
    seededRandom: function seededRandom(t) {
      return void 0 !== t && (gt = t % 2147483647), gt = 16807 * gt % 2147483647, (gt - 1) / 2147483646;
    },
    degToRad: function degToRad(t) {
      return t * vt;
    },
    radToDeg: function radToDeg(t) {
      return t * yt;
    },
    isPowerOfTwo: wt,
    ceilPowerOfTwo: St,
    floorPowerOfTwo: Tt,
    setQuaternionFromProperEuler: function setQuaternionFromProperEuler(t, e, n, i, r) {
      var s = Math.cos,
          a = Math.sin,
          o = s(n / 2),
          l = a(n / 2),
          c = s((e + i) / 2),
          h = a((e + i) / 2),
          u = s((e - i) / 2),
          d = a((e - i) / 2),
          p = s((i - e) / 2),
          m = a((i - e) / 2);

      switch (r) {
        case "XYX":
          t.set(o * h, l * u, l * d, o * c);
          break;

        case "YZY":
          t.set(l * d, o * h, l * u, o * c);
          break;

        case "ZXZ":
          t.set(l * u, l * d, o * h, o * c);
          break;

        case "XZX":
          t.set(o * h, l * m, l * p, o * c);
          break;

        case "YXY":
          t.set(l * p, o * h, l * m, o * c);
          break;

        case "ZYZ":
          t.set(l * m, l * p, o * h, o * c);
          break;

        default:
          console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
      }
    }
  });

  var At = /*#__PURE__*/function (_Symbol$iterator) {
    function At() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, At);

      this.x = t, this.y = e;
    }

    _createClass(At, [{
      key: "width",
      get: function get() {
        return this.x;
      },
      set: function set(t) {
        this.x = t;
      }
    }, {
      key: "height",
      get: function get() {
        return this.y;
      },
      set: function set(t) {
        this.y = t;
      }
    }, {
      key: "set",
      value: function set(t, e) {
        return this.x = t, this.y = e, this;
      }
    }, {
      key: "setScalar",
      value: function setScalar(t) {
        return this.x = t, this.y = t, this;
      }
    }, {
      key: "setX",
      value: function setX(t) {
        return this.x = t, this;
      }
    }, {
      key: "setY",
      value: function setY(t) {
        return this.y = t, this;
      }
    }, {
      key: "setComponent",
      value: function setComponent(t, e) {
        switch (t) {
          case 0:
            this.x = e;
            break;

          case 1:
            this.y = e;
            break;

          default:
            throw new Error("index is out of range: " + t);
        }

        return this;
      }
    }, {
      key: "getComponent",
      value: function getComponent(t) {
        switch (t) {
          case 0:
            return this.x;

          case 1:
            return this.y;

          default:
            throw new Error("index is out of range: " + t);
        }
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this.x, this.y);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.x = t.x, this.y = t.y, this;
      }
    }, {
      key: "add",
      value: function add(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this);
      }
    }, {
      key: "addScalar",
      value: function addScalar(t) {
        return this.x += t, this.y += t, this;
      }
    }, {
      key: "addVectors",
      value: function addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this;
      }
    }, {
      key: "addScaledVector",
      value: function addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this;
      }
    }, {
      key: "sub",
      value: function sub(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this);
      }
    }, {
      key: "subScalar",
      value: function subScalar(t) {
        return this.x -= t, this.y -= t, this;
      }
    }, {
      key: "subVectors",
      value: function subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this;
      }
    }, {
      key: "multiply",
      value: function multiply(t) {
        return this.x *= t.x, this.y *= t.y, this;
      }
    }, {
      key: "multiplyScalar",
      value: function multiplyScalar(t) {
        return this.x *= t, this.y *= t, this;
      }
    }, {
      key: "divide",
      value: function divide(t) {
        return this.x /= t.x, this.y /= t.y, this;
      }
    }, {
      key: "divideScalar",
      value: function divideScalar(t) {
        return this.multiplyScalar(1 / t);
      }
    }, {
      key: "applyMatrix3",
      value: function applyMatrix3(t) {
        var e = this.x,
            n = this.y,
            i = t.elements;
        return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
      }
    }, {
      key: "min",
      value: function min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
      }
    }, {
      key: "max",
      value: function max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
      }
    }, {
      key: "clamp",
      value: function clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
      }
    }, {
      key: "clampScalar",
      value: function clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
      }
    }, {
      key: "clampLength",
      value: function clampLength(t, e) {
        var n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
      }
    }, {
      key: "floor",
      value: function floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      }
    }, {
      key: "ceil",
      value: function ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      }
    }, {
      key: "round",
      value: function round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      }
    }, {
      key: "roundToZero",
      value: function roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
      }
    }, {
      key: "negate",
      value: function negate() {
        return this.x = -this.x, this.y = -this.y, this;
      }
    }, {
      key: "dot",
      value: function dot(t) {
        return this.x * t.x + this.y * t.y;
      }
    }, {
      key: "cross",
      value: function cross(t) {
        return this.x * t.y - this.y * t.x;
      }
    }, {
      key: "lengthSq",
      value: function lengthSq() {
        return this.x * this.x + this.y * this.y;
      }
    }, {
      key: "length",
      value: function length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }
    }, {
      key: "manhattanLength",
      value: function manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
      }
    }, {
      key: "normalize",
      value: function normalize() {
        return this.divideScalar(this.length() || 1);
      }
    }, {
      key: "angle",
      value: function angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
      }
    }, {
      key: "distanceTo",
      value: function distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
      }
    }, {
      key: "distanceToSquared",
      value: function distanceToSquared(t) {
        var e = this.x - t.x,
            n = this.y - t.y;
        return e * e + n * n;
      }
    }, {
      key: "manhattanDistanceTo",
      value: function manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
      }
    }, {
      key: "setLength",
      value: function setLength(t) {
        return this.normalize().multiplyScalar(t);
      }
    }, {
      key: "lerp",
      value: function lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
      }
    }, {
      key: "lerpVectors",
      value: function lerpVectors(t, e, n) {
        return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.x === this.x && t.y === this.y;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this.x = t[e], this.y = t[e + 1], this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t[e] = this.x, t[e + 1] = this.y, t;
      }
    }, {
      key: "fromBufferAttribute",
      value: function fromBufferAttribute(t, e, n) {
        return void 0 !== n && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this;
      }
    }, {
      key: "rotateAround",
      value: function rotateAround(t, e) {
        var n = Math.cos(e),
            i = Math.sin(e),
            r = this.x - t.x,
            s = this.y - t.y;
        return this.x = r * n - s * i + t.x, this.y = r * i + s * n + t.y, this;
      }
    }, {
      key: "random",
      value: function random() {
        return this.x = Math.random(), this.y = Math.random(), this;
      }
    }, {
      key: _Symbol$iterator,
      value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
        return _regeneratorRuntime.wrap(function value$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.x;

              case 2:
                _context.next = 4;
                return this.y;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, value, this);
      })
    }]);

    return At;
  }(Symbol.iterator);

  At.prototype.isVector2 = !0;

  var Rt = /*#__PURE__*/function () {
    function Rt() {
      _classCallCheck(this, Rt);

      this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }

    _createClass(Rt, [{
      key: "set",
      value: function set(t, e, n, i, r, s, a, o, l) {
        var c = this.elements;
        return c[0] = t, c[1] = i, c[2] = a, c[3] = e, c[4] = r, c[5] = o, c[6] = n, c[7] = s, c[8] = l, this;
      }
    }, {
      key: "identity",
      value: function identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        var e = this.elements,
            n = t.elements;
        return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
      }
    }, {
      key: "extractBasis",
      value: function extractBasis(t, e, n) {
        return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
      }
    }, {
      key: "setFromMatrix4",
      value: function setFromMatrix4(t) {
        var e = t.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
      }
    }, {
      key: "multiply",
      value: function multiply(t) {
        return this.multiplyMatrices(this, t);
      }
    }, {
      key: "premultiply",
      value: function premultiply(t) {
        return this.multiplyMatrices(t, this);
      }
    }, {
      key: "multiplyMatrices",
      value: function multiplyMatrices(t, e) {
        var n = t.elements,
            i = e.elements,
            r = this.elements,
            s = n[0],
            a = n[3],
            o = n[6],
            l = n[1],
            c = n[4],
            h = n[7],
            u = n[2],
            d = n[5],
            p = n[8],
            m = i[0],
            f = i[3],
            g = i[6],
            v = i[1],
            y = i[4],
            x = i[7],
            _ = i[2],
            M = i[5],
            b = i[8];
        return r[0] = s * m + a * v + o * _, r[3] = s * f + a * y + o * M, r[6] = s * g + a * x + o * b, r[1] = l * m + c * v + h * _, r[4] = l * f + c * y + h * M, r[7] = l * g + c * x + h * b, r[2] = u * m + d * v + p * _, r[5] = u * f + d * y + p * M, r[8] = u * g + d * x + p * b, this;
      }
    }, {
      key: "multiplyScalar",
      value: function multiplyScalar(t) {
        var e = this.elements;
        return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
      }
    }, {
      key: "determinant",
      value: function determinant() {
        var t = this.elements,
            e = t[0],
            n = t[1],
            i = t[2],
            r = t[3],
            s = t[4],
            a = t[5],
            o = t[6],
            l = t[7],
            c = t[8];
        return e * s * c - e * a * l - n * r * c + n * a * o + i * r * l - i * s * o;
      }
    }, {
      key: "invert",
      value: function invert() {
        var t = this.elements,
            e = t[0],
            n = t[1],
            i = t[2],
            r = t[3],
            s = t[4],
            a = t[5],
            o = t[6],
            l = t[7],
            c = t[8],
            h = c * s - a * l,
            u = a * o - c * r,
            d = l * r - s * o,
            p = e * h + n * u + i * d;
        if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        var m = 1 / p;
        return t[0] = h * m, t[1] = (i * l - c * n) * m, t[2] = (a * n - i * s) * m, t[3] = u * m, t[4] = (c * e - i * o) * m, t[5] = (i * r - a * e) * m, t[6] = d * m, t[7] = (n * o - l * e) * m, t[8] = (s * e - n * r) * m, this;
      }
    }, {
      key: "transpose",
      value: function transpose() {
        var t;
        var e = this.elements;
        return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
      }
    }, {
      key: "getNormalMatrix",
      value: function getNormalMatrix(t) {
        return this.setFromMatrix4(t).invert().transpose();
      }
    }, {
      key: "transposeIntoArray",
      value: function transposeIntoArray(t) {
        var e = this.elements;
        return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
      }
    }, {
      key: "setUvTransform",
      value: function setUvTransform(t, e, n, i, r, s, a) {
        var o = Math.cos(r),
            l = Math.sin(r);
        return this.set(n * o, n * l, -n * (o * s + l * a) + s + t, -i * l, i * o, -i * (-l * s + o * a) + a + e, 0, 0, 1), this;
      }
    }, {
      key: "scale",
      value: function scale(t, e) {
        var n = this.elements;
        return n[0] *= t, n[3] *= t, n[6] *= t, n[1] *= e, n[4] *= e, n[7] *= e, this;
      }
    }, {
      key: "rotate",
      value: function rotate(t) {
        var e = Math.cos(t),
            n = Math.sin(t),
            i = this.elements,
            r = i[0],
            s = i[3],
            a = i[6],
            o = i[1],
            l = i[4],
            c = i[7];
        return i[0] = e * r + n * o, i[3] = e * s + n * l, i[6] = e * a + n * c, i[1] = -n * r + e * o, i[4] = -n * s + e * l, i[7] = -n * a + e * c, this;
      }
    }, {
      key: "translate",
      value: function translate(t, e) {
        var n = this.elements;
        return n[0] += t * n[2], n[3] += t * n[5], n[6] += t * n[8], n[1] += e * n[2], n[4] += e * n[5], n[7] += e * n[8], this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        var e = this.elements,
            n = t.elements;

        for (var _t4 = 0; _t4 < 9; _t4++) {
          if (e[_t4] !== n[_t4]) return !1;
        }

        return !0;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        for (var _n3 = 0; _n3 < 9; _n3++) {
          this.elements[_n3] = t[_n3 + e];
        }

        return this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = this.elements;
        return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().fromArray(this.elements);
      }
    }]);

    return Rt;
  }();

  function Ct(t) {
    for (var _e3 = t.length - 1; _e3 >= 0; --_e3) {
      if (t[_e3] > 65535) return !0;
    }

    return !1;
  }

  Rt.prototype.isMatrix3 = !0;
  var Lt = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
  };

  function Pt(t, e) {
    return new Lt[t](e);
  }

  function Dt(t) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", t);
  }

  var It = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  },
      Nt = {
    h: 0,
    s: 0,
    l: 0
  },
      Bt = {
    h: 0,
    s: 0,
    l: 0
  };

  function zt(t, e, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - n) : t;
  }

  function Ot(t) {
    return t < .04045 ? .0773993808 * t : Math.pow(.9478672986 * t + .0521327014, 2.4);
  }

  function Ut(t) {
    return t < .0031308 ? 12.92 * t : 1.055 * Math.pow(t, .41666) - .055;
  }

  var Ft = /*#__PURE__*/function () {
    function Ft(t, e, n) {
      _classCallCheck(this, Ft);

      return void 0 === e && void 0 === n ? this.set(t) : this.setRGB(t, e, n);
    }

    _createClass(Ft, [{
      key: "set",
      value: function set(t) {
        return t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t), this;
      }
    }, {
      key: "setScalar",
      value: function setScalar(t) {
        return this.r = t, this.g = t, this.b = t, this;
      }
    }, {
      key: "setHex",
      value: function setHex(t) {
        return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (255 & t) / 255, this;
      }
    }, {
      key: "setRGB",
      value: function setRGB(t, e, n) {
        return this.r = t, this.g = e, this.b = n, this;
      }
    }, {
      key: "setHSL",
      value: function setHSL(t, e, n) {
        if (t = Mt(t, 1), e = _t(e, 0, 1), n = _t(n, 0, 1), 0 === e) this.r = this.g = this.b = n;else {
          var _i3 = n <= .5 ? n * (1 + e) : n + e - n * e,
              _r2 = 2 * n - _i3;

          this.r = zt(_r2, _i3, t + 1 / 3), this.g = zt(_r2, _i3, t), this.b = zt(_r2, _i3, t - 1 / 3);
        }
        return this;
      }
    }, {
      key: "setStyle",
      value: function setStyle(t) {
        function e(e) {
          void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
        }

        var n;

        if (n = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
          var _t5;

          var _i4 = n[1],
              _r3 = n[2];

          switch (_i4) {
            case "rgb":
            case "rgba":
              if (_t5 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_r3)) return this.r = Math.min(255, parseInt(_t5[1], 10)) / 255, this.g = Math.min(255, parseInt(_t5[2], 10)) / 255, this.b = Math.min(255, parseInt(_t5[3], 10)) / 255, e(_t5[4]), this;
              if (_t5 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_r3)) return this.r = Math.min(100, parseInt(_t5[1], 10)) / 100, this.g = Math.min(100, parseInt(_t5[2], 10)) / 100, this.b = Math.min(100, parseInt(_t5[3], 10)) / 100, e(_t5[4]), this;
              break;

            case "hsl":
            case "hsla":
              if (_t5 = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_r3)) {
                var _n4 = parseFloat(_t5[1]) / 360,
                    _i5 = parseInt(_t5[2], 10) / 100,
                    _r4 = parseInt(_t5[3], 10) / 100;

                return e(_t5[4]), this.setHSL(_n4, _i5, _r4);
              }

          }
        } else if (n = /^\#([A-Fa-f\d]+)$/.exec(t)) {
          var _t6 = n[1],
              _e4 = _t6.length;
          if (3 === _e4) return this.r = parseInt(_t6.charAt(0) + _t6.charAt(0), 16) / 255, this.g = parseInt(_t6.charAt(1) + _t6.charAt(1), 16) / 255, this.b = parseInt(_t6.charAt(2) + _t6.charAt(2), 16) / 255, this;
          if (6 === _e4) return this.r = parseInt(_t6.charAt(0) + _t6.charAt(1), 16) / 255, this.g = parseInt(_t6.charAt(2) + _t6.charAt(3), 16) / 255, this.b = parseInt(_t6.charAt(4) + _t6.charAt(5), 16) / 255, this;
        }

        return t && t.length > 0 ? this.setColorName(t) : this;
      }
    }, {
      key: "setColorName",
      value: function setColorName(t) {
        var e = It[t.toLowerCase()];
        return void 0 !== e ? this.setHex(e) : console.warn("THREE.Color: Unknown color " + t), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this.r, this.g, this.b);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this;
      }
    }, {
      key: "copySRGBToLinear",
      value: function copySRGBToLinear(t) {
        return this.r = Ot(t.r), this.g = Ot(t.g), this.b = Ot(t.b), this;
      }
    }, {
      key: "copyLinearToSRGB",
      value: function copyLinearToSRGB(t) {
        return this.r = Ut(t.r), this.g = Ut(t.g), this.b = Ut(t.b), this;
      }
    }, {
      key: "convertSRGBToLinear",
      value: function convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
      }
    }, {
      key: "convertLinearToSRGB",
      value: function convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
      }
    }, {
      key: "getHex",
      value: function getHex() {
        return 255 * this.r << 16 ^ 255 * this.g << 8 ^ 255 * this.b << 0;
      }
    }, {
      key: "getHexString",
      value: function getHexString() {
        return ("000000" + this.getHex().toString(16)).slice(-6);
      }
    }, {
      key: "getHSL",
      value: function getHSL(t) {
        var e = this.r,
            n = this.g,
            i = this.b,
            r = Math.max(e, n, i),
            s = Math.min(e, n, i);
        var a, o;
        var l = (s + r) / 2;
        if (s === r) a = 0, o = 0;else {
          var _t7 = r - s;

          switch (o = l <= .5 ? _t7 / (r + s) : _t7 / (2 - r - s), r) {
            case e:
              a = (n - i) / _t7 + (n < i ? 6 : 0);
              break;

            case n:
              a = (i - e) / _t7 + 2;
              break;

            case i:
              a = (e - n) / _t7 + 4;
          }

          a /= 6;
        }
        return t.h = a, t.s = o, t.l = l, t;
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        return "rgb(" + (255 * this.r | 0) + "," + (255 * this.g | 0) + "," + (255 * this.b | 0) + ")";
      }
    }, {
      key: "offsetHSL",
      value: function offsetHSL(t, e, n) {
        return this.getHSL(Nt), Nt.h += t, Nt.s += e, Nt.l += n, this.setHSL(Nt.h, Nt.s, Nt.l), this;
      }
    }, {
      key: "add",
      value: function add(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this;
      }
    }, {
      key: "addColors",
      value: function addColors(t, e) {
        return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
      }
    }, {
      key: "addScalar",
      value: function addScalar(t) {
        return this.r += t, this.g += t, this.b += t, this;
      }
    }, {
      key: "sub",
      value: function sub(t) {
        return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
      }
    }, {
      key: "multiply",
      value: function multiply(t) {
        return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
      }
    }, {
      key: "multiplyScalar",
      value: function multiplyScalar(t) {
        return this.r *= t, this.g *= t, this.b *= t, this;
      }
    }, {
      key: "lerp",
      value: function lerp(t, e) {
        return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
      }
    }, {
      key: "lerpColors",
      value: function lerpColors(t, e, n) {
        return this.r = t.r + (e.r - t.r) * n, this.g = t.g + (e.g - t.g) * n, this.b = t.b + (e.b - t.b) * n, this;
      }
    }, {
      key: "lerpHSL",
      value: function lerpHSL(t, e) {
        this.getHSL(Nt), t.getHSL(Bt);
        var n = bt(Nt.h, Bt.h, e),
            i = bt(Nt.s, Bt.s, e),
            r = bt(Nt.l, Bt.l, e);
        return this.setHSL(n, i, r), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.r === this.r && t.g === this.g && t.b === this.b;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
      }
    }, {
      key: "fromBufferAttribute",
      value: function fromBufferAttribute(t, e) {
        return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), !0 === t.normalized && (this.r /= 255, this.g /= 255, this.b /= 255), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return this.getHex();
      }
    }]);

    return Ft;
  }();

  var Ht;
  Ft.NAMES = It, Ft.prototype.isColor = !0, Ft.prototype.r = 1, Ft.prototype.g = 1, Ft.prototype.b = 1;

  var Gt = /*#__PURE__*/function () {
    function Gt() {
      _classCallCheck(this, Gt);
    }

    _createClass(Gt, null, [{
      key: "getDataURL",
      value: function getDataURL(t) {
        if (/^data:/i.test(t.src)) return t.src;
        if ("undefined" == typeof HTMLCanvasElement) return t.src;
        var e;
        if (t instanceof HTMLCanvasElement) e = t;else {
          void 0 === Ht && (Ht = Dt("canvas")), Ht.width = t.width, Ht.height = t.height;

          var _n5 = Ht.getContext("2d");

          t instanceof ImageData ? _n5.putImageData(t, 0, 0) : _n5.drawImage(t, 0, 0, t.width, t.height), e = Ht;
        }
        return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
      }
    }, {
      key: "sRGBToLinear",
      value: function sRGBToLinear(t) {
        if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
          var _e5 = Dt("canvas");

          _e5.width = t.width, _e5.height = t.height;

          var _n6 = _e5.getContext("2d");

          _n6.drawImage(t, 0, 0, t.width, t.height);

          var _i6 = _n6.getImageData(0, 0, t.width, t.height),
              _r5 = _i6.data;

          for (var _t8 = 0; _t8 < _r5.length; _t8++) {
            _r5[_t8] = 255 * Ot(_r5[_t8] / 255);
          }

          return _n6.putImageData(_i6, 0, 0), _e5;
        }

        if (t.data) {
          var _e6 = t.data.slice(0);

          for (var _t9 = 0; _t9 < _e6.length; _t9++) {
            _e6 instanceof Uint8Array || _e6 instanceof Uint8ClampedArray ? _e6[_t9] = Math.floor(255 * Ot(_e6[_t9] / 255)) : _e6[_t9] = Ot(_e6[_t9]);
          }

          return {
            data: _e6,
            width: t.width,
            height: t.height
          };
        }

        return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
      }
    }]);

    return Gt;
  }();

  var Vt = /*#__PURE__*/function () {
    function Vt() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      _classCallCheck(this, Vt);

      this.uuid = xt(), this.data = t, this.version = 0;
    }

    _createClass(Vt, [{
      key: "needsUpdate",
      set: function set(t) {
        !0 === t && this.version++;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = void 0 === t || "string" == typeof t;
        if (!e && void 0 !== t.images[this.uuid]) return t.images[this.uuid];
        var n = {
          uuid: this.uuid,
          url: ""
        },
            i = this.data;

        if (null !== i) {
          var _t10;

          if (Array.isArray(i)) {
            _t10 = [];

            for (var _e7 = 0, _n7 = i.length; _e7 < _n7; _e7++) {
              i[_e7].isDataTexture ? _t10.push(kt(i[_e7].image)) : _t10.push(kt(i[_e7]));
            }
          } else _t10 = kt(i);

          n.url = _t10;
        }

        return e || (t.images[this.uuid] = n), n;
      }
    }]);

    return Vt;
  }();

  function kt(t) {
    return "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap ? Gt.getDataURL(t) : t.data ? {
      data: Array.prototype.slice.call(t.data),
      width: t.width,
      height: t.height,
      type: t.data.constructor.name
    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
  }

  Vt.prototype.isSource = !0;
  var Wt = 0;

  var jt = /*#__PURE__*/function (_mt) {
    _inherits(jt, _mt);

    var _super = _createSuper(jt);

    function jt() {
      var _this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jt.DEFAULT_IMAGE;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jt.DEFAULT_MAPPING;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1001;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1001;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1006;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1008;
      var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1023;
      var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1009;
      var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
      var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 3e3;

      _classCallCheck(this, jt);

      _this = _super.call(this), Object.defineProperty(_assertThisInitialized(_this), "id", {
        value: Wt++
      }), _this.uuid = xt(), _this.name = "", _this.source = new Vt(t), _this.mipmaps = [], _this.mapping = e, _this.wrapS = n, _this.wrapT = i, _this.magFilter = r, _this.minFilter = s, _this.anisotropy = l, _this.format = a, _this.internalFormat = null, _this.type = o, _this.offset = new At(0, 0), _this.repeat = new At(1, 1), _this.center = new At(0, 0), _this.rotation = 0, _this.matrixAutoUpdate = !0, _this.matrix = new Rt(), _this.generateMipmaps = !0, _this.premultiplyAlpha = !1, _this.flipY = !0, _this.unpackAlignment = 4, _this.encoding = c, _this.userData = {}, _this.version = 0, _this.onUpdate = null, _this.isRenderTargetTexture = !1, _this.needsPMREMUpdate = !1;
      return _this;
    }

    _createClass(jt, [{
      key: "image",
      get: function get() {
        return this.source.data;
      },
      set: function set(t) {
        this.source.data = t;
      }
    }, {
      key: "updateMatrix",
      value: function updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = void 0 === t || "string" == typeof t;
        if (!e && void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];
        var n = {
          metadata: {
            version: 4.5,
            type: "Texture",
            generator: "Texture.toJSON"
          },
          uuid: this.uuid,
          name: this.name,
          image: this.source.toJSON(t).uuid,
          mapping: this.mapping,
          repeat: [this.repeat.x, this.repeat.y],
          offset: [this.offset.x, this.offset.y],
          center: [this.center.x, this.center.y],
          rotation: this.rotation,
          wrap: [this.wrapS, this.wrapT],
          format: this.format,
          type: this.type,
          encoding: this.encoding,
          minFilter: this.minFilter,
          magFilter: this.magFilter,
          anisotropy: this.anisotropy,
          flipY: this.flipY,
          premultiplyAlpha: this.premultiplyAlpha,
          unpackAlignment: this.unpackAlignment
        };
        return "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e || (t.textures[this.uuid] = n), n;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }, {
      key: "transformUv",
      value: function transformUv(t) {
        if (this.mapping !== i) return t;
        if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch (this.wrapS) {
          case h:
            t.x = t.x - Math.floor(t.x);
            break;

          case u:
            t.x = t.x < 0 ? 0 : 1;
            break;

          case d:
            1 === Math.abs(Math.floor(t.x) % 2) ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
        }
        if (t.y < 0 || t.y > 1) switch (this.wrapT) {
          case h:
            t.y = t.y - Math.floor(t.y);
            break;

          case u:
            t.y = t.y < 0 ? 0 : 1;
            break;

          case d:
            1 === Math.abs(Math.floor(t.y) % 2) ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
        }
        return this.flipY && (t.y = 1 - t.y), t;
      }
    }, {
      key: "needsUpdate",
      set: function set(t) {
        !0 === t && (this.version++, this.source.needsUpdate = !0);
      }
    }]);

    return jt;
  }(mt);

  jt.DEFAULT_IMAGE = null, jt.DEFAULT_MAPPING = i, jt.prototype.isTexture = !0;

  var qt = /*#__PURE__*/function (_Symbol$iterator2) {
    function qt() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, qt);

      this.x = t, this.y = e, this.z = n, this.w = i;
    }

    _createClass(qt, [{
      key: "width",
      get: function get() {
        return this.z;
      },
      set: function set(t) {
        this.z = t;
      }
    }, {
      key: "height",
      get: function get() {
        return this.w;
      },
      set: function set(t) {
        this.w = t;
      }
    }, {
      key: "set",
      value: function set(t, e, n, i) {
        return this.x = t, this.y = e, this.z = n, this.w = i, this;
      }
    }, {
      key: "setScalar",
      value: function setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this.w = t, this;
      }
    }, {
      key: "setX",
      value: function setX(t) {
        return this.x = t, this;
      }
    }, {
      key: "setY",
      value: function setY(t) {
        return this.y = t, this;
      }
    }, {
      key: "setZ",
      value: function setZ(t) {
        return this.z = t, this;
      }
    }, {
      key: "setW",
      value: function setW(t) {
        return this.w = t, this;
      }
    }, {
      key: "setComponent",
      value: function setComponent(t, e) {
        switch (t) {
          case 0:
            this.x = e;
            break;

          case 1:
            this.y = e;
            break;

          case 2:
            this.z = e;
            break;

          case 3:
            this.w = e;
            break;

          default:
            throw new Error("index is out of range: " + t);
        }

        return this;
      }
    }, {
      key: "getComponent",
      value: function getComponent(t) {
        switch (t) {
          case 0:
            return this.x;

          case 1:
            return this.y;

          case 2:
            return this.z;

          case 3:
            return this.w;

          default:
            throw new Error("index is out of range: " + t);
        }
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this.w = void 0 !== t.w ? t.w : 1, this;
      }
    }, {
      key: "add",
      value: function add(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this);
      }
    }, {
      key: "addScalar",
      value: function addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this.w += t, this;
      }
    }, {
      key: "addVectors",
      value: function addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
      }
    }, {
      key: "addScaledVector",
      value: function addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
      }
    }, {
      key: "sub",
      value: function sub(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this);
      }
    }, {
      key: "subScalar",
      value: function subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
      }
    }, {
      key: "subVectors",
      value: function subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
      }
    }, {
      key: "multiply",
      value: function multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
      }
    }, {
      key: "multiplyScalar",
      value: function multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        var e = this.x,
            n = this.y,
            i = this.z,
            r = this.w,
            s = t.elements;
        return this.x = s[0] * e + s[4] * n + s[8] * i + s[12] * r, this.y = s[1] * e + s[5] * n + s[9] * i + s[13] * r, this.z = s[2] * e + s[6] * n + s[10] * i + s[14] * r, this.w = s[3] * e + s[7] * n + s[11] * i + s[15] * r, this;
      }
    }, {
      key: "divideScalar",
      value: function divideScalar(t) {
        return this.multiplyScalar(1 / t);
      }
    }, {
      key: "setAxisAngleFromQuaternion",
      value: function setAxisAngleFromQuaternion(t) {
        this.w = 2 * Math.acos(t.w);
        var e = Math.sqrt(1 - t.w * t.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
      }
    }, {
      key: "setAxisAngleFromRotationMatrix",
      value: function setAxisAngleFromRotationMatrix(t) {
        var e, n, i, r;
        var s = .01,
            a = .1,
            o = t.elements,
            l = o[0],
            c = o[4],
            h = o[8],
            u = o[1],
            d = o[5],
            p = o[9],
            m = o[2],
            f = o[6],
            g = o[10];

        if (Math.abs(c - u) < s && Math.abs(h - m) < s && Math.abs(p - f) < s) {
          if (Math.abs(c + u) < a && Math.abs(h + m) < a && Math.abs(p + f) < a && Math.abs(l + d + g - 3) < a) return this.set(1, 0, 0, 0), this;
          e = Math.PI;

          var _t11 = (l + 1) / 2,
              _o2 = (d + 1) / 2,
              _v = (g + 1) / 2,
              _y = (c + u) / 4,
              _x = (h + m) / 4,
              _2 = (p + f) / 4;

          return _t11 > _o2 && _t11 > _v ? _t11 < s ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(_t11), i = _y / n, r = _x / n) : _o2 > _v ? _o2 < s ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(_o2), n = _y / i, r = _2 / i) : _v < s ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(_v), n = _x / r, i = _2 / r), this.set(n, i, r, e), this;
        }

        var v = Math.sqrt((f - p) * (f - p) + (h - m) * (h - m) + (u - c) * (u - c));
        return Math.abs(v) < .001 && (v = 1), this.x = (f - p) / v, this.y = (h - m) / v, this.z = (u - c) / v, this.w = Math.acos((l + d + g - 1) / 2), this;
      }
    }, {
      key: "min",
      value: function min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
      }
    }, {
      key: "max",
      value: function max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
      }
    }, {
      key: "clamp",
      value: function clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
      }
    }, {
      key: "clampScalar",
      value: function clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
      }
    }, {
      key: "clampLength",
      value: function clampLength(t, e) {
        var n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
      }
    }, {
      key: "floor",
      value: function floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
      }
    }, {
      key: "ceil",
      value: function ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
      }
    }, {
      key: "round",
      value: function round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
      }
    }, {
      key: "roundToZero",
      value: function roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
      }
    }, {
      key: "negate",
      value: function negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
      }
    }, {
      key: "dot",
      value: function dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
      }
    }, {
      key: "lengthSq",
      value: function lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
      }
    }, {
      key: "length",
      value: function length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
      }
    }, {
      key: "manhattanLength",
      value: function manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
      }
    }, {
      key: "normalize",
      value: function normalize() {
        return this.divideScalar(this.length() || 1);
      }
    }, {
      key: "setLength",
      value: function setLength(t) {
        return this.normalize().multiplyScalar(t);
      }
    }, {
      key: "lerp",
      value: function lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
      }
    }, {
      key: "lerpVectors",
      value: function lerpVectors(t, e, n) {
        return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this.w = t.w + (e.w - t.w) * n, this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
      }
    }, {
      key: "fromBufferAttribute",
      value: function fromBufferAttribute(t, e, n) {
        return void 0 !== n && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
      }
    }, {
      key: "random",
      value: function random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
      }
    }, {
      key: _Symbol$iterator2,
      value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
        return _regeneratorRuntime.wrap(function value$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.x;

              case 2:
                _context2.next = 4;
                return this.y;

              case 4:
                _context2.next = 6;
                return this.z;

              case 6:
                _context2.next = 8;
                return this.w;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, value, this);
      })
    }]);

    return qt;
  }(Symbol.iterator);

  qt.prototype.isVector4 = !0;

  var Xt = /*#__PURE__*/function (_mt2) {
    _inherits(Xt, _mt2);

    var _super2 = _createSuper(Xt);

    function Xt(t, e) {
      var _this2;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, Xt);

      _this2 = _super2.call(this), _this2.width = t, _this2.height = e, _this2.depth = 1, _this2.scissor = new qt(0, 0, t, e), _this2.scissorTest = !1, _this2.viewport = new qt(0, 0, t, e);
      var i = {
        width: t,
        height: e,
        depth: 1
      };
      _this2.texture = new jt(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), _this2.texture.isRenderTargetTexture = !0, _this2.texture.generateMipmaps = void 0 !== n.generateMipmaps && n.generateMipmaps, _this2.texture.internalFormat = void 0 !== n.internalFormat ? n.internalFormat : null, _this2.texture.minFilter = void 0 !== n.minFilter ? n.minFilter : g, _this2.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer, _this2.stencilBuffer = void 0 !== n.stencilBuffer && n.stencilBuffer, _this2.depthTexture = void 0 !== n.depthTexture ? n.depthTexture : null, _this2.samples = void 0 !== n.samples ? n.samples : 0;
      return _this2;
    }

    _createClass(Xt, [{
      key: "setSize",
      value: function setSize(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        this.width === t && this.height === e && this.depth === n || (this.width = t, this.height = e, this.depth = n, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.image = Object.assign({}, t.texture.image), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, null !== t.depthTexture && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }]);

    return Xt;
  }(mt);

  Xt.prototype.isWebGLRenderTarget = !0;

  var Jt = /*#__PURE__*/function (_jt) {
    _inherits(Jt, _jt);

    var _super3 = _createSuper(Jt);

    function Jt() {
      var _this3;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, Jt);

      _this3 = _super3.call(this, null), _this3.image = {
        data: t,
        width: e,
        height: n,
        depth: i
      }, _this3.magFilter = p, _this3.minFilter = p, _this3.wrapR = u, _this3.generateMipmaps = !1, _this3.flipY = !1, _this3.unpackAlignment = 1;
      return _this3;
    }

    return _createClass(Jt);
  }(jt);

  Jt.prototype.isDataArrayTexture = !0;

  var Yt = /*#__PURE__*/function (_Xt) {
    _inherits(Yt, _Xt);

    var _super4 = _createSuper(Yt);

    function Yt(t, e, n) {
      var _this4;

      _classCallCheck(this, Yt);

      _this4 = _super4.call(this, t, e), _this4.depth = n, _this4.texture = new Jt(null, t, e, n), _this4.texture.isRenderTargetTexture = !0;
      return _this4;
    }

    return _createClass(Yt);
  }(Xt);

  Yt.prototype.isWebGLArrayRenderTarget = !0;

  var Zt = /*#__PURE__*/function (_jt2) {
    _inherits(Zt, _jt2);

    var _super5 = _createSuper(Zt);

    function Zt() {
      var _this5;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, Zt);

      _this5 = _super5.call(this, null), _this5.image = {
        data: t,
        width: e,
        height: n,
        depth: i
      }, _this5.magFilter = p, _this5.minFilter = p, _this5.wrapR = u, _this5.generateMipmaps = !1, _this5.flipY = !1, _this5.unpackAlignment = 1;
      return _this5;
    }

    return _createClass(Zt);
  }(jt);

  Zt.prototype.isData3DTexture = !0;

  var Kt = /*#__PURE__*/function (_Xt2) {
    _inherits(Kt, _Xt2);

    var _super6 = _createSuper(Kt);

    function Kt(t, e, n) {
      var _this6;

      _classCallCheck(this, Kt);

      _this6 = _super6.call(this, t, e), _this6.depth = n, _this6.texture = new Zt(null, t, e, n), _this6.texture.isRenderTargetTexture = !0;
      return _this6;
    }

    return _createClass(Kt);
  }(Xt);

  Kt.prototype.isWebGL3DRenderTarget = !0;

  var Qt = /*#__PURE__*/function (_Xt3) {
    _inherits(Qt, _Xt3);

    var _super7 = _createSuper(Qt);

    function Qt(t, e, n) {
      var _this7;

      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      _classCallCheck(this, Qt);

      _this7 = _super7.call(this, t, e, i);
      var r = _this7.texture;
      _this7.texture = [];

      for (var _t12 = 0; _t12 < n; _t12++) {
        _this7.texture[_t12] = r.clone();
      }

      return _this7;
    }

    _createClass(Qt, [{
      key: "setSize",
      value: function setSize(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

        if (this.width !== t || this.height !== e || this.depth !== n) {
          this.width = t, this.height = e, this.depth = n;

          for (var _i7 = 0, _r6 = this.texture.length; _i7 < _r6; _i7++) {
            this.texture[_i7].image.width = t, this.texture[_i7].image.height = e, this.texture[_i7].image.depth = n;
          }

          this.dispose();
        }

        return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.depthTexture = t.depthTexture, this.texture.length = 0;

        for (var _e8 = 0, _n8 = t.texture.length; _e8 < _n8; _e8++) {
          this.texture[_e8] = t.texture[_e8].clone();
        }

        return this;
      }
    }]);

    return Qt;
  }(Xt);

  Qt.prototype.isWebGLMultipleRenderTargets = !0;

  var $t = /*#__PURE__*/function () {
    function $t() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, $t);

      this._x = t, this._y = e, this._z = n, this._w = i;
    }

    _createClass($t, [{
      key: "x",
      get: function get() {
        return this._x;
      },
      set: function set(t) {
        this._x = t, this._onChangeCallback();
      }
    }, {
      key: "y",
      get: function get() {
        return this._y;
      },
      set: function set(t) {
        this._y = t, this._onChangeCallback();
      }
    }, {
      key: "z",
      get: function get() {
        return this._z;
      },
      set: function set(t) {
        this._z = t, this._onChangeCallback();
      }
    }, {
      key: "w",
      get: function get() {
        return this._w;
      },
      set: function set(t) {
        this._w = t, this._onChangeCallback();
      }
    }, {
      key: "set",
      value: function set(t, e, n, i) {
        return this._x = t, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
      }
    }, {
      key: "setFromEuler",
      value: function setFromEuler(t, e) {
        if (!t || !t.isEuler) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        var n = t._x,
            i = t._y,
            r = t._z,
            s = t._order,
            a = Math.cos,
            o = Math.sin,
            l = a(n / 2),
            c = a(i / 2),
            h = a(r / 2),
            u = o(n / 2),
            d = o(i / 2),
            p = o(r / 2);

        switch (s) {
          case "XYZ":
            this._x = u * c * h + l * d * p, this._y = l * d * h - u * c * p, this._z = l * c * p + u * d * h, this._w = l * c * h - u * d * p;
            break;

          case "YXZ":
            this._x = u * c * h + l * d * p, this._y = l * d * h - u * c * p, this._z = l * c * p - u * d * h, this._w = l * c * h + u * d * p;
            break;

          case "ZXY":
            this._x = u * c * h - l * d * p, this._y = l * d * h + u * c * p, this._z = l * c * p + u * d * h, this._w = l * c * h - u * d * p;
            break;

          case "ZYX":
            this._x = u * c * h - l * d * p, this._y = l * d * h + u * c * p, this._z = l * c * p - u * d * h, this._w = l * c * h + u * d * p;
            break;

          case "YZX":
            this._x = u * c * h + l * d * p, this._y = l * d * h + u * c * p, this._z = l * c * p - u * d * h, this._w = l * c * h - u * d * p;
            break;

          case "XZY":
            this._x = u * c * h - l * d * p, this._y = l * d * h - u * c * p, this._z = l * c * p + u * d * h, this._w = l * c * h + u * d * p;
            break;

          default:
            console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + s);
        }

        return !1 !== e && this._onChangeCallback(), this;
      }
    }, {
      key: "setFromAxisAngle",
      value: function setFromAxisAngle(t, e) {
        var n = e / 2,
            i = Math.sin(n);
        return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
      }
    }, {
      key: "setFromRotationMatrix",
      value: function setFromRotationMatrix(t) {
        var e = t.elements,
            n = e[0],
            i = e[4],
            r = e[8],
            s = e[1],
            a = e[5],
            o = e[9],
            l = e[2],
            c = e[6],
            h = e[10],
            u = n + a + h;

        if (u > 0) {
          var _t13 = .5 / Math.sqrt(u + 1);

          this._w = .25 / _t13, this._x = (c - o) * _t13, this._y = (r - l) * _t13, this._z = (s - i) * _t13;
        } else if (n > a && n > h) {
          var _t14 = 2 * Math.sqrt(1 + n - a - h);

          this._w = (c - o) / _t14, this._x = .25 * _t14, this._y = (i + s) / _t14, this._z = (r + l) / _t14;
        } else if (a > h) {
          var _t15 = 2 * Math.sqrt(1 + a - n - h);

          this._w = (r - l) / _t15, this._x = (i + s) / _t15, this._y = .25 * _t15, this._z = (o + c) / _t15;
        } else {
          var _t16 = 2 * Math.sqrt(1 + h - n - a);

          this._w = (s - i) / _t16, this._x = (r + l) / _t16, this._y = (o + c) / _t16, this._z = .25 * _t16;
        }

        return this._onChangeCallback(), this;
      }
    }, {
      key: "setFromUnitVectors",
      value: function setFromUnitVectors(t, e) {
        var n = t.dot(e) + 1;
        return n < Number.EPSILON ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = n)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = n), this.normalize();
      }
    }, {
      key: "angleTo",
      value: function angleTo(t) {
        return 2 * Math.acos(Math.abs(_t(this.dot(t), -1, 1)));
      }
    }, {
      key: "rotateTowards",
      value: function rotateTowards(t, e) {
        var n = this.angleTo(t);
        if (0 === n) return this;
        var i = Math.min(1, e / n);
        return this.slerp(t, i), this;
      }
    }, {
      key: "identity",
      value: function identity() {
        return this.set(0, 0, 0, 1);
      }
    }, {
      key: "invert",
      value: function invert() {
        return this.conjugate();
      }
    }, {
      key: "conjugate",
      value: function conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
      }
    }, {
      key: "dot",
      value: function dot(t) {
        return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
      }
    }, {
      key: "lengthSq",
      value: function lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
      }
    }, {
      key: "length",
      value: function length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
      }
    }, {
      key: "normalize",
      value: function normalize() {
        var t = this.length();
        return 0 === t ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
      }
    }, {
      key: "multiply",
      value: function multiply(t, e) {
        return void 0 !== e ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(t, e)) : this.multiplyQuaternions(this, t);
      }
    }, {
      key: "premultiply",
      value: function premultiply(t) {
        return this.multiplyQuaternions(t, this);
      }
    }, {
      key: "multiplyQuaternions",
      value: function multiplyQuaternions(t, e) {
        var n = t._x,
            i = t._y,
            r = t._z,
            s = t._w,
            a = e._x,
            o = e._y,
            l = e._z,
            c = e._w;
        return this._x = n * c + s * a + i * l - r * o, this._y = i * c + s * o + r * a - n * l, this._z = r * c + s * l + n * o - i * a, this._w = s * c - n * a - i * o - r * l, this._onChangeCallback(), this;
      }
    }, {
      key: "slerp",
      value: function slerp(t, e) {
        if (0 === e) return this;
        if (1 === e) return this.copy(t);
        var n = this._x,
            i = this._y,
            r = this._z,
            s = this._w;
        var a = s * t._w + n * t._x + i * t._y + r * t._z;
        if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = s, this._x = n, this._y = i, this._z = r, this;
        var o = 1 - a * a;

        if (o <= Number.EPSILON) {
          var _t17 = 1 - e;

          return this._w = _t17 * s + e * this._w, this._x = _t17 * n + e * this._x, this._y = _t17 * i + e * this._y, this._z = _t17 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
        }

        var l = Math.sqrt(o),
            c = Math.atan2(l, a),
            h = Math.sin((1 - e) * c) / l,
            u = Math.sin(e * c) / l;
        return this._w = s * h + this._w * u, this._x = n * h + this._x * u, this._y = i * h + this._y * u, this._z = r * h + this._z * u, this._onChangeCallback(), this;
      }
    }, {
      key: "slerpQuaternions",
      value: function slerpQuaternions(t, e, n) {
        return this.copy(t).slerp(e, n);
      }
    }, {
      key: "random",
      value: function random() {
        var t = Math.random(),
            e = Math.sqrt(1 - t),
            n = Math.sqrt(t),
            i = 2 * Math.PI * Math.random(),
            r = 2 * Math.PI * Math.random();
        return this.set(e * Math.cos(i), n * Math.sin(r), n * Math.cos(r), e * Math.sin(i));
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
      }
    }, {
      key: "fromBufferAttribute",
      value: function fromBufferAttribute(t, e) {
        return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
      }
    }, {
      key: "_onChange",
      value: function _onChange(t) {
        return this._onChangeCallback = t, this;
      }
    }, {
      key: "_onChangeCallback",
      value: function _onChangeCallback() {}
    }], [{
      key: "slerp",
      value: function slerp(t, e, n, i) {
        return console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead."), n.slerpQuaternions(t, e, i);
      }
    }, {
      key: "slerpFlat",
      value: function slerpFlat(t, e, n, i, r, s, a) {
        var o = n[i + 0],
            l = n[i + 1],
            c = n[i + 2],
            h = n[i + 3];
        var u = r[s + 0],
            d = r[s + 1],
            p = r[s + 2],
            m = r[s + 3];
        if (0 === a) return t[e + 0] = o, t[e + 1] = l, t[e + 2] = c, void (t[e + 3] = h);
        if (1 === a) return t[e + 0] = u, t[e + 1] = d, t[e + 2] = p, void (t[e + 3] = m);

        if (h !== m || o !== u || l !== d || c !== p) {
          var _t18 = 1 - a;

          var _e9 = o * u + l * d + c * p + h * m,
              _n9 = _e9 >= 0 ? 1 : -1,
              _i8 = 1 - _e9 * _e9;

          if (_i8 > Number.EPSILON) {
            var _r8 = Math.sqrt(_i8),
                _s2 = Math.atan2(_r8, _e9 * _n9);

            _t18 = Math.sin(_t18 * _s2) / _r8, a = Math.sin(a * _s2) / _r8;
          }

          var _r7 = a * _n9;

          if (o = o * _t18 + u * _r7, l = l * _t18 + d * _r7, c = c * _t18 + p * _r7, h = h * _t18 + m * _r7, _t18 === 1 - a) {
            var _t19 = 1 / Math.sqrt(o * o + l * l + c * c + h * h);

            o *= _t19, l *= _t19, c *= _t19, h *= _t19;
          }
        }

        t[e] = o, t[e + 1] = l, t[e + 2] = c, t[e + 3] = h;
      }
    }, {
      key: "multiplyQuaternionsFlat",
      value: function multiplyQuaternionsFlat(t, e, n, i, r, s) {
        var a = n[i],
            o = n[i + 1],
            l = n[i + 2],
            c = n[i + 3],
            h = r[s],
            u = r[s + 1],
            d = r[s + 2],
            p = r[s + 3];
        return t[e] = a * p + c * h + o * d - l * u, t[e + 1] = o * p + c * u + l * h - a * d, t[e + 2] = l * p + c * d + a * u - o * h, t[e + 3] = c * p - a * h - o * u - l * d, t;
      }
    }]);

    return $t;
  }();

  $t.prototype.isQuaternion = !0;

  var te = /*#__PURE__*/function (_Symbol$iterator3) {
    function te() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      _classCallCheck(this, te);

      this.x = t, this.y = e, this.z = n;
    }

    _createClass(te, [{
      key: "set",
      value: function set(t, e, n) {
        return void 0 === n && (n = this.z), this.x = t, this.y = e, this.z = n, this;
      }
    }, {
      key: "setScalar",
      value: function setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this;
      }
    }, {
      key: "setX",
      value: function setX(t) {
        return this.x = t, this;
      }
    }, {
      key: "setY",
      value: function setY(t) {
        return this.y = t, this;
      }
    }, {
      key: "setZ",
      value: function setZ(t) {
        return this.z = t, this;
      }
    }, {
      key: "setComponent",
      value: function setComponent(t, e) {
        switch (t) {
          case 0:
            this.x = e;
            break;

          case 1:
            this.y = e;
            break;

          case 2:
            this.z = e;
            break;

          default:
            throw new Error("index is out of range: " + t);
        }

        return this;
      }
    }, {
      key: "getComponent",
      value: function getComponent(t) {
        switch (t) {
          case 0:
            return this.x;

          case 1:
            return this.y;

          case 2:
            return this.z;

          default:
            throw new Error("index is out of range: " + t);
        }
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this.x, this.y, this.z);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
      }
    }, {
      key: "add",
      value: function add(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this);
      }
    }, {
      key: "addScalar",
      value: function addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this;
      }
    }, {
      key: "addVectors",
      value: function addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
      }
    }, {
      key: "addScaledVector",
      value: function addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
      }
    }, {
      key: "sub",
      value: function sub(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this);
      }
    }, {
      key: "subScalar",
      value: function subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this;
      }
    }, {
      key: "subVectors",
      value: function subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
      }
    }, {
      key: "multiply",
      value: function multiply(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(t, e)) : (this.x *= t.x, this.y *= t.y, this.z *= t.z, this);
      }
    }, {
      key: "multiplyScalar",
      value: function multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
      }
    }, {
      key: "multiplyVectors",
      value: function multiplyVectors(t, e) {
        return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
      }
    }, {
      key: "applyEuler",
      value: function applyEuler(t) {
        return t && t.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion(ne.setFromEuler(t));
      }
    }, {
      key: "applyAxisAngle",
      value: function applyAxisAngle(t, e) {
        return this.applyQuaternion(ne.setFromAxisAngle(t, e));
      }
    }, {
      key: "applyMatrix3",
      value: function applyMatrix3(t) {
        var e = this.x,
            n = this.y,
            i = this.z,
            r = t.elements;
        return this.x = r[0] * e + r[3] * n + r[6] * i, this.y = r[1] * e + r[4] * n + r[7] * i, this.z = r[2] * e + r[5] * n + r[8] * i, this;
      }
    }, {
      key: "applyNormalMatrix",
      value: function applyNormalMatrix(t) {
        return this.applyMatrix3(t).normalize();
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        var e = this.x,
            n = this.y,
            i = this.z,
            r = t.elements,
            s = 1 / (r[3] * e + r[7] * n + r[11] * i + r[15]);
        return this.x = (r[0] * e + r[4] * n + r[8] * i + r[12]) * s, this.y = (r[1] * e + r[5] * n + r[9] * i + r[13]) * s, this.z = (r[2] * e + r[6] * n + r[10] * i + r[14]) * s, this;
      }
    }, {
      key: "applyQuaternion",
      value: function applyQuaternion(t) {
        var e = this.x,
            n = this.y,
            i = this.z,
            r = t.x,
            s = t.y,
            a = t.z,
            o = t.w,
            l = o * e + s * i - a * n,
            c = o * n + a * e - r * i,
            h = o * i + r * n - s * e,
            u = -r * e - s * n - a * i;
        return this.x = l * o + u * -r + c * -a - h * -s, this.y = c * o + u * -s + h * -r - l * -a, this.z = h * o + u * -a + l * -s - c * -r, this;
      }
    }, {
      key: "project",
      value: function project(t) {
        return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
      }
    }, {
      key: "unproject",
      value: function unproject(t) {
        return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
      }
    }, {
      key: "transformDirection",
      value: function transformDirection(t) {
        var e = this.x,
            n = this.y,
            i = this.z,
            r = t.elements;
        return this.x = r[0] * e + r[4] * n + r[8] * i, this.y = r[1] * e + r[5] * n + r[9] * i, this.z = r[2] * e + r[6] * n + r[10] * i, this.normalize();
      }
    }, {
      key: "divide",
      value: function divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
      }
    }, {
      key: "divideScalar",
      value: function divideScalar(t) {
        return this.multiplyScalar(1 / t);
      }
    }, {
      key: "min",
      value: function min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
      }
    }, {
      key: "max",
      value: function max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
      }
    }, {
      key: "clamp",
      value: function clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
      }
    }, {
      key: "clampScalar",
      value: function clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
      }
    }, {
      key: "clampLength",
      value: function clampLength(t, e) {
        var n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
      }
    }, {
      key: "floor",
      value: function floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
      }
    }, {
      key: "ceil",
      value: function ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
      }
    }, {
      key: "round",
      value: function round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
      }
    }, {
      key: "roundToZero",
      value: function roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
      }
    }, {
      key: "negate",
      value: function negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
      }
    }, {
      key: "dot",
      value: function dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z;
      }
    }, {
      key: "lengthSq",
      value: function lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
      }
    }, {
      key: "length",
      value: function length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
      }
    }, {
      key: "manhattanLength",
      value: function manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
      }
    }, {
      key: "normalize",
      value: function normalize() {
        return this.divideScalar(this.length() || 1);
      }
    }, {
      key: "setLength",
      value: function setLength(t) {
        return this.normalize().multiplyScalar(t);
      }
    }, {
      key: "lerp",
      value: function lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
      }
    }, {
      key: "lerpVectors",
      value: function lerpVectors(t, e, n) {
        return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this;
      }
    }, {
      key: "cross",
      value: function cross(t, e) {
        return void 0 !== e ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(t, e)) : this.crossVectors(this, t);
      }
    }, {
      key: "crossVectors",
      value: function crossVectors(t, e) {
        var n = t.x,
            i = t.y,
            r = t.z,
            s = e.x,
            a = e.y,
            o = e.z;
        return this.x = i * o - r * a, this.y = r * s - n * o, this.z = n * a - i * s, this;
      }
    }, {
      key: "projectOnVector",
      value: function projectOnVector(t) {
        var e = t.lengthSq();
        if (0 === e) return this.set(0, 0, 0);
        var n = t.dot(this) / e;
        return this.copy(t).multiplyScalar(n);
      }
    }, {
      key: "projectOnPlane",
      value: function projectOnPlane(t) {
        return ee.copy(this).projectOnVector(t), this.sub(ee);
      }
    }, {
      key: "reflect",
      value: function reflect(t) {
        return this.sub(ee.copy(t).multiplyScalar(2 * this.dot(t)));
      }
    }, {
      key: "angleTo",
      value: function angleTo(t) {
        var e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (0 === e) return Math.PI / 2;
        var n = this.dot(t) / e;
        return Math.acos(_t(n, -1, 1));
      }
    }, {
      key: "distanceTo",
      value: function distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
      }
    }, {
      key: "distanceToSquared",
      value: function distanceToSquared(t) {
        var e = this.x - t.x,
            n = this.y - t.y,
            i = this.z - t.z;
        return e * e + n * n + i * i;
      }
    }, {
      key: "manhattanDistanceTo",
      value: function manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
      }
    }, {
      key: "setFromSpherical",
      value: function setFromSpherical(t) {
        return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
      }
    }, {
      key: "setFromSphericalCoords",
      value: function setFromSphericalCoords(t, e, n) {
        var i = Math.sin(e) * t;
        return this.x = i * Math.sin(n), this.y = Math.cos(e) * t, this.z = i * Math.cos(n), this;
      }
    }, {
      key: "setFromCylindrical",
      value: function setFromCylindrical(t) {
        return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
      }
    }, {
      key: "setFromCylindricalCoords",
      value: function setFromCylindricalCoords(t, e, n) {
        return this.x = t * Math.sin(e), this.y = n, this.z = t * Math.cos(e), this;
      }
    }, {
      key: "setFromMatrixPosition",
      value: function setFromMatrixPosition(t) {
        var e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
      }
    }, {
      key: "setFromMatrixScale",
      value: function setFromMatrixScale(t) {
        var e = this.setFromMatrixColumn(t, 0).length(),
            n = this.setFromMatrixColumn(t, 1).length(),
            i = this.setFromMatrixColumn(t, 2).length();
        return this.x = e, this.y = n, this.z = i, this;
      }
    }, {
      key: "setFromMatrixColumn",
      value: function setFromMatrixColumn(t, e) {
        return this.fromArray(t.elements, 4 * e);
      }
    }, {
      key: "setFromMatrix3Column",
      value: function setFromMatrix3Column(t, e) {
        return this.fromArray(t.elements, 3 * e);
      }
    }, {
      key: "setFromEuler",
      value: function setFromEuler(t) {
        return this.x = t._x, this.y = t._y, this.z = t._z, this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
      }
    }, {
      key: "fromBufferAttribute",
      value: function fromBufferAttribute(t, e, n) {
        return void 0 !== n && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
      }
    }, {
      key: "random",
      value: function random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
      }
    }, {
      key: "randomDirection",
      value: function randomDirection() {
        var t = 2 * (Math.random() - .5),
            e = Math.random() * Math.PI * 2,
            n = Math.sqrt(1 - Math.pow(t, 2));
        return this.x = n * Math.cos(e), this.y = n * Math.sin(e), this.z = t, this;
      }
    }, {
      key: _Symbol$iterator3,
      value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
        return _regeneratorRuntime.wrap(function value$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.x;

              case 2:
                _context3.next = 4;
                return this.y;

              case 4:
                _context3.next = 6;
                return this.z;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, value, this);
      })
    }]);

    return te;
  }(Symbol.iterator);

  te.prototype.isVector3 = !0;
  var ee = new te(),
      ne = new $t();

  var ie = /*#__PURE__*/function () {
    function ie() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te(1 / 0, 1 / 0, 1 / 0);
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te(-1 / 0, -1 / 0, -1 / 0);

      _classCallCheck(this, ie);

      this.min = t, this.max = e;
    }

    _createClass(ie, [{
      key: "set",
      value: function set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
      }
    }, {
      key: "setFromArray",
      value: function setFromArray(t) {
        var e = 1 / 0,
            n = 1 / 0,
            i = 1 / 0,
            r = -1 / 0,
            s = -1 / 0,
            a = -1 / 0;

        for (var _o3 = 0, _l2 = t.length; _o3 < _l2; _o3 += 3) {
          var _l3 = t[_o3],
              _c2 = t[_o3 + 1],
              _h2 = t[_o3 + 2];
          _l3 < e && (e = _l3), _c2 < n && (n = _c2), _h2 < i && (i = _h2), _l3 > r && (r = _l3), _c2 > s && (s = _c2), _h2 > a && (a = _h2);
        }

        return this.min.set(e, n, i), this.max.set(r, s, a), this;
      }
    }, {
      key: "setFromBufferAttribute",
      value: function setFromBufferAttribute(t) {
        var e = 1 / 0,
            n = 1 / 0,
            i = 1 / 0,
            r = -1 / 0,
            s = -1 / 0,
            a = -1 / 0;

        for (var _o4 = 0, _l4 = t.count; _o4 < _l4; _o4++) {
          var _l5 = t.getX(_o4),
              _c3 = t.getY(_o4),
              _h3 = t.getZ(_o4);

          _l5 < e && (e = _l5), _c3 < n && (n = _c3), _h3 < i && (i = _h3), _l5 > r && (r = _l5), _c3 > s && (s = _c3), _h3 > a && (a = _h3);
        }

        return this.min.set(e, n, i), this.max.set(r, s, a), this;
      }
    }, {
      key: "setFromPoints",
      value: function setFromPoints(t) {
        this.makeEmpty();

        for (var _e10 = 0, _n10 = t.length; _e10 < _n10; _e10++) {
          this.expandByPoint(t[_e10]);
        }

        return this;
      }
    }, {
      key: "setFromCenterAndSize",
      value: function setFromCenterAndSize(t, e) {
        var n = se.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
      }
    }, {
      key: "setFromObject",
      value: function setFromObject(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return this.makeEmpty(), this.expandByObject(t, e);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
      }
    }, {
      key: "makeEmpty",
      value: function makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
      }
    }, {
      key: "isEmpty",
      value: function isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
      }
    }, {
      key: "getCenter",
      value: function getCenter(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
      }
    }, {
      key: "getSize",
      value: function getSize(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
      }
    }, {
      key: "expandByPoint",
      value: function expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
      }
    }, {
      key: "expandByVector",
      value: function expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
      }
    }, {
      key: "expandByScalar",
      value: function expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
      }
    }, {
      key: "expandByObject",
      value: function expandByObject(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        t.updateWorldMatrix(!1, !1);
        var n = t.geometry;
        if (void 0 !== n) if (e && null != n.attributes && void 0 !== n.attributes.position) {
          var _e11 = n.attributes.position;

          for (var _n11 = 0, _i9 = _e11.count; _n11 < _i9; _n11++) {
            se.fromBufferAttribute(_e11, _n11).applyMatrix4(t.matrixWorld), this.expandByPoint(se);
          }
        } else null === n.boundingBox && n.computeBoundingBox(), ae.copy(n.boundingBox), ae.applyMatrix4(t.matrixWorld), this.union(ae);
        var i = t.children;

        for (var _t20 = 0, _n12 = i.length; _t20 < _n12; _t20++) {
          this.expandByObject(i[_t20], e);
        }

        return this;
      }
    }, {
      key: "containsPoint",
      value: function containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
      }
    }, {
      key: "containsBox",
      value: function containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
      }
    }, {
      key: "getParameter",
      value: function getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
      }
    }, {
      key: "intersectsSphere",
      value: function intersectsSphere(t) {
        return this.clampPoint(t.center, se), se.distanceToSquared(t.center) <= t.radius * t.radius;
      }
    }, {
      key: "intersectsPlane",
      value: function intersectsPlane(t) {
        var e, n;
        return t.normal.x > 0 ? (e = t.normal.x * this.min.x, n = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, n = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, n += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, n += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, n += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, n += t.normal.z * this.min.z), e <= -t.constant && n >= -t.constant;
      }
    }, {
      key: "intersectsTriangle",
      value: function intersectsTriangle(t) {
        if (this.isEmpty()) return !1;
        this.getCenter(pe), me.subVectors(this.max, pe), oe.subVectors(t.a, pe), le.subVectors(t.b, pe), ce.subVectors(t.c, pe), he.subVectors(le, oe), ue.subVectors(ce, le), de.subVectors(oe, ce);
        var e = [0, -he.z, he.y, 0, -ue.z, ue.y, 0, -de.z, de.y, he.z, 0, -he.x, ue.z, 0, -ue.x, de.z, 0, -de.x, -he.y, he.x, 0, -ue.y, ue.x, 0, -de.y, de.x, 0];
        return !!ve(e, oe, le, ce, me) && (e = [1, 0, 0, 0, 1, 0, 0, 0, 1], !!ve(e, oe, le, ce, me) && (fe.crossVectors(he, ue), e = [fe.x, fe.y, fe.z], ve(e, oe, le, ce, me)));
      }
    }, {
      key: "clampPoint",
      value: function clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
      }
    }, {
      key: "distanceToPoint",
      value: function distanceToPoint(t) {
        return se.copy(t).clamp(this.min, this.max).sub(t).length();
      }
    }, {
      key: "getBoundingSphere",
      value: function getBoundingSphere(t) {
        return this.getCenter(t.center), t.radius = .5 * this.getSize(se).length(), t;
      }
    }, {
      key: "intersect",
      value: function intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
      }
    }, {
      key: "union",
      value: function union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        return this.isEmpty() || (re[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), re[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), re[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), re[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), re[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), re[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), re[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), re[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(re)), this;
      }
    }, {
      key: "translate",
      value: function translate(t) {
        return this.min.add(t), this.max.add(t), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
      }
    }]);

    return ie;
  }();

  ie.prototype.isBox3 = !0;
  var re = [new te(), new te(), new te(), new te(), new te(), new te(), new te(), new te()],
      se = new te(),
      ae = new ie(),
      oe = new te(),
      le = new te(),
      ce = new te(),
      he = new te(),
      ue = new te(),
      de = new te(),
      pe = new te(),
      me = new te(),
      fe = new te(),
      ge = new te();

  function ve(t, e, n, i, r) {
    for (var _s3 = 0, _a2 = t.length - 3; _s3 <= _a2; _s3 += 3) {
      ge.fromArray(t, _s3);

      var _a3 = r.x * Math.abs(ge.x) + r.y * Math.abs(ge.y) + r.z * Math.abs(ge.z),
          _o5 = e.dot(ge),
          _l6 = n.dot(ge),
          _c4 = i.dot(ge);

      if (Math.max(-Math.max(_o5, _l6, _c4), Math.min(_o5, _l6, _c4)) > _a3) return !1;
    }

    return !0;
  }

  var ye = new ie(),
      xe = new te(),
      _e = new te(),
      Me = new te();

  var be = /*#__PURE__*/function () {
    function be() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

      _classCallCheck(this, be);

      this.center = t, this.radius = e;
    }

    _createClass(be, [{
      key: "set",
      value: function set(t, e) {
        return this.center.copy(t), this.radius = e, this;
      }
    }, {
      key: "setFromPoints",
      value: function setFromPoints(t, e) {
        var n = this.center;
        void 0 !== e ? n.copy(e) : ye.setFromPoints(t).getCenter(n);
        var i = 0;

        for (var _e12 = 0, _r9 = t.length; _e12 < _r9; _e12++) {
          i = Math.max(i, n.distanceToSquared(t[_e12]));
        }

        return this.radius = Math.sqrt(i), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.center.copy(t.center), this.radius = t.radius, this;
      }
    }, {
      key: "isEmpty",
      value: function isEmpty() {
        return this.radius < 0;
      }
    }, {
      key: "makeEmpty",
      value: function makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
      }
    }, {
      key: "containsPoint",
      value: function containsPoint(t) {
        return t.distanceToSquared(this.center) <= this.radius * this.radius;
      }
    }, {
      key: "distanceToPoint",
      value: function distanceToPoint(t) {
        return t.distanceTo(this.center) - this.radius;
      }
    }, {
      key: "intersectsSphere",
      value: function intersectsSphere(t) {
        var e = this.radius + t.radius;
        return t.center.distanceToSquared(this.center) <= e * e;
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        return t.intersectsSphere(this);
      }
    }, {
      key: "intersectsPlane",
      value: function intersectsPlane(t) {
        return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
      }
    }, {
      key: "clampPoint",
      value: function clampPoint(t, e) {
        var n = this.center.distanceToSquared(t);
        return e.copy(t), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
      }
    }, {
      key: "getBoundingBox",
      value: function getBoundingBox(t) {
        return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
      }
    }, {
      key: "translate",
      value: function translate(t) {
        return this.center.add(t), this;
      }
    }, {
      key: "expandByPoint",
      value: function expandByPoint(t) {
        Me.subVectors(t, this.center);
        var e = Me.lengthSq();

        if (e > this.radius * this.radius) {
          var _t21 = Math.sqrt(e),
              _n13 = .5 * (_t21 - this.radius);

          this.center.add(Me.multiplyScalar(_n13 / _t21)), this.radius += _n13;
        }

        return this;
      }
    }, {
      key: "union",
      value: function union(t) {
        return !0 === this.center.equals(t.center) ? _e.set(0, 0, 1).multiplyScalar(t.radius) : _e.subVectors(t.center, this.center).normalize().multiplyScalar(t.radius), this.expandByPoint(xe.copy(t.center).add(_e)), this.expandByPoint(xe.copy(t.center).sub(_e)), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.center.equals(this.center) && t.radius === this.radius;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return be;
  }();

  var we = new te(),
      Se = new te(),
      Te = new te(),
      Ee = new te(),
      Ae = new te(),
      Re = new te(),
      Ce = new te();

  var Le = /*#__PURE__*/function () {
    function Le() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te(0, 0, -1);

      _classCallCheck(this, Le);

      this.origin = t, this.direction = e;
    }

    _createClass(Le, [{
      key: "set",
      value: function set(t, e) {
        return this.origin.copy(t), this.direction.copy(e), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
      }
    }, {
      key: "at",
      value: function at(t, e) {
        return e.copy(this.direction).multiplyScalar(t).add(this.origin);
      }
    }, {
      key: "lookAt",
      value: function lookAt(t) {
        return this.direction.copy(t).sub(this.origin).normalize(), this;
      }
    }, {
      key: "recast",
      value: function recast(t) {
        return this.origin.copy(this.at(t, we)), this;
      }
    }, {
      key: "closestPointToPoint",
      value: function closestPointToPoint(t, e) {
        e.subVectors(t, this.origin);
        var n = e.dot(this.direction);
        return n < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(n).add(this.origin);
      }
    }, {
      key: "distanceToPoint",
      value: function distanceToPoint(t) {
        return Math.sqrt(this.distanceSqToPoint(t));
      }
    }, {
      key: "distanceSqToPoint",
      value: function distanceSqToPoint(t) {
        var e = we.subVectors(t, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t) : (we.copy(this.direction).multiplyScalar(e).add(this.origin), we.distanceToSquared(t));
      }
    }, {
      key: "distanceSqToSegment",
      value: function distanceSqToSegment(t, e, n, i) {
        Se.copy(t).add(e).multiplyScalar(.5), Te.copy(e).sub(t).normalize(), Ee.copy(this.origin).sub(Se);
        var r = .5 * t.distanceTo(e),
            s = -this.direction.dot(Te),
            a = Ee.dot(this.direction),
            o = -Ee.dot(Te),
            l = Ee.lengthSq(),
            c = Math.abs(1 - s * s);
        var h, u, d, p;
        if (c > 0) {
          if (h = s * o - a, u = s * a - o, p = r * c, h >= 0) {
            if (u >= -p) {
              if (u <= p) {
                var _t22 = 1 / c;

                h *= _t22, u *= _t22, d = h * (h + s * u + 2 * a) + u * (s * h + u + 2 * o) + l;
              } else u = r, h = Math.max(0, -(s * u + a)), d = -h * h + u * (u + 2 * o) + l;
            } else u = -r, h = Math.max(0, -(s * u + a)), d = -h * h + u * (u + 2 * o) + l;
          } else u <= -p ? (h = Math.max(0, -(-s * r + a)), u = h > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -h * h + u * (u + 2 * o) + l) : u <= p ? (h = 0, u = Math.min(Math.max(-r, -o), r), d = u * (u + 2 * o) + l) : (h = Math.max(0, -(s * r + a)), u = h > 0 ? r : Math.min(Math.max(-r, -o), r), d = -h * h + u * (u + 2 * o) + l);
        } else u = s > 0 ? -r : r, h = Math.max(0, -(s * u + a)), d = -h * h + u * (u + 2 * o) + l;
        return n && n.copy(this.direction).multiplyScalar(h).add(this.origin), i && i.copy(Te).multiplyScalar(u).add(Se), d;
      }
    }, {
      key: "intersectSphere",
      value: function intersectSphere(t, e) {
        we.subVectors(t.center, this.origin);
        var n = we.dot(this.direction),
            i = we.dot(we) - n * n,
            r = t.radius * t.radius;
        if (i > r) return null;
        var s = Math.sqrt(r - i),
            a = n - s,
            o = n + s;
        return a < 0 && o < 0 ? null : a < 0 ? this.at(o, e) : this.at(a, e);
      }
    }, {
      key: "intersectsSphere",
      value: function intersectsSphere(t) {
        return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
      }
    }, {
      key: "distanceToPlane",
      value: function distanceToPlane(t) {
        var e = t.normal.dot(this.direction);
        if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;
        var n = -(this.origin.dot(t.normal) + t.constant) / e;
        return n >= 0 ? n : null;
      }
    }, {
      key: "intersectPlane",
      value: function intersectPlane(t, e) {
        var n = this.distanceToPlane(t);
        return null === n ? null : this.at(n, e);
      }
    }, {
      key: "intersectsPlane",
      value: function intersectsPlane(t) {
        var e = t.distanceToPoint(this.origin);
        if (0 === e) return !0;
        return t.normal.dot(this.direction) * e < 0;
      }
    }, {
      key: "intersectBox",
      value: function intersectBox(t, e) {
        var n, i, r, s, a, o;
        var l = 1 / this.direction.x,
            c = 1 / this.direction.y,
            h = 1 / this.direction.z,
            u = this.origin;
        return l >= 0 ? (n = (t.min.x - u.x) * l, i = (t.max.x - u.x) * l) : (n = (t.max.x - u.x) * l, i = (t.min.x - u.x) * l), c >= 0 ? (r = (t.min.y - u.y) * c, s = (t.max.y - u.y) * c) : (r = (t.max.y - u.y) * c, s = (t.min.y - u.y) * c), n > s || r > i ? null : ((r > n || n != n) && (n = r), (s < i || i != i) && (i = s), h >= 0 ? (a = (t.min.z - u.z) * h, o = (t.max.z - u.z) * h) : (a = (t.max.z - u.z) * h, o = (t.min.z - u.z) * h), n > o || a > i ? null : ((a > n || n != n) && (n = a), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, e)));
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        return null !== this.intersectBox(t, we);
      }
    }, {
      key: "intersectTriangle",
      value: function intersectTriangle(t, e, n, i, r) {
        Ae.subVectors(e, t), Re.subVectors(n, t), Ce.crossVectors(Ae, Re);
        var s,
            a = this.direction.dot(Ce);

        if (a > 0) {
          if (i) return null;
          s = 1;
        } else {
          if (!(a < 0)) return null;
          s = -1, a = -a;
        }

        Ee.subVectors(this.origin, t);
        var o = s * this.direction.dot(Re.crossVectors(Ee, Re));
        if (o < 0) return null;
        var l = s * this.direction.dot(Ae.cross(Ee));
        if (l < 0) return null;
        if (o + l > a) return null;
        var c = -s * Ee.dot(Ce);
        return c < 0 ? null : this.at(c / a, r);
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.origin.equals(this.origin) && t.direction.equals(this.direction);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return Le;
  }();

  var Pe = /*#__PURE__*/function () {
    function Pe() {
      _classCallCheck(this, Pe);

      this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }

    _createClass(Pe, [{
      key: "set",
      value: function set(t, e, n, i, r, s, a, o, l, c, h, u, d, p, m, f) {
        var g = this.elements;
        return g[0] = t, g[4] = e, g[8] = n, g[12] = i, g[1] = r, g[5] = s, g[9] = a, g[13] = o, g[2] = l, g[6] = c, g[10] = h, g[14] = u, g[3] = d, g[7] = p, g[11] = m, g[15] = f, this;
      }
    }, {
      key: "identity",
      value: function identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new Pe().fromArray(this.elements);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        var e = this.elements,
            n = t.elements;
        return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
      }
    }, {
      key: "copyPosition",
      value: function copyPosition(t) {
        var e = this.elements,
            n = t.elements;
        return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
      }
    }, {
      key: "setFromMatrix3",
      value: function setFromMatrix3(t) {
        var e = t.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "extractBasis",
      value: function extractBasis(t, e, n) {
        return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
      }
    }, {
      key: "makeBasis",
      value: function makeBasis(t, e, n) {
        return this.set(t.x, e.x, n.x, 0, t.y, e.y, n.y, 0, t.z, e.z, n.z, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "extractRotation",
      value: function extractRotation(t) {
        var e = this.elements,
            n = t.elements,
            i = 1 / De.setFromMatrixColumn(t, 0).length(),
            r = 1 / De.setFromMatrixColumn(t, 1).length(),
            s = 1 / De.setFromMatrixColumn(t, 2).length();
        return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * r, e[5] = n[5] * r, e[6] = n[6] * r, e[7] = 0, e[8] = n[8] * s, e[9] = n[9] * s, e[10] = n[10] * s, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
      }
    }, {
      key: "makeRotationFromEuler",
      value: function makeRotationFromEuler(t) {
        t && t.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        var e = this.elements,
            n = t.x,
            i = t.y,
            r = t.z,
            s = Math.cos(n),
            a = Math.sin(n),
            o = Math.cos(i),
            l = Math.sin(i),
            c = Math.cos(r),
            h = Math.sin(r);

        if ("XYZ" === t.order) {
          var _t23 = s * c,
              _n14 = s * h,
              _i10 = a * c,
              _r10 = a * h;

          e[0] = o * c, e[4] = -o * h, e[8] = l, e[1] = _n14 + _i10 * l, e[5] = _t23 - _r10 * l, e[9] = -a * o, e[2] = _r10 - _t23 * l, e[6] = _i10 + _n14 * l, e[10] = s * o;
        } else if ("YXZ" === t.order) {
          var _t24 = o * c,
              _n15 = o * h,
              _i11 = l * c,
              _r11 = l * h;

          e[0] = _t24 + _r11 * a, e[4] = _i11 * a - _n15, e[8] = s * l, e[1] = s * h, e[5] = s * c, e[9] = -a, e[2] = _n15 * a - _i11, e[6] = _r11 + _t24 * a, e[10] = s * o;
        } else if ("ZXY" === t.order) {
          var _t25 = o * c,
              _n16 = o * h,
              _i12 = l * c,
              _r12 = l * h;

          e[0] = _t25 - _r12 * a, e[4] = -s * h, e[8] = _i12 + _n16 * a, e[1] = _n16 + _i12 * a, e[5] = s * c, e[9] = _r12 - _t25 * a, e[2] = -s * l, e[6] = a, e[10] = s * o;
        } else if ("ZYX" === t.order) {
          var _t26 = s * c,
              _n17 = s * h,
              _i13 = a * c,
              _r13 = a * h;

          e[0] = o * c, e[4] = _i13 * l - _n17, e[8] = _t26 * l + _r13, e[1] = o * h, e[5] = _r13 * l + _t26, e[9] = _n17 * l - _i13, e[2] = -l, e[6] = a * o, e[10] = s * o;
        } else if ("YZX" === t.order) {
          var _t27 = s * o,
              _n18 = s * l,
              _i14 = a * o,
              _r14 = a * l;

          e[0] = o * c, e[4] = _r14 - _t27 * h, e[8] = _i14 * h + _n18, e[1] = h, e[5] = s * c, e[9] = -a * c, e[2] = -l * c, e[6] = _n18 * h + _i14, e[10] = _t27 - _r14 * h;
        } else if ("XZY" === t.order) {
          var _t28 = s * o,
              _n19 = s * l,
              _i15 = a * o,
              _r15 = a * l;

          e[0] = o * c, e[4] = -h, e[8] = l * c, e[1] = _t28 * h + _r15, e[5] = s * c, e[9] = _n19 * h - _i15, e[2] = _i15 * h - _n19, e[6] = a * c, e[10] = _r15 * h + _t28;
        }

        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
      }
    }, {
      key: "makeRotationFromQuaternion",
      value: function makeRotationFromQuaternion(t) {
        return this.compose(Ne, t, Be);
      }
    }, {
      key: "lookAt",
      value: function lookAt(t, e, n) {
        var i = this.elements;
        return Ue.subVectors(t, e), 0 === Ue.lengthSq() && (Ue.z = 1), Ue.normalize(), ze.crossVectors(n, Ue), 0 === ze.lengthSq() && (1 === Math.abs(n.z) ? Ue.x += 1e-4 : Ue.z += 1e-4, Ue.normalize(), ze.crossVectors(n, Ue)), ze.normalize(), Oe.crossVectors(Ue, ze), i[0] = ze.x, i[4] = Oe.x, i[8] = Ue.x, i[1] = ze.y, i[5] = Oe.y, i[9] = Ue.y, i[2] = ze.z, i[6] = Oe.z, i[10] = Ue.z, this;
      }
    }, {
      key: "multiply",
      value: function multiply(t, e) {
        return void 0 !== e ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(t, e)) : this.multiplyMatrices(this, t);
      }
    }, {
      key: "premultiply",
      value: function premultiply(t) {
        return this.multiplyMatrices(t, this);
      }
    }, {
      key: "multiplyMatrices",
      value: function multiplyMatrices(t, e) {
        var n = t.elements,
            i = e.elements,
            r = this.elements,
            s = n[0],
            a = n[4],
            o = n[8],
            l = n[12],
            c = n[1],
            h = n[5],
            u = n[9],
            d = n[13],
            p = n[2],
            m = n[6],
            f = n[10],
            g = n[14],
            v = n[3],
            y = n[7],
            x = n[11],
            _ = n[15],
            M = i[0],
            b = i[4],
            w = i[8],
            S = i[12],
            T = i[1],
            E = i[5],
            A = i[9],
            R = i[13],
            C = i[2],
            L = i[6],
            P = i[10],
            D = i[14],
            I = i[3],
            N = i[7],
            B = i[11],
            z = i[15];
        return r[0] = s * M + a * T + o * C + l * I, r[4] = s * b + a * E + o * L + l * N, r[8] = s * w + a * A + o * P + l * B, r[12] = s * S + a * R + o * D + l * z, r[1] = c * M + h * T + u * C + d * I, r[5] = c * b + h * E + u * L + d * N, r[9] = c * w + h * A + u * P + d * B, r[13] = c * S + h * R + u * D + d * z, r[2] = p * M + m * T + f * C + g * I, r[6] = p * b + m * E + f * L + g * N, r[10] = p * w + m * A + f * P + g * B, r[14] = p * S + m * R + f * D + g * z, r[3] = v * M + y * T + x * C + _ * I, r[7] = v * b + y * E + x * L + _ * N, r[11] = v * w + y * A + x * P + _ * B, r[15] = v * S + y * R + x * D + _ * z, this;
      }
    }, {
      key: "multiplyScalar",
      value: function multiplyScalar(t) {
        var e = this.elements;
        return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
      }
    }, {
      key: "determinant",
      value: function determinant() {
        var t = this.elements,
            e = t[0],
            n = t[4],
            i = t[8],
            r = t[12],
            s = t[1],
            a = t[5],
            o = t[9],
            l = t[13],
            c = t[2],
            h = t[6],
            u = t[10],
            d = t[14];
        return t[3] * (+r * o * h - i * l * h - r * a * u + n * l * u + i * a * d - n * o * d) + t[7] * (+e * o * d - e * l * u + r * s * u - i * s * d + i * l * c - r * o * c) + t[11] * (+e * l * h - e * a * d - r * s * h + n * s * d + r * a * c - n * l * c) + t[15] * (-i * a * c - e * o * h + e * a * u + i * s * h - n * s * u + n * o * c);
      }
    }, {
      key: "transpose",
      value: function transpose() {
        var t = this.elements;
        var e;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
      }
    }, {
      key: "setPosition",
      value: function setPosition(t, e, n) {
        var i = this.elements;
        return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = n), this;
      }
    }, {
      key: "invert",
      value: function invert() {
        var t = this.elements,
            e = t[0],
            n = t[1],
            i = t[2],
            r = t[3],
            s = t[4],
            a = t[5],
            o = t[6],
            l = t[7],
            c = t[8],
            h = t[9],
            u = t[10],
            d = t[11],
            p = t[12],
            m = t[13],
            f = t[14],
            g = t[15],
            v = h * f * l - m * u * l + m * o * d - a * f * d - h * o * g + a * u * g,
            y = p * u * l - c * f * l - p * o * d + s * f * d + c * o * g - s * u * g,
            x = c * m * l - p * h * l + p * a * d - s * m * d - c * a * g + s * h * g,
            _ = p * h * o - c * m * o - p * a * u + s * m * u + c * a * f - s * h * f,
            M = e * v + n * y + i * x + r * _;

        if (0 === M) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        var b = 1 / M;
        return t[0] = v * b, t[1] = (m * u * r - h * f * r - m * i * d + n * f * d + h * i * g - n * u * g) * b, t[2] = (a * f * r - m * o * r + m * i * l - n * f * l - a * i * g + n * o * g) * b, t[3] = (h * o * r - a * u * r - h * i * l + n * u * l + a * i * d - n * o * d) * b, t[4] = y * b, t[5] = (c * f * r - p * u * r + p * i * d - e * f * d - c * i * g + e * u * g) * b, t[6] = (p * o * r - s * f * r - p * i * l + e * f * l + s * i * g - e * o * g) * b, t[7] = (s * u * r - c * o * r + c * i * l - e * u * l - s * i * d + e * o * d) * b, t[8] = x * b, t[9] = (p * h * r - c * m * r - p * n * d + e * m * d + c * n * g - e * h * g) * b, t[10] = (s * m * r - p * a * r + p * n * l - e * m * l - s * n * g + e * a * g) * b, t[11] = (c * a * r - s * h * r - c * n * l + e * h * l + s * n * d - e * a * d) * b, t[12] = _ * b, t[13] = (c * m * i - p * h * i + p * n * u - e * m * u - c * n * f + e * h * f) * b, t[14] = (p * a * i - s * m * i - p * n * o + e * m * o + s * n * f - e * a * f) * b, t[15] = (s * h * i - c * a * i + c * n * o - e * h * o - s * n * u + e * a * u) * b, this;
      }
    }, {
      key: "scale",
      value: function scale(t) {
        var e = this.elements,
            n = t.x,
            i = t.y,
            r = t.z;
        return e[0] *= n, e[4] *= i, e[8] *= r, e[1] *= n, e[5] *= i, e[9] *= r, e[2] *= n, e[6] *= i, e[10] *= r, e[3] *= n, e[7] *= i, e[11] *= r, this;
      }
    }, {
      key: "getMaxScaleOnAxis",
      value: function getMaxScaleOnAxis() {
        var t = this.elements,
            e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2],
            n = t[4] * t[4] + t[5] * t[5] + t[6] * t[6],
            i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
        return Math.sqrt(Math.max(e, n, i));
      }
    }, {
      key: "makeTranslation",
      value: function makeTranslation(t, e, n) {
        return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
      }
    }, {
      key: "makeRotationX",
      value: function makeRotationX(t) {
        var e = Math.cos(t),
            n = Math.sin(t);
        return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "makeRotationY",
      value: function makeRotationY(t) {
        var e = Math.cos(t),
            n = Math.sin(t);
        return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "makeRotationZ",
      value: function makeRotationZ(t) {
        var e = Math.cos(t),
            n = Math.sin(t);
        return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "makeRotationAxis",
      value: function makeRotationAxis(t, e) {
        var n = Math.cos(e),
            i = Math.sin(e),
            r = 1 - n,
            s = t.x,
            a = t.y,
            o = t.z,
            l = r * s,
            c = r * a;
        return this.set(l * s + n, l * a - i * o, l * o + i * a, 0, l * a + i * o, c * a + n, c * o - i * s, 0, l * o - i * a, c * o + i * s, r * o * o + n, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "makeScale",
      value: function makeScale(t, e, n) {
        return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "makeShear",
      value: function makeShear(t, e, n, i, r, s) {
        return this.set(1, n, r, 0, t, 1, s, 0, e, i, 1, 0, 0, 0, 0, 1), this;
      }
    }, {
      key: "compose",
      value: function compose(t, e, n) {
        var i = this.elements,
            r = e._x,
            s = e._y,
            a = e._z,
            o = e._w,
            l = r + r,
            c = s + s,
            h = a + a,
            u = r * l,
            d = r * c,
            p = r * h,
            m = s * c,
            f = s * h,
            g = a * h,
            v = o * l,
            y = o * c,
            x = o * h,
            _ = n.x,
            M = n.y,
            b = n.z;
        return i[0] = (1 - (m + g)) * _, i[1] = (d + x) * _, i[2] = (p - y) * _, i[3] = 0, i[4] = (d - x) * M, i[5] = (1 - (u + g)) * M, i[6] = (f + v) * M, i[7] = 0, i[8] = (p + y) * b, i[9] = (f - v) * b, i[10] = (1 - (u + m)) * b, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
      }
    }, {
      key: "decompose",
      value: function decompose(t, e, n) {
        var i = this.elements;
        var r = De.set(i[0], i[1], i[2]).length();
        var s = De.set(i[4], i[5], i[6]).length(),
            a = De.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (r = -r), t.x = i[12], t.y = i[13], t.z = i[14], Ie.copy(this);
        var o = 1 / r,
            l = 1 / s,
            c = 1 / a;
        return Ie.elements[0] *= o, Ie.elements[1] *= o, Ie.elements[2] *= o, Ie.elements[4] *= l, Ie.elements[5] *= l, Ie.elements[6] *= l, Ie.elements[8] *= c, Ie.elements[9] *= c, Ie.elements[10] *= c, e.setFromRotationMatrix(Ie), n.x = r, n.y = s, n.z = a, this;
      }
    }, {
      key: "makePerspective",
      value: function makePerspective(t, e, n, i, r, s) {
        void 0 === s && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        var a = this.elements,
            o = 2 * r / (e - t),
            l = 2 * r / (n - i),
            c = (e + t) / (e - t),
            h = (n + i) / (n - i),
            u = -(s + r) / (s - r),
            d = -2 * s * r / (s - r);
        return a[0] = o, a[4] = 0, a[8] = c, a[12] = 0, a[1] = 0, a[5] = l, a[9] = h, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = u, a[14] = d, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
      }
    }, {
      key: "makeOrthographic",
      value: function makeOrthographic(t, e, n, i, r, s) {
        var a = this.elements,
            o = 1 / (e - t),
            l = 1 / (n - i),
            c = 1 / (s - r),
            h = (e + t) * o,
            u = (n + i) * l,
            d = (s + r) * c;
        return a[0] = 2 * o, a[4] = 0, a[8] = 0, a[12] = -h, a[1] = 0, a[5] = 2 * l, a[9] = 0, a[13] = -u, a[2] = 0, a[6] = 0, a[10] = -2 * c, a[14] = -d, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        var e = this.elements,
            n = t.elements;

        for (var _t29 = 0; _t29 < 16; _t29++) {
          if (e[_t29] !== n[_t29]) return !1;
        }

        return !0;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        for (var _n20 = 0; _n20 < 16; _n20++) {
          this.elements[_n20] = t[_n20 + e];
        }

        return this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = this.elements;
        return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t[e + 9] = n[9], t[e + 10] = n[10], t[e + 11] = n[11], t[e + 12] = n[12], t[e + 13] = n[13], t[e + 14] = n[14], t[e + 15] = n[15], t;
      }
    }]);

    return Pe;
  }();

  Pe.prototype.isMatrix4 = !0;
  var De = new te(),
      Ie = new Pe(),
      Ne = new te(0, 0, 0),
      Be = new te(1, 1, 1),
      ze = new te(),
      Oe = new te(),
      Ue = new te(),
      Fe = new Pe(),
      He = new $t();

  var Ge = /*#__PURE__*/function () {
    function Ge() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Ge.DefaultOrder;

      _classCallCheck(this, Ge);

      this._x = t, this._y = e, this._z = n, this._order = i;
    }

    _createClass(Ge, [{
      key: "x",
      get: function get() {
        return this._x;
      },
      set: function set(t) {
        this._x = t, this._onChangeCallback();
      }
    }, {
      key: "y",
      get: function get() {
        return this._y;
      },
      set: function set(t) {
        this._y = t, this._onChangeCallback();
      }
    }, {
      key: "z",
      get: function get() {
        return this._z;
      },
      set: function set(t) {
        this._z = t, this._onChangeCallback();
      }
    }, {
      key: "order",
      get: function get() {
        return this._order;
      },
      set: function set(t) {
        this._order = t, this._onChangeCallback();
      }
    }, {
      key: "set",
      value: function set(t, e, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._order;
        return this._x = t, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
      }
    }, {
      key: "setFromRotationMatrix",
      value: function setFromRotationMatrix(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        var i = t.elements,
            r = i[0],
            s = i[4],
            a = i[8],
            o = i[1],
            l = i[5],
            c = i[9],
            h = i[2],
            u = i[6],
            d = i[10];

        switch (e) {
          case "XYZ":
            this._y = Math.asin(_t(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-s, r)) : (this._x = Math.atan2(u, l), this._z = 0);
            break;

          case "YXZ":
            this._x = Math.asin(-_t(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(a, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-h, r), this._z = 0);
            break;

          case "ZXY":
            this._x = Math.asin(_t(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(-h, d), this._z = Math.atan2(-s, l)) : (this._y = 0, this._z = Math.atan2(o, r));
            break;

          case "ZYX":
            this._y = Math.asin(-_t(h, -1, 1)), Math.abs(h) < .9999999 ? (this._x = Math.atan2(u, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-s, l));
            break;

          case "YZX":
            this._z = Math.asin(_t(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-h, r)) : (this._x = 0, this._y = Math.atan2(a, d));
            break;

          case "XZY":
            this._z = Math.asin(-_t(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(u, l), this._y = Math.atan2(a, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
            break;

          default:
            console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }

        return this._order = e, !0 === n && this._onChangeCallback(), this;
      }
    }, {
      key: "setFromQuaternion",
      value: function setFromQuaternion(t, e, n) {
        return Fe.makeRotationFromQuaternion(t), this.setFromRotationMatrix(Fe, e, n);
      }
    }, {
      key: "setFromVector3",
      value: function setFromVector3(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
        return this.set(t.x, t.y, t.z, e);
      }
    }, {
      key: "reorder",
      value: function reorder(t) {
        return He.setFromEuler(this), this.setFromQuaternion(He, t);
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        return this._x = t[0], this._y = t[1], this._z = t[2], void 0 !== t[3] && (this._order = t[3]), this._onChangeCallback(), this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
      }
    }, {
      key: "_onChange",
      value: function _onChange(t) {
        return this._onChangeCallback = t, this;
      }
    }, {
      key: "_onChangeCallback",
      value: function _onChangeCallback() {}
    }]);

    return Ge;
  }();

  Ge.prototype.isEuler = !0, Ge.DefaultOrder = "XYZ", Ge.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];

  var Ve = /*#__PURE__*/function () {
    function Ve() {
      _classCallCheck(this, Ve);

      this.mask = 1;
    }

    _createClass(Ve, [{
      key: "set",
      value: function set(t) {
        this.mask = (1 << t | 0) >>> 0;
      }
    }, {
      key: "enable",
      value: function enable(t) {
        this.mask |= 1 << t | 0;
      }
    }, {
      key: "enableAll",
      value: function enableAll() {
        this.mask = -1;
      }
    }, {
      key: "toggle",
      value: function toggle(t) {
        this.mask ^= 1 << t | 0;
      }
    }, {
      key: "disable",
      value: function disable(t) {
        this.mask &= ~(1 << t | 0);
      }
    }, {
      key: "disableAll",
      value: function disableAll() {
        this.mask = 0;
      }
    }, {
      key: "test",
      value: function test(t) {
        return 0 != (this.mask & t.mask);
      }
    }, {
      key: "isEnabled",
      value: function isEnabled(t) {
        return 0 != (this.mask & (1 << t | 0));
      }
    }]);

    return Ve;
  }();

  var ke = 0;
  var We = new te(),
      je = new $t(),
      qe = new Pe(),
      Xe = new te(),
      Je = new te(),
      Ye = new te(),
      Ze = new $t(),
      Ke = new te(1, 0, 0),
      Qe = new te(0, 1, 0),
      $e = new te(0, 0, 1),
      tn = {
    type: "added"
  },
      en = {
    type: "removed"
  };

  var nn = /*#__PURE__*/function (_mt3) {
    _inherits(nn, _mt3);

    var _super8 = _createSuper(nn);

    function nn() {
      var _this8;

      _classCallCheck(this, nn);

      _this8 = _super8.call(this), Object.defineProperty(_assertThisInitialized(_this8), "id", {
        value: ke++
      }), _this8.uuid = xt(), _this8.name = "", _this8.type = "Object3D", _this8.parent = null, _this8.children = [], _this8.up = nn.DefaultUp.clone();
      var t = new te(),
          e = new Ge(),
          n = new $t(),
          i = new te(1, 1, 1);
      e._onChange(function () {
        n.setFromEuler(e, !1);
      }), n._onChange(function () {
        e.setFromQuaternion(n, void 0, !1);
      }), Object.defineProperties(_assertThisInitialized(_this8), {
        position: {
          configurable: !0,
          enumerable: !0,
          value: t
        },
        rotation: {
          configurable: !0,
          enumerable: !0,
          value: e
        },
        quaternion: {
          configurable: !0,
          enumerable: !0,
          value: n
        },
        scale: {
          configurable: !0,
          enumerable: !0,
          value: i
        },
        modelViewMatrix: {
          value: new Pe()
        },
        normalMatrix: {
          value: new Rt()
        }
      }), _this8.matrix = new Pe(), _this8.matrixWorld = new Pe(), _this8.matrixAutoUpdate = nn.DefaultMatrixAutoUpdate, _this8.matrixWorldNeedsUpdate = !1, _this8.layers = new Ve(), _this8.visible = !0, _this8.castShadow = !1, _this8.receiveShadow = !1, _this8.frustumCulled = !0, _this8.renderOrder = 0, _this8.animations = [], _this8.userData = {};
      return _this8;
    }

    _createClass(nn, [{
      key: "onBeforeRender",
      value: function onBeforeRender() {}
    }, {
      key: "onAfterRender",
      value: function onAfterRender() {}
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
      }
    }, {
      key: "applyQuaternion",
      value: function applyQuaternion(t) {
        return this.quaternion.premultiply(t), this;
      }
    }, {
      key: "setRotationFromAxisAngle",
      value: function setRotationFromAxisAngle(t, e) {
        this.quaternion.setFromAxisAngle(t, e);
      }
    }, {
      key: "setRotationFromEuler",
      value: function setRotationFromEuler(t) {
        this.quaternion.setFromEuler(t, !0);
      }
    }, {
      key: "setRotationFromMatrix",
      value: function setRotationFromMatrix(t) {
        this.quaternion.setFromRotationMatrix(t);
      }
    }, {
      key: "setRotationFromQuaternion",
      value: function setRotationFromQuaternion(t) {
        this.quaternion.copy(t);
      }
    }, {
      key: "rotateOnAxis",
      value: function rotateOnAxis(t, e) {
        return je.setFromAxisAngle(t, e), this.quaternion.multiply(je), this;
      }
    }, {
      key: "rotateOnWorldAxis",
      value: function rotateOnWorldAxis(t, e) {
        return je.setFromAxisAngle(t, e), this.quaternion.premultiply(je), this;
      }
    }, {
      key: "rotateX",
      value: function rotateX(t) {
        return this.rotateOnAxis(Ke, t);
      }
    }, {
      key: "rotateY",
      value: function rotateY(t) {
        return this.rotateOnAxis(Qe, t);
      }
    }, {
      key: "rotateZ",
      value: function rotateZ(t) {
        return this.rotateOnAxis($e, t);
      }
    }, {
      key: "translateOnAxis",
      value: function translateOnAxis(t, e) {
        return We.copy(t).applyQuaternion(this.quaternion), this.position.add(We.multiplyScalar(e)), this;
      }
    }, {
      key: "translateX",
      value: function translateX(t) {
        return this.translateOnAxis(Ke, t);
      }
    }, {
      key: "translateY",
      value: function translateY(t) {
        return this.translateOnAxis(Qe, t);
      }
    }, {
      key: "translateZ",
      value: function translateZ(t) {
        return this.translateOnAxis($e, t);
      }
    }, {
      key: "localToWorld",
      value: function localToWorld(t) {
        return t.applyMatrix4(this.matrixWorld);
      }
    }, {
      key: "worldToLocal",
      value: function worldToLocal(t) {
        return t.applyMatrix4(qe.copy(this.matrixWorld).invert());
      }
    }, {
      key: "lookAt",
      value: function lookAt(t, e, n) {
        t.isVector3 ? Xe.copy(t) : Xe.set(t, e, n);
        var i = this.parent;
        this.updateWorldMatrix(!0, !1), Je.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? qe.lookAt(Je, Xe, this.up) : qe.lookAt(Xe, Je, this.up), this.quaternion.setFromRotationMatrix(qe), i && (qe.extractRotation(i.matrixWorld), je.setFromRotationMatrix(qe), this.quaternion.premultiply(je.invert()));
      }
    }, {
      key: "add",
      value: function add(t) {
        if (arguments.length > 1) {
          for (var _t30 = 0; _t30 < arguments.length; _t30++) {
            this.add(arguments[_t30]);
          }

          return this;
        }

        return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (null !== t.parent && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(tn)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
      }
    }, {
      key: "remove",
      value: function remove(t) {
        if (arguments.length > 1) {
          for (var _t31 = 0; _t31 < arguments.length; _t31++) {
            this.remove(arguments[_t31]);
          }

          return this;
        }

        var e = this.children.indexOf(t);
        return -1 !== e && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(en)), this;
      }
    }, {
      key: "removeFromParent",
      value: function removeFromParent() {
        var t = this.parent;
        return null !== t && t.remove(this), this;
      }
    }, {
      key: "clear",
      value: function clear() {
        for (var _t32 = 0; _t32 < this.children.length; _t32++) {
          var _e13 = this.children[_t32];
          _e13.parent = null, _e13.dispatchEvent(en);
        }

        return this.children.length = 0, this;
      }
    }, {
      key: "attach",
      value: function attach(t) {
        return this.updateWorldMatrix(!0, !1), qe.copy(this.matrixWorld).invert(), null !== t.parent && (t.parent.updateWorldMatrix(!0, !1), qe.multiply(t.parent.matrixWorld)), t.applyMatrix4(qe), this.add(t), t.updateWorldMatrix(!1, !0), this;
      }
    }, {
      key: "getObjectById",
      value: function getObjectById(t) {
        return this.getObjectByProperty("id", t);
      }
    }, {
      key: "getObjectByName",
      value: function getObjectByName(t) {
        return this.getObjectByProperty("name", t);
      }
    }, {
      key: "getObjectByProperty",
      value: function getObjectByProperty(t, e) {
        if (this[t] === e) return this;

        for (var _n21 = 0, _i16 = this.children.length; _n21 < _i16; _n21++) {
          var _i17 = this.children[_n21].getObjectByProperty(t, e);

          if (void 0 !== _i17) return _i17;
        }
      }
    }, {
      key: "getWorldPosition",
      value: function getWorldPosition(t) {
        return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
      }
    }, {
      key: "getWorldQuaternion",
      value: function getWorldQuaternion(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Je, t, Ye), t;
      }
    }, {
      key: "getWorldScale",
      value: function getWorldScale(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Je, Ze, t), t;
      }
    }, {
      key: "getWorldDirection",
      value: function getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        var e = this.matrixWorld.elements;
        return t.set(e[8], e[9], e[10]).normalize();
      }
    }, {
      key: "raycast",
      value: function raycast() {}
    }, {
      key: "traverse",
      value: function traverse(t) {
        t(this);
        var e = this.children;

        for (var _n22 = 0, _i18 = e.length; _n22 < _i18; _n22++) {
          e[_n22].traverse(t);
        }
      }
    }, {
      key: "traverseVisible",
      value: function traverseVisible(t) {
        if (!1 === this.visible) return;
        t(this);
        var e = this.children;

        for (var _n23 = 0, _i19 = e.length; _n23 < _i19; _n23++) {
          e[_n23].traverseVisible(t);
        }
      }
    }, {
      key: "traverseAncestors",
      value: function traverseAncestors(t) {
        var e = this.parent;
        null !== e && (t(e), e.traverseAncestors(t));
      }
    }, {
      key: "updateMatrix",
      value: function updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
      }
    }, {
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
        var e = this.children;

        for (var _n24 = 0, _i20 = e.length; _n24 < _i20; _n24++) {
          e[_n24].updateMatrixWorld(t);
        }
      }
    }, {
      key: "updateWorldMatrix",
      value: function updateWorldMatrix(t, e) {
        var n = this.parent;

        if (!0 === t && null !== n && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
          var _t33 = this.children;

          for (var _e14 = 0, _n25 = _t33.length; _e14 < _n25; _e14++) {
            _t33[_e14].updateWorldMatrix(!1, !0);
          }
        }
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = void 0 === t || "string" == typeof t,
            n = {};
        e && (t = {
          geometries: {},
          materials: {},
          textures: {},
          images: {},
          shapes: {},
          skeletons: {},
          animations: {},
          nodes: {}
        }, n.metadata = {
          version: 4.5,
          type: "Object",
          generator: "Object3D.toJSON"
        });
        var i = {};

        function r(e, n) {
          return void 0 === e[n.uuid] && (e[n.uuid] = n.toJSON(t)), n.uuid;
        }

        if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), "{}" !== JSON.stringify(this.userData) && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && (i.environment = this.environment.toJSON(t).uuid);else if (this.isMesh || this.isLine || this.isPoints) {
          i.geometry = r(t.geometries, this.geometry);
          var _e15 = this.geometry.parameters;

          if (void 0 !== _e15 && void 0 !== _e15.shapes) {
            var _n26 = _e15.shapes;
            if (Array.isArray(_n26)) for (var _e16 = 0, _i21 = _n26.length; _e16 < _i21; _e16++) {
              var _i22 = _n26[_e16];
              r(t.shapes, _i22);
            } else r(t.shapes, _n26);
          }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) if (Array.isArray(this.material)) {
          var _e17 = [];

          for (var _n27 = 0, _i23 = this.material.length; _n27 < _i23; _n27++) {
            _e17.push(r(t.materials, this.material[_n27]));
          }

          i.material = _e17;
        } else i.material = r(t.materials, this.material);

        if (this.children.length > 0) {
          i.children = [];

          for (var _e18 = 0; _e18 < this.children.length; _e18++) {
            i.children.push(this.children[_e18].toJSON(t).object);
          }
        }

        if (this.animations.length > 0) {
          i.animations = [];

          for (var _e19 = 0; _e19 < this.animations.length; _e19++) {
            var _n28 = this.animations[_e19];
            i.animations.push(r(t.animations, _n28));
          }
        }

        if (e) {
          var _e20 = s(t.geometries),
              _i24 = s(t.materials),
              _r16 = s(t.textures),
              _a4 = s(t.images),
              _o6 = s(t.shapes),
              _l7 = s(t.skeletons),
              _c5 = s(t.animations),
              _h4 = s(t.nodes);

          _e20.length > 0 && (n.geometries = _e20), _i24.length > 0 && (n.materials = _i24), _r16.length > 0 && (n.textures = _r16), _a4.length > 0 && (n.images = _a4), _o6.length > 0 && (n.shapes = _o6), _l7.length > 0 && (n.skeletons = _l7), _c5.length > 0 && (n.animations = _c5), _h4.length > 0 && (n.nodes = _h4);
        }

        return n.object = i, n;

        function s(t) {
          var e = [];

          for (var _n29 in t) {
            var _i25 = t[_n29];
            delete _i25.metadata, e.push(_i25);
          }

          return e;
        }
      }
    }, {
      key: "clone",
      value: function clone(t) {
        return new this.constructor().copy(this, t);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), !0 === e) for (var _e21 = 0; _e21 < t.children.length; _e21++) {
          var _n30 = t.children[_e21];
          this.add(_n30.clone());
        }
        return this;
      }
    }]);

    return nn;
  }(mt);

  nn.DefaultUp = new te(0, 1, 0), nn.DefaultMatrixAutoUpdate = !0, nn.prototype.isObject3D = !0;
  var rn = new te(),
      sn = new te(),
      an = new te(),
      on = new te(),
      ln = new te(),
      cn = new te(),
      hn = new te(),
      un = new te(),
      dn = new te(),
      pn = new te();

  var mn = /*#__PURE__*/function () {
    function mn() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new te();

      _classCallCheck(this, mn);

      this.a = t, this.b = e, this.c = n;
    }

    _createClass(mn, [{
      key: "set",
      value: function set(t, e, n) {
        return this.a.copy(t), this.b.copy(e), this.c.copy(n), this;
      }
    }, {
      key: "setFromPointsAndIndices",
      value: function setFromPointsAndIndices(t, e, n, i) {
        return this.a.copy(t[e]), this.b.copy(t[n]), this.c.copy(t[i]), this;
      }
    }, {
      key: "setFromAttributeAndIndices",
      value: function setFromAttributeAndIndices(t, e, n, i) {
        return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, n), this.c.fromBufferAttribute(t, i), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
      }
    }, {
      key: "getArea",
      value: function getArea() {
        return rn.subVectors(this.c, this.b), sn.subVectors(this.a, this.b), .5 * rn.cross(sn).length();
      }
    }, {
      key: "getMidpoint",
      value: function getMidpoint(t) {
        return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
      }
    }, {
      key: "getNormal",
      value: function getNormal(t) {
        return mn.getNormal(this.a, this.b, this.c, t);
      }
    }, {
      key: "getPlane",
      value: function getPlane(t) {
        return t.setFromCoplanarPoints(this.a, this.b, this.c);
      }
    }, {
      key: "getBarycoord",
      value: function getBarycoord(t, e) {
        return mn.getBarycoord(t, this.a, this.b, this.c, e);
      }
    }, {
      key: "getUV",
      value: function getUV(t, e, n, i, r) {
        return mn.getUV(t, this.a, this.b, this.c, e, n, i, r);
      }
    }, {
      key: "containsPoint",
      value: function containsPoint(t) {
        return mn.containsPoint(t, this.a, this.b, this.c);
      }
    }, {
      key: "isFrontFacing",
      value: function isFrontFacing(t) {
        return mn.isFrontFacing(this.a, this.b, this.c, t);
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        return t.intersectsTriangle(this);
      }
    }, {
      key: "closestPointToPoint",
      value: function closestPointToPoint(t, e) {
        var n = this.a,
            i = this.b,
            r = this.c;
        var s, a;
        ln.subVectors(i, n), cn.subVectors(r, n), un.subVectors(t, n);
        var o = ln.dot(un),
            l = cn.dot(un);
        if (o <= 0 && l <= 0) return e.copy(n);
        dn.subVectors(t, i);
        var c = ln.dot(dn),
            h = cn.dot(dn);
        if (c >= 0 && h <= c) return e.copy(i);
        var u = o * h - c * l;
        if (u <= 0 && o >= 0 && c <= 0) return s = o / (o - c), e.copy(n).addScaledVector(ln, s);
        pn.subVectors(t, r);
        var d = ln.dot(pn),
            p = cn.dot(pn);
        if (p >= 0 && d <= p) return e.copy(r);
        var m = d * l - o * p;
        if (m <= 0 && l >= 0 && p <= 0) return a = l / (l - p), e.copy(n).addScaledVector(cn, a);
        var f = c * p - d * h;
        if (f <= 0 && h - c >= 0 && d - p >= 0) return hn.subVectors(r, i), a = (h - c) / (h - c + (d - p)), e.copy(i).addScaledVector(hn, a);
        var g = 1 / (f + m + u);
        return s = m * g, a = u * g, e.copy(n).addScaledVector(ln, s).addScaledVector(cn, a);
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
      }
    }], [{
      key: "getNormal",
      value: function getNormal(t, e, n, i) {
        i.subVectors(n, e), rn.subVectors(t, e), i.cross(rn);
        var r = i.lengthSq();
        return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
      }
    }, {
      key: "getBarycoord",
      value: function getBarycoord(t, e, n, i, r) {
        rn.subVectors(i, e), sn.subVectors(n, e), an.subVectors(t, e);
        var s = rn.dot(rn),
            a = rn.dot(sn),
            o = rn.dot(an),
            l = sn.dot(sn),
            c = sn.dot(an),
            h = s * l - a * a;
        if (0 === h) return r.set(-2, -1, -1);
        var u = 1 / h,
            d = (l * o - a * c) * u,
            p = (s * c - a * o) * u;
        return r.set(1 - d - p, p, d);
      }
    }, {
      key: "containsPoint",
      value: function containsPoint(t, e, n, i) {
        return this.getBarycoord(t, e, n, i, on), on.x >= 0 && on.y >= 0 && on.x + on.y <= 1;
      }
    }, {
      key: "getUV",
      value: function getUV(t, e, n, i, r, s, a, o) {
        return this.getBarycoord(t, e, n, i, on), o.set(0, 0), o.addScaledVector(r, on.x), o.addScaledVector(s, on.y), o.addScaledVector(a, on.z), o;
      }
    }, {
      key: "isFrontFacing",
      value: function isFrontFacing(t, e, n, i) {
        return rn.subVectors(n, e), sn.subVectors(t, e), rn.cross(sn).dot(i) < 0;
      }
    }]);

    return mn;
  }();

  var fn = 0;

  var gn = /*#__PURE__*/function (_mt4) {
    _inherits(gn, _mt4);

    var _super9 = _createSuper(gn);

    function gn() {
      var _this9;

      _classCallCheck(this, gn);

      _this9 = _super9.call(this), Object.defineProperty(_assertThisInitialized(_this9), "id", {
        value: fn++
      }), _this9.uuid = xt(), _this9.name = "", _this9.type = "Material", _this9.fog = !0, _this9.blending = 1, _this9.side = 0, _this9.vertexColors = !1, _this9.opacity = 1, _this9.transparent = !1, _this9.blendSrc = 204, _this9.blendDst = 205, _this9.blendEquation = n, _this9.blendSrcAlpha = null, _this9.blendDstAlpha = null, _this9.blendEquationAlpha = null, _this9.depthFunc = 3, _this9.depthTest = !0, _this9.depthWrite = !0, _this9.stencilWriteMask = 255, _this9.stencilFunc = 519, _this9.stencilRef = 0, _this9.stencilFuncMask = 255, _this9.stencilFail = ct, _this9.stencilZFail = ct, _this9.stencilZPass = ct, _this9.stencilWrite = !1, _this9.clippingPlanes = null, _this9.clipIntersection = !1, _this9.clipShadows = !1, _this9.shadowSide = null, _this9.colorWrite = !0, _this9.precision = null, _this9.polygonOffset = !1, _this9.polygonOffsetFactor = 0, _this9.polygonOffsetUnits = 0, _this9.dithering = !1, _this9.alphaToCoverage = !1, _this9.premultipliedAlpha = !1, _this9.visible = !0, _this9.toneMapped = !0, _this9.userData = {}, _this9.version = 0, _this9._alphaTest = 0;
      return _this9;
    }

    _createClass(gn, [{
      key: "alphaTest",
      get: function get() {
        return this._alphaTest;
      },
      set: function set(t) {
        this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
      }
    }, {
      key: "onBuild",
      value: function onBuild() {}
    }, {
      key: "onBeforeRender",
      value: function onBeforeRender() {}
    }, {
      key: "onBeforeCompile",
      value: function onBeforeCompile() {}
    }, {
      key: "customProgramCacheKey",
      value: function customProgramCacheKey() {
        return this.onBeforeCompile.toString();
      }
    }, {
      key: "setValues",
      value: function setValues(t) {
        if (void 0 !== t) for (var _e22 in t) {
          var _n31 = t[_e22];

          if (void 0 === _n31) {
            console.warn("THREE.Material: '" + _e22 + "' parameter is undefined.");
            continue;
          }

          if ("shading" === _e22) {
            console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === _n31;
            continue;
          }

          var _i26 = this[_e22];
          void 0 !== _i26 ? _i26 && _i26.isColor ? _i26.set(_n31) : _i26 && _i26.isVector3 && _n31 && _n31.isVector3 ? _i26.copy(_n31) : this[_e22] = _n31 : console.warn("THREE." + this.type + ": '" + _e22 + "' is not a property of this material.");
        }
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = void 0 === t || "string" == typeof t;
        e && (t = {
          textures: {},
          images: {}
        });
        var n = {
          metadata: {
            version: 4.5,
            type: "Material",
            generator: "Material.toJSON"
          }
        };

        function i(t) {
          var e = [];

          for (var _n32 in t) {
            var _i27 = t[_n32];
            delete _i27.metadata, e.push(_i27);
          }

          return e;
        }

        if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t).uuid), void 0 !== this.attenuationDistance && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (n.blending = this.blending), 0 !== this.side && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaToCoverage && (n.alphaToCoverage = this.alphaToCoverage), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = this.flatShading), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e) {
          var _e23 = i(t.textures),
              _r17 = i(t.images);

          _e23.length > 0 && (n.textures = _e23), _r17.length > 0 && (n.images = _r17);
        }

        return n;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        this.name = t.name, this.fog = t.fog, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
        var e = t.clippingPlanes;
        var n = null;

        if (null !== e) {
          var _t34 = e.length;
          n = new Array(_t34);

          for (var _i28 = 0; _i28 !== _t34; ++_i28) {
            n[_i28] = e[_i28].clone();
          }
        }

        return this.clippingPlanes = n, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }, {
      key: "needsUpdate",
      set: function set(t) {
        !0 === t && this.version++;
      }
    }]);

    return gn;
  }(mt);

  gn.prototype.isMaterial = !0, gn.fromType = function () {
    return null;
  };

  var vn = /*#__PURE__*/function (_gn) {
    _inherits(vn, _gn);

    var _super10 = _createSuper(vn);

    function vn(t) {
      var _this10;

      _classCallCheck(this, vn);

      _this10 = _super10.call(this), _this10.type = "MeshBasicMaterial", _this10.color = new Ft(16777215), _this10.map = null, _this10.lightMap = null, _this10.lightMapIntensity = 1, _this10.aoMap = null, _this10.aoMapIntensity = 1, _this10.specularMap = null, _this10.alphaMap = null, _this10.envMap = null, _this10.combine = 0, _this10.reflectivity = 1, _this10.refractionRatio = .98, _this10.wireframe = !1, _this10.wireframeLinewidth = 1, _this10.wireframeLinecap = "round", _this10.wireframeLinejoin = "round", _this10.setValues(t);
      return _this10;
    }

    _createClass(vn, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(vn.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
      }
    }]);

    return vn;
  }(gn);

  vn.prototype.isMeshBasicMaterial = !0;
  var yn = new te(),
      xn = new At();

  var _n = /*#__PURE__*/function () {
    function _n(t, e, n) {
      _classCallCheck(this, _n);

      if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
      this.name = "", this.array = t, this.itemSize = e, this.count = void 0 !== t ? t.length / e : 0, this.normalized = !0 === n, this.usage = ht, this.updateRange = {
        offset: 0,
        count: -1
      }, this.version = 0;
    }

    _createClass(_n, [{
      key: "onUploadCallback",
      value: function onUploadCallback() {}
    }, {
      key: "needsUpdate",
      set: function set(t) {
        !0 === t && this.version++;
      }
    }, {
      key: "setUsage",
      value: function setUsage(t) {
        return this.usage = t, this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
      }
    }, {
      key: "copyAt",
      value: function copyAt(t, e, n) {
        t *= this.itemSize, n *= e.itemSize;

        for (var _i29 = 0, _r18 = this.itemSize; _i29 < _r18; _i29++) {
          this.array[t + _i29] = e.array[n + _i29];
        }

        return this;
      }
    }, {
      key: "copyArray",
      value: function copyArray(t) {
        return this.array.set(t), this;
      }
    }, {
      key: "copyColorsArray",
      value: function copyColorsArray(t) {
        var e = this.array;
        var n = 0;

        for (var _i30 = 0, _r19 = t.length; _i30 < _r19; _i30++) {
          var _r20 = t[_i30];
          void 0 === _r20 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", _i30), _r20 = new Ft()), e[n++] = _r20.r, e[n++] = _r20.g, e[n++] = _r20.b;
        }

        return this;
      }
    }, {
      key: "copyVector2sArray",
      value: function copyVector2sArray(t) {
        var e = this.array;
        var n = 0;

        for (var _i31 = 0, _r21 = t.length; _i31 < _r21; _i31++) {
          var _r22 = t[_i31];
          void 0 === _r22 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", _i31), _r22 = new At()), e[n++] = _r22.x, e[n++] = _r22.y;
        }

        return this;
      }
    }, {
      key: "copyVector3sArray",
      value: function copyVector3sArray(t) {
        var e = this.array;
        var n = 0;

        for (var _i32 = 0, _r23 = t.length; _i32 < _r23; _i32++) {
          var _r24 = t[_i32];
          void 0 === _r24 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", _i32), _r24 = new te()), e[n++] = _r24.x, e[n++] = _r24.y, e[n++] = _r24.z;
        }

        return this;
      }
    }, {
      key: "copyVector4sArray",
      value: function copyVector4sArray(t) {
        var e = this.array;
        var n = 0;

        for (var _i33 = 0, _r25 = t.length; _i33 < _r25; _i33++) {
          var _r26 = t[_i33];
          void 0 === _r26 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", _i33), _r26 = new qt()), e[n++] = _r26.x, e[n++] = _r26.y, e[n++] = _r26.z, e[n++] = _r26.w;
        }

        return this;
      }
    }, {
      key: "applyMatrix3",
      value: function applyMatrix3(t) {
        if (2 === this.itemSize) for (var _e24 = 0, _n33 = this.count; _e24 < _n33; _e24++) {
          xn.fromBufferAttribute(this, _e24), xn.applyMatrix3(t), this.setXY(_e24, xn.x, xn.y);
        } else if (3 === this.itemSize) for (var _e25 = 0, _n34 = this.count; _e25 < _n34; _e25++) {
          yn.fromBufferAttribute(this, _e25), yn.applyMatrix3(t), this.setXYZ(_e25, yn.x, yn.y, yn.z);
        }
        return this;
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        for (var _e26 = 0, _n35 = this.count; _e26 < _n35; _e26++) {
          yn.x = this.getX(_e26), yn.y = this.getY(_e26), yn.z = this.getZ(_e26), yn.applyMatrix4(t), this.setXYZ(_e26, yn.x, yn.y, yn.z);
        }

        return this;
      }
    }, {
      key: "applyNormalMatrix",
      value: function applyNormalMatrix(t) {
        for (var _e27 = 0, _n36 = this.count; _e27 < _n36; _e27++) {
          yn.x = this.getX(_e27), yn.y = this.getY(_e27), yn.z = this.getZ(_e27), yn.applyNormalMatrix(t), this.setXYZ(_e27, yn.x, yn.y, yn.z);
        }

        return this;
      }
    }, {
      key: "transformDirection",
      value: function transformDirection(t) {
        for (var _e28 = 0, _n37 = this.count; _e28 < _n37; _e28++) {
          yn.x = this.getX(_e28), yn.y = this.getY(_e28), yn.z = this.getZ(_e28), yn.transformDirection(t), this.setXYZ(_e28, yn.x, yn.y, yn.z);
        }

        return this;
      }
    }, {
      key: "set",
      value: function set(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this.array.set(t, e), this;
      }
    }, {
      key: "getX",
      value: function getX(t) {
        return this.array[t * this.itemSize];
      }
    }, {
      key: "setX",
      value: function setX(t, e) {
        return this.array[t * this.itemSize] = e, this;
      }
    }, {
      key: "getY",
      value: function getY(t) {
        return this.array[t * this.itemSize + 1];
      }
    }, {
      key: "setY",
      value: function setY(t, e) {
        return this.array[t * this.itemSize + 1] = e, this;
      }
    }, {
      key: "getZ",
      value: function getZ(t) {
        return this.array[t * this.itemSize + 2];
      }
    }, {
      key: "setZ",
      value: function setZ(t, e) {
        return this.array[t * this.itemSize + 2] = e, this;
      }
    }, {
      key: "getW",
      value: function getW(t) {
        return this.array[t * this.itemSize + 3];
      }
    }, {
      key: "setW",
      value: function setW(t, e) {
        return this.array[t * this.itemSize + 3] = e, this;
      }
    }, {
      key: "setXY",
      value: function setXY(t, e, n) {
        return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this;
      }
    }, {
      key: "setXYZ",
      value: function setXYZ(t, e, n, i) {
        return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this;
      }
    }, {
      key: "setXYZW",
      value: function setXYZW(t, e, n, i, r) {
        return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this.array[t + 3] = r, this;
      }
    }, {
      key: "onUpload",
      value: function onUpload(t) {
        return this.onUploadCallback = t, this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array: Array.prototype.slice.call(this.array),
          normalized: this.normalized
        };
        return "" !== this.name && (t.name = this.name), this.usage !== ht && (t.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t.updateRange = this.updateRange), t;
      }
    }]);

    return _n;
  }();

  _n.prototype.isBufferAttribute = !0;

  var Mn = /*#__PURE__*/function (_n38) {
    _inherits(Mn, _n38);

    var _super11 = _createSuper(Mn);

    function Mn(t, e, n) {
      _classCallCheck(this, Mn);

      return _super11.call(this, new Int8Array(t), e, n);
    }

    return _createClass(Mn);
  }(_n);

  var bn = /*#__PURE__*/function (_n39) {
    _inherits(bn, _n39);

    var _super12 = _createSuper(bn);

    function bn(t, e, n) {
      _classCallCheck(this, bn);

      return _super12.call(this, new Uint8Array(t), e, n);
    }

    return _createClass(bn);
  }(_n);

  var wn = /*#__PURE__*/function (_n40) {
    _inherits(wn, _n40);

    var _super13 = _createSuper(wn);

    function wn(t, e, n) {
      _classCallCheck(this, wn);

      return _super13.call(this, new Uint8ClampedArray(t), e, n);
    }

    return _createClass(wn);
  }(_n);

  var Sn = /*#__PURE__*/function (_n41) {
    _inherits(Sn, _n41);

    var _super14 = _createSuper(Sn);

    function Sn(t, e, n) {
      _classCallCheck(this, Sn);

      return _super14.call(this, new Int16Array(t), e, n);
    }

    return _createClass(Sn);
  }(_n);

  var Tn = /*#__PURE__*/function (_n42) {
    _inherits(Tn, _n42);

    var _super15 = _createSuper(Tn);

    function Tn(t, e, n) {
      _classCallCheck(this, Tn);

      return _super15.call(this, new Uint16Array(t), e, n);
    }

    return _createClass(Tn);
  }(_n);

  var En = /*#__PURE__*/function (_n43) {
    _inherits(En, _n43);

    var _super16 = _createSuper(En);

    function En(t, e, n) {
      _classCallCheck(this, En);

      return _super16.call(this, new Int32Array(t), e, n);
    }

    return _createClass(En);
  }(_n);

  var An = /*#__PURE__*/function (_n44) {
    _inherits(An, _n44);

    var _super17 = _createSuper(An);

    function An(t, e, n) {
      _classCallCheck(this, An);

      return _super17.call(this, new Uint32Array(t), e, n);
    }

    return _createClass(An);
  }(_n);

  var Rn = /*#__PURE__*/function (_n45) {
    _inherits(Rn, _n45);

    var _super18 = _createSuper(Rn);

    function Rn(t, e, n) {
      _classCallCheck(this, Rn);

      return _super18.call(this, new Uint16Array(t), e, n);
    }

    return _createClass(Rn);
  }(_n);

  Rn.prototype.isFloat16BufferAttribute = !0;

  var Cn = /*#__PURE__*/function (_n46) {
    _inherits(Cn, _n46);

    var _super19 = _createSuper(Cn);

    function Cn(t, e, n) {
      _classCallCheck(this, Cn);

      return _super19.call(this, new Float32Array(t), e, n);
    }

    return _createClass(Cn);
  }(_n);

  var Ln = /*#__PURE__*/function (_n47) {
    _inherits(Ln, _n47);

    var _super20 = _createSuper(Ln);

    function Ln(t, e, n) {
      _classCallCheck(this, Ln);

      return _super20.call(this, new Float64Array(t), e, n);
    }

    return _createClass(Ln);
  }(_n);

  var Pn = 0;
  var Dn = new Pe(),
      In = new nn(),
      Nn = new te(),
      Bn = new ie(),
      zn = new ie(),
      On = new te();

  var Un = /*#__PURE__*/function (_mt5) {
    _inherits(Un, _mt5);

    var _super21 = _createSuper(Un);

    function Un() {
      var _this11;

      _classCallCheck(this, Un);

      _this11 = _super21.call(this), Object.defineProperty(_assertThisInitialized(_this11), "id", {
        value: Pn++
      }), _this11.uuid = xt(), _this11.name = "", _this11.type = "BufferGeometry", _this11.index = null, _this11.attributes = {}, _this11.morphAttributes = {}, _this11.morphTargetsRelative = !1, _this11.groups = [], _this11.boundingBox = null, _this11.boundingSphere = null, _this11.drawRange = {
        start: 0,
        count: 1 / 0
      }, _this11.userData = {};
      return _this11;
    }

    _createClass(Un, [{
      key: "getIndex",
      value: function getIndex() {
        return this.index;
      }
    }, {
      key: "setIndex",
      value: function setIndex(t) {
        return Array.isArray(t) ? this.index = new (Ct(t) ? An : Tn)(t, 1) : this.index = t, this;
      }
    }, {
      key: "getAttribute",
      value: function getAttribute(t) {
        return this.attributes[t];
      }
    }, {
      key: "setAttribute",
      value: function setAttribute(t, e) {
        return this.attributes[t] = e, this;
      }
    }, {
      key: "deleteAttribute",
      value: function deleteAttribute(t) {
        return delete this.attributes[t], this;
      }
    }, {
      key: "hasAttribute",
      value: function hasAttribute(t) {
        return void 0 !== this.attributes[t];
      }
    }, {
      key: "addGroup",
      value: function addGroup(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        this.groups.push({
          start: t,
          count: e,
          materialIndex: n
        });
      }
    }, {
      key: "clearGroups",
      value: function clearGroups() {
        this.groups = [];
      }
    }, {
      key: "setDrawRange",
      value: function setDrawRange(t, e) {
        this.drawRange.start = t, this.drawRange.count = e;
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        var e = this.attributes.position;
        void 0 !== e && (e.applyMatrix4(t), e.needsUpdate = !0);
        var n = this.attributes.normal;

        if (void 0 !== n) {
          var _e29 = new Rt().getNormalMatrix(t);

          n.applyNormalMatrix(_e29), n.needsUpdate = !0;
        }

        var i = this.attributes.tangent;
        return void 0 !== i && (i.transformDirection(t), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
      }
    }, {
      key: "applyQuaternion",
      value: function applyQuaternion(t) {
        return Dn.makeRotationFromQuaternion(t), this.applyMatrix4(Dn), this;
      }
    }, {
      key: "rotateX",
      value: function rotateX(t) {
        return Dn.makeRotationX(t), this.applyMatrix4(Dn), this;
      }
    }, {
      key: "rotateY",
      value: function rotateY(t) {
        return Dn.makeRotationY(t), this.applyMatrix4(Dn), this;
      }
    }, {
      key: "rotateZ",
      value: function rotateZ(t) {
        return Dn.makeRotationZ(t), this.applyMatrix4(Dn), this;
      }
    }, {
      key: "translate",
      value: function translate(t, e, n) {
        return Dn.makeTranslation(t, e, n), this.applyMatrix4(Dn), this;
      }
    }, {
      key: "scale",
      value: function scale(t, e, n) {
        return Dn.makeScale(t, e, n), this.applyMatrix4(Dn), this;
      }
    }, {
      key: "lookAt",
      value: function lookAt(t) {
        return In.lookAt(t), In.updateMatrix(), this.applyMatrix4(In.matrix), this;
      }
    }, {
      key: "center",
      value: function center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(Nn).negate(), this.translate(Nn.x, Nn.y, Nn.z), this;
      }
    }, {
      key: "setFromPoints",
      value: function setFromPoints(t) {
        var e = [];

        for (var _n48 = 0, _i34 = t.length; _n48 < _i34; _n48++) {
          var _i35 = t[_n48];
          e.push(_i35.x, _i35.y, _i35.z || 0);
        }

        return this.setAttribute("position", new Cn(e, 3)), this;
      }
    }, {
      key: "computeBoundingBox",
      value: function computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new ie());
        var t = this.attributes.position,
            e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new te(-1 / 0, -1 / 0, -1 / 0), new te(1 / 0, 1 / 0, 1 / 0));

        if (void 0 !== t) {
          if (this.boundingBox.setFromBufferAttribute(t), e) for (var _t35 = 0, _n49 = e.length; _t35 < _n49; _t35++) {
            var _n50 = e[_t35];
            Bn.setFromBufferAttribute(_n50), this.morphTargetsRelative ? (On.addVectors(this.boundingBox.min, Bn.min), this.boundingBox.expandByPoint(On), On.addVectors(this.boundingBox.max, Bn.max), this.boundingBox.expandByPoint(On)) : (this.boundingBox.expandByPoint(Bn.min), this.boundingBox.expandByPoint(Bn.max));
          }
        } else this.boundingBox.makeEmpty();

        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
      }
    }, {
      key: "computeBoundingSphere",
      value: function computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new be());
        var t = this.attributes.position,
            e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new te(), 1 / 0);

        if (t) {
          var _n51 = this.boundingSphere.center;
          if (Bn.setFromBufferAttribute(t), e) for (var _t36 = 0, _n52 = e.length; _t36 < _n52; _t36++) {
            var _n53 = e[_t36];
            zn.setFromBufferAttribute(_n53), this.morphTargetsRelative ? (On.addVectors(Bn.min, zn.min), Bn.expandByPoint(On), On.addVectors(Bn.max, zn.max), Bn.expandByPoint(On)) : (Bn.expandByPoint(zn.min), Bn.expandByPoint(zn.max));
          }
          Bn.getCenter(_n51);
          var _i36 = 0;

          for (var _e30 = 0, _r27 = t.count; _e30 < _r27; _e30++) {
            On.fromBufferAttribute(t, _e30), _i36 = Math.max(_i36, _n51.distanceToSquared(On));
          }

          if (e) for (var _r28 = 0, _s4 = e.length; _r28 < _s4; _r28++) {
            var _s5 = e[_r28],
                _a5 = this.morphTargetsRelative;

            for (var _e31 = 0, _r29 = _s5.count; _e31 < _r29; _e31++) {
              On.fromBufferAttribute(_s5, _e31), _a5 && (Nn.fromBufferAttribute(t, _e31), On.add(Nn)), _i36 = Math.max(_i36, _n51.distanceToSquared(On));
            }
          }
          this.boundingSphere.radius = Math.sqrt(_i36), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
      }
    }, {
      key: "computeTangents",
      value: function computeTangents() {
        var t = this.index,
            e = this.attributes;
        if (null === t || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        var n = t.array,
            i = e.position.array,
            r = e.normal.array,
            s = e.uv.array,
            a = i.length / 3;
        !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new _n(new Float32Array(4 * a), 4));
        var o = this.getAttribute("tangent").array,
            l = [],
            c = [];

        for (var _t37 = 0; _t37 < a; _t37++) {
          l[_t37] = new te(), c[_t37] = new te();
        }

        var h = new te(),
            u = new te(),
            d = new te(),
            p = new At(),
            m = new At(),
            f = new At(),
            g = new te(),
            v = new te();

        function y(t, e, n) {
          h.fromArray(i, 3 * t), u.fromArray(i, 3 * e), d.fromArray(i, 3 * n), p.fromArray(s, 2 * t), m.fromArray(s, 2 * e), f.fromArray(s, 2 * n), u.sub(h), d.sub(h), m.sub(p), f.sub(p);
          var r = 1 / (m.x * f.y - f.x * m.y);
          isFinite(r) && (g.copy(u).multiplyScalar(f.y).addScaledVector(d, -m.y).multiplyScalar(r), v.copy(d).multiplyScalar(m.x).addScaledVector(u, -f.x).multiplyScalar(r), l[t].add(g), l[e].add(g), l[n].add(g), c[t].add(v), c[e].add(v), c[n].add(v));
        }

        var x = this.groups;
        0 === x.length && (x = [{
          start: 0,
          count: n.length
        }]);

        for (var _t38 = 0, _e32 = x.length; _t38 < _e32; ++_t38) {
          var _e33 = x[_t38],
              _i37 = _e33.start;

          for (var _t39 = _i37, _r30 = _i37 + _e33.count; _t39 < _r30; _t39 += 3) {
            y(n[_t39 + 0], n[_t39 + 1], n[_t39 + 2]);
          }
        }

        var _ = new te(),
            M = new te(),
            b = new te(),
            w = new te();

        function S(t) {
          b.fromArray(r, 3 * t), w.copy(b);
          var e = l[t];
          _.copy(e), _.sub(b.multiplyScalar(b.dot(e))).normalize(), M.crossVectors(w, e);
          var n = M.dot(c[t]) < 0 ? -1 : 1;
          o[4 * t] = _.x, o[4 * t + 1] = _.y, o[4 * t + 2] = _.z, o[4 * t + 3] = n;
        }

        for (var _t40 = 0, _e34 = x.length; _t40 < _e34; ++_t40) {
          var _e35 = x[_t40],
              _i38 = _e35.start;

          for (var _t41 = _i38, _r31 = _i38 + _e35.count; _t41 < _r31; _t41 += 3) {
            S(n[_t41 + 0]), S(n[_t41 + 1]), S(n[_t41 + 2]);
          }
        }
      }
    }, {
      key: "computeVertexNormals",
      value: function computeVertexNormals() {
        var t = this.index,
            e = this.getAttribute("position");

        if (void 0 !== e) {
          var _n54 = this.getAttribute("normal");

          if (void 0 === _n54) _n54 = new _n(new Float32Array(3 * e.count), 3), this.setAttribute("normal", _n54);else for (var _t42 = 0, _e36 = _n54.count; _t42 < _e36; _t42++) {
            _n54.setXYZ(_t42, 0, 0, 0);
          }

          var _i39 = new te(),
              _r32 = new te(),
              _s6 = new te(),
              _a6 = new te(),
              _o7 = new te(),
              _l8 = new te(),
              _c6 = new te(),
              _h5 = new te();

          if (t) for (var _u = 0, _d = t.count; _u < _d; _u += 3) {
            var _d2 = t.getX(_u + 0),
                _p = t.getX(_u + 1),
                _m = t.getX(_u + 2);

            _i39.fromBufferAttribute(e, _d2), _r32.fromBufferAttribute(e, _p), _s6.fromBufferAttribute(e, _m), _c6.subVectors(_s6, _r32), _h5.subVectors(_i39, _r32), _c6.cross(_h5), _a6.fromBufferAttribute(_n54, _d2), _o7.fromBufferAttribute(_n54, _p), _l8.fromBufferAttribute(_n54, _m), _a6.add(_c6), _o7.add(_c6), _l8.add(_c6), _n54.setXYZ(_d2, _a6.x, _a6.y, _a6.z), _n54.setXYZ(_p, _o7.x, _o7.y, _o7.z), _n54.setXYZ(_m, _l8.x, _l8.y, _l8.z);
          } else for (var _t43 = 0, _a7 = e.count; _t43 < _a7; _t43 += 3) {
            _i39.fromBufferAttribute(e, _t43 + 0), _r32.fromBufferAttribute(e, _t43 + 1), _s6.fromBufferAttribute(e, _t43 + 2), _c6.subVectors(_s6, _r32), _h5.subVectors(_i39, _r32), _c6.cross(_h5), _n54.setXYZ(_t43 + 0, _c6.x, _c6.y, _c6.z), _n54.setXYZ(_t43 + 1, _c6.x, _c6.y, _c6.z), _n54.setXYZ(_t43 + 2, _c6.x, _c6.y, _c6.z);
          }
          this.normalizeNormals(), _n54.needsUpdate = !0;
        }
      }
    }, {
      key: "merge",
      value: function merge(t, e) {
        if (!t || !t.isBufferGeometry) return void console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", t);
        void 0 === e && (e = 0, console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."));
        var n = this.attributes;

        for (var _i40 in n) {
          if (void 0 === t.attributes[_i40]) continue;

          var _r33 = n[_i40].array,
              _s7 = t.attributes[_i40],
              _a8 = _s7.array,
              _o8 = _s7.itemSize * e,
              _l9 = Math.min(_a8.length, _r33.length - _o8);

          for (var _t44 = 0, _e37 = _o8; _t44 < _l9; _t44++, _e37++) {
            _r33[_e37] = _a8[_t44];
          }
        }

        return this;
      }
    }, {
      key: "normalizeNormals",
      value: function normalizeNormals() {
        var t = this.attributes.normal;

        for (var _e38 = 0, _n55 = t.count; _e38 < _n55; _e38++) {
          On.fromBufferAttribute(t, _e38), On.normalize(), t.setXYZ(_e38, On.x, On.y, On.z);
        }
      }
    }, {
      key: "toNonIndexed",
      value: function toNonIndexed() {
        function t(t, e) {
          var n = t.array,
              i = t.itemSize,
              r = t.normalized,
              s = new n.constructor(e.length * i);
          var a = 0,
              o = 0;

          for (var _r34 = 0, _l10 = e.length; _r34 < _l10; _r34++) {
            a = t.isInterleavedBufferAttribute ? e[_r34] * t.data.stride + t.offset : e[_r34] * i;

            for (var _t45 = 0; _t45 < i; _t45++) {
              s[o++] = n[a++];
            }
          }

          return new _n(s, i, r);
        }

        if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        var e = new Un(),
            n = this.index.array,
            i = this.attributes;

        for (var _r35 in i) {
          var _s8 = t(i[_r35], n);

          e.setAttribute(_r35, _s8);
        }

        var r = this.morphAttributes;

        for (var _i41 in r) {
          var _s9 = [],
              _a9 = r[_i41];

          for (var _e39 = 0, _i42 = _a9.length; _e39 < _i42; _e39++) {
            var _i43 = t(_a9[_e39], n);

            _s9.push(_i43);
          }

          e.morphAttributes[_i41] = _s9;
        }

        e.morphTargetsRelative = this.morphTargetsRelative;
        var s = this.groups;

        for (var _t46 = 0, _n56 = s.length; _t46 < _n56; _t46++) {
          var _n57 = s[_t46];
          e.addGroup(_n57.start, _n57.count, _n57.materialIndex);
        }

        return e;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = {
          metadata: {
            version: 4.5,
            type: "BufferGeometry",
            generator: "BufferGeometry.toJSON"
          }
        };

        if (t.uuid = this.uuid, t.type = this.type, "" !== this.name && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), void 0 !== this.parameters) {
          var _e40 = this.parameters;

          for (var _n58 in _e40) {
            void 0 !== _e40[_n58] && (t[_n58] = _e40[_n58]);
          }

          return t;
        }

        t.data = {
          attributes: {}
        };
        var e = this.index;
        null !== e && (t.data.index = {
          type: e.array.constructor.name,
          array: Array.prototype.slice.call(e.array)
        });
        var n = this.attributes;

        for (var _e41 in n) {
          var _i44 = n[_e41];
          t.data.attributes[_e41] = _i44.toJSON(t.data);
        }

        var i = {};
        var r = !1;

        for (var _e42 in this.morphAttributes) {
          var _n59 = this.morphAttributes[_e42],
              _s10 = [];

          for (var _e43 = 0, _i45 = _n59.length; _e43 < _i45; _e43++) {
            var _i46 = _n59[_e43];

            _s10.push(_i46.toJSON(t.data));
          }

          _s10.length > 0 && (i[_e42] = _s10, r = !0);
        }

        r && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
        var s = this.groups;
        s.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(s)));
        var a = this.boundingSphere;
        return null !== a && (t.data.boundingSphere = {
          center: a.center.toArray(),
          radius: a.radius
        }), t;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        var e = {};
        this.name = t.name;
        var n = t.index;
        null !== n && this.setIndex(n.clone(e));
        var i = t.attributes;

        for (var _t47 in i) {
          var _n60 = i[_t47];
          this.setAttribute(_t47, _n60.clone(e));
        }

        var r = t.morphAttributes;

        for (var _t48 in r) {
          var _n61 = [],
              _i47 = r[_t48];

          for (var _t49 = 0, _r36 = _i47.length; _t49 < _r36; _t49++) {
            _n61.push(_i47[_t49].clone(e));
          }

          this.morphAttributes[_t48] = _n61;
        }

        this.morphTargetsRelative = t.morphTargetsRelative;
        var s = t.groups;

        for (var _t50 = 0, _e44 = s.length; _t50 < _e44; _t50++) {
          var _e45 = s[_t50];
          this.addGroup(_e45.start, _e45.count, _e45.materialIndex);
        }

        var a = t.boundingBox;
        null !== a && (this.boundingBox = a.clone());
        var o = t.boundingSphere;
        return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, void 0 !== t.parameters && (this.parameters = Object.assign({}, t.parameters)), this;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }]);

    return Un;
  }(mt);

  Un.prototype.isBufferGeometry = !0;
  var Fn = new Pe(),
      Hn = new Le(),
      Gn = new be(),
      Vn = new te(),
      kn = new te(),
      Wn = new te(),
      jn = new te(),
      qn = new te(),
      Xn = new te(),
      Jn = new te(),
      Yn = new te(),
      Zn = new te(),
      Kn = new At(),
      Qn = new At(),
      $n = new At(),
      ti = new te(),
      ei = new te();

  var ni = /*#__PURE__*/function (_nn) {
    _inherits(ni, _nn);

    var _super22 = _createSuper(ni);

    function ni() {
      var _this12;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Un();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new vn();

      _classCallCheck(this, ni);

      _this12 = _super22.call(this), _this12.type = "Mesh", _this12.geometry = t, _this12.material = e, _this12.updateMorphTargets();
      return _this12;
    }

    _createClass(ni, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(ni.prototype), "copy", this).call(this, t), void 0 !== t.morphTargetInfluences && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), void 0 !== t.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
      }
    }, {
      key: "updateMorphTargets",
      value: function updateMorphTargets() {
        var t = this.geometry;

        if (t.isBufferGeometry) {
          var _e46 = t.morphAttributes,
              _n62 = Object.keys(_e46);

          if (_n62.length > 0) {
            var _t51 = _e46[_n62[0]];

            if (void 0 !== _t51) {
              this.morphTargetInfluences = [], this.morphTargetDictionary = {};

              for (var _e47 = 0, _n63 = _t51.length; _e47 < _n63; _e47++) {
                var _n64 = _t51[_e47].name || String(_e47);

                this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n64] = _e47;
              }
            }
          }
        } else {
          var _e48 = t.morphTargets;
          void 0 !== _e48 && _e48.length > 0 && console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
      }
    }, {
      key: "raycast",
      value: function raycast(t, e) {
        var n = this.geometry,
            i = this.material,
            r = this.matrixWorld;
        if (void 0 === i) return;
        if (null === n.boundingSphere && n.computeBoundingSphere(), Gn.copy(n.boundingSphere), Gn.applyMatrix4(r), !1 === t.ray.intersectsSphere(Gn)) return;
        if (Fn.copy(r).invert(), Hn.copy(t.ray).applyMatrix4(Fn), null !== n.boundingBox && !1 === Hn.intersectsBox(n.boundingBox)) return;
        var s;

        if (n.isBufferGeometry) {
          var _r37 = n.index,
              _a10 = n.attributes.position,
              _o9 = n.morphAttributes.position,
              _l11 = n.morphTargetsRelative,
              _c7 = n.attributes.uv,
              _h6 = n.attributes.uv2,
              _u2 = n.groups,
              _d3 = n.drawRange;
          if (null !== _r37) {
            if (Array.isArray(i)) for (var _n65 = 0, _p2 = _u2.length; _n65 < _p2; _n65++) {
              var _p3 = _u2[_n65],
                  _m2 = i[_p3.materialIndex];

              for (var _n66 = Math.max(_p3.start, _d3.start), _i48 = Math.min(_r37.count, Math.min(_p3.start + _p3.count, _d3.start + _d3.count)); _n66 < _i48; _n66 += 3) {
                var _i49 = _r37.getX(_n66),
                    _u3 = _r37.getX(_n66 + 1),
                    _d4 = _r37.getX(_n66 + 2);

                s = ii(this, _m2, t, Hn, _a10, _o9, _l11, _c7, _h6, _i49, _u3, _d4), s && (s.faceIndex = Math.floor(_n66 / 3), s.face.materialIndex = _p3.materialIndex, e.push(s));
              }
            } else {
              for (var _n67 = Math.max(0, _d3.start), _u4 = Math.min(_r37.count, _d3.start + _d3.count); _n67 < _u4; _n67 += 3) {
                var _u5 = _r37.getX(_n67),
                    _d5 = _r37.getX(_n67 + 1),
                    _p4 = _r37.getX(_n67 + 2);

                s = ii(this, i, t, Hn, _a10, _o9, _l11, _c7, _h6, _u5, _d5, _p4), s && (s.faceIndex = Math.floor(_n67 / 3), e.push(s));
              }
            }
          } else if (void 0 !== _a10) if (Array.isArray(i)) for (var _n68 = 0, _r38 = _u2.length; _n68 < _r38; _n68++) {
            var _r39 = _u2[_n68],
                _p5 = i[_r39.materialIndex];

            for (var _n69 = Math.max(_r39.start, _d3.start), _i50 = Math.min(_a10.count, Math.min(_r39.start + _r39.count, _d3.start + _d3.count)); _n69 < _i50; _n69 += 3) {
              s = ii(this, _p5, t, Hn, _a10, _o9, _l11, _c7, _h6, _n69, _n69 + 1, _n69 + 2), s && (s.faceIndex = Math.floor(_n69 / 3), s.face.materialIndex = _r39.materialIndex, e.push(s));
            }
          } else {
            for (var _n70 = Math.max(0, _d3.start), _r40 = Math.min(_a10.count, _d3.start + _d3.count); _n70 < _r40; _n70 += 3) {
              s = ii(this, i, t, Hn, _a10, _o9, _l11, _c7, _h6, _n70, _n70 + 1, _n70 + 2), s && (s.faceIndex = Math.floor(_n70 / 3), e.push(s));
            }
          }
        } else n.isGeometry && console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }]);

    return ni;
  }(nn);

  function ii(t, e, n, i, r, s, a, o, l, c, h, u) {
    Vn.fromBufferAttribute(r, c), kn.fromBufferAttribute(r, h), Wn.fromBufferAttribute(r, u);
    var d = t.morphTargetInfluences;

    if (s && d) {
      Jn.set(0, 0, 0), Yn.set(0, 0, 0), Zn.set(0, 0, 0);

      for (var _t52 = 0, _e49 = s.length; _t52 < _e49; _t52++) {
        var _e50 = d[_t52],
            _n71 = s[_t52];
        0 !== _e50 && (jn.fromBufferAttribute(_n71, c), qn.fromBufferAttribute(_n71, h), Xn.fromBufferAttribute(_n71, u), a ? (Jn.addScaledVector(jn, _e50), Yn.addScaledVector(qn, _e50), Zn.addScaledVector(Xn, _e50)) : (Jn.addScaledVector(jn.sub(Vn), _e50), Yn.addScaledVector(qn.sub(kn), _e50), Zn.addScaledVector(Xn.sub(Wn), _e50)));
      }

      Vn.add(Jn), kn.add(Yn), Wn.add(Zn);
    }

    t.isSkinnedMesh && (t.boneTransform(c, Vn), t.boneTransform(h, kn), t.boneTransform(u, Wn));

    var p = function (t, e, n, i, r, s, a, o) {
      var l;
      if (l = 1 === e.side ? i.intersectTriangle(a, s, r, !0, o) : i.intersectTriangle(r, s, a, 2 !== e.side, o), null === l) return null;
      ei.copy(o), ei.applyMatrix4(t.matrixWorld);
      var c = n.ray.origin.distanceTo(ei);
      return c < n.near || c > n.far ? null : {
        distance: c,
        point: ei.clone(),
        object: t
      };
    }(t, e, n, i, Vn, kn, Wn, ti);

    if (p) {
      o && (Kn.fromBufferAttribute(o, c), Qn.fromBufferAttribute(o, h), $n.fromBufferAttribute(o, u), p.uv = mn.getUV(ti, Vn, kn, Wn, Kn, Qn, $n, new At())), l && (Kn.fromBufferAttribute(l, c), Qn.fromBufferAttribute(l, h), $n.fromBufferAttribute(l, u), p.uv2 = mn.getUV(ti, Vn, kn, Wn, Kn, Qn, $n, new At()));
      var _t53 = {
        a: c,
        b: h,
        c: u,
        normal: new te(),
        materialIndex: 0
      };
      mn.getNormal(Vn, kn, Wn, _t53.normal), p.face = _t53;
    }

    return p;
  }

  ni.prototype.isMesh = !0;

  var ri = /*#__PURE__*/function (_Un) {
    _inherits(ri, _Un);

    var _super23 = _createSuper(ri);

    function ri() {
      var _this13;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

      _classCallCheck(this, ri);

      _this13 = _super23.call(this), _this13.type = "BoxGeometry", _this13.parameters = {
        width: t,
        height: e,
        depth: n,
        widthSegments: i,
        heightSegments: r,
        depthSegments: s
      };

      var a = _assertThisInitialized(_this13);

      i = Math.floor(i), r = Math.floor(r), s = Math.floor(s);
      var o = [],
          l = [],
          c = [],
          h = [];
      var u = 0,
          d = 0;

      function p(t, e, n, i, r, s, p, m, f, g, v) {
        var y = s / f,
            x = p / g,
            _ = s / 2,
            M = p / 2,
            b = m / 2,
            w = f + 1,
            S = g + 1;

        var T = 0,
            E = 0;
        var A = new te();

        for (var _s11 = 0; _s11 < S; _s11++) {
          var _a11 = _s11 * x - M;

          for (var _o10 = 0; _o10 < w; _o10++) {
            var _u6 = _o10 * y - _;

            A[t] = _u6 * i, A[e] = _a11 * r, A[n] = b, l.push(A.x, A.y, A.z), A[t] = 0, A[e] = 0, A[n] = m > 0 ? 1 : -1, c.push(A.x, A.y, A.z), h.push(_o10 / f), h.push(1 - _s11 / g), T += 1;
          }
        }

        for (var _t54 = 0; _t54 < g; _t54++) {
          for (var _e51 = 0; _e51 < f; _e51++) {
            var _n72 = u + _e51 + w * _t54,
                _i51 = u + _e51 + w * (_t54 + 1),
                _r41 = u + (_e51 + 1) + w * (_t54 + 1),
                _s12 = u + (_e51 + 1) + w * _t54;

            o.push(_n72, _i51, _s12), o.push(_i51, _r41, _s12), E += 6;
          }
        }

        a.addGroup(d, E, v), d += E, u += T;
      }

      p("z", "y", "x", -1, -1, n, e, t, s, r, 0), p("z", "y", "x", 1, -1, n, e, -t, s, r, 1), p("x", "z", "y", 1, 1, t, n, e, i, s, 2), p("x", "z", "y", 1, -1, t, n, -e, i, s, 3), p("x", "y", "z", 1, -1, t, e, n, i, r, 4), p("x", "y", "z", -1, -1, t, e, -n, i, r, 5), _this13.setIndex(o), _this13.setAttribute("position", new Cn(l, 3)), _this13.setAttribute("normal", new Cn(c, 3)), _this13.setAttribute("uv", new Cn(h, 2));
      return _this13;
    }

    _createClass(ri, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new ri(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
      }
    }]);

    return ri;
  }(Un);

  function si(t) {
    var e = {};

    for (var _n73 in t) {
      e[_n73] = {};

      for (var _i52 in t[_n73]) {
        var _r42 = t[_n73][_i52];
        _r42 && (_r42.isColor || _r42.isMatrix3 || _r42.isMatrix4 || _r42.isVector2 || _r42.isVector3 || _r42.isVector4 || _r42.isTexture || _r42.isQuaternion) ? e[_n73][_i52] = _r42.clone() : Array.isArray(_r42) ? e[_n73][_i52] = _r42.slice() : e[_n73][_i52] = _r42;
      }
    }

    return e;
  }

  function ai(t) {
    var e = {};

    for (var _n74 = 0; _n74 < t.length; _n74++) {
      var _i53 = si(t[_n74]);

      for (var _t55 in _i53) {
        e[_t55] = _i53[_t55];
      }
    }

    return e;
  }

  var oi = {
    clone: si,
    merge: ai
  };

  var li = /*#__PURE__*/function (_gn2) {
    _inherits(li, _gn2);

    var _super24 = _createSuper(li);

    function li(t) {
      var _this14;

      _classCallCheck(this, li);

      _this14 = _super24.call(this), _this14.type = "ShaderMaterial", _this14.defines = {}, _this14.uniforms = {}, _this14.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", _this14.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", _this14.linewidth = 1, _this14.wireframe = !1, _this14.wireframeLinewidth = 1, _this14.fog = !1, _this14.lights = !1, _this14.clipping = !1, _this14.extensions = {
        derivatives: !1,
        fragDepth: !1,
        drawBuffers: !1,
        shaderTextureLOD: !1
      }, _this14.defaultAttributeValues = {
        color: [1, 1, 1],
        uv: [0, 0],
        uv2: [0, 0]
      }, _this14.index0AttributeName = void 0, _this14.uniformsNeedUpdate = !1, _this14.glslVersion = null, void 0 !== t && (void 0 !== t.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), _this14.setValues(t));
      return _this14;
    }

    _createClass(li, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(li.prototype), "copy", this).call(this, t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = si(t.uniforms), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(li.prototype), "toJSON", this).call(this, t);

        e.glslVersion = this.glslVersion, e.uniforms = {};

        for (var _n75 in this.uniforms) {
          var _i54 = this.uniforms[_n75].value;
          _i54 && _i54.isTexture ? e.uniforms[_n75] = {
            type: "t",
            value: _i54.toJSON(t).uuid
          } : _i54 && _i54.isColor ? e.uniforms[_n75] = {
            type: "c",
            value: _i54.getHex()
          } : _i54 && _i54.isVector2 ? e.uniforms[_n75] = {
            type: "v2",
            value: _i54.toArray()
          } : _i54 && _i54.isVector3 ? e.uniforms[_n75] = {
            type: "v3",
            value: _i54.toArray()
          } : _i54 && _i54.isVector4 ? e.uniforms[_n75] = {
            type: "v4",
            value: _i54.toArray()
          } : _i54 && _i54.isMatrix3 ? e.uniforms[_n75] = {
            type: "m3",
            value: _i54.toArray()
          } : _i54 && _i54.isMatrix4 ? e.uniforms[_n75] = {
            type: "m4",
            value: _i54.toArray()
          } : e.uniforms[_n75] = {
            value: _i54
          };
        }

        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
        var n = {};

        for (var _t56 in this.extensions) {
          !0 === this.extensions[_t56] && (n[_t56] = !0);
        }

        return Object.keys(n).length > 0 && (e.extensions = n), e;
      }
    }]);

    return li;
  }(gn);

  li.prototype.isShaderMaterial = !0;

  var ci = /*#__PURE__*/function (_nn2) {
    _inherits(ci, _nn2);

    var _super25 = _createSuper(ci);

    function ci() {
      var _this15;

      _classCallCheck(this, ci);

      _this15 = _super25.call(this), _this15.type = "Camera", _this15.matrixWorldInverse = new Pe(), _this15.projectionMatrix = new Pe(), _this15.projectionMatrixInverse = new Pe();
      return _this15;
    }

    _createClass(ci, [{
      key: "copy",
      value: function copy(t, e) {
        return _get(_getPrototypeOf(ci.prototype), "copy", this).call(this, t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
      }
    }, {
      key: "getWorldDirection",
      value: function getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        var e = this.matrixWorld.elements;
        return t.set(-e[8], -e[9], -e[10]).normalize();
      }
    }, {
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        _get(_getPrototypeOf(ci.prototype), "updateMatrixWorld", this).call(this, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
      }
    }, {
      key: "updateWorldMatrix",
      value: function updateWorldMatrix(t, e) {
        _get(_getPrototypeOf(ci.prototype), "updateWorldMatrix", this).call(this, t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return ci;
  }(nn);

  ci.prototype.isCamera = !0;

  var hi = /*#__PURE__*/function (_ci) {
    _inherits(hi, _ci);

    var _super26 = _createSuper(hi);

    function hi() {
      var _this16;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2e3;

      _classCallCheck(this, hi);

      _this16 = _super26.call(this), _this16.type = "PerspectiveCamera", _this16.fov = t, _this16.zoom = 1, _this16.near = n, _this16.far = i, _this16.focus = 10, _this16.aspect = e, _this16.view = null, _this16.filmGauge = 35, _this16.filmOffset = 0, _this16.updateProjectionMatrix();
      return _this16;
    }

    _createClass(hi, [{
      key: "copy",
      value: function copy(t, e) {
        return _get(_getPrototypeOf(hi.prototype), "copy", this).call(this, t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = null === t.view ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
      }
    }, {
      key: "setFocalLength",
      value: function setFocalLength(t) {
        var e = .5 * this.getFilmHeight() / t;
        this.fov = 2 * yt * Math.atan(e), this.updateProjectionMatrix();
      }
    }, {
      key: "getFocalLength",
      value: function getFocalLength() {
        var t = Math.tan(.5 * vt * this.fov);
        return .5 * this.getFilmHeight() / t;
      }
    }, {
      key: "getEffectiveFOV",
      value: function getEffectiveFOV() {
        return 2 * yt * Math.atan(Math.tan(.5 * vt * this.fov) / this.zoom);
      }
    }, {
      key: "getFilmWidth",
      value: function getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
      }
    }, {
      key: "getFilmHeight",
      value: function getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
      }
    }, {
      key: "setViewOffset",
      value: function setViewOffset(t, e, n, i, r, s) {
        this.aspect = t / e, null === this.view && (this.view = {
          enabled: !0,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
      }
    }, {
      key: "clearViewOffset",
      value: function clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
      }
    }, {
      key: "updateProjectionMatrix",
      value: function updateProjectionMatrix() {
        var t = this.near;
        var e = t * Math.tan(.5 * vt * this.fov) / this.zoom,
            n = 2 * e,
            i = this.aspect * n,
            r = -.5 * i;
        var s = this.view;

        if (null !== this.view && this.view.enabled) {
          var _t57 = s.fullWidth,
              _a12 = s.fullHeight;
          r += s.offsetX * i / _t57, e -= s.offsetY * n / _a12, i *= s.width / _t57, n *= s.height / _a12;
        }

        var a = this.filmOffset;
        0 !== a && (r += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, e, e - n, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(hi.prototype), "toJSON", this).call(this, t);

        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
      }
    }]);

    return hi;
  }(ci);

  hi.prototype.isPerspectiveCamera = !0;
  var ui = 90;

  var di = /*#__PURE__*/function (_nn3) {
    _inherits(di, _nn3);

    var _super27 = _createSuper(di);

    function di(t, e, n) {
      var _this17;

      _classCallCheck(this, di);

      if (_this17 = _super27.call(this), _this17.type = "CubeCamera", !0 !== n.isWebGLCubeRenderTarget) return _possibleConstructorReturn(_this17, void console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter."));
      _this17.renderTarget = n;
      var i = new hi(ui, 1, t, e);
      i.layers = _this17.layers, i.up.set(0, -1, 0), i.lookAt(new te(1, 0, 0)), _this17.add(i);
      var r = new hi(ui, 1, t, e);
      r.layers = _this17.layers, r.up.set(0, -1, 0), r.lookAt(new te(-1, 0, 0)), _this17.add(r);
      var s = new hi(ui, 1, t, e);
      s.layers = _this17.layers, s.up.set(0, 0, 1), s.lookAt(new te(0, 1, 0)), _this17.add(s);
      var a = new hi(ui, 1, t, e);
      a.layers = _this17.layers, a.up.set(0, 0, -1), a.lookAt(new te(0, -1, 0)), _this17.add(a);
      var o = new hi(ui, 1, t, e);
      o.layers = _this17.layers, o.up.set(0, -1, 0), o.lookAt(new te(0, 0, 1)), _this17.add(o);
      var l = new hi(ui, 1, t, e);
      l.layers = _this17.layers, l.up.set(0, -1, 0), l.lookAt(new te(0, 0, -1)), _this17.add(l);
      return _possibleConstructorReturn(_this17);
    }

    _createClass(di, [{
      key: "update",
      value: function update(t, e) {
        null === this.parent && this.updateMatrixWorld();

        var n = this.renderTarget,
            _this$children = _slicedToArray(this.children, 6),
            i = _this$children[0],
            r = _this$children[1],
            s = _this$children[2],
            a = _this$children[3],
            o = _this$children[4],
            l = _this$children[5],
            c = t.xr.enabled,
            h = t.getRenderTarget();

        t.xr.enabled = !1;
        var u = n.texture.generateMipmaps;
        n.texture.generateMipmaps = !1, t.setRenderTarget(n, 0), t.render(e, i), t.setRenderTarget(n, 1), t.render(e, r), t.setRenderTarget(n, 2), t.render(e, s), t.setRenderTarget(n, 3), t.render(e, a), t.setRenderTarget(n, 4), t.render(e, o), n.texture.generateMipmaps = u, t.setRenderTarget(n, 5), t.render(e, l), t.setRenderTarget(h), t.xr.enabled = c, n.texture.needsPMREMUpdate = !0;
      }
    }]);

    return di;
  }(nn);

  var pi = /*#__PURE__*/function (_jt3) {
    _inherits(pi, _jt3);

    var _super28 = _createSuper(pi);

    function pi(t, e, n, i, s, a, o, l, c, h) {
      var _this18;

      _classCallCheck(this, pi);

      _this18 = _super28.call(this, t = void 0 !== t ? t : [], e = void 0 !== e ? e : r, n, i, s, a, o, l, c, h), _this18.flipY = !1;
      return _this18;
    }

    _createClass(pi, [{
      key: "images",
      get: function get() {
        return this.image;
      },
      set: function set(t) {
        this.image = t;
      }
    }]);

    return pi;
  }(jt);

  pi.prototype.isCubeTexture = !0;

  var mi = /*#__PURE__*/function (_Xt4) {
    _inherits(mi, _Xt4);

    var _super29 = _createSuper(mi);

    function mi(t) {
      var _this19;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, mi);

      _this19 = _super29.call(this, t, t, e);
      var n = {
        width: t,
        height: t,
        depth: 1
      },
          i = [n, n, n, n, n, n];
      _this19.texture = new pi(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), _this19.texture.isRenderTargetTexture = !0, _this19.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, _this19.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : g;
      return _this19;
    }

    _createClass(mi, [{
      key: "fromEquirectangularTexture",
      value: function fromEquirectangularTexture(t, e) {
        this.texture.type = e.type, this.texture.format = T, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        var n = {
          uniforms: {
            tEquirect: {
              value: null
            }
          },
          vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
          fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
        },
            i = new ri(5, 5, 5),
            r = new li({
          name: "CubemapFromEquirect",
          uniforms: si(n.uniforms),
          vertexShader: n.vertexShader,
          fragmentShader: n.fragmentShader,
          side: 1,
          blending: 0
        });
        r.uniforms.tEquirect.value = e;
        var s = new ni(i, r),
            a = e.minFilter;
        e.minFilter === y && (e.minFilter = g);
        return new di(1, 10, this).update(t, s), e.minFilter = a, s.geometry.dispose(), s.material.dispose(), this;
      }
    }, {
      key: "clear",
      value: function clear(t, e, n, i) {
        var r = t.getRenderTarget();

        for (var _r43 = 0; _r43 < 6; _r43++) {
          t.setRenderTarget(this, _r43), t.clear(e, n, i);
        }

        t.setRenderTarget(r);
      }
    }]);

    return mi;
  }(Xt);

  mi.prototype.isWebGLCubeRenderTarget = !0;
  var fi = new te(),
      gi = new te(),
      vi = new Rt();

  var yi = /*#__PURE__*/function () {
    function yi() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te(1, 0, 0);
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, yi);

      this.normal = t, this.constant = e;
    }

    _createClass(yi, [{
      key: "set",
      value: function set(t, e) {
        return this.normal.copy(t), this.constant = e, this;
      }
    }, {
      key: "setComponents",
      value: function setComponents(t, e, n, i) {
        return this.normal.set(t, e, n), this.constant = i, this;
      }
    }, {
      key: "setFromNormalAndCoplanarPoint",
      value: function setFromNormalAndCoplanarPoint(t, e) {
        return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
      }
    }, {
      key: "setFromCoplanarPoints",
      value: function setFromCoplanarPoints(t, e, n) {
        var i = fi.subVectors(n, e).cross(gi.subVectors(t, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, t), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.normal.copy(t.normal), this.constant = t.constant, this;
      }
    }, {
      key: "normalize",
      value: function normalize() {
        var t = 1 / this.normal.length();
        return this.normal.multiplyScalar(t), this.constant *= t, this;
      }
    }, {
      key: "negate",
      value: function negate() {
        return this.constant *= -1, this.normal.negate(), this;
      }
    }, {
      key: "distanceToPoint",
      value: function distanceToPoint(t) {
        return this.normal.dot(t) + this.constant;
      }
    }, {
      key: "distanceToSphere",
      value: function distanceToSphere(t) {
        return this.distanceToPoint(t.center) - t.radius;
      }
    }, {
      key: "projectPoint",
      value: function projectPoint(t, e) {
        return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
      }
    }, {
      key: "intersectLine",
      value: function intersectLine(t, e) {
        var n = t.delta(fi),
            i = this.normal.dot(n);
        if (0 === i) return 0 === this.distanceToPoint(t.start) ? e.copy(t.start) : null;
        var r = -(t.start.dot(this.normal) + this.constant) / i;
        return r < 0 || r > 1 ? null : e.copy(n).multiplyScalar(r).add(t.start);
      }
    }, {
      key: "intersectsLine",
      value: function intersectsLine(t) {
        var e = this.distanceToPoint(t.start),
            n = this.distanceToPoint(t.end);
        return e < 0 && n > 0 || n < 0 && e > 0;
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        return t.intersectsPlane(this);
      }
    }, {
      key: "intersectsSphere",
      value: function intersectsSphere(t) {
        return t.intersectsPlane(this);
      }
    }, {
      key: "coplanarPoint",
      value: function coplanarPoint(t) {
        return t.copy(this.normal).multiplyScalar(-this.constant);
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t, e) {
        var n = e || vi.getNormalMatrix(t),
            i = this.coplanarPoint(fi).applyMatrix4(t),
            r = this.normal.applyMatrix3(n).normalize();
        return this.constant = -i.dot(r), this;
      }
    }, {
      key: "translate",
      value: function translate(t) {
        return this.constant -= t.dot(this.normal), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.normal.equals(this.normal) && t.constant === this.constant;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return yi;
  }();

  yi.prototype.isPlane = !0;

  var xi = new be(),
      _i = new te();

  var Mi = /*#__PURE__*/function () {
    function Mi() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new yi();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new yi();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new yi();
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new yi();
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new yi();
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new yi();

      _classCallCheck(this, Mi);

      this.planes = [t, e, n, i, r, s];
    }

    _createClass(Mi, [{
      key: "set",
      value: function set(t, e, n, i, r, s) {
        var a = this.planes;
        return a[0].copy(t), a[1].copy(e), a[2].copy(n), a[3].copy(i), a[4].copy(r), a[5].copy(s), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        var e = this.planes;

        for (var _n76 = 0; _n76 < 6; _n76++) {
          e[_n76].copy(t.planes[_n76]);
        }

        return this;
      }
    }, {
      key: "setFromProjectionMatrix",
      value: function setFromProjectionMatrix(t) {
        var e = this.planes,
            n = t.elements,
            i = n[0],
            r = n[1],
            s = n[2],
            a = n[3],
            o = n[4],
            l = n[5],
            c = n[6],
            h = n[7],
            u = n[8],
            d = n[9],
            p = n[10],
            m = n[11],
            f = n[12],
            g = n[13],
            v = n[14],
            y = n[15];
        return e[0].setComponents(a - i, h - o, m - u, y - f).normalize(), e[1].setComponents(a + i, h + o, m + u, y + f).normalize(), e[2].setComponents(a + r, h + l, m + d, y + g).normalize(), e[3].setComponents(a - r, h - l, m - d, y - g).normalize(), e[4].setComponents(a - s, h - c, m - p, y - v).normalize(), e[5].setComponents(a + s, h + c, m + p, y + v).normalize(), this;
      }
    }, {
      key: "intersectsObject",
      value: function intersectsObject(t) {
        var e = t.geometry;
        return null === e.boundingSphere && e.computeBoundingSphere(), xi.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(xi);
      }
    }, {
      key: "intersectsSprite",
      value: function intersectsSprite(t) {
        return xi.center.set(0, 0, 0), xi.radius = .7071067811865476, xi.applyMatrix4(t.matrixWorld), this.intersectsSphere(xi);
      }
    }, {
      key: "intersectsSphere",
      value: function intersectsSphere(t) {
        var e = this.planes,
            n = t.center,
            i = -t.radius;

        for (var _t58 = 0; _t58 < 6; _t58++) {
          if (e[_t58].distanceToPoint(n) < i) return !1;
        }

        return !0;
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        var e = this.planes;

        for (var _n77 = 0; _n77 < 6; _n77++) {
          var _i55 = e[_n77];
          if (_i.x = _i55.normal.x > 0 ? t.max.x : t.min.x, _i.y = _i55.normal.y > 0 ? t.max.y : t.min.y, _i.z = _i55.normal.z > 0 ? t.max.z : t.min.z, _i55.distanceToPoint(_i) < 0) return !1;
        }

        return !0;
      }
    }, {
      key: "containsPoint",
      value: function containsPoint(t) {
        var e = this.planes;

        for (var _n78 = 0; _n78 < 6; _n78++) {
          if (e[_n78].distanceToPoint(t) < 0) return !1;
        }

        return !0;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return Mi;
  }();

  function bi() {
    var t = null,
        e = !1,
        n = null,
        i = null;

    function r(e, s) {
      n(e, s), i = t.requestAnimationFrame(r);
    }

    return {
      start: function start() {
        !0 !== e && null !== n && (i = t.requestAnimationFrame(r), e = !0);
      },
      stop: function stop() {
        t.cancelAnimationFrame(i), e = !1;
      },
      setAnimationLoop: function setAnimationLoop(t) {
        n = t;
      },
      setContext: function setContext(e) {
        t = e;
      }
    };
  }

  function wi(t, e) {
    var n = e.isWebGL2,
        i = new WeakMap();
    return {
      get: function get(t) {
        return t.isInterleavedBufferAttribute && (t = t.data), i.get(t);
      },
      remove: function remove(e) {
        e.isInterleavedBufferAttribute && (e = e.data);
        var n = i.get(e);
        n && (t.deleteBuffer(n.buffer), i.delete(e));
      },
      update: function update(e, r) {
        if (e.isGLBufferAttribute) {
          var _t59 = i.get(e);

          return void ((!_t59 || _t59.version < e.version) && i.set(e, {
            buffer: e.buffer,
            type: e.type,
            bytesPerElement: e.elementSize,
            version: e.version
          }));
        }

        e.isInterleavedBufferAttribute && (e = e.data);
        var s = i.get(e);
        void 0 === s ? i.set(e, function (e, i) {
          var r = e.array,
              s = e.usage,
              a = t.createBuffer();
          var o;
          if (t.bindBuffer(i, a), t.bufferData(i, r, s), e.onUploadCallback(), r instanceof Float32Array) o = 5126;else if (r instanceof Uint16Array) {
            if (e.isFloat16BufferAttribute) {
              if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
              o = 5131;
            } else o = 5123;
          } else if (r instanceof Int16Array) o = 5122;else if (r instanceof Uint32Array) o = 5125;else if (r instanceof Int32Array) o = 5124;else if (r instanceof Int8Array) o = 5120;else if (r instanceof Uint8Array) o = 5121;else {
            if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
            o = 5121;
          }
          return {
            buffer: a,
            type: o,
            bytesPerElement: r.BYTES_PER_ELEMENT,
            version: e.version
          };
        }(e, r)) : s.version < e.version && (!function (e, i, r) {
          var s = i.array,
              a = i.updateRange;
          t.bindBuffer(r, e), -1 === a.count ? t.bufferSubData(r, 0, s) : (n ? t.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s, a.offset, a.count) : t.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s.subarray(a.offset, a.offset + a.count)), a.count = -1);
        }(s.buffer, e, r), s.version = e.version);
      }
    };
  }

  var Si = /*#__PURE__*/function (_Un2) {
    _inherits(Si, _Un2);

    var _super30 = _createSuper(Si);

    function Si() {
      var _this20;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, Si);

      _this20 = _super30.call(this), _this20.type = "PlaneGeometry", _this20.parameters = {
        width: t,
        height: e,
        widthSegments: n,
        heightSegments: i
      };
      var r = t / 2,
          s = e / 2,
          a = Math.floor(n),
          o = Math.floor(i),
          l = a + 1,
          c = o + 1,
          h = t / a,
          u = e / o,
          d = [],
          p = [],
          m = [],
          f = [];

      for (var _t60 = 0; _t60 < c; _t60++) {
        var _e52 = _t60 * u - s;

        for (var _n79 = 0; _n79 < l; _n79++) {
          var _i56 = _n79 * h - r;

          p.push(_i56, -_e52, 0), m.push(0, 0, 1), f.push(_n79 / a), f.push(1 - _t60 / o);
        }
      }

      for (var _t61 = 0; _t61 < o; _t61++) {
        for (var _e53 = 0; _e53 < a; _e53++) {
          var _n80 = _e53 + l * _t61,
              _i57 = _e53 + l * (_t61 + 1),
              _r44 = _e53 + 1 + l * (_t61 + 1),
              _s13 = _e53 + 1 + l * _t61;

          d.push(_n80, _i57, _s13), d.push(_i57, _r44, _s13);
        }
      }

      _this20.setIndex(d), _this20.setAttribute("position", new Cn(p, 3)), _this20.setAttribute("normal", new Cn(m, 3)), _this20.setAttribute("uv", new Cn(f, 2));
      return _this20;
    }

    _createClass(Si, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Si(t.width, t.height, t.widthSegments, t.heightSegments);
      }
    }]);

    return Si;
  }(Un);

  var Ti = {
    alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif",
    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    alphatest_fragment: "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif",
    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
    aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
    aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
    begin_vertex: "vec3 transformed = vec3( position );",
    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
    bsdfs: "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif",
    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
    color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
    color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
    color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
    color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}",
    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 ) + 0.5;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif",
    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
    encodings_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
    encodings_pars_fragment: "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
    envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
    envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
    envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
    envmap_physical_pars_fragment: "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec;\n\t\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\t\treflectVec = reflect( - viewDir, normal );\n\t\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\t#else\n\t\t\t\treflectVec = refract( - viewDir, normal, refractionRatio );\n\t\t\t#endif\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif",
    envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
    fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
    fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
    fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
    fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}",
    lightmap_fragment: "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tlightMapIrradiance *= PI;\n\t#endif\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
    lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointLightInfo( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotLightInfo( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif",
    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)",
    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)",
    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif",
    lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\tvec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(\t\t0, 1,\t\t0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
    lights_fragment_begin: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif",
    logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
    logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
    logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
    map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
    map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
    map_particle_pars_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
    morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ]\n\t\t#endif\n\t}\n#endif",
    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif",
    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform vec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tfloat texelIndex = float( vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset );\n\t\t\tfloat y = floor( texelIndex / morphTargetsTextureSize.x );\n\t\t\tfloat x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tvec3 morphUV = vec3( ( x + 0.5 ) / morphTargetsTextureSize.x, y / morphTargetsTextureSize.y, morphTargetIndex );\n\t\t\treturn texture( morphTargetsTexture, morphUV );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif",
    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif",
    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;",
    normal_fragment_maps: "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
    normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif",
    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif",
    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif",
    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif",
    output_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}",
    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
    dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
    dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
    shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t\tf.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t\tf.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
    shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
    shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif",
    shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
    skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
    skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif",
    skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
    skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
    tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(\t1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,\t1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,\t1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
    transmission_fragment: "#ifdef USE_TRANSMISSION\n\tfloat transmissionAlpha = 1.0;\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n\ttransmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif",
    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif",
    uv_pars_fragment: "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif",
    uv_pars_vertex: "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif",
    uv_vertex: "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
    uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
    uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif",
    uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif",
    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
    background_frag: "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( t2D, vUv );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    cube_frag: "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
    depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
    depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
    distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
    distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}"
  },
      Ei = {
    common: {
      diffuse: {
        value: new Ft(16777215)
      },
      opacity: {
        value: 1
      },
      map: {
        value: null
      },
      uvTransform: {
        value: new Rt()
      },
      uv2Transform: {
        value: new Rt()
      },
      alphaMap: {
        value: null
      },
      alphaTest: {
        value: 0
      }
    },
    specularmap: {
      specularMap: {
        value: null
      }
    },
    envmap: {
      envMap: {
        value: null
      },
      flipEnvMap: {
        value: -1
      },
      reflectivity: {
        value: 1
      },
      ior: {
        value: 1.5
      },
      refractionRatio: {
        value: .98
      }
    },
    aomap: {
      aoMap: {
        value: null
      },
      aoMapIntensity: {
        value: 1
      }
    },
    lightmap: {
      lightMap: {
        value: null
      },
      lightMapIntensity: {
        value: 1
      }
    },
    emissivemap: {
      emissiveMap: {
        value: null
      }
    },
    bumpmap: {
      bumpMap: {
        value: null
      },
      bumpScale: {
        value: 1
      }
    },
    normalmap: {
      normalMap: {
        value: null
      },
      normalScale: {
        value: new At(1, 1)
      }
    },
    displacementmap: {
      displacementMap: {
        value: null
      },
      displacementScale: {
        value: 1
      },
      displacementBias: {
        value: 0
      }
    },
    roughnessmap: {
      roughnessMap: {
        value: null
      }
    },
    metalnessmap: {
      metalnessMap: {
        value: null
      }
    },
    gradientmap: {
      gradientMap: {
        value: null
      }
    },
    fog: {
      fogDensity: {
        value: 25e-5
      },
      fogNear: {
        value: 1
      },
      fogFar: {
        value: 2e3
      },
      fogColor: {
        value: new Ft(16777215)
      }
    },
    lights: {
      ambientLightColor: {
        value: []
      },
      lightProbe: {
        value: []
      },
      directionalLights: {
        value: [],
        properties: {
          direction: {},
          color: {}
        }
      },
      directionalLightShadows: {
        value: [],
        properties: {
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {}
        }
      },
      directionalShadowMap: {
        value: []
      },
      directionalShadowMatrix: {
        value: []
      },
      spotLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          direction: {},
          distance: {},
          coneCos: {},
          penumbraCos: {},
          decay: {}
        }
      },
      spotLightShadows: {
        value: [],
        properties: {
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {}
        }
      },
      spotShadowMap: {
        value: []
      },
      spotShadowMatrix: {
        value: []
      },
      pointLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          decay: {},
          distance: {}
        }
      },
      pointLightShadows: {
        value: [],
        properties: {
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
          shadowCameraNear: {},
          shadowCameraFar: {}
        }
      },
      pointShadowMap: {
        value: []
      },
      pointShadowMatrix: {
        value: []
      },
      hemisphereLights: {
        value: [],
        properties: {
          direction: {},
          skyColor: {},
          groundColor: {}
        }
      },
      rectAreaLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          width: {},
          height: {}
        }
      },
      ltc_1: {
        value: null
      },
      ltc_2: {
        value: null
      }
    },
    points: {
      diffuse: {
        value: new Ft(16777215)
      },
      opacity: {
        value: 1
      },
      size: {
        value: 1
      },
      scale: {
        value: 1
      },
      map: {
        value: null
      },
      alphaMap: {
        value: null
      },
      alphaTest: {
        value: 0
      },
      uvTransform: {
        value: new Rt()
      }
    },
    sprite: {
      diffuse: {
        value: new Ft(16777215)
      },
      opacity: {
        value: 1
      },
      center: {
        value: new At(.5, .5)
      },
      rotation: {
        value: 0
      },
      map: {
        value: null
      },
      alphaMap: {
        value: null
      },
      alphaTest: {
        value: 0
      },
      uvTransform: {
        value: new Rt()
      }
    }
  },
      Ai = {
    basic: {
      uniforms: ai([Ei.common, Ei.specularmap, Ei.envmap, Ei.aomap, Ei.lightmap, Ei.fog]),
      vertexShader: Ti.meshbasic_vert,
      fragmentShader: Ti.meshbasic_frag
    },
    lambert: {
      uniforms: ai([Ei.common, Ei.specularmap, Ei.envmap, Ei.aomap, Ei.lightmap, Ei.emissivemap, Ei.fog, Ei.lights, {
        emissive: {
          value: new Ft(0)
        }
      }]),
      vertexShader: Ti.meshlambert_vert,
      fragmentShader: Ti.meshlambert_frag
    },
    phong: {
      uniforms: ai([Ei.common, Ei.specularmap, Ei.envmap, Ei.aomap, Ei.lightmap, Ei.emissivemap, Ei.bumpmap, Ei.normalmap, Ei.displacementmap, Ei.fog, Ei.lights, {
        emissive: {
          value: new Ft(0)
        },
        specular: {
          value: new Ft(1118481)
        },
        shininess: {
          value: 30
        }
      }]),
      vertexShader: Ti.meshphong_vert,
      fragmentShader: Ti.meshphong_frag
    },
    standard: {
      uniforms: ai([Ei.common, Ei.envmap, Ei.aomap, Ei.lightmap, Ei.emissivemap, Ei.bumpmap, Ei.normalmap, Ei.displacementmap, Ei.roughnessmap, Ei.metalnessmap, Ei.fog, Ei.lights, {
        emissive: {
          value: new Ft(0)
        },
        roughness: {
          value: 1
        },
        metalness: {
          value: 0
        },
        envMapIntensity: {
          value: 1
        }
      }]),
      vertexShader: Ti.meshphysical_vert,
      fragmentShader: Ti.meshphysical_frag
    },
    toon: {
      uniforms: ai([Ei.common, Ei.aomap, Ei.lightmap, Ei.emissivemap, Ei.bumpmap, Ei.normalmap, Ei.displacementmap, Ei.gradientmap, Ei.fog, Ei.lights, {
        emissive: {
          value: new Ft(0)
        }
      }]),
      vertexShader: Ti.meshtoon_vert,
      fragmentShader: Ti.meshtoon_frag
    },
    matcap: {
      uniforms: ai([Ei.common, Ei.bumpmap, Ei.normalmap, Ei.displacementmap, Ei.fog, {
        matcap: {
          value: null
        }
      }]),
      vertexShader: Ti.meshmatcap_vert,
      fragmentShader: Ti.meshmatcap_frag
    },
    points: {
      uniforms: ai([Ei.points, Ei.fog]),
      vertexShader: Ti.points_vert,
      fragmentShader: Ti.points_frag
    },
    dashed: {
      uniforms: ai([Ei.common, Ei.fog, {
        scale: {
          value: 1
        },
        dashSize: {
          value: 1
        },
        totalSize: {
          value: 2
        }
      }]),
      vertexShader: Ti.linedashed_vert,
      fragmentShader: Ti.linedashed_frag
    },
    depth: {
      uniforms: ai([Ei.common, Ei.displacementmap]),
      vertexShader: Ti.depth_vert,
      fragmentShader: Ti.depth_frag
    },
    normal: {
      uniforms: ai([Ei.common, Ei.bumpmap, Ei.normalmap, Ei.displacementmap, {
        opacity: {
          value: 1
        }
      }]),
      vertexShader: Ti.meshnormal_vert,
      fragmentShader: Ti.meshnormal_frag
    },
    sprite: {
      uniforms: ai([Ei.sprite, Ei.fog]),
      vertexShader: Ti.sprite_vert,
      fragmentShader: Ti.sprite_frag
    },
    background: {
      uniforms: {
        uvTransform: {
          value: new Rt()
        },
        t2D: {
          value: null
        }
      },
      vertexShader: Ti.background_vert,
      fragmentShader: Ti.background_frag
    },
    cube: {
      uniforms: ai([Ei.envmap, {
        opacity: {
          value: 1
        }
      }]),
      vertexShader: Ti.cube_vert,
      fragmentShader: Ti.cube_frag
    },
    equirect: {
      uniforms: {
        tEquirect: {
          value: null
        }
      },
      vertexShader: Ti.equirect_vert,
      fragmentShader: Ti.equirect_frag
    },
    distanceRGBA: {
      uniforms: ai([Ei.common, Ei.displacementmap, {
        referencePosition: {
          value: new te()
        },
        nearDistance: {
          value: 1
        },
        farDistance: {
          value: 1e3
        }
      }]),
      vertexShader: Ti.distanceRGBA_vert,
      fragmentShader: Ti.distanceRGBA_frag
    },
    shadow: {
      uniforms: ai([Ei.lights, Ei.fog, {
        color: {
          value: new Ft(0)
        },
        opacity: {
          value: 1
        }
      }]),
      vertexShader: Ti.shadow_vert,
      fragmentShader: Ti.shadow_frag
    }
  };

  function Ri(t, e, n, i, r, s) {
    var a = new Ft(0);
    var o,
        c,
        h = !0 === r ? 0 : 1,
        u = null,
        d = 0,
        p = null;

    function m(t, e) {
      n.buffers.color.setClear(t.r, t.g, t.b, e, s);
    }

    return {
      getClearColor: function getClearColor() {
        return a;
      },
      setClearColor: function setClearColor(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        a.set(t), h = e, m(a, h);
      },
      getClearAlpha: function getClearAlpha() {
        return h;
      },
      setClearAlpha: function setClearAlpha(t) {
        h = t, m(a, h);
      },
      render: function render(n, r) {
        var s = !1,
            f = !0 === r.isScene ? r.background : null;
        f && f.isTexture && (f = e.get(f));
        var g = t.xr,
            v = g.getSession && g.getSession();
        v && "additive" === v.environmentBlendMode && (f = null), null === f ? m(a, h) : f && f.isColor && (m(f, 1), s = !0), (t.autoClear || s) && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), f && (f.isCubeTexture || f.mapping === l) ? (void 0 === c && (c = new ni(new ri(1, 1, 1), new li({
          name: "BackgroundCubeMaterial",
          uniforms: si(Ai.cube.uniforms),
          vertexShader: Ai.cube.vertexShader,
          fragmentShader: Ai.cube.fragmentShader,
          side: 1,
          depthTest: !1,
          depthWrite: !1,
          fog: !1
        })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function (t, e, n) {
          this.matrixWorld.copyPosition(n.matrixWorld);
        }, Object.defineProperty(c.material, "envMap", {
          get: function get() {
            return this.uniforms.envMap.value;
          }
        }), i.update(c)), c.material.uniforms.envMap.value = f, c.material.uniforms.flipEnvMap.value = f.isCubeTexture && !1 === f.isRenderTargetTexture ? -1 : 1, u === f && d === f.version && p === t.toneMapping || (c.material.needsUpdate = !0, u = f, d = f.version, p = t.toneMapping), n.unshift(c, c.geometry, c.material, 0, 0, null)) : f && f.isTexture && (void 0 === o && (o = new ni(new Si(2, 2), new li({
          name: "BackgroundMaterial",
          uniforms: si(Ai.background.uniforms),
          vertexShader: Ai.background.vertexShader,
          fragmentShader: Ai.background.fragmentShader,
          side: 0,
          depthTest: !1,
          depthWrite: !1,
          fog: !1
        })), o.geometry.deleteAttribute("normal"), Object.defineProperty(o.material, "map", {
          get: function get() {
            return this.uniforms.t2D.value;
          }
        }), i.update(o)), o.material.uniforms.t2D.value = f, !0 === f.matrixAutoUpdate && f.updateMatrix(), o.material.uniforms.uvTransform.value.copy(f.matrix), u === f && d === f.version && p === t.toneMapping || (o.material.needsUpdate = !0, u = f, d = f.version, p = t.toneMapping), n.unshift(o, o.geometry, o.material, 0, 0, null));
      }
    };
  }

  function Ci(t, e, n, i) {
    var r = t.getParameter(34921),
        s = i.isWebGL2 ? null : e.get("OES_vertex_array_object"),
        a = i.isWebGL2 || null !== s,
        o = {},
        l = d(null);
    var c = l;

    function h(e) {
      return i.isWebGL2 ? t.bindVertexArray(e) : s.bindVertexArrayOES(e);
    }

    function u(e) {
      return i.isWebGL2 ? t.deleteVertexArray(e) : s.deleteVertexArrayOES(e);
    }

    function d(t) {
      var e = [],
          n = [],
          i = [];

      for (var _t62 = 0; _t62 < r; _t62++) {
        e[_t62] = 0, n[_t62] = 0, i[_t62] = 0;
      }

      return {
        geometry: null,
        program: null,
        wireframe: !1,
        newAttributes: e,
        enabledAttributes: n,
        attributeDivisors: i,
        object: t,
        attributes: {},
        index: null
      };
    }

    function p() {
      var t = c.newAttributes;

      for (var _e54 = 0, _n81 = t.length; _e54 < _n81; _e54++) {
        t[_e54] = 0;
      }
    }

    function m(t) {
      f(t, 0);
    }

    function f(n, r) {
      var s = c.newAttributes,
          a = c.enabledAttributes,
          o = c.attributeDivisors;

      if (s[n] = 1, 0 === a[n] && (t.enableVertexAttribArray(n), a[n] = 1), o[n] !== r) {
        (i.isWebGL2 ? t : e.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r;
      }
    }

    function g() {
      var e = c.newAttributes,
          n = c.enabledAttributes;

      for (var _i58 = 0, _r45 = n.length; _i58 < _r45; _i58++) {
        n[_i58] !== e[_i58] && (t.disableVertexAttribArray(_i58), n[_i58] = 0);
      }
    }

    function v(e, n, r, s, a, o) {
      !0 !== i.isWebGL2 || 5124 !== r && 5125 !== r ? t.vertexAttribPointer(e, n, r, s, a, o) : t.vertexAttribIPointer(e, n, r, a, o);
    }

    function y() {
      x(), c !== l && (c = l, h(c.object));
    }

    function x() {
      l.geometry = null, l.program = null, l.wireframe = !1;
    }

    return {
      setup: function setup(r, l, u, y, x) {
        var _ = !1;

        if (a) {
          var _e55 = function (e, n, r) {
            var a = !0 === r.wireframe;
            var l = o[e.id];
            void 0 === l && (l = {}, o[e.id] = l);
            var c = l[n.id];
            void 0 === c && (c = {}, l[n.id] = c);
            var h = c[a];
            void 0 === h && (h = d(i.isWebGL2 ? t.createVertexArray() : s.createVertexArrayOES()), c[a] = h);
            return h;
          }(y, u, l);

          c !== _e55 && (c = _e55, h(c.object)), _ = function (t, e) {
            var n = c.attributes,
                i = t.attributes;
            var r = 0;

            for (var _t63 in i) {
              var _e56 = n[_t63],
                  _s14 = i[_t63];
              if (void 0 === _e56) return !0;
              if (_e56.attribute !== _s14) return !0;
              if (_e56.data !== _s14.data) return !0;
              r++;
            }

            return c.attributesNum !== r || c.index !== e;
          }(y, x), _ && function (t, e) {
            var n = {},
                i = t.attributes;
            var r = 0;

            for (var _t64 in i) {
              var _e57 = i[_t64],
                  _s15 = {};
              _s15.attribute = _e57, _e57.data && (_s15.data = _e57.data), n[_t64] = _s15, r++;
            }

            c.attributes = n, c.attributesNum = r, c.index = e;
          }(y, x);
        } else {
          var _t65 = !0 === l.wireframe;

          c.geometry === y.id && c.program === u.id && c.wireframe === _t65 || (c.geometry = y.id, c.program = u.id, c.wireframe = _t65, _ = !0);
        }

        !0 === r.isInstancedMesh && (_ = !0), null !== x && n.update(x, 34963), _ && (!function (r, s, a, o) {
          if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
          p();
          var l = o.attributes,
              c = a.getAttributes(),
              h = s.defaultAttributeValues;

          for (var _e58 in c) {
            var _i59 = c[_e58];

            if (_i59.location >= 0) {
              var _s16 = l[_e58];

              if (void 0 === _s16 && ("instanceMatrix" === _e58 && r.instanceMatrix && (_s16 = r.instanceMatrix), "instanceColor" === _e58 && r.instanceColor && (_s16 = r.instanceColor)), void 0 !== _s16) {
                var _e59 = _s16.normalized,
                    _a13 = _s16.itemSize,
                    _l12 = n.get(_s16);

                if (void 0 === _l12) continue;
                var _c8 = _l12.buffer,
                    _h7 = _l12.type,
                    _u7 = _l12.bytesPerElement;

                if (_s16.isInterleavedBufferAttribute) {
                  var _n82 = _s16.data,
                      _l13 = _n82.stride,
                      _d6 = _s16.offset;

                  if (_n82.isInstancedInterleavedBuffer) {
                    for (var _t66 = 0; _t66 < _i59.locationSize; _t66++) {
                      f(_i59.location + _t66, _n82.meshPerAttribute);
                    }

                    !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = _n82.meshPerAttribute * _n82.count);
                  } else for (var _t67 = 0; _t67 < _i59.locationSize; _t67++) {
                    m(_i59.location + _t67);
                  }

                  t.bindBuffer(34962, _c8);

                  for (var _t68 = 0; _t68 < _i59.locationSize; _t68++) {
                    v(_i59.location + _t68, _a13 / _i59.locationSize, _h7, _e59, _l13 * _u7, (_d6 + _a13 / _i59.locationSize * _t68) * _u7);
                  }
                } else {
                  if (_s16.isInstancedBufferAttribute) {
                    for (var _t69 = 0; _t69 < _i59.locationSize; _t69++) {
                      f(_i59.location + _t69, _s16.meshPerAttribute);
                    }

                    !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = _s16.meshPerAttribute * _s16.count);
                  } else for (var _t70 = 0; _t70 < _i59.locationSize; _t70++) {
                    m(_i59.location + _t70);
                  }

                  t.bindBuffer(34962, _c8);

                  for (var _t71 = 0; _t71 < _i59.locationSize; _t71++) {
                    v(_i59.location + _t71, _a13 / _i59.locationSize, _h7, _e59, _a13 * _u7, _a13 / _i59.locationSize * _t71 * _u7);
                  }
                }
              } else if (void 0 !== h) {
                var _n83 = h[_e58];
                if (void 0 !== _n83) switch (_n83.length) {
                  case 2:
                    t.vertexAttrib2fv(_i59.location, _n83);
                    break;

                  case 3:
                    t.vertexAttrib3fv(_i59.location, _n83);
                    break;

                  case 4:
                    t.vertexAttrib4fv(_i59.location, _n83);
                    break;

                  default:
                    t.vertexAttrib1fv(_i59.location, _n83);
                }
              }
            }
          }

          g();
        }(r, l, u, y), null !== x && t.bindBuffer(34963, n.get(x).buffer));
      },
      reset: y,
      resetDefaultState: x,
      dispose: function dispose() {
        y();

        for (var _t72 in o) {
          var _e60 = o[_t72];

          for (var _t73 in _e60) {
            var _n84 = _e60[_t73];

            for (var _t74 in _n84) {
              u(_n84[_t74].object), delete _n84[_t74];
            }

            delete _e60[_t73];
          }

          delete o[_t72];
        }
      },
      releaseStatesOfGeometry: function releaseStatesOfGeometry(t) {
        if (void 0 === o[t.id]) return;
        var e = o[t.id];

        for (var _t75 in e) {
          var _n85 = e[_t75];

          for (var _t76 in _n85) {
            u(_n85[_t76].object), delete _n85[_t76];
          }

          delete e[_t75];
        }

        delete o[t.id];
      },
      releaseStatesOfProgram: function releaseStatesOfProgram(t) {
        for (var _e61 in o) {
          var _n86 = o[_e61];
          if (void 0 === _n86[t.id]) continue;
          var _i60 = _n86[t.id];

          for (var _t77 in _i60) {
            u(_i60[_t77].object), delete _i60[_t77];
          }

          delete _n86[t.id];
        }
      },
      initAttributes: p,
      enableAttribute: m,
      disableUnusedAttributes: g
    };
  }

  function Li(t, e, n, i) {
    var r = i.isWebGL2;
    var s;
    this.setMode = function (t) {
      s = t;
    }, this.render = function (e, i) {
      t.drawArrays(s, e, i), n.update(i, s, 1);
    }, this.renderInstances = function (i, a, o) {
      if (0 === o) return;
      var l, c;
      if (r) l = t, c = "drawArraysInstanced";else if (l = e.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      l[c](s, i, a, o), n.update(a, s, o);
    };
  }

  function Pi(t, e, n) {
    var i;

    function r(e) {
      if ("highp" === e) {
        if (t.getShaderPrecisionFormat(35633, 36338).precision > 0 && t.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
        e = "mediump";
      }

      return "mediump" === e && t.getShaderPrecisionFormat(35633, 36337).precision > 0 && t.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
    }

    var s = "undefined" != typeof WebGL2RenderingContext && t instanceof WebGL2RenderingContext || "undefined" != typeof WebGL2ComputeRenderingContext && t instanceof WebGL2ComputeRenderingContext;
    var a = void 0 !== n.precision ? n.precision : "highp";
    var o = r(a);
    o !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", o, "instead."), a = o);
    var l = s || e.has("WEBGL_draw_buffers"),
        c = !0 === n.logarithmicDepthBuffer,
        h = t.getParameter(34930),
        u = t.getParameter(35660),
        d = t.getParameter(3379),
        p = t.getParameter(34076),
        m = t.getParameter(34921),
        f = t.getParameter(36347),
        g = t.getParameter(36348),
        v = t.getParameter(36349),
        y = u > 0,
        x = s || e.has("OES_texture_float");
    return {
      isWebGL2: s,
      drawBuffers: l,
      getMaxAnisotropy: function getMaxAnisotropy() {
        if (void 0 !== i) return i;

        if (!0 === e.has("EXT_texture_filter_anisotropic")) {
          var _n87 = e.get("EXT_texture_filter_anisotropic");

          i = t.getParameter(_n87.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else i = 0;

        return i;
      },
      getMaxPrecision: r,
      precision: a,
      logarithmicDepthBuffer: c,
      maxTextures: h,
      maxVertexTextures: u,
      maxTextureSize: d,
      maxCubemapSize: p,
      maxAttributes: m,
      maxVertexUniforms: f,
      maxVaryings: g,
      maxFragmentUniforms: v,
      vertexTextures: y,
      floatFragmentTextures: x,
      floatVertexTextures: y && x,
      maxSamples: s ? t.getParameter(36183) : 0
    };
  }

  function Di(t) {
    var e = this;
    var n = null,
        i = 0,
        r = !1,
        s = !1;
    var a = new yi(),
        o = new Rt(),
        l = {
      value: null,
      needsUpdate: !1
    };

    function c() {
      l.value !== n && (l.value = n, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0;
    }

    function h(t, n, i, r) {
      var s = null !== t ? t.length : 0;
      var c = null;

      if (0 !== s) {
        if (c = l.value, !0 !== r || null === c) {
          var _e62 = i + 4 * s,
              _r46 = n.matrixWorldInverse;

          o.getNormalMatrix(_r46), (null === c || c.length < _e62) && (c = new Float32Array(_e62));

          for (var _e63 = 0, _n88 = i; _e63 !== s; ++_e63, _n88 += 4) {
            a.copy(t[_e63]).applyMatrix4(_r46, o), a.normal.toArray(c, _n88), c[_n88 + 3] = a.constant;
          }
        }

        l.value = c, l.needsUpdate = !0;
      }

      return e.numPlanes = s, e.numIntersection = 0, c;
    }

    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function (t, e, s) {
      var a = 0 !== t.length || e || 0 !== i || r;
      return r = e, n = h(t, s, 0), i = t.length, a;
    }, this.beginShadows = function () {
      s = !0, h(null);
    }, this.endShadows = function () {
      s = !1, c();
    }, this.setState = function (e, a, o) {
      var u = e.clippingPlanes,
          d = e.clipIntersection,
          p = e.clipShadows,
          m = t.get(e);
      if (!r || null === u || 0 === u.length || s && !p) s ? h(null) : c();else {
        var _t78 = s ? 0 : i,
            _e64 = 4 * _t78;

        var _r47 = m.clippingState || null;

        l.value = _r47, _r47 = h(u, a, _e64, o);

        for (var _t79 = 0; _t79 !== _e64; ++_t79) {
          _r47[_t79] = n[_t79];
        }

        m.clippingState = _r47, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += _t78;
      }
    };
  }

  function Ii(t) {
    var e = new WeakMap();

    function n(t, e) {
      return e === a ? t.mapping = r : e === o && (t.mapping = s), t;
    }

    function i(t) {
      var n = t.target;
      n.removeEventListener("dispose", i);
      var r = e.get(n);
      void 0 !== r && (e.delete(n), r.dispose());
    }

    return {
      get: function get(r) {
        if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
          var _s17 = r.mapping;

          if (_s17 === a || _s17 === o) {
            if (e.has(r)) {
              return n(e.get(r).texture, r.mapping);
            }

            {
              var _s18 = r.image;

              if (_s18 && _s18.height > 0) {
                var _a14 = new mi(_s18.height / 2);

                return _a14.fromEquirectangularTexture(t, r), e.set(r, _a14), r.addEventListener("dispose", i), n(_a14.texture, r.mapping);
              }

              return null;
            }
          }
        }

        return r;
      },
      dispose: function dispose() {
        e = new WeakMap();
      }
    };
  }

  Ai.physical = {
    uniforms: ai([Ai.standard.uniforms, {
      clearcoat: {
        value: 0
      },
      clearcoatMap: {
        value: null
      },
      clearcoatRoughness: {
        value: 0
      },
      clearcoatRoughnessMap: {
        value: null
      },
      clearcoatNormalScale: {
        value: new At(1, 1)
      },
      clearcoatNormalMap: {
        value: null
      },
      sheen: {
        value: 0
      },
      sheenColor: {
        value: new Ft(0)
      },
      sheenColorMap: {
        value: null
      },
      sheenRoughness: {
        value: 1
      },
      sheenRoughnessMap: {
        value: null
      },
      transmission: {
        value: 0
      },
      transmissionMap: {
        value: null
      },
      transmissionSamplerSize: {
        value: new At()
      },
      transmissionSamplerMap: {
        value: null
      },
      thickness: {
        value: 0
      },
      thicknessMap: {
        value: null
      },
      attenuationDistance: {
        value: 0
      },
      attenuationColor: {
        value: new Ft(0)
      },
      specularIntensity: {
        value: 1
      },
      specularIntensityMap: {
        value: null
      },
      specularColor: {
        value: new Ft(1, 1, 1)
      },
      specularColorMap: {
        value: null
      }
    }]),
    vertexShader: Ti.meshphysical_vert,
    fragmentShader: Ti.meshphysical_frag
  };

  var Ni = /*#__PURE__*/function (_ci2) {
    _inherits(Ni, _ci2);

    var _super31 = _createSuper(Ni);

    function Ni() {
      var _this21;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : .1;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2e3;

      _classCallCheck(this, Ni);

      _this21 = _super31.call(this), _this21.type = "OrthographicCamera", _this21.zoom = 1, _this21.view = null, _this21.left = t, _this21.right = e, _this21.top = n, _this21.bottom = i, _this21.near = r, _this21.far = s, _this21.updateProjectionMatrix();
      return _this21;
    }

    _createClass(Ni, [{
      key: "copy",
      value: function copy(t, e) {
        return _get(_getPrototypeOf(Ni.prototype), "copy", this).call(this, t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = null === t.view ? null : Object.assign({}, t.view), this;
      }
    }, {
      key: "setViewOffset",
      value: function setViewOffset(t, e, n, i, r, s) {
        null === this.view && (this.view = {
          enabled: !0,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
      }
    }, {
      key: "clearViewOffset",
      value: function clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
      }
    }, {
      key: "updateProjectionMatrix",
      value: function updateProjectionMatrix() {
        var t = (this.right - this.left) / (2 * this.zoom),
            e = (this.top - this.bottom) / (2 * this.zoom),
            n = (this.right + this.left) / 2,
            i = (this.top + this.bottom) / 2;
        var r = n - t,
            s = n + t,
            a = i + e,
            o = i - e;

        if (null !== this.view && this.view.enabled) {
          var _t80 = (this.right - this.left) / this.view.fullWidth / this.zoom,
              _e65 = (this.top - this.bottom) / this.view.fullHeight / this.zoom;

          r += _t80 * this.view.offsetX, s = r + _t80 * this.view.width, a -= _e65 * this.view.offsetY, o = a - _e65 * this.view.height;
        }

        this.projectionMatrix.makeOrthographic(r, s, a, o, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(Ni.prototype), "toJSON", this).call(this, t);

        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
      }
    }]);

    return Ni;
  }(ci);

  Ni.prototype.isOrthographicCamera = !0;
  var Bi = [.125, .215, .35, .446, .526, .582],
      zi = 20,
      Oi = new Ni(),
      Ui = new Ft();
  var Fi = null;
  var Hi = (1 + Math.sqrt(5)) / 2,
      Gi = 1 / Hi,
      Vi = [new te(1, 1, 1), new te(-1, 1, 1), new te(1, 1, -1), new te(-1, 1, -1), new te(0, Hi, Gi), new te(0, Hi, -Gi), new te(Gi, 0, Hi), new te(-Gi, 0, Hi), new te(Hi, Gi, 0), new te(-Hi, Gi, 0)];

  var ki = /*#__PURE__*/function () {
    function ki(t) {
      _classCallCheck(this, ki);

      this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }

    _createClass(ki, [{
      key: "fromScene",
      value: function fromScene(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
        Fi = this._renderer.getRenderTarget(), this._setSize(256);

        var r = this._allocateTargets();

        return r.depthBuffer = !0, this._sceneToCubeUV(t, n, i, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
      }
    }, {
      key: "fromEquirectangular",
      value: function fromEquirectangular(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return this._fromTexture(t, e);
      }
    }, {
      key: "fromCubemap",
      value: function fromCubemap(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return this._fromTexture(t, e);
      }
    }, {
      key: "compileCubemapShader",
      value: function compileCubemapShader() {
        null === this._cubemapMaterial && (this._cubemapMaterial = Xi(), this._compileMaterial(this._cubemapMaterial));
      }
    }, {
      key: "compileEquirectangularShader",
      value: function compileEquirectangularShader() {
        null === this._equirectMaterial && (this._equirectMaterial = qi(), this._compileMaterial(this._equirectMaterial));
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
      }
    }, {
      key: "_setSize",
      value: function _setSize(t) {
        this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
      }
    }, {
      key: "_dispose",
      value: function _dispose() {
        this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();

        for (var _t81 = 0; _t81 < this._lodPlanes.length; _t81++) {
          this._lodPlanes[_t81].dispose();
        }
      }
    }, {
      key: "_cleanup",
      value: function _cleanup(t) {
        this._renderer.setRenderTarget(Fi), t.scissorTest = !1, ji(t, 0, 0, t.width, t.height);
      }
    }, {
      key: "_fromTexture",
      value: function _fromTexture(t, e) {
        t.mapping === r || t.mapping === s ? this._setSize(0 === t.image.length ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), Fi = this._renderer.getRenderTarget();

        var n = e || this._allocateTargets();

        return this._textureToCubeUV(t, n), this._applyPMREM(n), this._cleanup(n), n;
      }
    }, {
      key: "_allocateTargets",
      value: function _allocateTargets() {
        var t = 3 * Math.max(this._cubeSize, 112),
            e = 4 * this._cubeSize - 32,
            n = {
          magFilter: g,
          minFilter: g,
          generateMipmaps: !1,
          type: w,
          format: T,
          encoding: ot,
          depthBuffer: !1
        },
            i = Wi(t, e, n);

        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t) {
          var _ref;

          null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = Wi(t, e, n);
          var _i61 = this._lodMax;
          (_ref = function (t) {
            var e = [],
                n = [],
                i = [];
            var r = t;
            var s = t - 4 + 1 + Bi.length;

            for (var _a15 = 0; _a15 < s; _a15++) {
              var _s19 = Math.pow(2, r);

              n.push(_s19);

              var _o11 = 1 / _s19;

              _a15 > t - 4 ? _o11 = Bi[_a15 - t + 4 - 1] : 0 === _a15 && (_o11 = 0), i.push(_o11);

              var _l14 = 1 / (_s19 - 1),
                  _c9 = -_l14 / 2,
                  _h8 = 1 + _l14 / 2,
                  _u8 = [_c9, _c9, _h8, _c9, _h8, _h8, _c9, _c9, _h8, _h8, _c9, _h8],
                  _d7 = 6,
                  _p6 = 6,
                  _m3 = 3,
                  _f = 2,
                  _g = 1,
                  _v2 = new Float32Array(_m3 * _p6 * _d7),
                  _y2 = new Float32Array(_f * _p6 * _d7),
                  _x2 = new Float32Array(_g * _p6 * _d7);

              for (var _t82 = 0; _t82 < _d7; _t82++) {
                var _e66 = _t82 % 3 * 2 / 3 - 1,
                    _n89 = _t82 > 2 ? 0 : -1,
                    _i62 = [_e66, _n89, 0, _e66 + 2 / 3, _n89, 0, _e66 + 2 / 3, _n89 + 1, 0, _e66, _n89, 0, _e66 + 2 / 3, _n89 + 1, 0, _e66, _n89 + 1, 0];

                _v2.set(_i62, _m3 * _p6 * _t82), _y2.set(_u8, _f * _p6 * _t82);
                var _r48 = [_t82, _t82, _t82, _t82, _t82, _t82];

                _x2.set(_r48, _g * _p6 * _t82);
              }

              var _3 = new Un();

              _3.setAttribute("position", new _n(_v2, _m3)), _3.setAttribute("uv", new _n(_y2, _f)), _3.setAttribute("faceIndex", new _n(_x2, _g)), e.push(_3), r > 4 && r--;
            }

            return {
              lodPlanes: e,
              sizeLods: n,
              sigmas: i
            };
          }(_i61), this._sizeLods = _ref.sizeLods, this._lodPlanes = _ref.lodPlanes, this._sigmas = _ref.sigmas, _ref), this._blurMaterial = function (t, e, n) {
            var i = new Float32Array(zi),
                r = new te(0, 1, 0);
            return new li({
              name: "SphericalGaussianBlur",
              defines: {
                n: zi,
                CUBEUV_TEXEL_WIDTH: 1 / e,
                CUBEUV_TEXEL_HEIGHT: 1 / n,
                CUBEUV_MAX_MIP: "".concat(t, ".0")
              },
              uniforms: {
                envMap: {
                  value: null
                },
                samples: {
                  value: 1
                },
                weights: {
                  value: i
                },
                latitudinal: {
                  value: !1
                },
                dTheta: {
                  value: 0
                },
                mipInt: {
                  value: 0
                },
                poleAxis: {
                  value: r
                }
              },
              vertexShader: Ji(),
              fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
              blending: 0,
              depthTest: !1,
              depthWrite: !1
            });
          }(_i61, t, e);
        }

        return i;
      }
    }, {
      key: "_compileMaterial",
      value: function _compileMaterial(t) {
        var e = new ni(this._lodPlanes[0], t);

        this._renderer.compile(e, Oi);
      }
    }, {
      key: "_sceneToCubeUV",
      value: function _sceneToCubeUV(t, e, n, i) {
        var r = new hi(90, 1, e, n),
            s = [1, -1, 1, 1, 1, 1],
            a = [1, 1, 1, -1, -1, -1],
            o = this._renderer,
            l = o.autoClear,
            c = o.toneMapping;
        o.getClearColor(Ui), o.toneMapping = 0, o.autoClear = !1;
        var h = new vn({
          name: "PMREM.Background",
          side: 1,
          depthWrite: !1,
          depthTest: !1
        }),
            u = new ni(new ri(), h);
        var d = !1;
        var p = t.background;
        p ? p.isColor && (h.color.copy(p), t.background = null, d = !0) : (h.color.copy(Ui), d = !0);

        for (var _e67 = 0; _e67 < 6; _e67++) {
          var _n90 = _e67 % 3;

          0 === _n90 ? (r.up.set(0, s[_e67], 0), r.lookAt(a[_e67], 0, 0)) : 1 === _n90 ? (r.up.set(0, 0, s[_e67]), r.lookAt(0, a[_e67], 0)) : (r.up.set(0, s[_e67], 0), r.lookAt(0, 0, a[_e67]));
          var _l15 = this._cubeSize;
          ji(i, _n90 * _l15, _e67 > 2 ? _l15 : 0, _l15, _l15), o.setRenderTarget(i), d && o.render(u, r), o.render(t, r);
        }

        u.geometry.dispose(), u.material.dispose(), o.toneMapping = c, o.autoClear = l, t.background = p;
      }
    }, {
      key: "_textureToCubeUV",
      value: function _textureToCubeUV(t, e) {
        var n = this._renderer,
            i = t.mapping === r || t.mapping === s;
        i ? (null === this._cubemapMaterial && (this._cubemapMaterial = Xi()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = qi());
        var a = i ? this._cubemapMaterial : this._equirectMaterial,
            o = new ni(this._lodPlanes[0], a);
        a.uniforms.envMap.value = t;
        var l = this._cubeSize;
        ji(e, 0, 0, 3 * l, 2 * l), n.setRenderTarget(e), n.render(o, Oi);
      }
    }, {
      key: "_applyPMREM",
      value: function _applyPMREM(t) {
        var e = this._renderer,
            n = e.autoClear;
        e.autoClear = !1;

        for (var _e68 = 1; _e68 < this._lodPlanes.length; _e68++) {
          var _n91 = Math.sqrt(this._sigmas[_e68] * this._sigmas[_e68] - this._sigmas[_e68 - 1] * this._sigmas[_e68 - 1]),
              _i63 = Vi[(_e68 - 1) % Vi.length];

          this._blur(t, _e68 - 1, _e68, _n91, _i63);
        }

        e.autoClear = n;
      }
    }, {
      key: "_blur",
      value: function _blur(t, e, n, i, r) {
        var s = this._pingPongRenderTarget;
        this._halfBlur(t, s, e, n, i, "latitudinal", r), this._halfBlur(s, t, n, n, i, "longitudinal", r);
      }
    }, {
      key: "_halfBlur",
      value: function _halfBlur(t, e, n, i, r, s, a) {
        var o = this._renderer,
            l = this._blurMaterial;
        "latitudinal" !== s && "longitudinal" !== s && console.error("blur direction must be either latitudinal or longitudinal!");
        var c = new ni(this._lodPlanes[i], l),
            h = l.uniforms,
            u = this._sizeLods[n] - 1,
            d = isFinite(r) ? Math.PI / (2 * u) : 2 * Math.PI / 39,
            p = r / d,
            m = isFinite(r) ? 1 + Math.floor(3 * p) : zi;
        m > zi && console.warn("sigmaRadians, ".concat(r, ", is too large and will clip, as it requested ").concat(m, " samples when the maximum is set to 20"));
        var f = [];
        var g = 0;

        for (var _t83 = 0; _t83 < zi; ++_t83) {
          var _e69 = _t83 / p,
              _n92 = Math.exp(-_e69 * _e69 / 2);

          f.push(_n92), 0 === _t83 ? g += _n92 : _t83 < m && (g += 2 * _n92);
        }

        for (var _t84 = 0; _t84 < f.length; _t84++) {
          f[_t84] = f[_t84] / g;
        }

        h.envMap.value = t.texture, h.samples.value = m, h.weights.value = f, h.latitudinal.value = "latitudinal" === s, a && (h.poleAxis.value = a);
        var v = this._lodMax;
        h.dTheta.value = d, h.mipInt.value = v - n;
        var y = this._sizeLods[i];
        ji(e, 3 * y * (i > v - 4 ? i - v + 4 : 0), 4 * (this._cubeSize - y), 3 * y, 2 * y), o.setRenderTarget(e), o.render(c, Oi);
      }
    }]);

    return ki;
  }();

  function Wi(t, e, n) {
    var i = new Xt(t, e, n);
    return i.texture.mapping = l, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
  }

  function ji(t, e, n, i, r) {
    t.viewport.set(e, n, i, r), t.scissor.set(e, n, i, r);
  }

  function qi() {
    return new li({
      name: "EquirectangularToCubeUV",
      uniforms: {
        envMap: {
          value: null
        }
      },
      vertexShader: Ji(),
      fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
      blending: 0,
      depthTest: !1,
      depthWrite: !1
    });
  }

  function Xi() {
    return new li({
      name: "CubemapToCubeUV",
      uniforms: {
        envMap: {
          value: null
        },
        flipEnvMap: {
          value: -1
        }
      },
      vertexShader: Ji(),
      fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
      blending: 0,
      depthTest: !1,
      depthWrite: !1
    });
  }

  function Ji() {
    return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
  }

  function Yi(t) {
    var e = new WeakMap(),
        n = null;

    function i(t) {
      var n = t.target;
      n.removeEventListener("dispose", i);
      var r = e.get(n);
      void 0 !== r && (e.delete(n), r.dispose());
    }

    return {
      get: function get(l) {
        if (l && l.isTexture) {
          var _c10 = l.mapping,
              _h9 = _c10 === a || _c10 === o,
              _u9 = _c10 === r || _c10 === s;

          if (_h9 || _u9) {
            if (l.isRenderTargetTexture && !0 === l.needsPMREMUpdate) {
              l.needsPMREMUpdate = !1;

              var _i64 = e.get(l);

              return null === n && (n = new ki(t)), _i64 = _h9 ? n.fromEquirectangular(l, _i64) : n.fromCubemap(l, _i64), e.set(l, _i64), _i64.texture;
            }

            if (e.has(l)) return e.get(l).texture;
            {
              var _r49 = l.image;

              if (_h9 && _r49 && _r49.height > 0 || _u9 && _r49 && function (t) {
                var e = 0;
                var n = 6;

                for (var _i65 = 0; _i65 < n; _i65++) {
                  void 0 !== t[_i65] && e++;
                }

                return e === n;
              }(_r49)) {
                null === n && (n = new ki(t));

                var _r50 = _h9 ? n.fromEquirectangular(l) : n.fromCubemap(l);

                return e.set(l, _r50), l.addEventListener("dispose", i), _r50.texture;
              }

              return null;
            }
          }
        }

        return l;
      },
      dispose: function dispose() {
        e = new WeakMap(), null !== n && (n.dispose(), n = null);
      }
    };
  }

  function Zi(t) {
    var e = {};

    function n(n) {
      if (void 0 !== e[n]) return e[n];
      var i;

      switch (n) {
        case "WEBGL_depth_texture":
          i = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");
          break;

        case "EXT_texture_filter_anisotropic":
          i = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
          break;

        case "WEBGL_compressed_texture_s3tc":
          i = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
          break;

        case "WEBGL_compressed_texture_pvrtc":
          i = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
          break;

        default:
          i = t.getExtension(n);
      }

      return e[n] = i, i;
    }

    return {
      has: function has(t) {
        return null !== n(t);
      },
      init: function init(t) {
        t.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
      },
      get: function get(t) {
        var e = n(t);
        return null === e && console.warn("THREE.WebGLRenderer: " + t + " extension not supported."), e;
      }
    };
  }

  function Ki(t, e, n, i) {
    var r = {},
        s = new WeakMap();

    function a(t) {
      var o = t.target;
      null !== o.index && e.remove(o.index);

      for (var _t85 in o.attributes) {
        e.remove(o.attributes[_t85]);
      }

      o.removeEventListener("dispose", a), delete r[o.id];
      var l = s.get(o);
      l && (e.remove(l), s.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
    }

    function o(t) {
      var n = [],
          i = t.index,
          r = t.attributes.position;
      var a = 0;

      if (null !== i) {
        var _t86 = i.array;
        a = i.version;

        for (var _e70 = 0, _i66 = _t86.length; _e70 < _i66; _e70 += 3) {
          var _i67 = _t86[_e70 + 0],
              _r51 = _t86[_e70 + 1],
              _s20 = _t86[_e70 + 2];
          n.push(_i67, _r51, _r51, _s20, _s20, _i67);
        }
      } else {
        var _t87 = r.array;
        a = r.version;

        for (var _e71 = 0, _i68 = _t87.length / 3 - 1; _e71 < _i68; _e71 += 3) {
          var _t88 = _e71 + 0,
              _i69 = _e71 + 1,
              _r52 = _e71 + 2;

          n.push(_t88, _i69, _i69, _r52, _r52, _t88);
        }
      }

      var o = new (Ct(n) ? An : Tn)(n, 1);
      o.version = a;
      var l = s.get(t);
      l && e.remove(l), s.set(t, o);
    }

    return {
      get: function get(t, e) {
        return !0 === r[e.id] || (e.addEventListener("dispose", a), r[e.id] = !0, n.memory.geometries++), e;
      },
      update: function update(t) {
        var n = t.attributes;

        for (var _t89 in n) {
          e.update(n[_t89], 34962);
        }

        var i = t.morphAttributes;

        for (var _t90 in i) {
          var _n93 = i[_t90];

          for (var _t91 = 0, _i70 = _n93.length; _t91 < _i70; _t91++) {
            e.update(_n93[_t91], 34962);
          }
        }
      },
      getWireframeAttribute: function getWireframeAttribute(t) {
        var e = s.get(t);

        if (e) {
          var _n94 = t.index;
          null !== _n94 && e.version < _n94.version && o(t);
        } else o(t);

        return s.get(t);
      }
    };
  }

  function Qi(t, e, n, i) {
    var r = i.isWebGL2;
    var s, a, o;
    this.setMode = function (t) {
      s = t;
    }, this.setIndex = function (t) {
      a = t.type, o = t.bytesPerElement;
    }, this.render = function (e, i) {
      t.drawElements(s, i, a, e * o), n.update(i, s, 1);
    }, this.renderInstances = function (i, l, c) {
      if (0 === c) return;
      var h, u;
      if (r) h = t, u = "drawElementsInstanced";else if (h = e.get("ANGLE_instanced_arrays"), u = "drawElementsInstancedANGLE", null === h) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      h[u](s, l, a, i * o, c), n.update(l, s, c);
    };
  }

  function $i(t) {
    var e = {
      frame: 0,
      calls: 0,
      triangles: 0,
      points: 0,
      lines: 0
    };
    return {
      memory: {
        geometries: 0,
        textures: 0
      },
      render: e,
      programs: null,
      autoReset: !0,
      reset: function reset() {
        e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
      },
      update: function update(t, n, i) {
        switch (e.calls++, n) {
          case 4:
            e.triangles += i * (t / 3);
            break;

          case 1:
            e.lines += i * (t / 2);
            break;

          case 3:
            e.lines += i * (t - 1);
            break;

          case 2:
            e.lines += i * t;
            break;

          case 0:
            e.points += i * t;
            break;

          default:
            console.error("THREE.WebGLInfo: Unknown draw mode:", n);
        }
      }
    };
  }

  function tr(t, e) {
    return t[0] - e[0];
  }

  function er(t, e) {
    return Math.abs(e[1]) - Math.abs(t[1]);
  }

  function nr(t, e) {
    var n = 1;
    var i = e.isInterleavedBufferAttribute ? e.data.array : e.array;
    i instanceof Int8Array ? n = 127 : i instanceof Int16Array ? n = 32767 : i instanceof Int32Array ? n = 2147483647 : console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", i), t.divideScalar(n);
  }

  function ir(t, e, n) {
    var i = {},
        r = new Float32Array(8),
        s = new WeakMap(),
        a = new qt(),
        o = [];

    for (var _t92 = 0; _t92 < 8; _t92++) {
      o[_t92] = [_t92, 0];
    }

    return {
      update: function update(l, c, h, u) {
        var d = l.morphTargetInfluences;

        if (!0 === e.isWebGL2) {
          var _i71 = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color,
              _r53 = void 0 !== _i71 ? _i71.length : 0;

          var _o12 = s.get(c);

          if (void 0 === _o12 || _o12.count !== _r53) {
            void 0 !== _o12 && _o12.texture.dispose();

            var _t93 = void 0 !== c.morphAttributes.position,
                _n95 = void 0 !== c.morphAttributes.normal,
                _i72 = void 0 !== c.morphAttributes.color,
                _l17 = c.morphAttributes.position || [],
                _h11 = c.morphAttributes.normal || [],
                _u10 = c.morphAttributes.color || [];

            var _d8 = 0;
            !0 === _t93 && (_d8 = 1), !0 === _n95 && (_d8 = 2), !0 === _i72 && (_d8 = 3);

            var _p7 = c.attributes.position.count * _d8,
                _m4 = 1;

            _p7 > e.maxTextureSize && (_m4 = Math.ceil(_p7 / e.maxTextureSize), _p7 = e.maxTextureSize);

            var _f2 = new Float32Array(_p7 * _m4 * 4 * _r53),
                _g2 = new Jt(_f2, _p7, _m4, _r53);

            _g2.format = T, _g2.type = b, _g2.needsUpdate = !0;

            var _v3 = 4 * _d8;

            for (var _e72 = 0; _e72 < _r53; _e72++) {
              var _r54 = _l17[_e72],
                  _s21 = _h11[_e72],
                  _o13 = _u10[_e72],
                  _c11 = _p7 * _m4 * 4 * _e72;

              for (var _e73 = 0; _e73 < _r54.count; _e73++) {
                var _l18 = _e73 * _v3;

                !0 === _t93 && (a.fromBufferAttribute(_r54, _e73), !0 === _r54.normalized && nr(a, _r54), _f2[_c11 + _l18 + 0] = a.x, _f2[_c11 + _l18 + 1] = a.y, _f2[_c11 + _l18 + 2] = a.z, _f2[_c11 + _l18 + 3] = 0), !0 === _n95 && (a.fromBufferAttribute(_s21, _e73), !0 === _s21.normalized && nr(a, _s21), _f2[_c11 + _l18 + 4] = a.x, _f2[_c11 + _l18 + 5] = a.y, _f2[_c11 + _l18 + 6] = a.z, _f2[_c11 + _l18 + 7] = 0), !0 === _i72 && (a.fromBufferAttribute(_o13, _e73), !0 === _o13.normalized && nr(a, _s21), _f2[_c11 + _l18 + 8] = a.x, _f2[_c11 + _l18 + 9] = a.y, _f2[_c11 + _l18 + 10] = a.z, _f2[_c11 + _l18 + 11] = 4 === _o13.itemSize ? a.w : 1);
              }
            }

            function _y3() {
              _g2.dispose(), s.delete(c), c.removeEventListener("dispose", _y3);
            }

            _o12 = {
              count: _r53,
              texture: _g2,
              size: new At(_p7, _m4)
            }, s.set(c, _o12), c.addEventListener("dispose", _y3);
          }

          var _l16 = 0;

          for (var _t94 = 0; _t94 < d.length; _t94++) {
            _l16 += d[_t94];
          }

          var _h10 = c.morphTargetsRelative ? 1 : 1 - _l16;

          u.getUniforms().setValue(t, "morphTargetBaseInfluence", _h10), u.getUniforms().setValue(t, "morphTargetInfluences", d), u.getUniforms().setValue(t, "morphTargetsTexture", _o12.texture, n), u.getUniforms().setValue(t, "morphTargetsTextureSize", _o12.size);
        } else {
          var _e74 = void 0 === d ? 0 : d.length;

          var _n96 = i[c.id];

          if (void 0 === _n96 || _n96.length !== _e74) {
            _n96 = [];

            for (var _t95 = 0; _t95 < _e74; _t95++) {
              _n96[_t95] = [_t95, 0];
            }

            i[c.id] = _n96;
          }

          for (var _t96 = 0; _t96 < _e74; _t96++) {
            var _e75 = _n96[_t96];
            _e75[0] = _t96, _e75[1] = d[_t96];
          }

          _n96.sort(er);

          for (var _t97 = 0; _t97 < 8; _t97++) {
            _t97 < _e74 && _n96[_t97][1] ? (o[_t97][0] = _n96[_t97][0], o[_t97][1] = _n96[_t97][1]) : (o[_t97][0] = Number.MAX_SAFE_INTEGER, o[_t97][1] = 0);
          }

          o.sort(tr);
          var _s22 = c.morphAttributes.position,
              _a16 = c.morphAttributes.normal;
          var _l19 = 0;

          for (var _t98 = 0; _t98 < 8; _t98++) {
            var _e76 = o[_t98],
                _n97 = _e76[0],
                _i73 = _e76[1];
            _n97 !== Number.MAX_SAFE_INTEGER && _i73 ? (_s22 && c.getAttribute("morphTarget" + _t98) !== _s22[_n97] && c.setAttribute("morphTarget" + _t98, _s22[_n97]), _a16 && c.getAttribute("morphNormal" + _t98) !== _a16[_n97] && c.setAttribute("morphNormal" + _t98, _a16[_n97]), r[_t98] = _i73, _l19 += _i73) : (_s22 && !0 === c.hasAttribute("morphTarget" + _t98) && c.deleteAttribute("morphTarget" + _t98), _a16 && !0 === c.hasAttribute("morphNormal" + _t98) && c.deleteAttribute("morphNormal" + _t98), r[_t98] = 0);
          }

          var _h12 = c.morphTargetsRelative ? 1 : 1 - _l19;

          u.getUniforms().setValue(t, "morphTargetBaseInfluence", _h12), u.getUniforms().setValue(t, "morphTargetInfluences", r);
        }
      }
    };
  }

  function rr(t, e, n, i) {
    var r = new WeakMap();

    function s(t) {
      var e = t.target;
      e.removeEventListener("dispose", s), n.remove(e.instanceMatrix), null !== e.instanceColor && n.remove(e.instanceColor);
    }

    return {
      update: function update(t) {
        var a = i.render.frame,
            o = t.geometry,
            l = e.get(t, o);
        return r.get(l) !== a && (e.update(l), r.set(l, a)), t.isInstancedMesh && (!1 === t.hasEventListener("dispose", s) && t.addEventListener("dispose", s), n.update(t.instanceMatrix, 34962), null !== t.instanceColor && n.update(t.instanceColor, 34962)), l;
      },
      dispose: function dispose() {
        r = new WeakMap();
      }
    };
  }

  var sr = new jt(),
      ar = new Jt(),
      or = new Zt(),
      lr = new pi(),
      cr = [],
      hr = [],
      ur = new Float32Array(16),
      dr = new Float32Array(9),
      pr = new Float32Array(4);

  function mr(t, e, n) {
    var i = t[0];
    if (i <= 0 || i > 0) return t;
    var r = e * n;
    var s = cr[r];

    if (void 0 === s && (s = new Float32Array(r), cr[r] = s), 0 !== e) {
      i.toArray(s, 0);

      for (var _i74 = 1, _r55 = 0; _i74 !== e; ++_i74) {
        _r55 += n, t[_i74].toArray(s, _r55);
      }
    }

    return s;
  }

  function fr(t, e) {
    if (t.length !== e.length) return !1;

    for (var _n98 = 0, _i75 = t.length; _n98 < _i75; _n98++) {
      if (t[_n98] !== e[_n98]) return !1;
    }

    return !0;
  }

  function gr(t, e) {
    for (var _n99 = 0, _i76 = e.length; _n99 < _i76; _n99++) {
      t[_n99] = e[_n99];
    }
  }

  function vr(t, e) {
    var n = hr[e];
    void 0 === n && (n = new Int32Array(e), hr[e] = n);

    for (var _i77 = 0; _i77 !== e; ++_i77) {
      n[_i77] = t.allocateTextureUnit();
    }

    return n;
  }

  function yr(t, e) {
    var n = this.cache;
    n[0] !== e && (t.uniform1f(this.addr, e), n[0] = e);
  }

  function xr(t, e) {
    var n = this.cache;
    if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);else {
      if (fr(n, e)) return;
      t.uniform2fv(this.addr, e), gr(n, e);
    }
  }

  function _r(t, e) {
    var n = this.cache;
    if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);else if (void 0 !== e.r) n[0] === e.r && n[1] === e.g && n[2] === e.b || (t.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);else {
      if (fr(n, e)) return;
      t.uniform3fv(this.addr, e), gr(n, e);
    }
  }

  function Mr(t, e) {
    var n = this.cache;
    if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);else {
      if (fr(n, e)) return;
      t.uniform4fv(this.addr, e), gr(n, e);
    }
  }

  function br(t, e) {
    var n = this.cache,
        i = e.elements;

    if (void 0 === i) {
      if (fr(n, e)) return;
      t.uniformMatrix2fv(this.addr, !1, e), gr(n, e);
    } else {
      if (fr(n, i)) return;
      pr.set(i), t.uniformMatrix2fv(this.addr, !1, pr), gr(n, i);
    }
  }

  function wr(t, e) {
    var n = this.cache,
        i = e.elements;

    if (void 0 === i) {
      if (fr(n, e)) return;
      t.uniformMatrix3fv(this.addr, !1, e), gr(n, e);
    } else {
      if (fr(n, i)) return;
      dr.set(i), t.uniformMatrix3fv(this.addr, !1, dr), gr(n, i);
    }
  }

  function Sr(t, e) {
    var n = this.cache,
        i = e.elements;

    if (void 0 === i) {
      if (fr(n, e)) return;
      t.uniformMatrix4fv(this.addr, !1, e), gr(n, e);
    } else {
      if (fr(n, i)) return;
      ur.set(i), t.uniformMatrix4fv(this.addr, !1, ur), gr(n, i);
    }
  }

  function Tr(t, e) {
    var n = this.cache;
    n[0] !== e && (t.uniform1i(this.addr, e), n[0] = e);
  }

  function Er(t, e) {
    var n = this.cache;
    fr(n, e) || (t.uniform2iv(this.addr, e), gr(n, e));
  }

  function Ar(t, e) {
    var n = this.cache;
    fr(n, e) || (t.uniform3iv(this.addr, e), gr(n, e));
  }

  function Rr(t, e) {
    var n = this.cache;
    fr(n, e) || (t.uniform4iv(this.addr, e), gr(n, e));
  }

  function Cr(t, e) {
    var n = this.cache;
    n[0] !== e && (t.uniform1ui(this.addr, e), n[0] = e);
  }

  function Lr(t, e) {
    var n = this.cache;
    fr(n, e) || (t.uniform2uiv(this.addr, e), gr(n, e));
  }

  function Pr(t, e) {
    var n = this.cache;
    fr(n, e) || (t.uniform3uiv(this.addr, e), gr(n, e));
  }

  function Dr(t, e) {
    var n = this.cache;
    fr(n, e) || (t.uniform4uiv(this.addr, e), gr(n, e));
  }

  function Ir(t, e, n) {
    var i = this.cache,
        r = n.allocateTextureUnit();
    i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(e || sr, r);
  }

  function Nr(t, e, n) {
    var i = this.cache,
        r = n.allocateTextureUnit();
    i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(e || or, r);
  }

  function Br(t, e, n) {
    var i = this.cache,
        r = n.allocateTextureUnit();
    i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(e || lr, r);
  }

  function zr(t, e, n) {
    var i = this.cache,
        r = n.allocateTextureUnit();
    i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(e || ar, r);
  }

  function Or(t, e) {
    t.uniform1fv(this.addr, e);
  }

  function Ur(t, e) {
    var n = mr(e, this.size, 2);
    t.uniform2fv(this.addr, n);
  }

  function Fr(t, e) {
    var n = mr(e, this.size, 3);
    t.uniform3fv(this.addr, n);
  }

  function Hr(t, e) {
    var n = mr(e, this.size, 4);
    t.uniform4fv(this.addr, n);
  }

  function Gr(t, e) {
    var n = mr(e, this.size, 4);
    t.uniformMatrix2fv(this.addr, !1, n);
  }

  function Vr(t, e) {
    var n = mr(e, this.size, 9);
    t.uniformMatrix3fv(this.addr, !1, n);
  }

  function kr(t, e) {
    var n = mr(e, this.size, 16);
    t.uniformMatrix4fv(this.addr, !1, n);
  }

  function Wr(t, e) {
    t.uniform1iv(this.addr, e);
  }

  function jr(t, e) {
    t.uniform2iv(this.addr, e);
  }

  function qr(t, e) {
    t.uniform3iv(this.addr, e);
  }

  function Xr(t, e) {
    t.uniform4iv(this.addr, e);
  }

  function Jr(t, e) {
    t.uniform1uiv(this.addr, e);
  }

  function Yr(t, e) {
    t.uniform2uiv(this.addr, e);
  }

  function Zr(t, e) {
    t.uniform3uiv(this.addr, e);
  }

  function Kr(t, e) {
    t.uniform4uiv(this.addr, e);
  }

  function Qr(t, e, n) {
    var i = e.length,
        r = vr(n, i);
    t.uniform1iv(this.addr, r);

    for (var _t99 = 0; _t99 !== i; ++_t99) {
      n.setTexture2D(e[_t99] || sr, r[_t99]);
    }
  }

  function $r(t, e, n) {
    var i = e.length,
        r = vr(n, i);
    t.uniform1iv(this.addr, r);

    for (var _t100 = 0; _t100 !== i; ++_t100) {
      n.setTexture3D(e[_t100] || or, r[_t100]);
    }
  }

  function ts(t, e, n) {
    var i = e.length,
        r = vr(n, i);
    t.uniform1iv(this.addr, r);

    for (var _t101 = 0; _t101 !== i; ++_t101) {
      n.setTextureCube(e[_t101] || lr, r[_t101]);
    }
  }

  function es(t, e, n) {
    var i = e.length,
        r = vr(n, i);
    t.uniform1iv(this.addr, r);

    for (var _t102 = 0; _t102 !== i; ++_t102) {
      n.setTexture2DArray(e[_t102] || ar, r[_t102]);
    }
  }

  function ns(t, e, n) {
    this.id = t, this.addr = n, this.cache = [], this.setValue = function (t) {
      switch (t) {
        case 5126:
          return yr;

        case 35664:
          return xr;

        case 35665:
          return _r;

        case 35666:
          return Mr;

        case 35674:
          return br;

        case 35675:
          return wr;

        case 35676:
          return Sr;

        case 5124:
        case 35670:
          return Tr;

        case 35667:
        case 35671:
          return Er;

        case 35668:
        case 35672:
          return Ar;

        case 35669:
        case 35673:
          return Rr;

        case 5125:
          return Cr;

        case 36294:
          return Lr;

        case 36295:
          return Pr;

        case 36296:
          return Dr;

        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
          return Ir;

        case 35679:
        case 36299:
        case 36307:
          return Nr;

        case 35680:
        case 36300:
        case 36308:
        case 36293:
          return Br;

        case 36289:
        case 36303:
        case 36311:
        case 36292:
          return zr;
      }
    }(e.type);
  }

  function is(t, e, n) {
    this.id = t, this.addr = n, this.cache = [], this.size = e.size, this.setValue = function (t) {
      switch (t) {
        case 5126:
          return Or;

        case 35664:
          return Ur;

        case 35665:
          return Fr;

        case 35666:
          return Hr;

        case 35674:
          return Gr;

        case 35675:
          return Vr;

        case 35676:
          return kr;

        case 5124:
        case 35670:
          return Wr;

        case 35667:
        case 35671:
          return jr;

        case 35668:
        case 35672:
          return qr;

        case 35669:
        case 35673:
          return Xr;

        case 5125:
          return Jr;

        case 36294:
          return Yr;

        case 36295:
          return Zr;

        case 36296:
          return Kr;

        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
          return Qr;

        case 35679:
        case 36299:
        case 36307:
          return $r;

        case 35680:
        case 36300:
        case 36308:
        case 36293:
          return ts;

        case 36289:
        case 36303:
        case 36311:
        case 36292:
          return es;
      }
    }(e.type);
  }

  function rs(t) {
    this.id = t, this.seq = [], this.map = {};
  }

  is.prototype.updateCache = function (t) {
    var e = this.cache;
    t instanceof Float32Array && e.length !== t.length && (this.cache = new Float32Array(t.length)), gr(e, t);
  }, rs.prototype.setValue = function (t, e, n) {
    var i = this.seq;

    for (var _r56 = 0, _s23 = i.length; _r56 !== _s23; ++_r56) {
      var _s24 = i[_r56];

      _s24.setValue(t, e[_s24.id], n);
    }
  };
  var ss = /(\w+)(\])?(\[|\.)?/g;

  function as(t, e) {
    t.seq.push(e), t.map[e.id] = e;
  }

  function os(t, e, n) {
    var i = t.name,
        r = i.length;

    for (ss.lastIndex = 0;;) {
      var _s25 = ss.exec(i),
          _a17 = ss.lastIndex;

      var _o14 = _s25[1];

      var _l20 = "]" === _s25[2],
          _c12 = _s25[3];

      if (_l20 && (_o14 |= 0), void 0 === _c12 || "[" === _c12 && _a17 + 2 === r) {
        as(n, void 0 === _c12 ? new ns(_o14, t, e) : new is(_o14, t, e));
        break;
      }

      {
        var _t103 = n.map[_o14];
        void 0 === _t103 && (_t103 = new rs(_o14), as(n, _t103)), n = _t103;
      }
    }
  }

  function ls(t, e) {
    this.seq = [], this.map = {};
    var n = t.getProgramParameter(e, 35718);

    for (var _i78 = 0; _i78 < n; ++_i78) {
      var _n100 = t.getActiveUniform(e, _i78);

      os(_n100, t.getUniformLocation(e, _n100.name), this);
    }
  }

  function cs(t, e, n) {
    var i = t.createShader(e);
    return t.shaderSource(i, n), t.compileShader(i), i;
  }

  ls.prototype.setValue = function (t, e, n, i) {
    var r = this.map[e];
    void 0 !== r && r.setValue(t, n, i);
  }, ls.prototype.setOptional = function (t, e, n) {
    var i = e[n];
    void 0 !== i && this.setValue(t, n, i);
  }, ls.upload = function (t, e, n, i) {
    for (var _r57 = 0, _s26 = e.length; _r57 !== _s26; ++_r57) {
      var _s27 = e[_r57],
          _a18 = n[_s27.id];
      !1 !== _a18.needsUpdate && _s27.setValue(t, _a18.value, i);
    }
  }, ls.seqWithValue = function (t, e) {
    var n = [];

    for (var _i79 = 0, _r58 = t.length; _i79 !== _r58; ++_i79) {
      var _r59 = t[_i79];
      _r59.id in e && n.push(_r59);
    }

    return n;
  };
  var hs = 0;

  function us(t, e, n) {
    var i = t.getShaderParameter(e, 35713),
        r = t.getShaderInfoLog(e).trim();
    return i && "" === r ? "" : n.toUpperCase() + "\n\n" + r + "\n\n" + function (t) {
      var e = t.split("\n");

      for (var _t104 = 0; _t104 < e.length; _t104++) {
        e[_t104] = _t104 + 1 + ": " + e[_t104];
      }

      return e.join("\n");
    }(t.getShaderSource(e));
  }

  function ds(t, e) {
    var n = function (t) {
      switch (t) {
        case ot:
          return ["Linear", "( value )"];

        case lt:
          return ["sRGB", "( value )"];

        default:
          return console.warn("THREE.WebGLProgram: Unsupported encoding:", t), ["Linear", "( value )"];
      }
    }(e);

    return "vec4 " + t + "( vec4 value ) { return LinearTo" + n[0] + n[1] + "; }";
  }

  function ps(t, e) {
    var n;

    switch (e) {
      case 1:
        n = "Linear";
        break;

      case 2:
        n = "Reinhard";
        break;

      case 3:
        n = "OptimizedCineon";
        break;

      case 4:
        n = "ACESFilmic";
        break;

      case 5:
        n = "Custom";
        break;

      default:
        console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
    }

    return "vec3 " + t + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
  }

  function ms(t) {
    return "" !== t;
  }

  function fs(t, e) {
    return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
  }

  function gs(t, e) {
    return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
  }

  var vs = /^[ \t]*#include +<([\w\d./]+)>/gm;

  function ys(t) {
    return t.replace(vs, xs);
  }

  function xs(t, e) {
    var n = Ti[e];
    if (void 0 === n) throw new Error("Can not resolve #include <" + e + ">");
    return ys(n);
  }

  var _s = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g,
      Ms = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

  function bs(t) {
    return t.replace(Ms, Ss).replace(_s, ws);
  }

  function ws(t, e, n, i) {
    return console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead."), Ss(t, e, n, i);
  }

  function Ss(t, e, n, i) {
    var r = "";

    for (var _t105 = parseInt(e); _t105 < parseInt(n); _t105++) {
      r += i.replace(/\[\s*i\s*\]/g, "[ " + _t105 + " ]").replace(/UNROLLED_LOOP_INDEX/g, _t105);
    }

    return r;
  }

  function Ts(t) {
    var e = "precision " + t.precision + " float;\nprecision " + t.precision + " int;";
    return "highp" === t.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t.precision && (e += "\n#define LOW_PRECISION"), e;
  }

  function Es(t, e, n, i) {
    var a = t.getContext(),
        o = n.defines;
    var h = n.vertexShader,
        u = n.fragmentShader;

    var d = function (t) {
      var e = "SHADOWMAP_TYPE_BASIC";
      return 1 === t.shadowMapType ? e = "SHADOWMAP_TYPE_PCF" : 2 === t.shadowMapType ? e = "SHADOWMAP_TYPE_PCF_SOFT" : 3 === t.shadowMapType && (e = "SHADOWMAP_TYPE_VSM"), e;
    }(n),
        p = function (t) {
      var e = "ENVMAP_TYPE_CUBE";
      if (t.envMap) switch (t.envMapMode) {
        case r:
        case s:
          e = "ENVMAP_TYPE_CUBE";
          break;

        case l:
        case c:
          e = "ENVMAP_TYPE_CUBE_UV";
      }
      return e;
    }(n),
        m = function (t) {
      var e = "ENVMAP_MODE_REFLECTION";
      if (t.envMap) switch (t.envMapMode) {
        case s:
        case c:
          e = "ENVMAP_MODE_REFRACTION";
      }
      return e;
    }(n),
        f = function (t) {
      var e = "ENVMAP_BLENDING_NONE";
      if (t.envMap) switch (t.combine) {
        case 0:
          e = "ENVMAP_BLENDING_MULTIPLY";
          break;

        case 1:
          e = "ENVMAP_BLENDING_MIX";
          break;

        case 2:
          e = "ENVMAP_BLENDING_ADD";
      }
      return e;
    }(n),
        g = function (t) {
      var e = t.envMapCubeUVHeight;
      if (null === e) return null;
      var n = Math.log2(e / 32 + 1) + 3,
          i = 1 / e;
      return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
        texelHeight: i,
        maxMip: n
      };
    }(n),
        v = n.isWebGL2 ? "" : function (t) {
      return [t.extensionDerivatives || t.envMapCubeUVHeight || t.bumpMap || t.tangentSpaceNormalMap || t.clearcoatNormalMap || t.flatShading || "physical" === t.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "", (t.extensionFragDepth || t.logarithmicDepthBuffer) && t.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "", t.extensionDrawBuffers && t.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "", (t.extensionShaderTextureLOD || t.envMap || t.transmission) && t.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(ms).join("\n");
    }(n),
        y = function (t) {
      var e = [];

      for (var _n101 in t) {
        var _i80 = t[_n101];
        !1 !== _i80 && e.push("#define " + _n101 + " " + _i80);
      }

      return e.join("\n");
    }(o),
        x = a.createProgram();

    var _,
        M,
        b = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";

    n.isRawShaderMaterial ? (_ = [y].filter(ms).join("\n"), _.length > 0 && (_ += "\n"), M = [v, y].filter(ms).join("\n"), M.length > 0 && (M += "\n")) : (_ = [Ts(n), "#define SHADER_NAME " + n.shaderName, y, n.instancing ? "#define USE_INSTANCING" : "", n.instancingColor ? "#define USE_INSTANCING_COLOR" : "", n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define MAX_BONES " + n.maxBones, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + m : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.displacementMap && n.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "", n.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "", n.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUvs ? "#define USE_UV" : "", n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.skinning ? "#define USE_SKINNING" : "", n.useVertexTexture ? "#define BONE_TEXTURE" : "", n.morphTargets ? "#define USE_MORPHTARGETS" : "", n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "", n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "", n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + d : "", n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", "#ifdef USE_INSTANCING", "\tattribute mat4 instanceMatrix;", "#endif", "#ifdef USE_INSTANCING_COLOR", "\tattribute vec3 instanceColor;", "#endif", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_TANGENT", "\tattribute vec4 tangent;", "#endif", "#if defined( USE_COLOR_ALPHA )", "\tattribute vec4 color;", "#elif defined( USE_COLOR )", "\tattribute vec3 color;", "#endif", "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(ms).join("\n"), M = [v, Ts(n), "#define SHADER_NAME " + n.shaderName, y, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.matcap ? "#define USE_MATCAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + p : "", n.envMap ? "#define " + m : "", n.envMap ? "#define " + f : "", g ? "#define CUBEUV_TEXEL_WIDTH " + g.texelWidth : "", g ? "#define CUBEUV_TEXEL_HEIGHT " + g.texelHeight : "", g ? "#define CUBEUV_MAX_MIP " + g.maxMip + ".0" : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "", n.clearcoat ? "#define USE_CLEARCOAT" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "", n.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.alphaTest ? "#define USE_ALPHATEST" : "", n.sheen ? "#define USE_SHEEN" : "", n.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "", n.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUvs ? "#define USE_UV" : "", n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "", n.gradientMap ? "#define USE_GRADIENTMAP" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + d : "", n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", n.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", 0 !== n.toneMapping ? "#define TONE_MAPPING" : "", 0 !== n.toneMapping ? Ti.tonemapping_pars_fragment : "", 0 !== n.toneMapping ? ps("toneMapping", n.toneMapping) : "", n.dithering ? "#define DITHERING" : "", n.opaque ? "#define OPAQUE" : "", Ti.encodings_pars_fragment, ds("linearToOutputTexel", n.outputEncoding), n.depthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "", "\n"].filter(ms).join("\n")), h = ys(h), h = fs(h, n), h = gs(h, n), u = ys(u), u = fs(u, n), u = gs(u, n), h = bs(h), u = bs(u), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (b = "#version 300 es\n", _ = ["precision mediump sampler2DArray;", "#define attribute in", "#define varying out", "#define texture2D texture"].join("\n") + "\n" + _, M = ["#define varying in", n.glslVersion === dt ? "" : "layout(location = 0) out highp vec4 pc_fragColor;", n.glslVersion === dt ? "" : "#define gl_FragColor pc_fragColor", "#define gl_FragDepthEXT gl_FragDepth", "#define texture2D texture", "#define textureCube texture", "#define texture2DProj textureProj", "#define texture2DLodEXT textureLod", "#define texture2DProjLodEXT textureProjLod", "#define textureCubeLodEXT textureLod", "#define texture2DGradEXT textureGrad", "#define texture2DProjGradEXT textureProjGrad", "#define textureCubeGradEXT textureGrad"].join("\n") + "\n" + M);
    var w = b + M + u,
        S = cs(a, 35633, b + _ + h),
        T = cs(a, 35632, w);

    if (a.attachShader(x, S), a.attachShader(x, T), void 0 !== n.index0AttributeName ? a.bindAttribLocation(x, 0, n.index0AttributeName) : !0 === n.morphTargets && a.bindAttribLocation(x, 0, "position"), a.linkProgram(x), t.debug.checkShaderErrors) {
      var _t106 = a.getProgramInfoLog(x).trim(),
          _e77 = a.getShaderInfoLog(S).trim(),
          _n102 = a.getShaderInfoLog(T).trim();

      var _i81 = !0,
          _r60 = !0;

      if (!1 === a.getProgramParameter(x, 35714)) {
        _i81 = !1;

        var _e78 = us(a, S, "vertex"),
            _n103 = us(a, T, "fragment");

        console.error("THREE.WebGLProgram: Shader Error " + a.getError() + " - VALIDATE_STATUS " + a.getProgramParameter(x, 35715) + "\n\nProgram Info Log: " + _t106 + "\n" + _e78 + "\n" + _n103);
      } else "" !== _t106 ? console.warn("THREE.WebGLProgram: Program Info Log:", _t106) : "" !== _e77 && "" !== _n102 || (_r60 = !1);

      _r60 && (this.diagnostics = {
        runnable: _i81,
        programLog: _t106,
        vertexShader: {
          log: _e77,
          prefix: _
        },
        fragmentShader: {
          log: _n102,
          prefix: M
        }
      });
    }

    var E, A;
    return a.deleteShader(S), a.deleteShader(T), this.getUniforms = function () {
      return void 0 === E && (E = new ls(a, x)), E;
    }, this.getAttributes = function () {
      return void 0 === A && (A = function (t, e) {
        var n = {},
            i = t.getProgramParameter(e, 35721);

        for (var _r61 = 0; _r61 < i; _r61++) {
          var _i82 = t.getActiveAttrib(e, _r61),
              _s28 = _i82.name;

          var _a19 = 1;
          35674 === _i82.type && (_a19 = 2), 35675 === _i82.type && (_a19 = 3), 35676 === _i82.type && (_a19 = 4), n[_s28] = {
            type: _i82.type,
            location: t.getAttribLocation(e, _s28),
            locationSize: _a19
          };
        }

        return n;
      }(a, x)), A;
    }, this.destroy = function () {
      i.releaseStatesOfProgram(this), a.deleteProgram(x), this.program = void 0;
    }, this.name = n.shaderName, this.id = hs++, this.cacheKey = e, this.usedTimes = 1, this.program = x, this.vertexShader = S, this.fragmentShader = T, this;
  }

  var As = 0;

  var Rs = /*#__PURE__*/function () {
    function Rs() {
      _classCallCheck(this, Rs);

      this.shaderCache = new Map(), this.materialCache = new Map();
    }

    _createClass(Rs, [{
      key: "update",
      value: function update(t) {
        var e = t.vertexShader,
            n = t.fragmentShader,
            i = this._getShaderStage(e),
            r = this._getShaderStage(n),
            s = this._getShaderCacheForMaterial(t);

        return !1 === s.has(i) && (s.add(i), i.usedTimes++), !1 === s.has(r) && (s.add(r), r.usedTimes++), this;
      }
    }, {
      key: "remove",
      value: function remove(t) {
        var e = this.materialCache.get(t);

        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t107 = _step.value;
            _t107.usedTimes--, 0 === _t107.usedTimes && this.shaderCache.delete(_t107);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return this.materialCache.delete(t), this;
      }
    }, {
      key: "getVertexShaderID",
      value: function getVertexShaderID(t) {
        return this._getShaderStage(t.vertexShader).id;
      }
    }, {
      key: "getFragmentShaderID",
      value: function getFragmentShaderID(t) {
        return this._getShaderStage(t.fragmentShader).id;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
      }
    }, {
      key: "_getShaderCacheForMaterial",
      value: function _getShaderCacheForMaterial(t) {
        var e = this.materialCache;
        return !1 === e.has(t) && e.set(t, new Set()), e.get(t);
      }
    }, {
      key: "_getShaderStage",
      value: function _getShaderStage(t) {
        var e = this.shaderCache;

        if (!1 === e.has(t)) {
          var _n104 = new Cs();

          e.set(t, _n104);
        }

        return e.get(t);
      }
    }]);

    return Rs;
  }();

  var Cs = /*#__PURE__*/_createClass(function Cs() {
    _classCallCheck(this, Cs);

    this.id = As++, this.usedTimes = 0;
  });

  function Ls(t, e, n, i, r, s, a) {
    var o = new Ve(),
        h = new Rs(),
        u = [],
        d = r.isWebGL2,
        p = r.logarithmicDepthBuffer,
        m = r.floatVertexTextures,
        f = r.maxVertexUniforms,
        g = r.vertexTextures;
    var v = r.precision;
    var y = {
      MeshDepthMaterial: "depth",
      MeshDistanceMaterial: "distanceRGBA",
      MeshNormalMaterial: "normal",
      MeshBasicMaterial: "basic",
      MeshLambertMaterial: "lambert",
      MeshPhongMaterial: "phong",
      MeshToonMaterial: "toon",
      MeshStandardMaterial: "physical",
      MeshPhysicalMaterial: "physical",
      MeshMatcapMaterial: "matcap",
      LineBasicMaterial: "basic",
      LineDashedMaterial: "dashed",
      PointsMaterial: "points",
      ShadowMaterial: "shadow",
      SpriteMaterial: "sprite"
    };
    return {
      getParameters: function getParameters(s, o, u, x, _) {
        var M = x.fog,
            b = _.geometry,
            w = s.isMeshStandardMaterial ? x.environment : null,
            S = (s.isMeshStandardMaterial ? n : e).get(s.envMap || w),
            T = !S || S.mapping !== l && S.mapping !== c ? null : S.image.height,
            E = y[s.type],
            A = _.isSkinnedMesh ? function (t) {
          var e = t.skeleton.bones;
          if (m) return 1024;
          {
            var _t108 = f,
                _n105 = Math.floor((_t108 - 20) / 4),
                _i83 = Math.min(_n105, e.length);

            return _i83 < e.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + e.length + " bones. This GPU supports " + _i83 + "."), 0) : _i83;
          }
        }(_) : 0;
        null !== s.precision && (v = r.getMaxPrecision(s.precision), v !== s.precision && console.warn("THREE.WebGLProgram.getParameters:", s.precision, "not supported, using", v, "instead."));
        var R = b.morphAttributes.position || b.morphAttributes.normal || b.morphAttributes.color,
            C = void 0 !== R ? R.length : 0;
        var L,
            P,
            D,
            I,
            N = 0;

        if (void 0 !== b.morphAttributes.position && (N = 1), void 0 !== b.morphAttributes.normal && (N = 2), void 0 !== b.morphAttributes.color && (N = 3), E) {
          var _t109 = Ai[E];
          L = _t109.vertexShader, P = _t109.fragmentShader;
        } else L = s.vertexShader, P = s.fragmentShader, h.update(s), D = h.getVertexShaderID(s), I = h.getFragmentShaderID(s);

        var B = t.getRenderTarget(),
            z = s.alphaTest > 0,
            O = s.clearcoat > 0;
        return {
          isWebGL2: d,
          shaderID: E,
          shaderName: s.type,
          vertexShader: L,
          fragmentShader: P,
          defines: s.defines,
          customVertexShaderID: D,
          customFragmentShaderID: I,
          isRawShaderMaterial: !0 === s.isRawShaderMaterial,
          glslVersion: s.glslVersion,
          precision: v,
          instancing: !0 === _.isInstancedMesh,
          instancingColor: !0 === _.isInstancedMesh && null !== _.instanceColor,
          supportsVertexTextures: g,
          outputEncoding: null === B ? t.outputEncoding : !0 === B.isXRRenderTarget ? B.texture.encoding : ot,
          map: !!s.map,
          matcap: !!s.matcap,
          envMap: !!S,
          envMapMode: S && S.mapping,
          envMapCubeUVHeight: T,
          lightMap: !!s.lightMap,
          aoMap: !!s.aoMap,
          emissiveMap: !!s.emissiveMap,
          bumpMap: !!s.bumpMap,
          normalMap: !!s.normalMap,
          objectSpaceNormalMap: 1 === s.normalMapType,
          tangentSpaceNormalMap: 0 === s.normalMapType,
          decodeVideoTexture: !!s.map && !0 === s.map.isVideoTexture && s.map.encoding === lt,
          clearcoat: O,
          clearcoatMap: O && !!s.clearcoatMap,
          clearcoatRoughnessMap: O && !!s.clearcoatRoughnessMap,
          clearcoatNormalMap: O && !!s.clearcoatNormalMap,
          displacementMap: !!s.displacementMap,
          roughnessMap: !!s.roughnessMap,
          metalnessMap: !!s.metalnessMap,
          specularMap: !!s.specularMap,
          specularIntensityMap: !!s.specularIntensityMap,
          specularColorMap: !!s.specularColorMap,
          opaque: !1 === s.transparent && 1 === s.blending,
          alphaMap: !!s.alphaMap,
          alphaTest: z,
          gradientMap: !!s.gradientMap,
          sheen: s.sheen > 0,
          sheenColorMap: !!s.sheenColorMap,
          sheenRoughnessMap: !!s.sheenRoughnessMap,
          transmission: s.transmission > 0,
          transmissionMap: !!s.transmissionMap,
          thicknessMap: !!s.thicknessMap,
          combine: s.combine,
          vertexTangents: !!s.normalMap && !!b.attributes.tangent,
          vertexColors: s.vertexColors,
          vertexAlphas: !0 === s.vertexColors && !!b.attributes.color && 4 === b.attributes.color.itemSize,
          vertexUvs: !!(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatMap || s.clearcoatRoughnessMap || s.clearcoatNormalMap || s.displacementMap || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularColorMap || s.sheenColorMap || s.sheenRoughnessMap),
          uvsVertexOnly: !(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatNormalMap || s.transmission > 0 || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularColorMap || s.sheen > 0 || s.sheenColorMap || s.sheenRoughnessMap || !s.displacementMap),
          fog: !!M,
          useFog: s.fog,
          fogExp2: M && M.isFogExp2,
          flatShading: !!s.flatShading,
          sizeAttenuation: s.sizeAttenuation,
          logarithmicDepthBuffer: p,
          skinning: !0 === _.isSkinnedMesh && A > 0,
          maxBones: A,
          useVertexTexture: m,
          morphTargets: void 0 !== b.morphAttributes.position,
          morphNormals: void 0 !== b.morphAttributes.normal,
          morphColors: void 0 !== b.morphAttributes.color,
          morphTargetsCount: C,
          morphTextureStride: N,
          numDirLights: o.directional.length,
          numPointLights: o.point.length,
          numSpotLights: o.spot.length,
          numRectAreaLights: o.rectArea.length,
          numHemiLights: o.hemi.length,
          numDirLightShadows: o.directionalShadowMap.length,
          numPointLightShadows: o.pointShadowMap.length,
          numSpotLightShadows: o.spotShadowMap.length,
          numClippingPlanes: a.numPlanes,
          numClipIntersection: a.numIntersection,
          dithering: s.dithering,
          shadowMapEnabled: t.shadowMap.enabled && u.length > 0,
          shadowMapType: t.shadowMap.type,
          toneMapping: s.toneMapped ? t.toneMapping : 0,
          physicallyCorrectLights: t.physicallyCorrectLights,
          premultipliedAlpha: s.premultipliedAlpha,
          doubleSided: 2 === s.side,
          flipSided: 1 === s.side,
          depthPacking: void 0 !== s.depthPacking && s.depthPacking,
          index0AttributeName: s.index0AttributeName,
          extensionDerivatives: s.extensions && s.extensions.derivatives,
          extensionFragDepth: s.extensions && s.extensions.fragDepth,
          extensionDrawBuffers: s.extensions && s.extensions.drawBuffers,
          extensionShaderTextureLOD: s.extensions && s.extensions.shaderTextureLOD,
          rendererExtensionFragDepth: d || i.has("EXT_frag_depth"),
          rendererExtensionDrawBuffers: d || i.has("WEBGL_draw_buffers"),
          rendererExtensionShaderTextureLod: d || i.has("EXT_shader_texture_lod"),
          customProgramCacheKey: s.customProgramCacheKey()
        };
      },
      getProgramCacheKey: function getProgramCacheKey(e) {
        var n = [];
        if (e.shaderID ? n.push(e.shaderID) : (n.push(e.customVertexShaderID), n.push(e.customFragmentShaderID)), void 0 !== e.defines) for (var _t110 in e.defines) {
          n.push(_t110), n.push(e.defines[_t110]);
        }
        return !1 === e.isRawShaderMaterial && (!function (t, e) {
          t.push(e.precision), t.push(e.outputEncoding), t.push(e.envMapMode), t.push(e.envMapCubeUVHeight), t.push(e.combine), t.push(e.vertexUvs), t.push(e.fogExp2), t.push(e.sizeAttenuation), t.push(e.maxBones), t.push(e.morphTargetsCount), t.push(e.morphAttributeCount), t.push(e.numDirLights), t.push(e.numPointLights), t.push(e.numSpotLights), t.push(e.numHemiLights), t.push(e.numRectAreaLights), t.push(e.numDirLightShadows), t.push(e.numPointLightShadows), t.push(e.numSpotLightShadows), t.push(e.shadowMapType), t.push(e.toneMapping), t.push(e.numClippingPlanes), t.push(e.numClipIntersection);
        }(n, e), function (t, e) {
          o.disableAll(), e.isWebGL2 && o.enable(0);
          e.supportsVertexTextures && o.enable(1);
          e.instancing && o.enable(2);
          e.instancingColor && o.enable(3);
          e.map && o.enable(4);
          e.matcap && o.enable(5);
          e.envMap && o.enable(6);
          e.lightMap && o.enable(7);
          e.aoMap && o.enable(8);
          e.emissiveMap && o.enable(9);
          e.bumpMap && o.enable(10);
          e.normalMap && o.enable(11);
          e.objectSpaceNormalMap && o.enable(12);
          e.tangentSpaceNormalMap && o.enable(13);
          e.clearcoat && o.enable(14);
          e.clearcoatMap && o.enable(15);
          e.clearcoatRoughnessMap && o.enable(16);
          e.clearcoatNormalMap && o.enable(17);
          e.displacementMap && o.enable(18);
          e.specularMap && o.enable(19);
          e.roughnessMap && o.enable(20);
          e.metalnessMap && o.enable(21);
          e.gradientMap && o.enable(22);
          e.alphaMap && o.enable(23);
          e.alphaTest && o.enable(24);
          e.vertexColors && o.enable(25);
          e.vertexAlphas && o.enable(26);
          e.vertexUvs && o.enable(27);
          e.vertexTangents && o.enable(28);
          e.uvsVertexOnly && o.enable(29);
          e.fog && o.enable(30);
          t.push(o.mask), o.disableAll(), e.useFog && o.enable(0);
          e.flatShading && o.enable(1);
          e.logarithmicDepthBuffer && o.enable(2);
          e.skinning && o.enable(3);
          e.useVertexTexture && o.enable(4);
          e.morphTargets && o.enable(5);
          e.morphNormals && o.enable(6);
          e.morphColors && o.enable(7);
          e.premultipliedAlpha && o.enable(8);
          e.shadowMapEnabled && o.enable(9);
          e.physicallyCorrectLights && o.enable(10);
          e.doubleSided && o.enable(11);
          e.flipSided && o.enable(12);
          e.depthPacking && o.enable(13);
          e.dithering && o.enable(14);
          e.specularIntensityMap && o.enable(15);
          e.specularColorMap && o.enable(16);
          e.transmission && o.enable(17);
          e.transmissionMap && o.enable(18);
          e.thicknessMap && o.enable(19);
          e.sheen && o.enable(20);
          e.sheenColorMap && o.enable(21);
          e.sheenRoughnessMap && o.enable(22);
          e.decodeVideoTexture && o.enable(23);
          e.opaque && o.enable(24);
          t.push(o.mask);
        }(n, e), n.push(t.outputEncoding)), n.push(e.customProgramCacheKey), n.join();
      },
      getUniforms: function getUniforms(t) {
        var e = y[t.type];
        var n;

        if (e) {
          var _t111 = Ai[e];
          n = oi.clone(_t111.uniforms);
        } else n = t.uniforms;

        return n;
      },
      acquireProgram: function acquireProgram(e, n) {
        var i;

        for (var _t112 = 0, _e79 = u.length; _t112 < _e79; _t112++) {
          var _e80 = u[_t112];

          if (_e80.cacheKey === n) {
            i = _e80, ++i.usedTimes;
            break;
          }
        }

        return void 0 === i && (i = new Es(t, n, e, s), u.push(i)), i;
      },
      releaseProgram: function releaseProgram(t) {
        if (0 == --t.usedTimes) {
          var _e81 = u.indexOf(t);

          u[_e81] = u[u.length - 1], u.pop(), t.destroy();
        }
      },
      releaseShaderCache: function releaseShaderCache(t) {
        h.remove(t);
      },
      programs: u,
      dispose: function dispose() {
        h.dispose();
      }
    };
  }

  function Ps() {
    var t = new WeakMap();
    return {
      get: function get(e) {
        var n = t.get(e);
        return void 0 === n && (n = {}, t.set(e, n)), n;
      },
      remove: function remove(e) {
        t.delete(e);
      },
      update: function update(e, n, i) {
        t.get(e)[n] = i;
      },
      dispose: function dispose() {
        t = new WeakMap();
      }
    };
  }

  function Ds(t, e) {
    return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
  }

  function Is(t, e) {
    return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
  }

  function Ns() {
    var t = [];
    var e = 0;
    var n = [],
        i = [],
        r = [];

    function s(n, i, r, s, a, o) {
      var l = t[e];
      return void 0 === l ? (l = {
        id: n.id,
        object: n,
        geometry: i,
        material: r,
        groupOrder: s,
        renderOrder: n.renderOrder,
        z: a,
        group: o
      }, t[e] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = s, l.renderOrder = n.renderOrder, l.z = a, l.group = o), e++, l;
    }

    return {
      opaque: n,
      transmissive: i,
      transparent: r,
      init: function init() {
        e = 0, n.length = 0, i.length = 0, r.length = 0;
      },
      push: function push(t, e, a, o, l, c) {
        var h = s(t, e, a, o, l, c);
        a.transmission > 0 ? i.push(h) : !0 === a.transparent ? r.push(h) : n.push(h);
      },
      unshift: function unshift(t, e, a, o, l, c) {
        var h = s(t, e, a, o, l, c);
        a.transmission > 0 ? i.unshift(h) : !0 === a.transparent ? r.unshift(h) : n.unshift(h);
      },
      finish: function finish() {
        for (var _n106 = e, _i84 = t.length; _n106 < _i84; _n106++) {
          var _e82 = t[_n106];
          if (null === _e82.id) break;
          _e82.id = null, _e82.object = null, _e82.geometry = null, _e82.material = null, _e82.group = null;
        }
      },
      sort: function sort(t, e) {
        n.length > 1 && n.sort(t || Ds), i.length > 1 && i.sort(e || Is), r.length > 1 && r.sort(e || Is);
      }
    };
  }

  function Bs() {
    var t = new WeakMap();
    return {
      get: function get(e, n) {
        var i;
        return !1 === t.has(e) ? (i = new Ns(), t.set(e, [i])) : n >= t.get(e).length ? (i = new Ns(), t.get(e).push(i)) : i = t.get(e)[n], i;
      },
      dispose: function dispose() {
        t = new WeakMap();
      }
    };
  }

  function zs() {
    var t = {};
    return {
      get: function get(e) {
        if (void 0 !== t[e.id]) return t[e.id];
        var n;

        switch (e.type) {
          case "DirectionalLight":
            n = {
              direction: new te(),
              color: new Ft()
            };
            break;

          case "SpotLight":
            n = {
              position: new te(),
              direction: new te(),
              color: new Ft(),
              distance: 0,
              coneCos: 0,
              penumbraCos: 0,
              decay: 0
            };
            break;

          case "PointLight":
            n = {
              position: new te(),
              color: new Ft(),
              distance: 0,
              decay: 0
            };
            break;

          case "HemisphereLight":
            n = {
              direction: new te(),
              skyColor: new Ft(),
              groundColor: new Ft()
            };
            break;

          case "RectAreaLight":
            n = {
              color: new Ft(),
              position: new te(),
              halfWidth: new te(),
              halfHeight: new te()
            };
        }

        return t[e.id] = n, n;
      }
    };
  }

  var Os = 0;

  function Us(t, e) {
    return (e.castShadow ? 1 : 0) - (t.castShadow ? 1 : 0);
  }

  function Fs(t, e) {
    var n = new zs(),
        i = function () {
      var t = {};
      return {
        get: function get(e) {
          if (void 0 !== t[e.id]) return t[e.id];
          var n;

          switch (e.type) {
            case "DirectionalLight":
            case "SpotLight":
              n = {
                shadowBias: 0,
                shadowNormalBias: 0,
                shadowRadius: 1,
                shadowMapSize: new At()
              };
              break;

            case "PointLight":
              n = {
                shadowBias: 0,
                shadowNormalBias: 0,
                shadowRadius: 1,
                shadowMapSize: new At(),
                shadowCameraNear: 1,
                shadowCameraFar: 1e3
              };
          }

          return t[e.id] = n, n;
        }
      };
    }(),
        r = {
      version: 0,
      hash: {
        directionalLength: -1,
        pointLength: -1,
        spotLength: -1,
        rectAreaLength: -1,
        hemiLength: -1,
        numDirectionalShadows: -1,
        numPointShadows: -1,
        numSpotShadows: -1
      },
      ambient: [0, 0, 0],
      probe: [],
      directional: [],
      directionalShadow: [],
      directionalShadowMap: [],
      directionalShadowMatrix: [],
      spot: [],
      spotShadow: [],
      spotShadowMap: [],
      spotShadowMatrix: [],
      rectArea: [],
      rectAreaLTC1: null,
      rectAreaLTC2: null,
      point: [],
      pointShadow: [],
      pointShadowMap: [],
      pointShadowMatrix: [],
      hemi: []
    };

    for (var _t113 = 0; _t113 < 9; _t113++) {
      r.probe.push(new te());
    }

    var s = new te(),
        a = new Pe(),
        o = new Pe();
    return {
      setup: function setup(s, a) {
        var o = 0,
            l = 0,
            c = 0;

        for (var _t114 = 0; _t114 < 9; _t114++) {
          r.probe[_t114].set(0, 0, 0);
        }

        var h = 0,
            u = 0,
            d = 0,
            p = 0,
            m = 0,
            f = 0,
            g = 0,
            v = 0;
        s.sort(Us);
        var y = !0 !== a ? Math.PI : 1;

        for (var _t115 = 0, _e83 = s.length; _t115 < _e83; _t115++) {
          var _e84 = s[_t115],
              _a20 = _e84.color,
              _x3 = _e84.intensity,
              _4 = _e84.distance,
              _M = _e84.shadow && _e84.shadow.map ? _e84.shadow.map.texture : null;

          if (_e84.isAmbientLight) o += _a20.r * _x3 * y, l += _a20.g * _x3 * y, c += _a20.b * _x3 * y;else if (_e84.isLightProbe) for (var _t116 = 0; _t116 < 9; _t116++) {
            r.probe[_t116].addScaledVector(_e84.sh.coefficients[_t116], _x3);
          } else if (_e84.isDirectionalLight) {
            var _t117 = n.get(_e84);

            if (_t117.color.copy(_e84.color).multiplyScalar(_e84.intensity * y), _e84.castShadow) {
              var _t118 = _e84.shadow,
                  _n107 = i.get(_e84);

              _n107.shadowBias = _t118.bias, _n107.shadowNormalBias = _t118.normalBias, _n107.shadowRadius = _t118.radius, _n107.shadowMapSize = _t118.mapSize, r.directionalShadow[h] = _n107, r.directionalShadowMap[h] = _M, r.directionalShadowMatrix[h] = _e84.shadow.matrix, f++;
            }

            r.directional[h] = _t117, h++;
          } else if (_e84.isSpotLight) {
            var _t119 = n.get(_e84);

            if (_t119.position.setFromMatrixPosition(_e84.matrixWorld), _t119.color.copy(_a20).multiplyScalar(_x3 * y), _t119.distance = _4, _t119.coneCos = Math.cos(_e84.angle), _t119.penumbraCos = Math.cos(_e84.angle * (1 - _e84.penumbra)), _t119.decay = _e84.decay, _e84.castShadow) {
              var _t120 = _e84.shadow,
                  _n108 = i.get(_e84);

              _n108.shadowBias = _t120.bias, _n108.shadowNormalBias = _t120.normalBias, _n108.shadowRadius = _t120.radius, _n108.shadowMapSize = _t120.mapSize, r.spotShadow[d] = _n108, r.spotShadowMap[d] = _M, r.spotShadowMatrix[d] = _e84.shadow.matrix, v++;
            }

            r.spot[d] = _t119, d++;
          } else if (_e84.isRectAreaLight) {
            var _t121 = n.get(_e84);

            _t121.color.copy(_a20).multiplyScalar(_x3), _t121.halfWidth.set(.5 * _e84.width, 0, 0), _t121.halfHeight.set(0, .5 * _e84.height, 0), r.rectArea[p] = _t121, p++;
          } else if (_e84.isPointLight) {
            var _t122 = n.get(_e84);

            if (_t122.color.copy(_e84.color).multiplyScalar(_e84.intensity * y), _t122.distance = _e84.distance, _t122.decay = _e84.decay, _e84.castShadow) {
              var _t123 = _e84.shadow,
                  _n109 = i.get(_e84);

              _n109.shadowBias = _t123.bias, _n109.shadowNormalBias = _t123.normalBias, _n109.shadowRadius = _t123.radius, _n109.shadowMapSize = _t123.mapSize, _n109.shadowCameraNear = _t123.camera.near, _n109.shadowCameraFar = _t123.camera.far, r.pointShadow[u] = _n109, r.pointShadowMap[u] = _M, r.pointShadowMatrix[u] = _e84.shadow.matrix, g++;
            }

            r.point[u] = _t122, u++;
          } else if (_e84.isHemisphereLight) {
            var _t124 = n.get(_e84);

            _t124.skyColor.copy(_e84.color).multiplyScalar(_x3 * y), _t124.groundColor.copy(_e84.groundColor).multiplyScalar(_x3 * y), r.hemi[m] = _t124, m++;
          }
        }

        p > 0 && (e.isWebGL2 || !0 === t.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = Ei.LTC_FLOAT_1, r.rectAreaLTC2 = Ei.LTC_FLOAT_2) : !0 === t.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = Ei.LTC_HALF_1, r.rectAreaLTC2 = Ei.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = c;
        var x = r.hash;
        x.directionalLength === h && x.pointLength === u && x.spotLength === d && x.rectAreaLength === p && x.hemiLength === m && x.numDirectionalShadows === f && x.numPointShadows === g && x.numSpotShadows === v || (r.directional.length = h, r.spot.length = d, r.rectArea.length = p, r.point.length = u, r.hemi.length = m, r.directionalShadow.length = f, r.directionalShadowMap.length = f, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = v, r.spotShadowMap.length = v, r.directionalShadowMatrix.length = f, r.pointShadowMatrix.length = g, r.spotShadowMatrix.length = v, x.directionalLength = h, x.pointLength = u, x.spotLength = d, x.rectAreaLength = p, x.hemiLength = m, x.numDirectionalShadows = f, x.numPointShadows = g, x.numSpotShadows = v, r.version = Os++);
      },
      setupView: function setupView(t, e) {
        var n = 0,
            i = 0,
            l = 0,
            c = 0,
            h = 0;
        var u = e.matrixWorldInverse;

        for (var _e85 = 0, _d9 = t.length; _e85 < _d9; _e85++) {
          var _d10 = t[_e85];

          if (_d10.isDirectionalLight) {
            var _t125 = r.directional[n];
            _t125.direction.setFromMatrixPosition(_d10.matrixWorld), s.setFromMatrixPosition(_d10.target.matrixWorld), _t125.direction.sub(s), _t125.direction.transformDirection(u), n++;
          } else if (_d10.isSpotLight) {
            var _t126 = r.spot[l];
            _t126.position.setFromMatrixPosition(_d10.matrixWorld), _t126.position.applyMatrix4(u), _t126.direction.setFromMatrixPosition(_d10.matrixWorld), s.setFromMatrixPosition(_d10.target.matrixWorld), _t126.direction.sub(s), _t126.direction.transformDirection(u), l++;
          } else if (_d10.isRectAreaLight) {
            var _t127 = r.rectArea[c];
            _t127.position.setFromMatrixPosition(_d10.matrixWorld), _t127.position.applyMatrix4(u), o.identity(), a.copy(_d10.matrixWorld), a.premultiply(u), o.extractRotation(a), _t127.halfWidth.set(.5 * _d10.width, 0, 0), _t127.halfHeight.set(0, .5 * _d10.height, 0), _t127.halfWidth.applyMatrix4(o), _t127.halfHeight.applyMatrix4(o), c++;
          } else if (_d10.isPointLight) {
            var _t128 = r.point[i];
            _t128.position.setFromMatrixPosition(_d10.matrixWorld), _t128.position.applyMatrix4(u), i++;
          } else if (_d10.isHemisphereLight) {
            var _t129 = r.hemi[h];
            _t129.direction.setFromMatrixPosition(_d10.matrixWorld), _t129.direction.transformDirection(u), _t129.direction.normalize(), h++;
          }
        }
      },
      state: r
    };
  }

  function Hs(t, e) {
    var n = new Fs(t, e),
        i = [],
        r = [];
    return {
      init: function init() {
        i.length = 0, r.length = 0;
      },
      state: {
        lightsArray: i,
        shadowsArray: r,
        lights: n
      },
      setupLights: function setupLights(t) {
        n.setup(i, t);
      },
      setupLightsView: function setupLightsView(t) {
        n.setupView(i, t);
      },
      pushLight: function pushLight(t) {
        i.push(t);
      },
      pushShadow: function pushShadow(t) {
        r.push(t);
      }
    };
  }

  function Gs(t, e) {
    var n = new WeakMap();
    return {
      get: function get(i) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var s;
        return !1 === n.has(i) ? (s = new Hs(t, e), n.set(i, [s])) : r >= n.get(i).length ? (s = new Hs(t, e), n.get(i).push(s)) : s = n.get(i)[r], s;
      },
      dispose: function dispose() {
        n = new WeakMap();
      }
    };
  }

  var Vs = /*#__PURE__*/function (_gn3) {
    _inherits(Vs, _gn3);

    var _super32 = _createSuper(Vs);

    function Vs(t) {
      var _this22;

      _classCallCheck(this, Vs);

      _this22 = _super32.call(this), _this22.type = "MeshDepthMaterial", _this22.depthPacking = 3200, _this22.map = null, _this22.alphaMap = null, _this22.displacementMap = null, _this22.displacementScale = 1, _this22.displacementBias = 0, _this22.wireframe = !1, _this22.wireframeLinewidth = 1, _this22.fog = !1, _this22.setValues(t);
      return _this22;
    }

    _createClass(Vs, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Vs.prototype), "copy", this).call(this, t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
      }
    }]);

    return Vs;
  }(gn);

  Vs.prototype.isMeshDepthMaterial = !0;

  var ks = /*#__PURE__*/function (_gn4) {
    _inherits(ks, _gn4);

    var _super33 = _createSuper(ks);

    function ks(t) {
      var _this23;

      _classCallCheck(this, ks);

      _this23 = _super33.call(this), _this23.type = "MeshDistanceMaterial", _this23.referencePosition = new te(), _this23.nearDistance = 1, _this23.farDistance = 1e3, _this23.map = null, _this23.alphaMap = null, _this23.displacementMap = null, _this23.displacementScale = 1, _this23.displacementBias = 0, _this23.fog = !1, _this23.setValues(t);
      return _this23;
    }

    _createClass(ks, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(ks.prototype), "copy", this).call(this, t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
      }
    }]);

    return ks;
  }(gn);

  ks.prototype.isMeshDistanceMaterial = !0;

  function Ws(t, e, n) {
    var i = new Mi();
    var r = new At(),
        s = new At(),
        a = new qt(),
        o = new Vs({
      depthPacking: 3201
    }),
        l = new ks(),
        c = {},
        h = n.maxTextureSize,
        u = {
      0: 1,
      1: 0,
      2: 2
    },
        d = new li({
      defines: {
        VSM_SAMPLES: 8
      },
      uniforms: {
        shadow_pass: {
          value: null
        },
        resolution: {
          value: new At()
        },
        radius: {
          value: 4
        }
      },
      vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
      fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
    }),
        m = d.clone();
    m.defines.HORIZONTAL_PASS = 1;
    var f = new Un();
    f.setAttribute("position", new _n(new Float32Array([-1, -1, .5, 3, -1, .5, -1, 3, .5]), 3));
    var v = new ni(f, d),
        y = this;

    function x(n, i) {
      var r = e.update(v);
      d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, m.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, m.needsUpdate = !0), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, t.setRenderTarget(n.mapPass), t.clear(), t.renderBufferDirect(i, null, r, d, v, null), m.uniforms.shadow_pass.value = n.mapPass.texture, m.uniforms.resolution.value = n.mapSize, m.uniforms.radius.value = n.radius, t.setRenderTarget(n.map), t.clear(), t.renderBufferDirect(i, null, r, m, v, null);
    }

    function _(e, n, i, r, s, a) {
      var h = null;
      var d = !0 === i.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;

      if (h = void 0 !== d ? d : !0 === i.isPointLight ? l : o, t.localClippingEnabled && !0 === n.clipShadows && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0) {
        var _t130 = h.uuid,
            _e86 = n.uuid;
        var _i85 = c[_t130];
        void 0 === _i85 && (_i85 = {}, c[_t130] = _i85);
        var _r62 = _i85[_e86];
        void 0 === _r62 && (_r62 = h.clone(), _i85[_e86] = _r62), h = _r62;
      }

      return h.visible = n.visible, h.wireframe = n.wireframe, h.side = 3 === a ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : u[n.side], h.alphaMap = n.alphaMap, h.alphaTest = n.alphaTest, h.clipShadows = n.clipShadows, h.clippingPlanes = n.clippingPlanes, h.clipIntersection = n.clipIntersection, h.displacementMap = n.displacementMap, h.displacementScale = n.displacementScale, h.displacementBias = n.displacementBias, h.wireframeLinewidth = n.wireframeLinewidth, h.linewidth = n.linewidth, !0 === i.isPointLight && !0 === h.isMeshDistanceMaterial && (h.referencePosition.setFromMatrixPosition(i.matrixWorld), h.nearDistance = r, h.farDistance = s), h;
    }

    function M(n, r, s, a, o) {
      if (!1 === n.visible) return;

      if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && 3 === o) && (!n.frustumCulled || i.intersectsObject(n))) {
        n.modelViewMatrix.multiplyMatrices(s.matrixWorldInverse, n.matrixWorld);

        var _i86 = e.update(n),
            _r63 = n.material;

        if (Array.isArray(_r63)) {
          var _e87 = _i86.groups;

          for (var _l21 = 0, _c13 = _e87.length; _l21 < _c13; _l21++) {
            var _c14 = _e87[_l21],
                _h13 = _r63[_c14.materialIndex];

            if (_h13 && _h13.visible) {
              var _e88 = _(n, _h13, a, s.near, s.far, o);

              t.renderBufferDirect(s, null, _i86, _e88, n, _c14);
            }
          }
        } else if (_r63.visible) {
          var _e89 = _(n, _r63, a, s.near, s.far, o);

          t.renderBufferDirect(s, null, _i86, _e89, n, null);
        }
      }

      var l = n.children;

      for (var _t131 = 0, _e90 = l.length; _t131 < _e90; _t131++) {
        M(l[_t131], r, s, a, o);
      }
    }

    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1, this.render = function (e, n, o) {
      if (!1 === y.enabled) return;
      if (!1 === y.autoUpdate && !1 === y.needsUpdate) return;
      if (0 === e.length) return;
      var l = t.getRenderTarget(),
          c = t.getActiveCubeFace(),
          u = t.getActiveMipmapLevel(),
          d = t.state;
      d.setBlending(0), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);

      for (var _l22 = 0, _c15 = e.length; _l22 < _c15; _l22++) {
        var _c16 = e[_l22],
            _u11 = _c16.shadow;

        if (void 0 === _u11) {
          console.warn("THREE.WebGLShadowMap:", _c16, "has no shadow.");
          continue;
        }

        if (!1 === _u11.autoUpdate && !1 === _u11.needsUpdate) continue;
        r.copy(_u11.mapSize);

        var _m5 = _u11.getFrameExtents();

        if (r.multiply(_m5), s.copy(_u11.mapSize), (r.x > h || r.y > h) && (r.x > h && (s.x = Math.floor(h / _m5.x), r.x = s.x * _m5.x, _u11.mapSize.x = s.x), r.y > h && (s.y = Math.floor(h / _m5.y), r.y = s.y * _m5.y, _u11.mapSize.y = s.y)), null === _u11.map && !_u11.isPointLightShadow && 3 === this.type) {
          var _t132 = {
            minFilter: g,
            magFilter: g,
            format: T
          };
          _u11.map = new Xt(r.x, r.y, _t132), _u11.map.texture.name = _c16.name + ".shadowMap", _u11.mapPass = new Xt(r.x, r.y, _t132), _u11.camera.updateProjectionMatrix();
        }

        if (null === _u11.map) {
          var _t133 = {
            minFilter: p,
            magFilter: p,
            format: T
          };
          _u11.map = new Xt(r.x, r.y, _t133), _u11.map.texture.name = _c16.name + ".shadowMap", _u11.camera.updateProjectionMatrix();
        }

        t.setRenderTarget(_u11.map), t.clear();

        var _f3 = _u11.getViewportCount();

        for (var _t134 = 0; _t134 < _f3; _t134++) {
          var _e91 = _u11.getViewport(_t134);

          a.set(s.x * _e91.x, s.y * _e91.y, s.x * _e91.z, s.y * _e91.w), d.viewport(a), _u11.updateMatrices(_c16, _t134), i = _u11.getFrustum(), M(n, o, _u11.camera, _c16, this.type);
        }

        _u11.isPointLightShadow || 3 !== this.type || x(_u11, o), _u11.needsUpdate = !1;
      }

      y.needsUpdate = !1, t.setRenderTarget(l, c, u);
    };
  }

  function js(t, e, i) {
    var _G;

    var r = i.isWebGL2;
    var s = new function () {
      var e = !1;
      var n = new qt();
      var i = null;
      var r = new qt(0, 0, 0, 0);
      return {
        setMask: function setMask(n) {
          i === n || e || (t.colorMask(n, n, n, n), i = n);
        },
        setLocked: function setLocked(t) {
          e = t;
        },
        setClear: function setClear(e, i, s, a, o) {
          !0 === o && (e *= a, i *= a, s *= a), n.set(e, i, s, a), !1 === r.equals(n) && (t.clearColor(e, i, s, a), r.copy(n));
        },
        reset: function reset() {
          e = !1, i = null, r.set(-1, 0, 0, 0);
        }
      };
    }(),
        a = new function () {
      var e = !1,
          n = null,
          i = null,
          r = null;
      return {
        setTest: function setTest(t) {
          t ? F(2929) : H(2929);
        },
        setMask: function setMask(i) {
          n === i || e || (t.depthMask(i), n = i);
        },
        setFunc: function setFunc(e) {
          if (i !== e) {
            if (e) switch (e) {
              case 0:
                t.depthFunc(512);
                break;

              case 1:
                t.depthFunc(519);
                break;

              case 2:
                t.depthFunc(513);
                break;

              case 3:
              default:
                t.depthFunc(515);
                break;

              case 4:
                t.depthFunc(514);
                break;

              case 5:
                t.depthFunc(518);
                break;

              case 6:
                t.depthFunc(516);
                break;

              case 7:
                t.depthFunc(517);
            } else t.depthFunc(515);
            i = e;
          }
        },
        setLocked: function setLocked(t) {
          e = t;
        },
        setClear: function setClear(e) {
          r !== e && (t.clearDepth(e), r = e);
        },
        reset: function reset() {
          e = !1, n = null, i = null, r = null;
        }
      };
    }(),
        o = new function () {
      var e = !1,
          n = null,
          i = null,
          r = null,
          s = null,
          a = null,
          o = null,
          l = null,
          c = null;
      return {
        setTest: function setTest(t) {
          e || (t ? F(2960) : H(2960));
        },
        setMask: function setMask(i) {
          n === i || e || (t.stencilMask(i), n = i);
        },
        setFunc: function setFunc(e, n, a) {
          i === e && r === n && s === a || (t.stencilFunc(e, n, a), i = e, r = n, s = a);
        },
        setOp: function setOp(e, n, i) {
          a === e && o === n && l === i || (t.stencilOp(e, n, i), a = e, o = n, l = i);
        },
        setLocked: function setLocked(t) {
          e = t;
        },
        setClear: function setClear(e) {
          c !== e && (t.clearStencil(e), c = e);
        },
        reset: function reset() {
          e = !1, n = null, i = null, r = null, s = null, a = null, o = null, l = null, c = null;
        }
      };
    }();
    var l = {},
        c = {},
        h = new WeakMap(),
        u = [],
        d = null,
        p = !1,
        m = null,
        f = null,
        g = null,
        v = null,
        y = null,
        x = null,
        _ = null,
        M = !1,
        b = null,
        w = null,
        S = null,
        T = null,
        E = null;
    var A = t.getParameter(35661);
    var R = !1,
        C = 0;
    var L = t.getParameter(7938);
    -1 !== L.indexOf("WebGL") ? (C = parseFloat(/^WebGL (\d)/.exec(L)[1]), R = C >= 1) : -1 !== L.indexOf("OpenGL ES") && (C = parseFloat(/^OpenGL ES (\d)/.exec(L)[1]), R = C >= 2);
    var P = null,
        D = {};
    var I = t.getParameter(3088),
        N = t.getParameter(2978),
        B = new qt().fromArray(I),
        z = new qt().fromArray(N);

    function O(e, n, i) {
      var r = new Uint8Array(4),
          s = t.createTexture();
      t.bindTexture(e, s), t.texParameteri(e, 10241, 9728), t.texParameteri(e, 10240, 9728);

      for (var _e92 = 0; _e92 < i; _e92++) {
        t.texImage2D(n + _e92, 0, 6408, 1, 1, 0, 6408, 5121, r);
      }

      return s;
    }

    var U = {};

    function F(e) {
      !0 !== l[e] && (t.enable(e), l[e] = !0);
    }

    function H(e) {
      !1 !== l[e] && (t.disable(e), l[e] = !1);
    }

    U[3553] = O(3553, 3553, 1), U[34067] = O(34067, 34069, 6), s.setClear(0, 0, 0, 1), a.setClear(1), o.setClear(0), F(2929), a.setFunc(3), W(!1), j(1), F(2884), k(0);
    var G = (_G = {}, _defineProperty(_G, n, 32774), _defineProperty(_G, 101, 32778), _defineProperty(_G, 102, 32779), _G);
    if (r) G[103] = 32775, G[104] = 32776;else {
      var _t135 = e.get("EXT_blend_minmax");

      null !== _t135 && (G[103] = _t135.MIN_EXT, G[104] = _t135.MAX_EXT);
    }
    var V = {
      200: 0,
      201: 1,
      202: 768,
      204: 770,
      210: 776,
      208: 774,
      206: 772,
      203: 769,
      205: 771,
      209: 775,
      207: 773
    };

    function k(e, i, r, s, a, o, l, c) {
      if (0 !== e) {
        if (!1 === p && (F(3042), p = !0), 5 === e) a = a || i, o = o || r, l = l || s, i === f && a === y || (t.blendEquationSeparate(G[i], G[a]), f = i, y = a), r === g && s === v && o === x && l === _ || (t.blendFuncSeparate(V[r], V[s], V[o], V[l]), g = r, v = s, x = o, _ = l), m = e, M = null;else if (e !== m || c !== M) {
          if (f === n && y === n || (t.blendEquation(32774), f = n, y = n), c) switch (e) {
            case 1:
              t.blendFuncSeparate(1, 771, 1, 771);
              break;

            case 2:
              t.blendFunc(1, 1);
              break;

            case 3:
              t.blendFuncSeparate(0, 769, 0, 1);
              break;

            case 4:
              t.blendFuncSeparate(0, 768, 0, 770);
              break;

            default:
              console.error("THREE.WebGLState: Invalid blending: ", e);
          } else switch (e) {
            case 1:
              t.blendFuncSeparate(770, 771, 1, 771);
              break;

            case 2:
              t.blendFunc(770, 1);
              break;

            case 3:
              t.blendFuncSeparate(0, 769, 0, 1);
              break;

            case 4:
              t.blendFunc(0, 768);
              break;

            default:
              console.error("THREE.WebGLState: Invalid blending: ", e);
          }
          g = null, v = null, x = null, _ = null, m = e, M = c;
        }
      } else !0 === p && (H(3042), p = !1);
    }

    function W(e) {
      b !== e && (e ? t.frontFace(2304) : t.frontFace(2305), b = e);
    }

    function j(e) {
      0 !== e ? (F(2884), e !== w && (1 === e ? t.cullFace(1029) : 2 === e ? t.cullFace(1028) : t.cullFace(1032))) : H(2884), w = e;
    }

    function q(e, n, i) {
      e ? (F(32823), T === n && E === i || (t.polygonOffset(n, i), T = n, E = i)) : H(32823);
    }

    function X(e) {
      void 0 === e && (e = 33984 + A - 1), P !== e && (t.activeTexture(e), P = e);
    }

    return {
      buffers: {
        color: s,
        depth: a,
        stencil: o
      },
      enable: F,
      disable: H,
      bindFramebuffer: function bindFramebuffer(e, n) {
        return c[e] !== n && (t.bindFramebuffer(e, n), c[e] = n, r && (36009 === e && (c[36160] = n), 36160 === e && (c[36009] = n)), !0);
      },
      drawBuffers: function drawBuffers(n, r) {
        var s = u,
            a = !1;
        if (n) {
          if (s = h.get(r), void 0 === s && (s = [], h.set(r, s)), n.isWebGLMultipleRenderTargets) {
            var _t136 = n.texture;

            if (s.length !== _t136.length || 36064 !== s[0]) {
              for (var _e93 = 0, _n110 = _t136.length; _e93 < _n110; _e93++) {
                s[_e93] = 36064 + _e93;
              }

              s.length = _t136.length, a = !0;
            }
          } else 36064 !== s[0] && (s[0] = 36064, a = !0);
        } else 1029 !== s[0] && (s[0] = 1029, a = !0);
        a && (i.isWebGL2 ? t.drawBuffers(s) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(s));
      },
      useProgram: function useProgram(e) {
        return d !== e && (t.useProgram(e), d = e, !0);
      },
      setBlending: k,
      setMaterial: function setMaterial(t, e) {
        2 === t.side ? H(2884) : F(2884);
        var n = 1 === t.side;
        e && (n = !n), W(n), 1 === t.blending && !1 === t.transparent ? k(0) : k(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.premultipliedAlpha), a.setFunc(t.depthFunc), a.setTest(t.depthTest), a.setMask(t.depthWrite), s.setMask(t.colorWrite);
        var i = t.stencilWrite;
        o.setTest(i), i && (o.setMask(t.stencilWriteMask), o.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), o.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), q(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? F(32926) : H(32926);
      },
      setFlipSided: W,
      setCullFace: j,
      setLineWidth: function setLineWidth(e) {
        e !== S && (R && t.lineWidth(e), S = e);
      },
      setPolygonOffset: q,
      setScissorTest: function setScissorTest(t) {
        t ? F(3089) : H(3089);
      },
      activeTexture: X,
      bindTexture: function bindTexture(e, n) {
        null === P && X();
        var i = D[P];
        void 0 === i && (i = {
          type: void 0,
          texture: void 0
        }, D[P] = i), i.type === e && i.texture === n || (t.bindTexture(e, n || U[e]), i.type = e, i.texture = n);
      },
      unbindTexture: function unbindTexture() {
        var e = D[P];
        void 0 !== e && void 0 !== e.type && (t.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
      },
      compressedTexImage2D: function compressedTexImage2D() {
        try {
          t.compressedTexImage2D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      texImage2D: function texImage2D() {
        try {
          t.texImage2D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      texImage3D: function texImage3D() {
        try {
          t.texImage3D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      texStorage2D: function texStorage2D() {
        try {
          t.texStorage2D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      texStorage3D: function texStorage3D() {
        try {
          t.texStorage3D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      texSubImage2D: function texSubImage2D() {
        try {
          t.texSubImage2D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      texSubImage3D: function texSubImage3D() {
        try {
          t.texSubImage3D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      compressedTexSubImage2D: function compressedTexSubImage2D() {
        try {
          t.compressedTexSubImage2D.apply(t, arguments);
        } catch (t) {
          console.error("THREE.WebGLState:", t);
        }
      },
      scissor: function scissor(e) {
        !1 === B.equals(e) && (t.scissor(e.x, e.y, e.z, e.w), B.copy(e));
      },
      viewport: function viewport(e) {
        !1 === z.equals(e) && (t.viewport(e.x, e.y, e.z, e.w), z.copy(e));
      },
      reset: function reset() {
        t.disable(3042), t.disable(2884), t.disable(2929), t.disable(32823), t.disable(3089), t.disable(2960), t.disable(32926), t.blendEquation(32774), t.blendFunc(1, 0), t.blendFuncSeparate(1, 0, 1, 0), t.colorMask(!0, !0, !0, !0), t.clearColor(0, 0, 0, 0), t.depthMask(!0), t.depthFunc(513), t.clearDepth(1), t.stencilMask(4294967295), t.stencilFunc(519, 0, 4294967295), t.stencilOp(7680, 7680, 7680), t.clearStencil(0), t.cullFace(1029), t.frontFace(2305), t.polygonOffset(0, 0), t.activeTexture(33984), t.bindFramebuffer(36160, null), !0 === r && (t.bindFramebuffer(36009, null), t.bindFramebuffer(36008, null)), t.useProgram(null), t.lineWidth(1), t.scissor(0, 0, t.canvas.width, t.canvas.height), t.viewport(0, 0, t.canvas.width, t.canvas.height), l = {}, P = null, D = {}, c = {}, h = new WeakMap(), u = [], d = null, p = !1, m = null, f = null, g = null, v = null, y = null, x = null, _ = null, M = !1, b = null, w = null, S = null, T = null, E = null, B.set(0, 0, t.canvas.width, t.canvas.height), z.set(0, 0, t.canvas.width, t.canvas.height), s.reset(), a.reset(), o.reset();
      }
    };
  }

  function qs(t, e, n, i, r, s, a) {
    var _J, _Y;

    var o = r.isWebGL2,
        l = r.maxTextures,
        c = r.maxCubemapSize,
        R = r.maxTextureSize,
        C = r.maxSamples,
        L = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null,
        P = new WeakMap();
    var D;
    var I = new WeakMap();
    var N = !1;

    try {
      N = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
    } catch (t) {}

    function B(t, e) {
      return N ? new OffscreenCanvas(t, e) : Dt("canvas");
    }

    function z(t, e, n, i) {
      var r = 1;

      if ((t.width > i || t.height > i) && (r = i / Math.max(t.width, t.height)), r < 1 || !0 === e) {
        if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
          var _i87 = e ? Tt : Math.floor,
              _s29 = _i87(r * t.width),
              _a21 = _i87(r * t.height);

          void 0 === D && (D = B(_s29, _a21));

          var _o15 = n ? B(_s29, _a21) : D;

          _o15.width = _s29, _o15.height = _a21;
          return _o15.getContext("2d").drawImage(t, 0, 0, _s29, _a21), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t.width + "x" + t.height + ") to (" + _s29 + "x" + _a21 + ")."), _o15;
        }

        return "data" in t && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t.width + "x" + t.height + ")."), t;
      }

      return t;
    }

    function O(t) {
      return wt(t.width) && wt(t.height);
    }

    function U(t, e) {
      return t.generateMipmaps && e && t.minFilter !== p && t.minFilter !== g;
    }

    function F(e) {
      t.generateMipmap(e);
    }

    function H(n, i, r, s) {
      var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      if (!1 === o) return i;

      if (null !== n) {
        if (void 0 !== t[n]) return t[n];
        console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
      }

      var l = i;
      return 6403 === i && (5126 === r && (l = 33326), 5131 === r && (l = 33325), 5121 === r && (l = 33321)), 33319 === i && (5126 === r && (l = 33328), 5131 === r && (l = 33327), 5121 === r && (l = 33323)), 6408 === i && (5126 === r && (l = 34836), 5131 === r && (l = 34842), 5121 === r && (l = s === lt && !1 === a ? 35907 : 32856), 32819 === r && (l = 32854), 32820 === r && (l = 32855)), 33325 !== l && 33326 !== l && 33327 !== l && 33328 !== l && 34842 !== l && 34836 !== l || e.get("EXT_color_buffer_float"), l;
    }

    function G(t, e, n) {
      return !0 === U(t, n) || t.isFramebufferTexture && t.minFilter !== p && t.minFilter !== g ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t.mipmaps && t.mipmaps.length > 0 ? t.mipmaps.length : t.isCompressedTexture && Array.isArray(t.image) ? e.mipmaps.length : 1;
    }

    function V(t) {
      return t === p || t === m || t === f ? 9728 : 9729;
    }

    function k(t) {
      var e = t.target;
      e.removeEventListener("dispose", k), function (t) {
        var e = i.get(t);
        if (void 0 === e.__webglInit) return;
        var n = t.source,
            r = I.get(n);

        if (r) {
          var _i88 = r[e.__cacheKey];
          _i88.usedTimes--, 0 === _i88.usedTimes && j(t), 0 === Object.keys(r).length && I.delete(n);
        }

        i.remove(t);
      }(e), e.isVideoTexture && P.delete(e);
    }

    function W(e) {
      var n = e.target;
      n.removeEventListener("dispose", W), function (e) {
        var n = e.texture,
            r = i.get(e),
            s = i.get(n);
        void 0 !== s.__webglTexture && (t.deleteTexture(s.__webglTexture), a.memory.textures--);
        e.depthTexture && e.depthTexture.dispose();
        if (e.isWebGLCubeRenderTarget) for (var _e94 = 0; _e94 < 6; _e94++) {
          t.deleteFramebuffer(r.__webglFramebuffer[_e94]), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer[_e94]);
        } else t.deleteFramebuffer(r.__webglFramebuffer), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer && t.deleteRenderbuffer(r.__webglColorRenderbuffer), r.__webglDepthRenderbuffer && t.deleteRenderbuffer(r.__webglDepthRenderbuffer);
        if (e.isWebGLMultipleRenderTargets) for (var _e95 = 0, _r64 = n.length; _e95 < _r64; _e95++) {
          var _r65 = i.get(n[_e95]);

          _r65.__webglTexture && (t.deleteTexture(_r65.__webglTexture), a.memory.textures--), i.remove(n[_e95]);
        }
        i.remove(n), i.remove(e);
      }(n);
    }

    function j(e) {
      var n = i.get(e);
      t.deleteTexture(n.__webglTexture);
      var r = e.source;
      delete I.get(r)[n.__cacheKey], a.memory.textures--;
    }

    var q = 0;

    function X(t, e) {
      var r = i.get(t);

      if (t.isVideoTexture && function (t) {
        var e = a.render.frame;
        P.get(t) !== e && (P.set(t, e), t.update());
      }(t), t.version > 0 && r.__version !== t.version) {
        var _n111 = t.image;
        if (null === _n111) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");else {
          if (!1 !== _n111.complete) return void Q(r, t, e);
          console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
        }
      }

      n.activeTexture(33984 + e), n.bindTexture(3553, r.__webglTexture);
    }

    var J = (_J = {}, _defineProperty(_J, h, 10497), _defineProperty(_J, u, 33071), _defineProperty(_J, d, 33648), _J),
        Y = (_Y = {}, _defineProperty(_Y, p, 9728), _defineProperty(_Y, m, 9984), _defineProperty(_Y, f, 9986), _defineProperty(_Y, g, 9729), _defineProperty(_Y, v, 9985), _defineProperty(_Y, y, 9987), _Y);

    function Z(n, s, a) {
      if (a ? (t.texParameteri(n, 10242, J[s.wrapS]), t.texParameteri(n, 10243, J[s.wrapT]), 32879 !== n && 35866 !== n || t.texParameteri(n, 32882, J[s.wrapR]), t.texParameteri(n, 10240, Y[s.magFilter]), t.texParameteri(n, 10241, Y[s.minFilter])) : (t.texParameteri(n, 10242, 33071), t.texParameteri(n, 10243, 33071), 32879 !== n && 35866 !== n || t.texParameteri(n, 32882, 33071), s.wrapS === u && s.wrapT === u || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t.texParameteri(n, 10240, V(s.magFilter)), t.texParameteri(n, 10241, V(s.minFilter)), s.minFilter !== p && s.minFilter !== g && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), !0 === e.has("EXT_texture_filter_anisotropic")) {
        var _a22 = e.get("EXT_texture_filter_anisotropic");

        if (s.type === b && !1 === e.has("OES_texture_float_linear")) return;
        if (!1 === o && s.type === w && !1 === e.has("OES_texture_half_float_linear")) return;
        (s.anisotropy > 1 || i.get(s).__currentAnisotropy) && (t.texParameterf(n, _a22.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(s.anisotropy, r.getMaxAnisotropy())), i.get(s).__currentAnisotropy = s.anisotropy);
      }
    }

    function K(e, n) {
      var i = !1;
      void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", k));
      var r = n.source;
      var s = I.get(r);
      void 0 === s && (s = {}, I.set(r, s));

      var o = function (t) {
        var e = [];
        return e.push(t.wrapS), e.push(t.wrapT), e.push(t.magFilter), e.push(t.minFilter), e.push(t.anisotropy), e.push(t.internalFormat), e.push(t.format), e.push(t.type), e.push(t.generateMipmaps), e.push(t.premultiplyAlpha), e.push(t.flipY), e.push(t.unpackAlignment), e.push(t.encoding), e.join();
      }(n);

      if (o !== e.__cacheKey) {
        void 0 === s[o] && (s[o] = {
          texture: t.createTexture(),
          usedTimes: 0
        }, a.memory.textures++, i = !0), s[o].usedTimes++;
        var _r66 = s[e.__cacheKey];
        void 0 !== _r66 && (s[e.__cacheKey].usedTimes--, 0 === _r66.usedTimes && j(n)), e.__cacheKey = o, e.__webglTexture = s[o].texture;
      }

      return i;
    }

    function Q(e, i, r) {
      var a = 3553;
      i.isDataArrayTexture && (a = 35866), i.isData3DTexture && (a = 32879);
      var l = K(e, i),
          c = i.source;

      if (n.activeTexture(33984 + r), n.bindTexture(a, e.__webglTexture), c.version !== c.__currentVersion || !0 === l) {
        t.pixelStorei(37440, i.flipY), t.pixelStorei(37441, i.premultiplyAlpha), t.pixelStorei(3317, i.unpackAlignment), t.pixelStorei(37443, 0);

        var _r67 = function (t) {
          return !o && (t.wrapS !== u || t.wrapT !== u || t.minFilter !== p && t.minFilter !== g);
        }(i) && !1 === O(i.image);

        var _l23 = z(i.image, _r67, !1, R);

        _l23 = rt(i, _l23);

        var _h14 = O(_l23) || o,
            _d11 = s.convert(i.format, i.encoding);

        var _m6,
            _f4 = s.convert(i.type),
            _v4 = H(i.internalFormat, _d11, _f4, i.encoding, i.isVideoTexture);

        Z(a, i, _h14);

        var _y4 = i.mipmaps,
            _x4 = o && !0 !== i.isVideoTexture,
            _w = void 0 === e.__version,
            _C = G(i, _l23, _h14);

        if (i.isDepthTexture) _v4 = 6402, o ? _v4 = i.type === b ? 36012 : i.type === M ? 33190 : i.type === S ? 35056 : 33189 : i.type === b && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), i.format === E && 6402 === _v4 && i.type !== _ && i.type !== M && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), i.type = _, _f4 = s.convert(i.type)), i.format === A && 6402 === _v4 && (_v4 = 34041, i.type !== S && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), i.type = S, _f4 = s.convert(i.type))), _x4 && _w ? n.texStorage2D(3553, 1, _v4, _l23.width, _l23.height) : n.texImage2D(3553, 0, _v4, _l23.width, _l23.height, 0, _d11, _f4, null);else if (i.isDataTexture) {
          if (_y4.length > 0 && _h14) {
            _x4 && _w && n.texStorage2D(3553, _C, _v4, _y4[0].width, _y4[0].height);

            for (var _t137 = 0, _e96 = _y4.length; _t137 < _e96; _t137++) {
              _m6 = _y4[_t137], _x4 ? n.texSubImage2D(3553, _t137, 0, 0, _m6.width, _m6.height, _d11, _f4, _m6.data) : n.texImage2D(3553, _t137, _v4, _m6.width, _m6.height, 0, _d11, _f4, _m6.data);
            }

            i.generateMipmaps = !1;
          } else _x4 ? (_w && n.texStorage2D(3553, _C, _v4, _l23.width, _l23.height), n.texSubImage2D(3553, 0, 0, 0, _l23.width, _l23.height, _d11, _f4, _l23.data)) : n.texImage2D(3553, 0, _v4, _l23.width, _l23.height, 0, _d11, _f4, _l23.data);
        } else if (i.isCompressedTexture) {
          _x4 && _w && n.texStorage2D(3553, _C, _v4, _y4[0].width, _y4[0].height);

          for (var _t138 = 0, _e97 = _y4.length; _t138 < _e97; _t138++) {
            _m6 = _y4[_t138], i.format !== T ? null !== _d11 ? _x4 ? n.compressedTexSubImage2D(3553, _t138, 0, 0, _m6.width, _m6.height, _d11, _m6.data) : n.compressedTexImage2D(3553, _t138, _v4, _m6.width, _m6.height, 0, _m6.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : _x4 ? n.texSubImage2D(3553, _t138, 0, 0, _m6.width, _m6.height, _d11, _f4, _m6.data) : n.texImage2D(3553, _t138, _v4, _m6.width, _m6.height, 0, _d11, _f4, _m6.data);
          }
        } else if (i.isDataArrayTexture) _x4 ? (_w && n.texStorage3D(35866, _C, _v4, _l23.width, _l23.height, _l23.depth), n.texSubImage3D(35866, 0, 0, 0, 0, _l23.width, _l23.height, _l23.depth, _d11, _f4, _l23.data)) : n.texImage3D(35866, 0, _v4, _l23.width, _l23.height, _l23.depth, 0, _d11, _f4, _l23.data);else if (i.isData3DTexture) _x4 ? (_w && n.texStorage3D(32879, _C, _v4, _l23.width, _l23.height, _l23.depth), n.texSubImage3D(32879, 0, 0, 0, 0, _l23.width, _l23.height, _l23.depth, _d11, _f4, _l23.data)) : n.texImage3D(32879, 0, _v4, _l23.width, _l23.height, _l23.depth, 0, _d11, _f4, _l23.data);else if (i.isFramebufferTexture) _x4 && _w ? n.texStorage2D(3553, _C, _v4, _l23.width, _l23.height) : n.texImage2D(3553, 0, _v4, _l23.width, _l23.height, 0, _d11, _f4, null);else if (_y4.length > 0 && _h14) {
          _x4 && _w && n.texStorage2D(3553, _C, _v4, _y4[0].width, _y4[0].height);

          for (var _t139 = 0, _e98 = _y4.length; _t139 < _e98; _t139++) {
            _m6 = _y4[_t139], _x4 ? n.texSubImage2D(3553, _t139, 0, 0, _d11, _f4, _m6) : n.texImage2D(3553, _t139, _v4, _d11, _f4, _m6);
          }

          i.generateMipmaps = !1;
        } else _x4 ? (_w && n.texStorage2D(3553, _C, _v4, _l23.width, _l23.height), n.texSubImage2D(3553, 0, 0, 0, _d11, _f4, _l23)) : n.texImage2D(3553, 0, _v4, _d11, _f4, _l23);
        U(i, _h14) && F(a), c.__currentVersion = c.version, i.onUpdate && i.onUpdate(i);
      }

      e.__version = i.version;
    }

    function $(e, r, a, o, l) {
      var c = s.convert(a.format, a.encoding),
          h = s.convert(a.type),
          u = H(a.internalFormat, c, h, a.encoding);
      i.get(r).__hasExternalTextures || (32879 === l || 35866 === l ? n.texImage3D(l, 0, u, r.width, r.height, r.depth, 0, c, h, null) : n.texImage2D(l, 0, u, r.width, r.height, 0, c, h, null)), n.bindFramebuffer(36160, e), it(r) ? L.framebufferTexture2DMultisampleEXT(36160, o, l, i.get(a).__webglTexture, 0, nt(r)) : t.framebufferTexture2D(36160, o, l, i.get(a).__webglTexture, 0), n.bindFramebuffer(36160, null);
    }

    function tt(e, n, i) {
      if (t.bindRenderbuffer(36161, e), n.depthBuffer && !n.stencilBuffer) {
        var _r68 = 33189;

        if (i || it(n)) {
          var _e99 = n.depthTexture;
          _e99 && _e99.isDepthTexture && (_e99.type === b ? _r68 = 36012 : _e99.type === M && (_r68 = 33190));

          var _i89 = nt(n);

          it(n) ? L.renderbufferStorageMultisampleEXT(36161, _i89, _r68, n.width, n.height) : t.renderbufferStorageMultisample(36161, _i89, _r68, n.width, n.height);
        } else t.renderbufferStorage(36161, _r68, n.width, n.height);

        t.framebufferRenderbuffer(36160, 36096, 36161, e);
      } else if (n.depthBuffer && n.stencilBuffer) {
        var _r69 = nt(n);

        i && !1 === it(n) ? t.renderbufferStorageMultisample(36161, _r69, 35056, n.width, n.height) : it(n) ? L.renderbufferStorageMultisampleEXT(36161, _r69, 35056, n.width, n.height) : t.renderbufferStorage(36161, 34041, n.width, n.height), t.framebufferRenderbuffer(36160, 33306, 36161, e);
      } else {
        var _e100 = !0 === n.isWebGLMultipleRenderTargets ? n.texture[0] : n.texture,
            _r70 = s.convert(_e100.format, _e100.encoding),
            _a23 = s.convert(_e100.type),
            _o16 = H(_e100.internalFormat, _r70, _a23, _e100.encoding),
            _l24 = nt(n);

        i && !1 === it(n) ? t.renderbufferStorageMultisample(36161, _l24, _o16, n.width, n.height) : it(n) ? L.renderbufferStorageMultisampleEXT(36161, _l24, _o16, n.width, n.height) : t.renderbufferStorage(36161, _o16, n.width, n.height);
      }

      t.bindRenderbuffer(36161, null);
    }

    function et(e) {
      var r = i.get(e),
          s = !0 === e.isWebGLCubeRenderTarget;

      if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
        if (s) throw new Error("target.depthTexture not supported in Cube render targets");
        !function (e, r) {
          if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
          if (n.bindFramebuffer(36160, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
          i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), X(r.depthTexture, 0);

          var s = i.get(r.depthTexture).__webglTexture,
              a = nt(r);

          if (r.depthTexture.format === E) it(r) ? L.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, s, 0, a) : t.framebufferTexture2D(36160, 36096, 3553, s, 0);else {
            if (r.depthTexture.format !== A) throw new Error("Unknown depthTexture format");
            it(r) ? L.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, s, 0, a) : t.framebufferTexture2D(36160, 33306, 3553, s, 0);
          }
        }(r.__webglFramebuffer, e);
      } else if (s) {
        r.__webglDepthbuffer = [];

        for (var _i90 = 0; _i90 < 6; _i90++) {
          n.bindFramebuffer(36160, r.__webglFramebuffer[_i90]), r.__webglDepthbuffer[_i90] = t.createRenderbuffer(), tt(r.__webglDepthbuffer[_i90], e, !1);
        }
      } else n.bindFramebuffer(36160, r.__webglFramebuffer), r.__webglDepthbuffer = t.createRenderbuffer(), tt(r.__webglDepthbuffer, e, !1);

      n.bindFramebuffer(36160, null);
    }

    function nt(t) {
      return Math.min(C, t.samples);
    }

    function it(t) {
      var n = i.get(t);
      return o && t.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
    }

    function rt(t, n) {
      var i = t.encoding,
          r = t.format,
          s = t.type;
      return !0 === t.isCompressedTexture || !0 === t.isVideoTexture || t.format === pt || i !== ot && (i === lt ? !1 === o ? !0 === e.has("EXT_sRGB") && r === T ? (t.format = pt, t.minFilter = g, t.generateMipmaps = !1) : n = Gt.sRGBToLinear(n) : r === T && s === x || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", i)), n;
    }

    this.allocateTextureUnit = function () {
      var t = q;
      return t >= l && console.warn("THREE.WebGLTextures: Trying to use " + t + " texture units while this GPU supports only " + l), q += 1, t;
    }, this.resetTextureUnits = function () {
      q = 0;
    }, this.setTexture2D = X, this.setTexture2DArray = function (t, e) {
      var r = i.get(t);
      t.version > 0 && r.__version !== t.version ? Q(r, t, e) : (n.activeTexture(33984 + e), n.bindTexture(35866, r.__webglTexture));
    }, this.setTexture3D = function (t, e) {
      var r = i.get(t);
      t.version > 0 && r.__version !== t.version ? Q(r, t, e) : (n.activeTexture(33984 + e), n.bindTexture(32879, r.__webglTexture));
    }, this.setTextureCube = function (e, r) {
      var a = i.get(e);
      e.version > 0 && a.__version !== e.version ? function (e, i, r) {
        if (6 !== i.image.length) return;
        var a = K(e, i),
            l = i.source;

        if (n.activeTexture(33984 + r), n.bindTexture(34067, e.__webglTexture), l.version !== l.__currentVersion || !0 === a) {
          t.pixelStorei(37440, i.flipY), t.pixelStorei(37441, i.premultiplyAlpha), t.pixelStorei(3317, i.unpackAlignment), t.pixelStorei(37443, 0);

          var _r71 = i.isCompressedTexture || i.image[0].isCompressedTexture,
              _a24 = i.image[0] && i.image[0].isDataTexture,
              _h15 = [];

          for (var _t140 = 0; _t140 < 6; _t140++) {
            _h15[_t140] = _r71 || _a24 ? _a24 ? i.image[_t140].image : i.image[_t140] : z(i.image[_t140], !1, !0, c), _h15[_t140] = rt(i, _h15[_t140]);
          }

          var _u12 = _h15[0],
              _d12 = O(_u12) || o,
              _p8 = s.convert(i.format, i.encoding),
              _m7 = s.convert(i.type),
              _f5 = H(i.internalFormat, _p8, _m7, i.encoding),
              _g3 = o && !0 !== i.isVideoTexture,
              _v5 = void 0 === e.__version;

          var _y5,
              _x5 = G(i, _u12, _d12);

          if (Z(34067, i, _d12), _r71) {
            _g3 && _v5 && n.texStorage2D(34067, _x5, _f5, _u12.width, _u12.height);

            for (var _t141 = 0; _t141 < 6; _t141++) {
              _y5 = _h15[_t141].mipmaps;

              for (var _e101 = 0; _e101 < _y5.length; _e101++) {
                var _r72 = _y5[_e101];
                i.format !== T ? null !== _p8 ? _g3 ? n.compressedTexSubImage2D(34069 + _t141, _e101, 0, 0, _r72.width, _r72.height, _p8, _r72.data) : n.compressedTexImage2D(34069 + _t141, _e101, _f5, _r72.width, _r72.height, 0, _r72.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : _g3 ? n.texSubImage2D(34069 + _t141, _e101, 0, 0, _r72.width, _r72.height, _p8, _m7, _r72.data) : n.texImage2D(34069 + _t141, _e101, _f5, _r72.width, _r72.height, 0, _p8, _m7, _r72.data);
              }
            }
          } else {
            _y5 = i.mipmaps, _g3 && _v5 && (_y5.length > 0 && _x5++, n.texStorage2D(34067, _x5, _f5, _h15[0].width, _h15[0].height));

            for (var _t142 = 0; _t142 < 6; _t142++) {
              if (_a24) {
                _g3 ? n.texSubImage2D(34069 + _t142, 0, 0, 0, _h15[_t142].width, _h15[_t142].height, _p8, _m7, _h15[_t142].data) : n.texImage2D(34069 + _t142, 0, _f5, _h15[_t142].width, _h15[_t142].height, 0, _p8, _m7, _h15[_t142].data);

                for (var _e102 = 0; _e102 < _y5.length; _e102++) {
                  var _i91 = _y5[_e102].image[_t142].image;
                  _g3 ? n.texSubImage2D(34069 + _t142, _e102 + 1, 0, 0, _i91.width, _i91.height, _p8, _m7, _i91.data) : n.texImage2D(34069 + _t142, _e102 + 1, _f5, _i91.width, _i91.height, 0, _p8, _m7, _i91.data);
                }
              } else {
                _g3 ? n.texSubImage2D(34069 + _t142, 0, 0, 0, _p8, _m7, _h15[_t142]) : n.texImage2D(34069 + _t142, 0, _f5, _p8, _m7, _h15[_t142]);

                for (var _e103 = 0; _e103 < _y5.length; _e103++) {
                  var _i92 = _y5[_e103];
                  _g3 ? n.texSubImage2D(34069 + _t142, _e103 + 1, 0, 0, _p8, _m7, _i92.image[_t142]) : n.texImage2D(34069 + _t142, _e103 + 1, _f5, _p8, _m7, _i92.image[_t142]);
                }
              }
            }
          }

          U(i, _d12) && F(34067), l.__currentVersion = l.version, i.onUpdate && i.onUpdate(i);
        }

        e.__version = i.version;
      }(a, e, r) : (n.activeTexture(33984 + r), n.bindTexture(34067, a.__webglTexture));
    }, this.rebindTextures = function (t, e, n) {
      var r = i.get(t);
      void 0 !== e && $(r.__webglFramebuffer, t, t.texture, 36064, 3553), void 0 !== n && et(t);
    }, this.setupRenderTarget = function (e) {
      var l = e.texture,
          c = i.get(e),
          h = i.get(l);
      e.addEventListener("dispose", W), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === h.__webglTexture && (h.__webglTexture = t.createTexture()), h.__version = l.version, a.memory.textures++);
      var u = !0 === e.isWebGLCubeRenderTarget,
          d = !0 === e.isWebGLMultipleRenderTargets,
          p = O(e) || o;

      if (u) {
        c.__webglFramebuffer = [];

        for (var _e104 = 0; _e104 < 6; _e104++) {
          c.__webglFramebuffer[_e104] = t.createFramebuffer();
        }
      } else if (c.__webglFramebuffer = t.createFramebuffer(), d) {
        if (r.drawBuffers) {
          var _n112 = e.texture;

          for (var _e105 = 0, _r73 = _n112.length; _e105 < _r73; _e105++) {
            var _r74 = i.get(_n112[_e105]);

            void 0 === _r74.__webglTexture && (_r74.__webglTexture = t.createTexture(), a.memory.textures++);
          }
        } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
      } else if (o && e.samples > 0 && !1 === it(e)) {
        c.__webglMultisampledFramebuffer = t.createFramebuffer(), c.__webglColorRenderbuffer = t.createRenderbuffer(), t.bindRenderbuffer(36161, c.__webglColorRenderbuffer);

        var _i93 = s.convert(l.format, l.encoding),
            _r75 = s.convert(l.type),
            _a25 = H(l.internalFormat, _i93, _r75, l.encoding),
            _o17 = nt(e);

        t.renderbufferStorageMultisample(36161, _o17, _a25, e.width, e.height), n.bindFramebuffer(36160, c.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(36160, 36064, 36161, c.__webglColorRenderbuffer), t.bindRenderbuffer(36161, null), e.depthBuffer && (c.__webglDepthRenderbuffer = t.createRenderbuffer(), tt(c.__webglDepthRenderbuffer, e, !0)), n.bindFramebuffer(36160, null);
      }

      if (u) {
        n.bindTexture(34067, h.__webglTexture), Z(34067, l, p);

        for (var _t143 = 0; _t143 < 6; _t143++) {
          $(c.__webglFramebuffer[_t143], e, l, 36064, 34069 + _t143);
        }

        U(l, p) && F(34067), n.unbindTexture();
      } else if (d) {
        var _t144 = e.texture;

        for (var _r76 = 0, _s30 = _t144.length; _r76 < _s30; _r76++) {
          var _s31 = _t144[_r76],
              _a26 = i.get(_s31);

          n.bindTexture(3553, _a26.__webglTexture), Z(3553, _s31, p), $(c.__webglFramebuffer, e, _s31, 36064 + _r76, 3553), U(_s31, p) && F(3553);
        }

        n.unbindTexture();
      } else {
        var _t145 = 3553;
        (e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (o ? _t145 = e.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(_t145, h.__webglTexture), Z(_t145, l, p), $(c.__webglFramebuffer, e, l, 36064, _t145), U(l, p) && F(_t145), n.unbindTexture();
      }

      e.depthBuffer && et(e);
    }, this.updateRenderTargetMipmap = function (t) {
      var e = O(t) || o,
          r = !0 === t.isWebGLMultipleRenderTargets ? t.texture : [t.texture];

      for (var _s32 = 0, _a27 = r.length; _s32 < _a27; _s32++) {
        var _a28 = r[_s32];

        if (U(_a28, e)) {
          var _e106 = t.isWebGLCubeRenderTarget ? 34067 : 3553,
              _r77 = i.get(_a28).__webglTexture;

          n.bindTexture(_e106, _r77), F(_e106), n.unbindTexture();
        }
      }
    }, this.updateMultisampleRenderTarget = function (e) {
      if (o && e.samples > 0 && !1 === it(e)) {
        var _r78 = e.width,
            _s33 = e.height;
        var _a29 = 16384;

        var _o18 = [36064],
            _l25 = e.stencilBuffer ? 33306 : 36096;

        e.depthBuffer && _o18.push(_l25);

        var _c17 = i.get(e),
            _h16 = void 0 === _c17.__ignoreDepthValues || _c17.__ignoreDepthValues;

        !1 === _h16 && (e.depthBuffer && (_a29 |= 256), e.stencilBuffer && (_a29 |= 1024)), n.bindFramebuffer(36008, _c17.__webglMultisampledFramebuffer), n.bindFramebuffer(36009, _c17.__webglFramebuffer), !0 === _h16 && (t.invalidateFramebuffer(36008, [_l25]), t.invalidateFramebuffer(36009, [_l25])), t.blitFramebuffer(0, 0, _r78, _s33, 0, 0, _r78, _s33, _a29, 9728), t.invalidateFramebuffer(36008, _o18), n.bindFramebuffer(36008, null), n.bindFramebuffer(36009, _c17.__webglMultisampledFramebuffer);
      }
    }, this.setupDepthRenderbuffer = et, this.setupFrameBufferTexture = $, this.useMultisampledRTT = it;
  }

  function Xs(t, e, n) {
    var i = n.isWebGL2;
    return {
      convert: function convert(t) {
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var r;
        if (t === x) return 5121;
        if (1017 === t) return 32819;
        if (1018 === t) return 32820;
        if (1010 === t) return 5120;
        if (1011 === t) return 5122;
        if (t === _) return 5123;
        if (1013 === t) return 5124;
        if (t === M) return 5125;
        if (t === b) return 5126;
        if (t === w) return i ? 5131 : (r = e.get("OES_texture_half_float"), null !== r ? r.HALF_FLOAT_OES : null);
        if (1021 === t) return 6406;
        if (t === T) return 6408;
        if (1024 === t) return 6409;
        if (1025 === t) return 6410;
        if (t === E) return 6402;
        if (t === A) return 34041;
        if (1028 === t) return 6403;
        if (1022 === t) return console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228"), 6408;
        if (t === pt) return r = e.get("EXT_sRGB"), null !== r ? r.SRGB_ALPHA_EXT : null;
        if (1029 === t) return 36244;
        if (1030 === t) return 33319;
        if (1031 === t) return 33320;
        if (1033 === t) return 36249;
        if (t === R || t === C || t === L || t === P) if (n === lt) {
          if (r = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === r) return null;
          if (t === R) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (t === C) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (t === L) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (t === P) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else {
          if (r = e.get("WEBGL_compressed_texture_s3tc"), null === r) return null;
          if (t === R) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (t === C) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (t === L) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (t === P) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        }

        if (t === D || t === I || t === N || t === B) {
          if (r = e.get("WEBGL_compressed_texture_pvrtc"), null === r) return null;
          if (t === D) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
          if (t === I) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
          if (t === N) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
          if (t === B) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
        }

        if (36196 === t) return r = e.get("WEBGL_compressed_texture_etc1"), null !== r ? r.COMPRESSED_RGB_ETC1_WEBGL : null;

        if (t === z || t === O) {
          if (r = e.get("WEBGL_compressed_texture_etc"), null === r) return null;
          if (t === z) return n === lt ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
          if (t === O) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
        }

        if (t === U || t === F || t === H || t === G || t === V || t === k || t === W || t === j || t === q || t === X || t === J || t === Y || t === Z || t === K) {
          if (r = e.get("WEBGL_compressed_texture_astc"), null === r) return null;
          if (t === U) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
          if (t === F) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
          if (t === H) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
          if (t === G) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
          if (t === V) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
          if (t === k) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
          if (t === W) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
          if (t === j) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
          if (t === q) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
          if (t === X) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
          if (t === J) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
          if (t === Y) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
          if (t === Z) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
          if (t === K) return n === lt ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
        }

        if (t === Q) {
          if (r = e.get("EXT_texture_compression_bptc"), null === r) return null;
          if (t === Q) return n === lt ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        }

        return t === S ? i ? 34042 : (r = e.get("WEBGL_depth_texture"), null !== r ? r.UNSIGNED_INT_24_8_WEBGL : null) : void 0;
      }
    };
  }

  var Js = /*#__PURE__*/function (_hi) {
    _inherits(Js, _hi);

    var _super34 = _createSuper(Js);

    function Js() {
      var _this24;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      _classCallCheck(this, Js);

      _this24 = _super34.call(this), _this24.cameras = t;
      return _this24;
    }

    return _createClass(Js);
  }(hi);

  Js.prototype.isArrayCamera = !0;

  var Ys = /*#__PURE__*/function (_nn4) {
    _inherits(Ys, _nn4);

    var _super35 = _createSuper(Ys);

    function Ys() {
      var _this25;

      _classCallCheck(this, Ys);

      _this25 = _super35.call(this), _this25.type = "Group";
      return _this25;
    }

    return _createClass(Ys);
  }(nn);

  Ys.prototype.isGroup = !0;
  var Zs = {
    type: "move"
  };

  var Ks = /*#__PURE__*/function () {
    function Ks() {
      _classCallCheck(this, Ks);

      this._targetRay = null, this._grip = null, this._hand = null;
    }

    _createClass(Ks, [{
      key: "getHandSpace",
      value: function getHandSpace() {
        return null === this._hand && (this._hand = new Ys(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
          pinching: !1
        }), this._hand;
      }
    }, {
      key: "getTargetRaySpace",
      value: function getTargetRaySpace() {
        return null === this._targetRay && (this._targetRay = new Ys(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new te(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new te()), this._targetRay;
      }
    }, {
      key: "getGripSpace",
      value: function getGripSpace() {
        return null === this._grip && (this._grip = new Ys(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new te(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new te()), this._grip;
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(t) {
        return null !== this._targetRay && this._targetRay.dispatchEvent(t), null !== this._grip && this._grip.dispatchEvent(t), null !== this._hand && this._hand.dispatchEvent(t), this;
      }
    }, {
      key: "disconnect",
      value: function disconnect(t) {
        return this.dispatchEvent({
          type: "disconnected",
          data: t
        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
      }
    }, {
      key: "update",
      value: function update(t, e, n) {
        var i = null,
            r = null,
            s = null;
        var a = this._targetRay,
            o = this._grip,
            l = this._hand;
        if (t && "visible-blurred" !== e.session.visibilityState) if (null !== a && (i = e.getPose(t.targetRaySpace, n), null !== i && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(Zs))), l && t.hand) {
          s = !0;

          var _iterator2 = _createForOfIteratorHelper(t.hand.values()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _i95 = _step2.value;

              var _t146 = e.getJointPose(_i95, n);

              if (void 0 === l.joints[_i95.jointName]) {
                var _t147 = new Ys();

                _t147.matrixAutoUpdate = !1, _t147.visible = !1, l.joints[_i95.jointName] = _t147, l.add(_t147);
              }

              var _r80 = l.joints[_i95.jointName];
              null !== _t146 && (_r80.matrix.fromArray(_t146.transform.matrix), _r80.matrix.decompose(_r80.position, _r80.rotation, _r80.scale), _r80.jointRadius = _t146.radius), _r80.visible = null !== _t146;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var _i94 = l.joints["index-finger-tip"],
              _r79 = l.joints["thumb-tip"],
              _a30 = _i94.position.distanceTo(_r79.position),
              _o19 = .02,
              _c18 = .005;

          l.inputState.pinching && _a30 > _o19 + _c18 ? (l.inputState.pinching = !1, this.dispatchEvent({
            type: "pinchend",
            handedness: t.handedness,
            target: this
          })) : !l.inputState.pinching && _a30 <= _o19 - _c18 && (l.inputState.pinching = !0, this.dispatchEvent({
            type: "pinchstart",
            handedness: t.handedness,
            target: this
          }));
        } else null !== o && t.gripSpace && (r = e.getPose(t.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
        return null !== a && (a.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== s), this;
      }
    }]);

    return Ks;
  }();

  var Qs = /*#__PURE__*/function (_jt4) {
    _inherits(Qs, _jt4);

    var _super36 = _createSuper(Qs);

    function Qs(t, e, n, i, r, s, a, o, l, c) {
      var _this26;

      _classCallCheck(this, Qs);

      if ((c = void 0 !== c ? c : E) !== E && c !== A) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
      void 0 === n && c === E && (n = _), void 0 === n && c === A && (n = S), _this26 = _super36.call(this, null, i, r, s, a, o, c, n, l), _this26.image = {
        width: t,
        height: e
      }, _this26.magFilter = void 0 !== a ? a : p, _this26.minFilter = void 0 !== o ? o : p, _this26.flipY = !1, _this26.generateMipmaps = !1;
      return _this26;
    }

    return _createClass(Qs);
  }(jt);

  Qs.prototype.isDepthTexture = !0;

  var $s = /*#__PURE__*/function (_mt6) {
    _inherits($s, _mt6);

    var _super37 = _createSuper($s);

    function $s(t, e) {
      var _this27;

      _classCallCheck(this, $s);

      _this27 = _super37.call(this);

      var n = _assertThisInitialized(_this27);

      var i = null,
          r = 1,
          s = null,
          a = "local-floor",
          o = null,
          l = null,
          c = null,
          h = null,
          u = null;
      var d = e.getContextAttributes();
      var p = null,
          m = null;
      var f = [],
          g = new Map(),
          v = new hi();
      v.layers.enable(1), v.viewport = new qt();
      var y = new hi();
      y.layers.enable(2), y.viewport = new qt();
      var M = [v, y],
          b = new Js();
      b.layers.enable(1), b.layers.enable(2);
      var w = null,
          R = null;

      function C(t) {
        var e = g.get(t.inputSource);
        e && e.dispatchEvent({
          type: t.type,
          data: t.inputSource
        });
      }

      function L() {
        g.forEach(function (t, e) {
          t.disconnect(e);
        }), g.clear(), w = null, R = null, t.setRenderTarget(p), h = null, c = null, l = null, i = null, m = null, z.stop(), n.isPresenting = !1, n.dispatchEvent({
          type: "sessionend"
        });
      }

      function P(t) {
        var e = i.inputSources;

        for (var _t148 = 0; _t148 < f.length; _t148++) {
          g.set(e[_t148], f[_t148]);
        }

        for (var _e107 = 0; _e107 < t.removed.length; _e107++) {
          var _n113 = t.removed[_e107],
              _i96 = g.get(_n113);

          _i96 && (_i96.dispatchEvent({
            type: "disconnected",
            data: _n113
          }), g.delete(_n113));
        }

        for (var _e108 = 0; _e108 < t.added.length; _e108++) {
          var _n114 = t.added[_e108],
              _i97 = g.get(_n114);

          _i97 && _i97.dispatchEvent({
            type: "connected",
            data: _n114
          });
        }
      }

      _this27.cameraAutoUpdate = !0, _this27.enabled = !1, _this27.isPresenting = !1, _this27.getController = function (t) {
        var e = f[t];
        return void 0 === e && (e = new Ks(), f[t] = e), e.getTargetRaySpace();
      }, _this27.getControllerGrip = function (t) {
        var e = f[t];
        return void 0 === e && (e = new Ks(), f[t] = e), e.getGripSpace();
      }, _this27.getHand = function (t) {
        var e = f[t];
        return void 0 === e && (e = new Ks(), f[t] = e), e.getHandSpace();
      }, _this27.setFramebufferScaleFactor = function (t) {
        r = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }, _this27.setReferenceSpaceType = function (t) {
        a = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
      }, _this27.getReferenceSpace = function () {
        return s;
      }, _this27.getBaseLayer = function () {
        return null !== c ? c : h;
      }, _this27.getBinding = function () {
        return l;
      }, _this27.getFrame = function () {
        return u;
      }, _this27.getSession = function () {
        return i;
      }, _this27.setSession = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(o) {
          var _n115, _n116, _s34, _a31, _o20;

          return _regeneratorRuntime.wrap(function _callee$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(i = o, null !== i)) {
                    _context4.next = 33;
                    break;
                  }

                  p = t.getRenderTarget();
                  i.addEventListener("select", C);
                  i.addEventListener("selectstart", C);
                  i.addEventListener("selectend", C);
                  i.addEventListener("squeeze", C);
                  i.addEventListener("squeezestart", C);
                  i.addEventListener("squeezeend", C);
                  i.addEventListener("end", L);
                  i.addEventListener("inputsourceschange", P);
                  _context4.t0 = !0 !== d.xrCompatible;

                  if (!_context4.t0) {
                    _context4.next = 14;
                    break;
                  }

                  _context4.next = 14;
                  return e.makeXRCompatible();

                case 14:
                  if (!(void 0 === i.renderState.layers || !1 === t.capabilities.isWebGL2)) {
                    _context4.next = 19;
                    break;
                  }

                  _n115 = {
                    antialias: void 0 !== i.renderState.layers || d.antialias,
                    alpha: d.alpha,
                    depth: d.depth,
                    stencil: d.stencil,
                    framebufferScaleFactor: r
                  };
                  h = new XRWebGLLayer(i, e, _n115), i.updateRenderState({
                    baseLayer: h
                  }), m = new Xt(h.framebufferWidth, h.framebufferHeight, {
                    format: T,
                    type: x,
                    encoding: t.outputEncoding
                  });
                  _context4.next = 24;
                  break;

                case 19:
                  _n116 = null, _s34 = null, _a31 = null;
                  d.depth && (_a31 = d.stencil ? 35056 : 33190, _n116 = d.stencil ? A : E, _s34 = d.stencil ? S : _);
                  _o20 = {
                    colorFormat: t.outputEncoding === lt ? 35907 : 32856,
                    depthFormat: _a31,
                    scaleFactor: r
                  };
                  l = new XRWebGLBinding(i, e), c = l.createProjectionLayer(_o20), i.updateRenderState({
                    layers: [c]
                  }), m = new Xt(c.textureWidth, c.textureHeight, {
                    format: T,
                    type: x,
                    depthTexture: new Qs(c.textureWidth, c.textureHeight, _s34, void 0, void 0, void 0, void 0, void 0, void 0, _n116),
                    stencilBuffer: d.stencil,
                    encoding: t.outputEncoding,
                    samples: d.antialias ? 4 : 0
                  });
                  t.properties.get(m).__ignoreDepthValues = c.ignoreDepthValues;

                case 24:
                  m.isXRRenderTarget = !0;
                  this.setFoveation(1);
                  _context4.next = 28;
                  return i.requestReferenceSpace(a);

                case 28:
                  s = _context4.sent;
                  z.setContext(i);
                  z.start();
                  n.isPresenting = !0;
                  n.dispatchEvent({
                    type: "sessionstart"
                  });

                case 33:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x6) {
          return _ref2.apply(this, arguments);
        };
      }();
      var D = new te(),
          I = new te();

      function N(t, e) {
        null === e ? t.matrixWorld.copy(t.matrix) : t.matrixWorld.multiplyMatrices(e.matrixWorld, t.matrix), t.matrixWorldInverse.copy(t.matrixWorld).invert();
      }

      _this27.updateCamera = function (t) {
        if (null === i) return;
        b.near = y.near = v.near = t.near, b.far = y.far = v.far = t.far, w === b.near && R === b.far || (i.updateRenderState({
          depthNear: b.near,
          depthFar: b.far
        }), w = b.near, R = b.far);
        var e = t.parent,
            n = b.cameras;
        N(b, e);

        for (var _t149 = 0; _t149 < n.length; _t149++) {
          N(n[_t149], e);
        }

        b.matrixWorld.decompose(b.position, b.quaternion, b.scale), t.position.copy(b.position), t.quaternion.copy(b.quaternion), t.scale.copy(b.scale), t.matrix.copy(b.matrix), t.matrixWorld.copy(b.matrixWorld);
        var r = t.children;

        for (var _t150 = 0, _e109 = r.length; _t150 < _e109; _t150++) {
          r[_t150].updateMatrixWorld(!0);
        }

        2 === n.length ? function (t, e, n) {
          D.setFromMatrixPosition(e.matrixWorld), I.setFromMatrixPosition(n.matrixWorld);
          var i = D.distanceTo(I),
              r = e.projectionMatrix.elements,
              s = n.projectionMatrix.elements,
              a = r[14] / (r[10] - 1),
              o = r[14] / (r[10] + 1),
              l = (r[9] + 1) / r[5],
              c = (r[9] - 1) / r[5],
              h = (r[8] - 1) / r[0],
              u = (s[8] + 1) / s[0],
              d = a * h,
              p = a * u,
              m = i / (-h + u),
              f = m * -h;
          e.matrixWorld.decompose(t.position, t.quaternion, t.scale), t.translateX(f), t.translateZ(m), t.matrixWorld.compose(t.position, t.quaternion, t.scale), t.matrixWorldInverse.copy(t.matrixWorld).invert();

          var g = a + m,
              v = o + m,
              y = d - f,
              x = p + (i - f),
              _ = l * o / v * g,
              M = c * o / v * g;

          t.projectionMatrix.makePerspective(y, x, _, M, g, v);
        }(b, v, y) : b.projectionMatrix.copy(v.projectionMatrix);
      }, _this27.getCamera = function () {
        return b;
      }, _this27.getFoveation = function () {
        return null !== c ? c.fixedFoveation : null !== h ? h.fixedFoveation : void 0;
      }, _this27.setFoveation = function (t) {
        null !== c && (c.fixedFoveation = t), null !== h && void 0 !== h.fixedFoveation && (h.fixedFoveation = t);
      };
      var B = null;
      var z = new bi();
      z.setAnimationLoop(function (e, n) {
        if (o = n.getViewerPose(s), u = n, null !== o) {
          var _e110 = o.views;
          null !== h && (t.setRenderTargetFramebuffer(m, h.framebuffer), t.setRenderTarget(m));

          var _n117 = !1;

          _e110.length !== b.cameras.length && (b.cameras.length = 0, _n117 = !0);

          for (var _i98 = 0; _i98 < _e110.length; _i98++) {
            var _r81 = _e110[_i98];
            var _s35 = null;
            if (null !== h) _s35 = h.getViewport(_r81);else {
              var _e111 = l.getViewSubImage(c, _r81);

              _s35 = _e111.viewport, 0 === _i98 && (t.setRenderTargetTextures(m, _e111.colorTexture, c.ignoreDepthValues ? void 0 : _e111.depthStencilTexture), t.setRenderTarget(m));
            }
            var _a32 = M[_i98];
            _a32.matrix.fromArray(_r81.transform.matrix), _a32.projectionMatrix.fromArray(_r81.projectionMatrix), _a32.viewport.set(_s35.x, _s35.y, _s35.width, _s35.height), 0 === _i98 && b.matrix.copy(_a32.matrix), !0 === _n117 && b.cameras.push(_a32);
          }
        }

        var r = i.inputSources;

        for (var _t151 = 0; _t151 < f.length; _t151++) {
          var _e112 = f[_t151],
              _i99 = r[_t151];

          _e112.update(_i99, n, s);
        }

        B && B(e, n), u = null;
      }), _this27.setAnimationLoop = function (t) {
        B = t;
      }, _this27.dispose = function () {};
      return _this27;
    }

    return _createClass($s);
  }(mt);

  function ta(t) {
    function e(e, n) {
      e.opacity.value = n.opacity, n.color && e.diffuse.value.copy(n.color), n.emissive && e.emissive.value.copy(n.emissive).multiplyScalar(n.emissiveIntensity), n.map && (e.map.value = n.map), n.alphaMap && (e.alphaMap.value = n.alphaMap), n.specularMap && (e.specularMap.value = n.specularMap), n.alphaTest > 0 && (e.alphaTest.value = n.alphaTest);
      var i = t.get(n).envMap;
      var r, s;
      i && (e.envMap.value = i, e.flipEnvMap.value = i.isCubeTexture && !1 === i.isRenderTargetTexture ? -1 : 1, e.reflectivity.value = n.reflectivity, e.ior.value = n.ior, e.refractionRatio.value = n.refractionRatio), n.lightMap && (e.lightMap.value = n.lightMap, e.lightMapIntensity.value = n.lightMapIntensity), n.aoMap && (e.aoMap.value = n.aoMap, e.aoMapIntensity.value = n.aoMapIntensity), n.map ? r = n.map : n.specularMap ? r = n.specularMap : n.displacementMap ? r = n.displacementMap : n.normalMap ? r = n.normalMap : n.bumpMap ? r = n.bumpMap : n.roughnessMap ? r = n.roughnessMap : n.metalnessMap ? r = n.metalnessMap : n.alphaMap ? r = n.alphaMap : n.emissiveMap ? r = n.emissiveMap : n.clearcoatMap ? r = n.clearcoatMap : n.clearcoatNormalMap ? r = n.clearcoatNormalMap : n.clearcoatRoughnessMap ? r = n.clearcoatRoughnessMap : n.specularIntensityMap ? r = n.specularIntensityMap : n.specularColorMap ? r = n.specularColorMap : n.transmissionMap ? r = n.transmissionMap : n.thicknessMap ? r = n.thicknessMap : n.sheenColorMap ? r = n.sheenColorMap : n.sheenRoughnessMap && (r = n.sheenRoughnessMap), void 0 !== r && (r.isWebGLRenderTarget && (r = r.texture), !0 === r.matrixAutoUpdate && r.updateMatrix(), e.uvTransform.value.copy(r.matrix)), n.aoMap ? s = n.aoMap : n.lightMap && (s = n.lightMap), void 0 !== s && (s.isWebGLRenderTarget && (s = s.texture), !0 === s.matrixAutoUpdate && s.updateMatrix(), e.uv2Transform.value.copy(s.matrix));
    }

    function n(e, n) {
      e.roughness.value = n.roughness, e.metalness.value = n.metalness, n.roughnessMap && (e.roughnessMap.value = n.roughnessMap), n.metalnessMap && (e.metalnessMap.value = n.metalnessMap), n.emissiveMap && (e.emissiveMap.value = n.emissiveMap), n.bumpMap && (e.bumpMap.value = n.bumpMap, e.bumpScale.value = n.bumpScale, 1 === n.side && (e.bumpScale.value *= -1)), n.normalMap && (e.normalMap.value = n.normalMap, e.normalScale.value.copy(n.normalScale), 1 === n.side && e.normalScale.value.negate()), n.displacementMap && (e.displacementMap.value = n.displacementMap, e.displacementScale.value = n.displacementScale, e.displacementBias.value = n.displacementBias);
      t.get(n).envMap && (e.envMapIntensity.value = n.envMapIntensity);
    }

    return {
      refreshFogUniforms: function refreshFogUniforms(t, e) {
        t.fogColor.value.copy(e.color), e.isFog ? (t.fogNear.value = e.near, t.fogFar.value = e.far) : e.isFogExp2 && (t.fogDensity.value = e.density);
      },
      refreshMaterialUniforms: function refreshMaterialUniforms(t, i, r, s, a) {
        i.isMeshBasicMaterial ? e(t, i) : i.isMeshLambertMaterial ? (e(t, i), function (t, e) {
          e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
        }(t, i)) : i.isMeshToonMaterial ? (e(t, i), function (t, e) {
          e.gradientMap && (t.gradientMap.value = e.gradientMap);
          e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
          e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
          e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
          e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
        }(t, i)) : i.isMeshPhongMaterial ? (e(t, i), function (t, e) {
          t.specular.value.copy(e.specular), t.shininess.value = Math.max(e.shininess, 1e-4), e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
          e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
          e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
          e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
        }(t, i)) : i.isMeshStandardMaterial ? (e(t, i), i.isMeshPhysicalMaterial ? function (t, e, i) {
          n(t, e), t.ior.value = e.ior, e.sheen > 0 && (t.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t.sheenColorMap.value = e.sheenColorMap), e.sheenRoughnessMap && (t.sheenRoughnessMap.value = e.sheenRoughnessMap));
          e.clearcoat > 0 && (t.clearcoat.value = e.clearcoat, t.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t.clearcoatMap.value = e.clearcoatMap), e.clearcoatRoughnessMap && (t.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap), e.clearcoatNormalMap && (t.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), t.clearcoatNormalMap.value = e.clearcoatNormalMap, 1 === e.side && t.clearcoatNormalScale.value.negate()));
          e.transmission > 0 && (t.transmission.value = e.transmission, t.transmissionSamplerMap.value = i.texture, t.transmissionSamplerSize.value.set(i.width, i.height), e.transmissionMap && (t.transmissionMap.value = e.transmissionMap), t.thickness.value = e.thickness, e.thicknessMap && (t.thicknessMap.value = e.thicknessMap), t.attenuationDistance.value = e.attenuationDistance, t.attenuationColor.value.copy(e.attenuationColor));
          t.specularIntensity.value = e.specularIntensity, t.specularColor.value.copy(e.specularColor), e.specularIntensityMap && (t.specularIntensityMap.value = e.specularIntensityMap);
          e.specularColorMap && (t.specularColorMap.value = e.specularColorMap);
        }(t, i, a) : n(t, i)) : i.isMeshMatcapMaterial ? (e(t, i), function (t, e) {
          e.matcap && (t.matcap.value = e.matcap);
          e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
          e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
          e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
        }(t, i)) : i.isMeshDepthMaterial ? (e(t, i), function (t, e) {
          e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
        }(t, i)) : i.isMeshDistanceMaterial ? (e(t, i), function (t, e) {
          e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
          t.referencePosition.value.copy(e.referencePosition), t.nearDistance.value = e.nearDistance, t.farDistance.value = e.farDistance;
        }(t, i)) : i.isMeshNormalMaterial ? (e(t, i), function (t, e) {
          e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
          e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
          e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
        }(t, i)) : i.isLineBasicMaterial ? (function (t, e) {
          t.diffuse.value.copy(e.color), t.opacity.value = e.opacity;
        }(t, i), i.isLineDashedMaterial && function (t, e) {
          t.dashSize.value = e.dashSize, t.totalSize.value = e.dashSize + e.gapSize, t.scale.value = e.scale;
        }(t, i)) : i.isPointsMaterial ? function (t, e, n, i) {
          t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.size.value = e.size * n, t.scale.value = .5 * i, e.map && (t.map.value = e.map);
          e.alphaMap && (t.alphaMap.value = e.alphaMap);
          e.alphaTest > 0 && (t.alphaTest.value = e.alphaTest);
          var r;
          e.map ? r = e.map : e.alphaMap && (r = e.alphaMap);
          void 0 !== r && (!0 === r.matrixAutoUpdate && r.updateMatrix(), t.uvTransform.value.copy(r.matrix));
        }(t, i, r, s) : i.isSpriteMaterial ? function (t, e) {
          t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.rotation.value = e.rotation, e.map && (t.map.value = e.map);
          e.alphaMap && (t.alphaMap.value = e.alphaMap);
          e.alphaTest > 0 && (t.alphaTest.value = e.alphaTest);
          var n;
          e.map ? n = e.map : e.alphaMap && (n = e.alphaMap);
          void 0 !== n && (!0 === n.matrixAutoUpdate && n.updateMatrix(), t.uvTransform.value.copy(n.matrix));
        }(t, i) : i.isShadowMaterial ? (t.color.value.copy(i.color), t.opacity.value = i.opacity) : i.isShaderMaterial && (i.uniformsNeedUpdate = !1);
      }
    };
  }

  function ea() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var e = void 0 !== t.canvas ? t.canvas : function () {
      var t = Dt("canvas");
      return t.style.display = "block", t;
    }(),
        n = void 0 !== t.context ? t.context : null,
        i = void 0 === t.depth || t.depth,
        r = void 0 === t.stencil || t.stencil,
        s = void 0 !== t.antialias && t.antialias,
        a = void 0 === t.premultipliedAlpha || t.premultipliedAlpha,
        o = void 0 !== t.preserveDrawingBuffer && t.preserveDrawingBuffer,
        l = void 0 !== t.powerPreference ? t.powerPreference : "default",
        c = void 0 !== t.failIfMajorPerformanceCaveat && t.failIfMajorPerformanceCaveat;
    var h;
    h = void 0 !== t.context ? n.getContextAttributes().alpha : void 0 !== t.alpha && t.alpha;
    var u = null,
        d = null;
    var p = [],
        m = [];
    this.domElement = e, this.debug = {
      checkShaderErrors: !0
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = ot, this.physicallyCorrectLights = !1, this.toneMapping = 0, this.toneMappingExposure = 1;
    var f = this;
    var g = !1,
        v = 0,
        _ = 0,
        M = null,
        S = -1,
        E = null;
    var A = new qt(),
        R = new qt();
    var C = null,
        L = e.width,
        P = e.height,
        D = 1,
        I = null,
        N = null;
    var B = new qt(0, 0, L, P),
        z = new qt(0, 0, L, P);
    var O = !1;
    var U = new Mi();
    var F = !1,
        H = !1,
        G = null;
    var V = new Pe(),
        k = new At(),
        W = new te(),
        j = {
      background: null,
      fog: null,
      environment: null,
      overrideMaterial: null,
      isScene: !0
    };

    function q() {
      return null === M ? D : 1;
    }

    var X,
        J,
        Y,
        Z,
        K,
        Q,
        $,
        tt,
        et,
        nt,
        it,
        rt,
        st,
        at,
        lt,
        ct,
        ht,
        ut,
        dt,
        pt,
        mt,
        ft,
        gt,
        vt = n;

    function yt(t, n) {
      for (var _i100 = 0; _i100 < t.length; _i100++) {
        var _r82 = t[_i100],
            _s36 = e.getContext(_r82, n);

        if (null !== _s36) return _s36;
      }

      return null;
    }

    try {
      var _t152 = {
        alpha: !0,
        depth: i,
        stencil: r,
        antialias: s,
        premultipliedAlpha: a,
        preserveDrawingBuffer: o,
        powerPreference: l,
        failIfMajorPerformanceCaveat: c
      };

      if ("setAttribute" in e && e.setAttribute("data-engine", "three.js r138"), e.addEventListener("webglcontextlost", Mt, !1), e.addEventListener("webglcontextrestored", bt, !1), null === vt) {
        var _e113 = ["webgl2", "webgl", "experimental-webgl"];
        if (!0 === f.isWebGL1Renderer && _e113.shift(), vt = yt(_e113, _t152), null === vt) throw yt(_e113) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }

      void 0 === vt.getShaderPrecisionFormat && (vt.getShaderPrecisionFormat = function () {
        return {
          rangeMin: 1,
          rangeMax: 1,
          precision: 1
        };
      });
    } catch (t) {
      throw console.error("THREE.WebGLRenderer: " + t.message), t;
    }

    function xt() {
      X = new Zi(vt), J = new Pi(vt, X, t), X.init(J), ft = new Xs(vt, X, J), Y = new js(vt, X, J), Z = new $i(vt), K = new Ps(), Q = new qs(vt, X, Y, K, J, ft, Z), $ = new Ii(f), tt = new Yi(f), et = new wi(vt, J), gt = new Ci(vt, X, et, J), nt = new Ki(vt, et, Z, gt), it = new rr(vt, nt, et, Z), dt = new ir(vt, J, Q), ct = new Di(K), rt = new Ls(f, $, tt, X, J, gt, ct), st = new ta(K), at = new Bs(), lt = new Gs(X, J), ut = new Ri(f, $, Y, it, h, a), ht = new Ws(f, it, J), pt = new Li(vt, X, Z, J), mt = new Qi(vt, X, Z, J), Z.programs = rt.programs, f.capabilities = J, f.extensions = X, f.properties = K, f.renderLists = at, f.shadowMap = ht, f.state = Y, f.info = Z;
    }

    xt();

    var _t = new $s(f, vt);

    function Mt(t) {
      t.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
    }

    function bt() {
      console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
      var t = Z.autoReset,
          e = ht.enabled,
          n = ht.autoUpdate,
          i = ht.needsUpdate,
          r = ht.type;
      xt(), Z.autoReset = t, ht.enabled = e, ht.autoUpdate = n, ht.needsUpdate = i, ht.type = r;
    }

    function wt(t) {
      var e = t.target;
      e.removeEventListener("dispose", wt), function (t) {
        (function (t) {
          var e = K.get(t).programs;
          void 0 !== e && (e.forEach(function (t) {
            rt.releaseProgram(t);
          }), t.isShaderMaterial && rt.releaseShaderCache(t));
        })(t), K.remove(t);
      }(e);
    }

    this.xr = _t, this.getContext = function () {
      return vt;
    }, this.getContextAttributes = function () {
      return vt.getContextAttributes();
    }, this.forceContextLoss = function () {
      var t = X.get("WEBGL_lose_context");
      t && t.loseContext();
    }, this.forceContextRestore = function () {
      var t = X.get("WEBGL_lose_context");
      t && t.restoreContext();
    }, this.getPixelRatio = function () {
      return D;
    }, this.setPixelRatio = function (t) {
      void 0 !== t && (D = t, this.setSize(L, P, !1));
    }, this.getSize = function (t) {
      return t.set(L, P);
    }, this.setSize = function (t, n, i) {
      _t.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (L = t, P = n, e.width = Math.floor(t * D), e.height = Math.floor(n * D), !1 !== i && (e.style.width = t + "px", e.style.height = n + "px"), this.setViewport(0, 0, t, n));
    }, this.getDrawingBufferSize = function (t) {
      return t.set(L * D, P * D).floor();
    }, this.setDrawingBufferSize = function (t, n, i) {
      L = t, P = n, D = i, e.width = Math.floor(t * i), e.height = Math.floor(n * i), this.setViewport(0, 0, t, n);
    }, this.getCurrentViewport = function (t) {
      return t.copy(A);
    }, this.getViewport = function (t) {
      return t.copy(B);
    }, this.setViewport = function (t, e, n, i) {
      t.isVector4 ? B.set(t.x, t.y, t.z, t.w) : B.set(t, e, n, i), Y.viewport(A.copy(B).multiplyScalar(D).floor());
    }, this.getScissor = function (t) {
      return t.copy(z);
    }, this.setScissor = function (t, e, n, i) {
      t.isVector4 ? z.set(t.x, t.y, t.z, t.w) : z.set(t, e, n, i), Y.scissor(R.copy(z).multiplyScalar(D).floor());
    }, this.getScissorTest = function () {
      return O;
    }, this.setScissorTest = function (t) {
      Y.setScissorTest(O = t);
    }, this.setOpaqueSort = function (t) {
      I = t;
    }, this.setTransparentSort = function (t) {
      N = t;
    }, this.getClearColor = function (t) {
      return t.copy(ut.getClearColor());
    }, this.setClearColor = function () {
      ut.setClearColor.apply(ut, arguments);
    }, this.getClearAlpha = function () {
      return ut.getClearAlpha();
    }, this.setClearAlpha = function () {
      ut.setClearAlpha.apply(ut, arguments);
    }, this.clear = function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var i = 0;
      t && (i |= 16384), e && (i |= 256), n && (i |= 1024), vt.clear(i);
    }, this.clearColor = function () {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function () {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function () {
      this.clear(!1, !1, !0);
    }, this.dispose = function () {
      e.removeEventListener("webglcontextlost", Mt, !1), e.removeEventListener("webglcontextrestored", bt, !1), at.dispose(), lt.dispose(), K.dispose(), $.dispose(), tt.dispose(), it.dispose(), gt.dispose(), rt.dispose(), _t.dispose(), _t.removeEventListener("sessionstart", Et), _t.removeEventListener("sessionend", Rt), G && (G.dispose(), G = null), Ct.stop();
    }, this.renderBufferDirect = function (t, e, n, i, r, s) {
      null === e && (e = j);

      var a = r.isMesh && r.matrixWorld.determinant() < 0,
          o = function (t, e, n, i, r) {
        !0 !== e.isScene && (e = j);
        Q.resetTextureUnits();
        var s = e.fog,
            a = i.isMeshStandardMaterial ? e.environment : null,
            o = null === M ? f.outputEncoding : !0 === M.isXRRenderTarget ? M.texture.encoding : ot,
            l = (i.isMeshStandardMaterial ? tt : $).get(i.envMap || a),
            c = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize,
            h = !!i.normalMap && !!n.attributes.tangent,
            u = !!n.morphAttributes.position,
            p = !!n.morphAttributes.normal,
            m = !!n.morphAttributes.color,
            g = i.toneMapped ? f.toneMapping : 0,
            v = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color,
            y = void 0 !== v ? v.length : 0,
            x = K.get(i),
            _ = d.state.lights;

        if (!0 === F && (!0 === H || t !== E)) {
          var _e114 = t === E && i.id === S;

          ct.setState(i, t, _e114);
        }

        var b = !1;
        i.version === x.__version ? x.needsLights && x.lightsStateVersion !== _.state.version || x.outputEncoding !== o || r.isInstancedMesh && !1 === x.instancing ? b = !0 : r.isInstancedMesh || !0 !== x.instancing ? r.isSkinnedMesh && !1 === x.skinning ? b = !0 : r.isSkinnedMesh || !0 !== x.skinning ? x.envMap !== l || i.fog && x.fog !== s ? b = !0 : void 0 === x.numClippingPlanes || x.numClippingPlanes === ct.numPlanes && x.numIntersection === ct.numIntersection ? (x.vertexAlphas !== c || x.vertexTangents !== h || x.morphTargets !== u || x.morphNormals !== p || x.morphColors !== m || x.toneMapping !== g || !0 === J.isWebGL2 && x.morphTargetsCount !== y) && (b = !0) : b = !0 : b = !0 : b = !0 : (b = !0, x.__version = i.version);
        var w = x.currentProgram;
        !0 === b && (w = Bt(i, e, r));
        var T = !1,
            A = !1,
            R = !1;
        var C = w.getUniforms(),
            L = x.uniforms;
        Y.useProgram(w.program) && (T = !0, A = !0, R = !0);
        i.id !== S && (S = i.id, A = !0);

        if (T || E !== t) {
          if (C.setValue(vt, "projectionMatrix", t.projectionMatrix), J.logarithmicDepthBuffer && C.setValue(vt, "logDepthBufFC", 2 / (Math.log(t.far + 1) / Math.LN2)), E !== t && (E = t, A = !0, R = !0), i.isShaderMaterial || i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshStandardMaterial || i.envMap) {
            var _e115 = C.map.cameraPosition;
            void 0 !== _e115 && _e115.setValue(vt, W.setFromMatrixPosition(t.matrixWorld));
          }

          (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && C.setValue(vt, "isOrthographic", !0 === t.isOrthographicCamera), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial || i.isShadowMaterial || r.isSkinnedMesh) && C.setValue(vt, "viewMatrix", t.matrixWorldInverse);
        }

        if (r.isSkinnedMesh) {
          C.setOptional(vt, r, "bindMatrix"), C.setOptional(vt, r, "bindMatrixInverse");
          var _t153 = r.skeleton;
          _t153 && (J.floatVertexTextures ? (null === _t153.boneTexture && _t153.computeBoneTexture(), C.setValue(vt, "boneTexture", _t153.boneTexture, Q), C.setValue(vt, "boneTextureSize", _t153.boneTextureSize)) : C.setOptional(vt, _t153, "boneMatrices"));
        }

        var I = n.morphAttributes;
        (void 0 !== I.position || void 0 !== I.normal || void 0 !== I.color && !0 === J.isWebGL2) && dt.update(r, n, i, w);
        (A || x.receiveShadow !== r.receiveShadow) && (x.receiveShadow = r.receiveShadow, C.setValue(vt, "receiveShadow", r.receiveShadow));
        A && (C.setValue(vt, "toneMappingExposure", f.toneMappingExposure), x.needsLights && (B = R, (N = L).ambientLightColor.needsUpdate = B, N.lightProbe.needsUpdate = B, N.directionalLights.needsUpdate = B, N.directionalLightShadows.needsUpdate = B, N.pointLights.needsUpdate = B, N.pointLightShadows.needsUpdate = B, N.spotLights.needsUpdate = B, N.spotLightShadows.needsUpdate = B, N.rectAreaLights.needsUpdate = B, N.hemisphereLights.needsUpdate = B, N.directionalShadowMap.needsUpdate = B, N.directionalShadowMatrix.needsUpdate = B, N.spotShadowMap.needsUpdate = B, N.spotShadowMatrix.needsUpdate = B, N.pointShadowMap.needsUpdate = B, N.pointShadowMatrix.needsUpdate = B), s && i.fog && st.refreshFogUniforms(L, s), st.refreshMaterialUniforms(L, i, D, P, G), ls.upload(vt, x.uniformsList, L, Q));
        var N, B;
        i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (ls.upload(vt, x.uniformsList, L, Q), i.uniformsNeedUpdate = !1);
        i.isSpriteMaterial && C.setValue(vt, "center", r.center);
        return C.setValue(vt, "modelViewMatrix", r.modelViewMatrix), C.setValue(vt, "normalMatrix", r.normalMatrix), C.setValue(vt, "modelMatrix", r.matrixWorld), w;
      }(t, e, n, i, r);

      Y.setMaterial(i, a);
      var l = n.index;
      var c = n.attributes.position;

      if (null === l) {
        if (void 0 === c || 0 === c.count) return;
      } else if (0 === l.count) return;

      var h,
          u = 1;
      !0 === i.wireframe && (l = nt.getWireframeAttribute(n), u = 2), gt.setup(r, i, o, n, l);
      var p = pt;
      null !== l && (h = et.get(l), p = mt, p.setIndex(h));

      var m = null !== l ? l.count : c.count,
          g = n.drawRange.start * u,
          v = n.drawRange.count * u,
          y = null !== s ? s.start * u : 0,
          x = null !== s ? s.count * u : 1 / 0,
          _ = Math.max(g, y),
          b = Math.min(m, g + v, y + x) - 1,
          w = Math.max(0, b - _ + 1);

      if (0 !== w) {
        if (r.isMesh) !0 === i.wireframe ? (Y.setLineWidth(i.wireframeLinewidth * q()), p.setMode(1)) : p.setMode(4);else if (r.isLine) {
          var _t154 = i.linewidth;
          void 0 === _t154 && (_t154 = 1), Y.setLineWidth(_t154 * q()), r.isLineSegments ? p.setMode(1) : r.isLineLoop ? p.setMode(2) : p.setMode(3);
        } else r.isPoints ? p.setMode(0) : r.isSprite && p.setMode(4);
        if (r.isInstancedMesh) p.renderInstances(_, w, r.count);else if (n.isInstancedBufferGeometry) {
          var _t155 = Math.min(n.instanceCount, n._maxInstanceCount);

          p.renderInstances(_, w, _t155);
        } else p.render(_, w);
      }
    }, this.compile = function (t, e) {
      d = lt.get(t), d.init(), m.push(d), t.traverseVisible(function (t) {
        t.isLight && t.layers.test(e.layers) && (d.pushLight(t), t.castShadow && d.pushShadow(t));
      }), d.setupLights(f.physicallyCorrectLights), t.traverse(function (e) {
        var n = e.material;
        if (n) if (Array.isArray(n)) for (var _i101 = 0; _i101 < n.length; _i101++) {
          Bt(n[_i101], t, e);
        } else Bt(n, t, e);
      }), m.pop(), d = null;
    };
    var St = null;

    function Et() {
      Ct.stop();
    }

    function Rt() {
      Ct.start();
    }

    var Ct = new bi();

    function Lt(t, e, n, i) {
      if (!1 === t.visible) return;
      if (t.layers.test(e.layers)) if (t.isGroup) n = t.renderOrder;else if (t.isLOD) !0 === t.autoUpdate && t.update(e);else if (t.isLight) d.pushLight(t), t.castShadow && d.pushShadow(t);else if (t.isSprite) {
        if (!t.frustumCulled || U.intersectsSprite(t)) {
          i && W.setFromMatrixPosition(t.matrixWorld).applyMatrix4(V);

          var _e116 = it.update(t),
              _r83 = t.material;

          _r83.visible && u.push(t, _e116, _r83, n, W.z, null);
        }
      } else if ((t.isMesh || t.isLine || t.isPoints) && (t.isSkinnedMesh && t.skeleton.frame !== Z.render.frame && (t.skeleton.update(), t.skeleton.frame = Z.render.frame), !t.frustumCulled || U.intersectsObject(t))) {
        i && W.setFromMatrixPosition(t.matrixWorld).applyMatrix4(V);

        var _e117 = it.update(t),
            _r84 = t.material;

        if (Array.isArray(_r84)) {
          var _i102 = _e117.groups;

          for (var _s37 = 0, _a33 = _i102.length; _s37 < _a33; _s37++) {
            var _a34 = _i102[_s37],
                _o21 = _r84[_a34.materialIndex];
            _o21 && _o21.visible && u.push(t, _e117, _o21, n, W.z, _a34);
          }
        } else _r84.visible && u.push(t, _e117, _r84, n, W.z, null);
      }
      var r = t.children;

      for (var _t156 = 0, _s38 = r.length; _t156 < _s38; _t156++) {
        Lt(r[_t156], e, n, i);
      }
    }

    function Pt(t, e, n, i) {
      var r = t.opaque,
          a = t.transmissive,
          o = t.transparent;
      d.setupLightsView(n), a.length > 0 && function (t, e, n) {
        var i = J.isWebGL2;
        null === G && (G = new Xt(1, 1, {
          generateMipmaps: !0,
          type: null !== ft.convert(w) ? w : x,
          minFilter: y,
          samples: i && !0 === s ? 4 : 0
        }));
        f.getDrawingBufferSize(k), i ? G.setSize(k.x, k.y) : G.setSize(Tt(k.x), Tt(k.y));
        var r = f.getRenderTarget();
        f.setRenderTarget(G), f.clear();
        var a = f.toneMapping;
        f.toneMapping = 0, It(t, e, n), f.toneMapping = a, Q.updateMultisampleRenderTarget(G), Q.updateRenderTargetMipmap(G), f.setRenderTarget(r);
      }(r, e, n), i && Y.viewport(A.copy(i)), r.length > 0 && It(r, e, n), a.length > 0 && It(a, e, n), o.length > 0 && It(o, e, n), Y.buffers.depth.setTest(!0), Y.buffers.depth.setMask(!0), Y.buffers.color.setMask(!0), Y.setPolygonOffset(!1);
    }

    function It(t, e, n) {
      var i = !0 === e.isScene ? e.overrideMaterial : null;

      for (var _r85 = 0, _s39 = t.length; _r85 < _s39; _r85++) {
        var _s40 = t[_r85],
            _a35 = _s40.object,
            _o22 = _s40.geometry,
            _l26 = null === i ? _s40.material : i,
            _c19 = _s40.group;

        _a35.layers.test(n.layers) && Nt(_a35, e, n, _o22, _l26, _c19);
      }
    }

    function Nt(t, e, n, i, r, s) {
      t.onBeforeRender(f, e, n, i, r, s), t.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix), r.onBeforeRender(f, e, n, i, t, s), !0 === r.transparent && 2 === r.side ? (r.side = 1, r.needsUpdate = !0, f.renderBufferDirect(n, e, i, r, t, s), r.side = 0, r.needsUpdate = !0, f.renderBufferDirect(n, e, i, r, t, s), r.side = 2) : f.renderBufferDirect(n, e, i, r, t, s), t.onAfterRender(f, e, n, i, r, s);
    }

    function Bt(t, e, n) {
      !0 !== e.isScene && (e = j);
      var i = K.get(t),
          r = d.state.lights,
          s = d.state.shadowsArray,
          a = r.state.version,
          o = rt.getParameters(t, r.state, s, e, n),
          l = rt.getProgramCacheKey(o);
      var c = i.programs;
      i.environment = t.isMeshStandardMaterial ? e.environment : null, i.fog = e.fog, i.envMap = (t.isMeshStandardMaterial ? tt : $).get(t.envMap || i.environment), void 0 === c && (t.addEventListener("dispose", wt), c = new Map(), i.programs = c);
      var h = c.get(l);

      if (void 0 !== h) {
        if (i.currentProgram === h && i.lightsStateVersion === a) return zt(t, o), h;
      } else o.uniforms = rt.getUniforms(t), t.onBuild(n, o, f), t.onBeforeCompile(o, f), h = rt.acquireProgram(o, l), c.set(l, h), i.uniforms = o.uniforms;

      var u = i.uniforms;
      (t.isShaderMaterial || t.isRawShaderMaterial) && !0 !== t.clipping || (u.clippingPlanes = ct.uniform), zt(t, o), i.needsLights = function (t) {
        return t.isMeshLambertMaterial || t.isMeshToonMaterial || t.isMeshPhongMaterial || t.isMeshStandardMaterial || t.isShadowMaterial || t.isShaderMaterial && !0 === t.lights;
      }(t), i.lightsStateVersion = a, i.needsLights && (u.ambientLightColor.value = r.state.ambient, u.lightProbe.value = r.state.probe, u.directionalLights.value = r.state.directional, u.directionalLightShadows.value = r.state.directionalShadow, u.spotLights.value = r.state.spot, u.spotLightShadows.value = r.state.spotShadow, u.rectAreaLights.value = r.state.rectArea, u.ltc_1.value = r.state.rectAreaLTC1, u.ltc_2.value = r.state.rectAreaLTC2, u.pointLights.value = r.state.point, u.pointLightShadows.value = r.state.pointShadow, u.hemisphereLights.value = r.state.hemi, u.directionalShadowMap.value = r.state.directionalShadowMap, u.directionalShadowMatrix.value = r.state.directionalShadowMatrix, u.spotShadowMap.value = r.state.spotShadowMap, u.spotShadowMatrix.value = r.state.spotShadowMatrix, u.pointShadowMap.value = r.state.pointShadowMap, u.pointShadowMatrix.value = r.state.pointShadowMatrix);
      var p = h.getUniforms(),
          m = ls.seqWithValue(p.seq, u);
      return i.currentProgram = h, i.uniformsList = m, h;
    }

    function zt(t, e) {
      var n = K.get(t);
      n.outputEncoding = e.outputEncoding, n.instancing = e.instancing, n.skinning = e.skinning, n.morphTargets = e.morphTargets, n.morphNormals = e.morphNormals, n.morphColors = e.morphColors, n.morphTargetsCount = e.morphTargetsCount, n.numClippingPlanes = e.numClippingPlanes, n.numIntersection = e.numClipIntersection, n.vertexAlphas = e.vertexAlphas, n.vertexTangents = e.vertexTangents, n.toneMapping = e.toneMapping;
    }

    Ct.setAnimationLoop(function (t) {
      St && St(t);
    }), "undefined" != typeof window && Ct.setContext(window), this.setAnimationLoop = function (t) {
      St = t, _t.setAnimationLoop(t), null === t ? Ct.stop() : Ct.start();
    }, _t.addEventListener("sessionstart", Et), _t.addEventListener("sessionend", Rt), this.render = function (t, e) {
      if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      if (!0 === g) return;
      !0 === t.autoUpdate && t.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), !0 === _t.enabled && !0 === _t.isPresenting && (!0 === _t.cameraAutoUpdate && _t.updateCamera(e), e = _t.getCamera()), !0 === t.isScene && t.onBeforeRender(f, t, e, M), d = lt.get(t, m.length), d.init(), m.push(d), V.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), U.setFromProjectionMatrix(V), H = this.localClippingEnabled, F = ct.init(this.clippingPlanes, H, e), u = at.get(t, p.length), u.init(), p.push(u), Lt(t, e, 0, f.sortObjects), u.finish(), !0 === f.sortObjects && u.sort(I, N), !0 === F && ct.beginShadows();
      var n = d.state.shadowsArray;

      if (ht.render(n, t, e), !0 === F && ct.endShadows(), !0 === this.info.autoReset && this.info.reset(), ut.render(u, t), d.setupLights(f.physicallyCorrectLights), e.isArrayCamera) {
        var _n118 = e.cameras;

        for (var _e118 = 0, _i103 = _n118.length; _e118 < _i103; _e118++) {
          var _i104 = _n118[_e118];
          Pt(u, t, _i104, _i104.viewport);
        }
      } else Pt(u, t, e);

      null !== M && (Q.updateMultisampleRenderTarget(M), Q.updateRenderTargetMipmap(M)), !0 === t.isScene && t.onAfterRender(f, t, e), gt.resetDefaultState(), S = -1, E = null, m.pop(), d = m.length > 0 ? m[m.length - 1] : null, p.pop(), u = p.length > 0 ? p[p.length - 1] : null;
    }, this.getActiveCubeFace = function () {
      return v;
    }, this.getActiveMipmapLevel = function () {
      return _;
    }, this.getRenderTarget = function () {
      return M;
    }, this.setRenderTargetTextures = function (t, e, n) {
      K.get(t.texture).__webglTexture = e, K.get(t.depthTexture).__webglTexture = n;
      var i = K.get(t);
      i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === X.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), t.useRenderToTexture = !1, t.useRenderbuffer = !0));
    }, this.setRenderTargetFramebuffer = function (t, e) {
      var n = K.get(t);
      n.__webglFramebuffer = e, n.__useDefaultFramebuffer = void 0 === e;
    }, this.setRenderTarget = function (t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      M = t, v = e, _ = n;
      var i = !0;

      if (t) {
        var _e119 = K.get(t);

        void 0 !== _e119.__useDefaultFramebuffer ? (Y.bindFramebuffer(36160, null), i = !1) : void 0 === _e119.__webglFramebuffer ? Q.setupRenderTarget(t) : _e119.__hasExternalTextures && Q.rebindTextures(t, K.get(t.texture).__webglTexture, K.get(t.depthTexture).__webglTexture);
      }

      var r = null,
          s = !1,
          a = !1;

      if (t) {
        var _n119 = t.texture;
        (_n119.isData3DTexture || _n119.isDataArrayTexture) && (a = !0);

        var _i105 = K.get(t).__webglFramebuffer;

        t.isWebGLCubeRenderTarget ? (r = _i105[e], s = !0) : r = J.isWebGL2 && t.samples > 0 && !1 === Q.useMultisampledRTT(t) ? K.get(t).__webglMultisampledFramebuffer : _i105, A.copy(t.viewport), R.copy(t.scissor), C = t.scissorTest;
      } else A.copy(B).multiplyScalar(D).floor(), R.copy(z).multiplyScalar(D).floor(), C = O;

      if (Y.bindFramebuffer(36160, r) && J.drawBuffers && i && Y.drawBuffers(t, r), Y.viewport(A), Y.scissor(R), Y.setScissorTest(C), s) {
        var _i106 = K.get(t.texture);

        vt.framebufferTexture2D(36160, 36064, 34069 + e, _i106.__webglTexture, n);
      } else if (a) {
        var _i107 = K.get(t.texture),
            _r86 = e || 0;

        vt.framebufferTextureLayer(36160, 36064, _i107.__webglTexture, n || 0, _r86);
      }

      S = -1;
    }, this.readRenderTargetPixels = function (t, e, n, i, r, s, a) {
      if (!t || !t.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");

      var o = K.get(t).__webglFramebuffer;

      if (t.isWebGLCubeRenderTarget && void 0 !== a && (o = o[a]), o) {
        Y.bindFramebuffer(36160, o);

        try {
          var _a36 = t.texture,
              _o23 = _a36.format,
              _l27 = _a36.type;
          if (_o23 !== T && ft.convert(_o23) !== vt.getParameter(35739)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");

          var _c20 = _l27 === w && (X.has("EXT_color_buffer_half_float") || J.isWebGL2 && X.has("EXT_color_buffer_float"));

          if (!(_l27 === x || ft.convert(_l27) === vt.getParameter(35738) || _l27 === b && (J.isWebGL2 || X.has("OES_texture_float") || X.has("WEBGL_color_buffer_float")) || _c20)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          36053 === vt.checkFramebufferStatus(36160) ? e >= 0 && e <= t.width - i && n >= 0 && n <= t.height - r && vt.readPixels(e, n, i, r, ft.convert(_o23), ft.convert(_l27), s) : console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
        } finally {
          var _t157 = null !== M ? K.get(M).__webglFramebuffer : null;

          Y.bindFramebuffer(36160, _t157);
        }
      }
    }, this.copyFramebufferToTexture = function (t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (!0 !== e.isFramebufferTexture) return void console.error("THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.");
      var i = Math.pow(2, -n),
          r = Math.floor(e.image.width * i),
          s = Math.floor(e.image.height * i);
      Q.setTexture2D(e, 0), vt.copyTexSubImage2D(3553, n, 0, 0, t.x, t.y, r, s), Y.unbindTexture();
    }, this.copyTextureToTexture = function (t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = e.image.width,
          s = e.image.height,
          a = ft.convert(n.format),
          o = ft.convert(n.type);
      Q.setTexture2D(n, 0), vt.pixelStorei(37440, n.flipY), vt.pixelStorei(37441, n.premultiplyAlpha), vt.pixelStorei(3317, n.unpackAlignment), e.isDataTexture ? vt.texSubImage2D(3553, i, t.x, t.y, r, s, a, o, e.image.data) : e.isCompressedTexture ? vt.compressedTexSubImage2D(3553, i, t.x, t.y, e.mipmaps[0].width, e.mipmaps[0].height, a, e.mipmaps[0].data) : vt.texSubImage2D(3553, i, t.x, t.y, a, o, e.image), 0 === i && n.generateMipmaps && vt.generateMipmap(3553), Y.unbindTexture();
    }, this.copyTextureToTexture3D = function (t, e, n, i) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (f.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      var s = t.max.x - t.min.x + 1,
          a = t.max.y - t.min.y + 1,
          o = t.max.z - t.min.z + 1,
          l = ft.convert(i.format),
          c = ft.convert(i.type);
      var h;
      if (i.isData3DTexture) Q.setTexture3D(i, 0), h = 32879;else {
        if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
        Q.setTexture2DArray(i, 0), h = 35866;
      }
      vt.pixelStorei(37440, i.flipY), vt.pixelStorei(37441, i.premultiplyAlpha), vt.pixelStorei(3317, i.unpackAlignment);
      var u = vt.getParameter(3314),
          d = vt.getParameter(32878),
          p = vt.getParameter(3316),
          m = vt.getParameter(3315),
          g = vt.getParameter(32877),
          v = n.isCompressedTexture ? n.mipmaps[0] : n.image;
      vt.pixelStorei(3314, v.width), vt.pixelStorei(32878, v.height), vt.pixelStorei(3316, t.min.x), vt.pixelStorei(3315, t.min.y), vt.pixelStorei(32877, t.min.z), n.isDataTexture || n.isData3DTexture ? vt.texSubImage3D(h, r, e.x, e.y, e.z, s, a, o, l, c, v.data) : n.isCompressedTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), vt.compressedTexSubImage3D(h, r, e.x, e.y, e.z, s, a, o, l, v.data)) : vt.texSubImage3D(h, r, e.x, e.y, e.z, s, a, o, l, c, v), vt.pixelStorei(3314, u), vt.pixelStorei(32878, d), vt.pixelStorei(3316, p), vt.pixelStorei(3315, m), vt.pixelStorei(32877, g), 0 === r && i.generateMipmaps && vt.generateMipmap(h), Y.unbindTexture();
    }, this.initTexture = function (t) {
      Q.setTexture2D(t, 0), Y.unbindTexture();
    }, this.resetState = function () {
      v = 0, _ = 0, M = null, Y.reset(), gt.reset();
    }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
      detail: this
    }));
  }

  ea.prototype.isWebGLRenderer = !0;

  var na = /*#__PURE__*/function (_ea) {
    _inherits(na, _ea);

    var _super38 = _createSuper(na);

    function na() {
      _classCallCheck(this, na);

      return _super38.apply(this, arguments);
    }

    return _createClass(na);
  }(ea);

  na.prototype.isWebGL1Renderer = !0;

  var ia = /*#__PURE__*/function () {
    function ia(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25e-5;

      _classCallCheck(this, ia);

      this.name = "", this.color = new Ft(t), this.density = e;
    }

    _createClass(ia, [{
      key: "clone",
      value: function clone() {
        return new ia(this.color, this.density);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return {
          type: "FogExp2",
          color: this.color.getHex(),
          density: this.density
        };
      }
    }]);

    return ia;
  }();

  ia.prototype.isFogExp2 = !0;

  var ra = /*#__PURE__*/function () {
    function ra(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;

      _classCallCheck(this, ra);

      this.name = "", this.color = new Ft(t), this.near = e, this.far = n;
    }

    _createClass(ra, [{
      key: "clone",
      value: function clone() {
        return new ra(this.color, this.near, this.far);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return {
          type: "Fog",
          color: this.color.getHex(),
          near: this.near,
          far: this.far
        };
      }
    }]);

    return ra;
  }();

  ra.prototype.isFog = !0;

  var sa = /*#__PURE__*/function (_nn5) {
    _inherits(sa, _nn5);

    var _super39 = _createSuper(sa);

    function sa() {
      var _this28;

      _classCallCheck(this, sa);

      _this28 = _super39.call(this), _this28.type = "Scene", _this28.background = null, _this28.environment = null, _this28.fog = null, _this28.overrideMaterial = null, _this28.autoUpdate = !0, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: _assertThisInitialized(_this28)
      }));
      return _this28;
    }

    _createClass(sa, [{
      key: "copy",
      value: function copy(t, e) {
        return _get(_getPrototypeOf(sa.prototype), "copy", this).call(this, t, e), null !== t.background && (this.background = t.background.clone()), null !== t.environment && (this.environment = t.environment.clone()), null !== t.fog && (this.fog = t.fog.clone()), null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone()), this.autoUpdate = t.autoUpdate, this.matrixAutoUpdate = t.matrixAutoUpdate, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(sa.prototype), "toJSON", this).call(this, t);

        return null !== this.fog && (e.object.fog = this.fog.toJSON()), e;
      }
    }]);

    return sa;
  }(nn);

  sa.prototype.isScene = !0;

  var aa = /*#__PURE__*/function () {
    function aa(t, e) {
      _classCallCheck(this, aa);

      this.array = t, this.stride = e, this.count = void 0 !== t ? t.length / e : 0, this.usage = ht, this.updateRange = {
        offset: 0,
        count: -1
      }, this.version = 0, this.uuid = xt();
    }

    _createClass(aa, [{
      key: "onUploadCallback",
      value: function onUploadCallback() {}
    }, {
      key: "needsUpdate",
      set: function set(t) {
        !0 === t && this.version++;
      }
    }, {
      key: "setUsage",
      value: function setUsage(t) {
        return this.usage = t, this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
      }
    }, {
      key: "copyAt",
      value: function copyAt(t, e, n) {
        t *= this.stride, n *= e.stride;

        for (var _i108 = 0, _r87 = this.stride; _i108 < _r87; _i108++) {
          this.array[t + _i108] = e.array[n + _i108];
        }

        return this;
      }
    }, {
      key: "set",
      value: function set(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return this.array.set(t, e), this;
      }
    }, {
      key: "clone",
      value: function clone(t) {
        void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = xt()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        var e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]),
            n = new this.constructor(e, this.stride);
        return n.setUsage(this.usage), n;
      }
    }, {
      key: "onUpload",
      value: function onUpload(t) {
        return this.onUploadCallback = t, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        return void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = xt()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer))), {
          uuid: this.uuid,
          buffer: this.array.buffer._uuid,
          type: this.array.constructor.name,
          stride: this.stride
        };
      }
    }]);

    return aa;
  }();

  aa.prototype.isInterleavedBuffer = !0;
  var oa = new te();

  var la = /*#__PURE__*/function () {
    function la(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      _classCallCheck(this, la);

      this.name = "", this.data = t, this.itemSize = e, this.offset = n, this.normalized = !0 === i;
    }

    _createClass(la, [{
      key: "count",
      get: function get() {
        return this.data.count;
      }
    }, {
      key: "array",
      get: function get() {
        return this.data.array;
      }
    }, {
      key: "needsUpdate",
      set: function set(t) {
        this.data.needsUpdate = t;
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        for (var _e120 = 0, _n120 = this.data.count; _e120 < _n120; _e120++) {
          oa.x = this.getX(_e120), oa.y = this.getY(_e120), oa.z = this.getZ(_e120), oa.applyMatrix4(t), this.setXYZ(_e120, oa.x, oa.y, oa.z);
        }

        return this;
      }
    }, {
      key: "applyNormalMatrix",
      value: function applyNormalMatrix(t) {
        for (var _e121 = 0, _n121 = this.count; _e121 < _n121; _e121++) {
          oa.x = this.getX(_e121), oa.y = this.getY(_e121), oa.z = this.getZ(_e121), oa.applyNormalMatrix(t), this.setXYZ(_e121, oa.x, oa.y, oa.z);
        }

        return this;
      }
    }, {
      key: "transformDirection",
      value: function transformDirection(t) {
        for (var _e122 = 0, _n122 = this.count; _e122 < _n122; _e122++) {
          oa.x = this.getX(_e122), oa.y = this.getY(_e122), oa.z = this.getZ(_e122), oa.transformDirection(t), this.setXYZ(_e122, oa.x, oa.y, oa.z);
        }

        return this;
      }
    }, {
      key: "setX",
      value: function setX(t, e) {
        return this.data.array[t * this.data.stride + this.offset] = e, this;
      }
    }, {
      key: "setY",
      value: function setY(t, e) {
        return this.data.array[t * this.data.stride + this.offset + 1] = e, this;
      }
    }, {
      key: "setZ",
      value: function setZ(t, e) {
        return this.data.array[t * this.data.stride + this.offset + 2] = e, this;
      }
    }, {
      key: "setW",
      value: function setW(t, e) {
        return this.data.array[t * this.data.stride + this.offset + 3] = e, this;
      }
    }, {
      key: "getX",
      value: function getX(t) {
        return this.data.array[t * this.data.stride + this.offset];
      }
    }, {
      key: "getY",
      value: function getY(t) {
        return this.data.array[t * this.data.stride + this.offset + 1];
      }
    }, {
      key: "getZ",
      value: function getZ(t) {
        return this.data.array[t * this.data.stride + this.offset + 2];
      }
    }, {
      key: "getW",
      value: function getW(t) {
        return this.data.array[t * this.data.stride + this.offset + 3];
      }
    }, {
      key: "setXY",
      value: function setXY(t, e, n) {
        return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this;
      }
    }, {
      key: "setXYZ",
      value: function setXYZ(t, e, n, i) {
        return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this;
      }
    }, {
      key: "setXYZW",
      value: function setXYZW(t, e, n, i, r) {
        return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this.data.array[t + 3] = r, this;
      }
    }, {
      key: "clone",
      value: function clone(t) {
        if (void 0 === t) {
          console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
          var _t158 = [];

          for (var _e123 = 0; _e123 < this.count; _e123++) {
            var _n123 = _e123 * this.data.stride + this.offset;

            for (var _e124 = 0; _e124 < this.itemSize; _e124++) {
              _t158.push(this.data.array[_n123 + _e124]);
            }
          }

          return new _n(new this.array.constructor(_t158), this.itemSize, this.normalized);
        }

        return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new la(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        if (void 0 === t) {
          console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
          var _t159 = [];

          for (var _e125 = 0; _e125 < this.count; _e125++) {
            var _n124 = _e125 * this.data.stride + this.offset;

            for (var _e126 = 0; _e126 < this.itemSize; _e126++) {
              _t159.push(this.data.array[_n124 + _e126]);
            }
          }

          return {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: _t159,
            normalized: this.normalized
          };
        }

        return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
          isInterleavedBufferAttribute: !0,
          itemSize: this.itemSize,
          data: this.data.uuid,
          offset: this.offset,
          normalized: this.normalized
        };
      }
    }]);

    return la;
  }();

  la.prototype.isInterleavedBufferAttribute = !0;

  var ca = /*#__PURE__*/function (_gn5) {
    _inherits(ca, _gn5);

    var _super40 = _createSuper(ca);

    function ca(t) {
      var _this29;

      _classCallCheck(this, ca);

      _this29 = _super40.call(this), _this29.type = "SpriteMaterial", _this29.color = new Ft(16777215), _this29.map = null, _this29.alphaMap = null, _this29.rotation = 0, _this29.sizeAttenuation = !0, _this29.transparent = !0, _this29.setValues(t);
      return _this29;
    }

    _createClass(ca, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(ca.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.rotation = t.rotation, this.sizeAttenuation = t.sizeAttenuation, this;
      }
    }]);

    return ca;
  }(gn);

  var ha;
  ca.prototype.isSpriteMaterial = !0;

  var ua = new te(),
      da = new te(),
      pa = new te(),
      ma = new At(),
      fa = new At(),
      ga = new Pe(),
      va = new te(),
      ya = new te(),
      xa = new te(),
      _a = new At(),
      Ma = new At(),
      ba = new At();

  var wa = /*#__PURE__*/function (_nn6) {
    _inherits(wa, _nn6);

    var _super41 = _createSuper(wa);

    function wa(t) {
      var _this30;

      _classCallCheck(this, wa);

      if (_this30 = _super41.call(this), _this30.type = "Sprite", void 0 === ha) {
        ha = new Un();

        var _t160 = new Float32Array([-.5, -.5, 0, 0, 0, .5, -.5, 0, 1, 0, .5, .5, 0, 1, 1, -.5, .5, 0, 0, 1]),
            _e127 = new aa(_t160, 5);

        ha.setIndex([0, 1, 2, 0, 2, 3]), ha.setAttribute("position", new la(_e127, 3, 0, !1)), ha.setAttribute("uv", new la(_e127, 2, 3, !1));
      }

      _this30.geometry = ha, _this30.material = void 0 !== t ? t : new ca(), _this30.center = new At(.5, .5);
      return _possibleConstructorReturn(_this30);
    }

    _createClass(wa, [{
      key: "raycast",
      value: function raycast(t, e) {
        null === t.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), da.setFromMatrixScale(this.matrixWorld), ga.copy(t.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t.camera.matrixWorldInverse, this.matrixWorld), pa.setFromMatrixPosition(this.modelViewMatrix), t.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && da.multiplyScalar(-pa.z);
        var n = this.material.rotation;
        var i, r;
        0 !== n && (r = Math.cos(n), i = Math.sin(n));
        var s = this.center;
        Sa(va.set(-.5, -.5, 0), pa, s, da, i, r), Sa(ya.set(.5, -.5, 0), pa, s, da, i, r), Sa(xa.set(.5, .5, 0), pa, s, da, i, r), _a.set(0, 0), Ma.set(1, 0), ba.set(1, 1);
        var a = t.ray.intersectTriangle(va, ya, xa, !1, ua);
        if (null === a && (Sa(ya.set(-.5, .5, 0), pa, s, da, i, r), Ma.set(0, 1), a = t.ray.intersectTriangle(va, xa, ya, !1, ua), null === a)) return;
        var o = t.ray.origin.distanceTo(ua);
        o < t.near || o > t.far || e.push({
          distance: o,
          point: ua.clone(),
          uv: mn.getUV(ua, va, ya, xa, _a, Ma, ba, new At()),
          face: null,
          object: this
        });
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(wa.prototype), "copy", this).call(this, t), void 0 !== t.center && this.center.copy(t.center), this.material = t.material, this;
      }
    }]);

    return wa;
  }(nn);

  function Sa(t, e, n, i, r, s) {
    ma.subVectors(t, n).addScalar(.5).multiply(i), void 0 !== r ? (fa.x = s * ma.x - r * ma.y, fa.y = r * ma.x + s * ma.y) : fa.copy(ma), t.copy(e), t.x += fa.x, t.y += fa.y, t.applyMatrix4(ga);
  }

  wa.prototype.isSprite = !0;
  var Ta = new te(),
      Ea = new te();

  var Aa = /*#__PURE__*/function (_nn7) {
    _inherits(Aa, _nn7);

    var _super42 = _createSuper(Aa);

    function Aa() {
      var _this31;

      _classCallCheck(this, Aa);

      _this31 = _super42.call(this), _this31._currentLevel = 0, _this31.type = "LOD", Object.defineProperties(_assertThisInitialized(_this31), {
        levels: {
          enumerable: !0,
          value: []
        },
        isLOD: {
          value: !0
        }
      }), _this31.autoUpdate = !0;
      return _this31;
    }

    _createClass(Aa, [{
      key: "copy",
      value: function copy(t) {
        _get(_getPrototypeOf(Aa.prototype), "copy", this).call(this, t, !1);

        var e = t.levels;

        for (var _t161 = 0, _n125 = e.length; _t161 < _n125; _t161++) {
          var _n126 = e[_t161];
          this.addLevel(_n126.object.clone(), _n126.distance);
        }

        return this.autoUpdate = t.autoUpdate, this;
      }
    }, {
      key: "addLevel",
      value: function addLevel(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        e = Math.abs(e);
        var n = this.levels;
        var i;

        for (i = 0; i < n.length && !(e < n[i].distance); i++) {
          ;
        }

        return n.splice(i, 0, {
          distance: e,
          object: t
        }), this.add(t), this;
      }
    }, {
      key: "getCurrentLevel",
      value: function getCurrentLevel() {
        return this._currentLevel;
      }
    }, {
      key: "getObjectForDistance",
      value: function getObjectForDistance(t) {
        var e = this.levels;

        if (e.length > 0) {
          var _n127, _i109;

          for (_n127 = 1, _i109 = e.length; _n127 < _i109 && !(t < e[_n127].distance); _n127++) {
            ;
          }

          return e[_n127 - 1].object;
        }

        return null;
      }
    }, {
      key: "raycast",
      value: function raycast(t, e) {
        if (this.levels.length > 0) {
          Ta.setFromMatrixPosition(this.matrixWorld);

          var _n128 = t.ray.origin.distanceTo(Ta);

          this.getObjectForDistance(_n128).raycast(t, e);
        }
      }
    }, {
      key: "update",
      value: function update(t) {
        var e = this.levels;

        if (e.length > 1) {
          Ta.setFromMatrixPosition(t.matrixWorld), Ea.setFromMatrixPosition(this.matrixWorld);

          var _n129 = Ta.distanceTo(Ea) / t.zoom;

          var _i110, _r88;

          for (e[0].object.visible = !0, _i110 = 1, _r88 = e.length; _i110 < _r88 && _n129 >= e[_i110].distance; _i110++) {
            e[_i110 - 1].object.visible = !1, e[_i110].object.visible = !0;
          }

          for (this._currentLevel = _i110 - 1; _i110 < _r88; _i110++) {
            e[_i110].object.visible = !1;
          }
        }
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(Aa.prototype), "toJSON", this).call(this, t);

        !1 === this.autoUpdate && (e.object.autoUpdate = !1), e.object.levels = [];
        var n = this.levels;

        for (var _t162 = 0, _i111 = n.length; _t162 < _i111; _t162++) {
          var _i112 = n[_t162];
          e.object.levels.push({
            object: _i112.object.uuid,
            distance: _i112.distance
          });
        }

        return e;
      }
    }]);

    return Aa;
  }(nn);

  var Ra = new te(),
      Ca = new qt(),
      La = new qt(),
      Pa = new te(),
      Da = new Pe();

  var Ia = /*#__PURE__*/function (_ni) {
    _inherits(Ia, _ni);

    var _super43 = _createSuper(Ia);

    function Ia(t, e) {
      var _this32;

      _classCallCheck(this, Ia);

      _this32 = _super43.call(this, t, e), _this32.type = "SkinnedMesh", _this32.bindMode = "attached", _this32.bindMatrix = new Pe(), _this32.bindMatrixInverse = new Pe();
      return _this32;
    }

    _createClass(Ia, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Ia.prototype), "copy", this).call(this, t), this.bindMode = t.bindMode, this.bindMatrix.copy(t.bindMatrix), this.bindMatrixInverse.copy(t.bindMatrixInverse), this.skeleton = t.skeleton, this;
      }
    }, {
      key: "bind",
      value: function bind(t, e) {
        this.skeleton = t, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
      }
    }, {
      key: "pose",
      value: function pose() {
        this.skeleton.pose();
      }
    }, {
      key: "normalizeSkinWeights",
      value: function normalizeSkinWeights() {
        var t = new qt(),
            e = this.geometry.attributes.skinWeight;

        for (var _n130 = 0, _i113 = e.count; _n130 < _i113; _n130++) {
          t.x = e.getX(_n130), t.y = e.getY(_n130), t.z = e.getZ(_n130), t.w = e.getW(_n130);

          var _i114 = 1 / t.manhattanLength();

          _i114 !== 1 / 0 ? t.multiplyScalar(_i114) : t.set(1, 0, 0, 0), e.setXYZW(_n130, t.x, t.y, t.z, t.w);
        }
      }
    }, {
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        _get(_getPrototypeOf(Ia.prototype), "updateMatrixWorld", this).call(this, t), "attached" === this.bindMode ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : "detached" === this.bindMode ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
      }
    }, {
      key: "boneTransform",
      value: function boneTransform(t, e) {
        var n = this.skeleton,
            i = this.geometry;
        Ca.fromBufferAttribute(i.attributes.skinIndex, t), La.fromBufferAttribute(i.attributes.skinWeight, t), Ra.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);

        for (var _t163 = 0; _t163 < 4; _t163++) {
          var _i115 = La.getComponent(_t163);

          if (0 !== _i115) {
            var _r89 = Ca.getComponent(_t163);

            Da.multiplyMatrices(n.bones[_r89].matrixWorld, n.boneInverses[_r89]), e.addScaledVector(Pa.copy(Ra).applyMatrix4(Da), _i115);
          }
        }

        return e.applyMatrix4(this.bindMatrixInverse);
      }
    }]);

    return Ia;
  }(ni);

  Ia.prototype.isSkinnedMesh = !0;

  var Na = /*#__PURE__*/function (_nn8) {
    _inherits(Na, _nn8);

    var _super44 = _createSuper(Na);

    function Na() {
      var _this33;

      _classCallCheck(this, Na);

      _this33 = _super44.call(this), _this33.type = "Bone";
      return _this33;
    }

    return _createClass(Na);
  }(nn);

  Na.prototype.isBone = !0;

  var Ba = /*#__PURE__*/function (_jt5) {
    _inherits(Ba, _jt5);

    var _super45 = _createSuper(Ba);

    function Ba() {
      var _this34;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 ? arguments[3] : undefined;
      var r = arguments.length > 4 ? arguments[4] : undefined;
      var s = arguments.length > 5 ? arguments[5] : undefined;
      var a = arguments.length > 6 ? arguments[6] : undefined;
      var o = arguments.length > 7 ? arguments[7] : undefined;
      var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1003;
      var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1003;
      var h = arguments.length > 10 ? arguments[10] : undefined;
      var u = arguments.length > 11 ? arguments[11] : undefined;

      _classCallCheck(this, Ba);

      _this34 = _super45.call(this, null, s, a, o, l, c, i, r, h, u), _this34.image = {
        data: t,
        width: e,
        height: n
      }, _this34.generateMipmaps = !1, _this34.flipY = !1, _this34.unpackAlignment = 1;
      return _this34;
    }

    return _createClass(Ba);
  }(jt);

  Ba.prototype.isDataTexture = !0;
  var za = new Pe(),
      Oa = new Pe();

  var Ua = /*#__PURE__*/function () {
    function Ua() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      _classCallCheck(this, Ua);

      this.uuid = xt(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
    }

    _createClass(Ua, [{
      key: "init",
      value: function init() {
        var t = this.bones,
            e = this.boneInverses;
        if (this.boneMatrices = new Float32Array(16 * t.length), 0 === e.length) this.calculateInverses();else if (t.length !== e.length) {
          console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];

          for (var _t164 = 0, _e128 = this.bones.length; _t164 < _e128; _t164++) {
            this.boneInverses.push(new Pe());
          }
        }
      }
    }, {
      key: "calculateInverses",
      value: function calculateInverses() {
        this.boneInverses.length = 0;

        for (var _t165 = 0, _e129 = this.bones.length; _t165 < _e129; _t165++) {
          var _e130 = new Pe();

          this.bones[_t165] && _e130.copy(this.bones[_t165].matrixWorld).invert(), this.boneInverses.push(_e130);
        }
      }
    }, {
      key: "pose",
      value: function pose() {
        for (var _t166 = 0, _e131 = this.bones.length; _t166 < _e131; _t166++) {
          var _e132 = this.bones[_t166];
          _e132 && _e132.matrixWorld.copy(this.boneInverses[_t166]).invert();
        }

        for (var _t167 = 0, _e133 = this.bones.length; _t167 < _e133; _t167++) {
          var _e134 = this.bones[_t167];
          _e134 && (_e134.parent && _e134.parent.isBone ? (_e134.matrix.copy(_e134.parent.matrixWorld).invert(), _e134.matrix.multiply(_e134.matrixWorld)) : _e134.matrix.copy(_e134.matrixWorld), _e134.matrix.decompose(_e134.position, _e134.quaternion, _e134.scale));
        }
      }
    }, {
      key: "update",
      value: function update() {
        var t = this.bones,
            e = this.boneInverses,
            n = this.boneMatrices,
            i = this.boneTexture;

        for (var _i116 = 0, _r90 = t.length; _i116 < _r90; _i116++) {
          var _r91 = t[_i116] ? t[_i116].matrixWorld : Oa;

          za.multiplyMatrices(_r91, e[_i116]), za.toArray(n, 16 * _i116);
        }

        null !== i && (i.needsUpdate = !0);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new Ua(this.bones, this.boneInverses);
      }
    }, {
      key: "computeBoneTexture",
      value: function computeBoneTexture() {
        var t = Math.sqrt(4 * this.bones.length);
        t = St(t), t = Math.max(t, 4);
        var e = new Float32Array(t * t * 4);
        e.set(this.boneMatrices);
        var n = new Ba(e, t, t, T, b);
        return n.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = n, this.boneTextureSize = t, this;
      }
    }, {
      key: "getBoneByName",
      value: function getBoneByName(t) {
        for (var _e135 = 0, _n131 = this.bones.length; _e135 < _n131; _e135++) {
          var _n132 = this.bones[_e135];
          if (_n132.name === t) return _n132;
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t, e) {
        this.uuid = t.uuid;

        for (var _n133 = 0, _i117 = t.bones.length; _n133 < _i117; _n133++) {
          var _i118 = t.bones[_n133];
          var _r92 = e[_i118];
          void 0 === _r92 && (console.warn("THREE.Skeleton: No bone found with UUID:", _i118), _r92 = new Na()), this.bones.push(_r92), this.boneInverses.push(new Pe().fromArray(t.boneInverses[_n133]));
        }

        return this.init(), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = {
          metadata: {
            version: 4.5,
            type: "Skeleton",
            generator: "Skeleton.toJSON"
          },
          bones: [],
          boneInverses: []
        };
        t.uuid = this.uuid;
        var e = this.bones,
            n = this.boneInverses;

        for (var _i119 = 0, _r93 = e.length; _i119 < _r93; _i119++) {
          var _r94 = e[_i119];
          t.bones.push(_r94.uuid);
          var _s41 = n[_i119];
          t.boneInverses.push(_s41.toArray());
        }

        return t;
      }
    }]);

    return Ua;
  }();

  var Fa = /*#__PURE__*/function (_n134) {
    _inherits(Fa, _n134);

    var _super46 = _createSuper(Fa);

    function Fa(t, e, n) {
      var _this35;

      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, Fa);

      "number" == typeof n && (i = n, n = !1, console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.")), _this35 = _super46.call(this, t, e, n), _this35.meshPerAttribute = i;
      return _this35;
    }

    _createClass(Fa, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Fa.prototype), "copy", this).call(this, t), this.meshPerAttribute = t.meshPerAttribute, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Fa.prototype), "toJSON", this).call(this);

        return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
      }
    }]);

    return Fa;
  }(_n);

  Fa.prototype.isInstancedBufferAttribute = !0;
  var Ha = new Pe(),
      Ga = new Pe(),
      Va = [],
      ka = new ni();

  var Wa = /*#__PURE__*/function (_ni2) {
    _inherits(Wa, _ni2);

    var _super47 = _createSuper(Wa);

    function Wa(t, e, n) {
      var _this36;

      _classCallCheck(this, Wa);

      _this36 = _super47.call(this, t, e), _this36.instanceMatrix = new Fa(new Float32Array(16 * n), 16), _this36.instanceColor = null, _this36.count = n, _this36.frustumCulled = !1;
      return _this36;
    }

    _createClass(Wa, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Wa.prototype), "copy", this).call(this, t), this.instanceMatrix.copy(t.instanceMatrix), null !== t.instanceColor && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, this;
      }
    }, {
      key: "getColorAt",
      value: function getColorAt(t, e) {
        e.fromArray(this.instanceColor.array, 3 * t);
      }
    }, {
      key: "getMatrixAt",
      value: function getMatrixAt(t, e) {
        e.fromArray(this.instanceMatrix.array, 16 * t);
      }
    }, {
      key: "raycast",
      value: function raycast(t, e) {
        var n = this.matrixWorld,
            i = this.count;
        if (ka.geometry = this.geometry, ka.material = this.material, void 0 !== ka.material) for (var _r95 = 0; _r95 < i; _r95++) {
          this.getMatrixAt(_r95, Ha), Ga.multiplyMatrices(n, Ha), ka.matrixWorld = Ga, ka.raycast(t, Va);

          for (var _t168 = 0, _n135 = Va.length; _t168 < _n135; _t168++) {
            var _n136 = Va[_t168];
            _n136.instanceId = _r95, _n136.object = this, e.push(_n136);
          }

          Va.length = 0;
        }
      }
    }, {
      key: "setColorAt",
      value: function setColorAt(t, e) {
        null === this.instanceColor && (this.instanceColor = new Fa(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t);
      }
    }, {
      key: "setMatrixAt",
      value: function setMatrixAt(t, e) {
        e.toArray(this.instanceMatrix.array, 16 * t);
      }
    }, {
      key: "updateMorphTargets",
      value: function updateMorphTargets() {}
    }, {
      key: "dispose",
      value: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }]);

    return Wa;
  }(ni);

  Wa.prototype.isInstancedMesh = !0;

  var ja = /*#__PURE__*/function (_gn6) {
    _inherits(ja, _gn6);

    var _super48 = _createSuper(ja);

    function ja(t) {
      var _this37;

      _classCallCheck(this, ja);

      _this37 = _super48.call(this), _this37.type = "LineBasicMaterial", _this37.color = new Ft(16777215), _this37.linewidth = 1, _this37.linecap = "round", _this37.linejoin = "round", _this37.setValues(t);
      return _this37;
    }

    _createClass(ja, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(ja.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this;
      }
    }]);

    return ja;
  }(gn);

  ja.prototype.isLineBasicMaterial = !0;
  var qa = new te(),
      Xa = new te(),
      Ja = new Pe(),
      Ya = new Le(),
      Za = new be();

  var Ka = /*#__PURE__*/function (_nn9) {
    _inherits(Ka, _nn9);

    var _super49 = _createSuper(Ka);

    function Ka() {
      var _this38;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Un();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new ja();

      _classCallCheck(this, Ka);

      _this38 = _super49.call(this), _this38.type = "Line", _this38.geometry = t, _this38.material = e, _this38.updateMorphTargets();
      return _this38;
    }

    _createClass(Ka, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Ka.prototype), "copy", this).call(this, t), this.material = t.material, this.geometry = t.geometry, this;
      }
    }, {
      key: "computeLineDistances",
      value: function computeLineDistances() {
        var t = this.geometry;
        if (t.isBufferGeometry) {
          if (null === t.index) {
            var _e136 = t.attributes.position,
                _n137 = [0];

            for (var _t169 = 1, _i120 = _e136.count; _t169 < _i120; _t169++) {
              qa.fromBufferAttribute(_e136, _t169 - 1), Xa.fromBufferAttribute(_e136, _t169), _n137[_t169] = _n137[_t169 - 1], _n137[_t169] += qa.distanceTo(Xa);
            }

            t.setAttribute("lineDistance", new Cn(_n137, 1));
          } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else t.isGeometry && console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
      }
    }, {
      key: "raycast",
      value: function raycast(t, e) {
        var n = this.geometry,
            i = this.matrixWorld,
            r = t.params.Line.threshold,
            s = n.drawRange;
        if (null === n.boundingSphere && n.computeBoundingSphere(), Za.copy(n.boundingSphere), Za.applyMatrix4(i), Za.radius += r, !1 === t.ray.intersectsSphere(Za)) return;
        Ja.copy(i).invert(), Ya.copy(t.ray).applyMatrix4(Ja);
        var a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
            o = a * a,
            l = new te(),
            c = new te(),
            h = new te(),
            u = new te(),
            d = this.isLineSegments ? 2 : 1;

        if (n.isBufferGeometry) {
          var _i121 = n.index,
              _r96 = n.attributes.position;

          if (null !== _i121) {
            for (var _n138 = Math.max(0, s.start), _a37 = Math.min(_i121.count, s.start + s.count) - 1; _n138 < _a37; _n138 += d) {
              var _s42 = _i121.getX(_n138),
                  _a38 = _i121.getX(_n138 + 1);

              l.fromBufferAttribute(_r96, _s42), c.fromBufferAttribute(_r96, _a38);
              if (Ya.distanceSqToSegment(l, c, u, h) > o) continue;
              u.applyMatrix4(this.matrixWorld);

              var _d13 = t.ray.origin.distanceTo(u);

              _d13 < t.near || _d13 > t.far || e.push({
                distance: _d13,
                point: h.clone().applyMatrix4(this.matrixWorld),
                index: _n138,
                face: null,
                faceIndex: null,
                object: this
              });
            }
          } else {
            for (var _n139 = Math.max(0, s.start), _i122 = Math.min(_r96.count, s.start + s.count) - 1; _n139 < _i122; _n139 += d) {
              l.fromBufferAttribute(_r96, _n139), c.fromBufferAttribute(_r96, _n139 + 1);
              if (Ya.distanceSqToSegment(l, c, u, h) > o) continue;
              u.applyMatrix4(this.matrixWorld);

              var _i123 = t.ray.origin.distanceTo(u);

              _i123 < t.near || _i123 > t.far || e.push({
                distance: _i123,
                point: h.clone().applyMatrix4(this.matrixWorld),
                index: _n139,
                face: null,
                faceIndex: null,
                object: this
              });
            }
          }
        } else n.isGeometry && console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }, {
      key: "updateMorphTargets",
      value: function updateMorphTargets() {
        var t = this.geometry;

        if (t.isBufferGeometry) {
          var _e137 = t.morphAttributes,
              _n140 = Object.keys(_e137);

          if (_n140.length > 0) {
            var _t170 = _e137[_n140[0]];

            if (void 0 !== _t170) {
              this.morphTargetInfluences = [], this.morphTargetDictionary = {};

              for (var _e138 = 0, _n141 = _t170.length; _e138 < _n141; _e138++) {
                var _n142 = _t170[_e138].name || String(_e138);

                this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n142] = _e138;
              }
            }
          }
        } else {
          var _e139 = t.morphTargets;
          void 0 !== _e139 && _e139.length > 0 && console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
      }
    }]);

    return Ka;
  }(nn);

  Ka.prototype.isLine = !0;
  var Qa = new te(),
      $a = new te();

  var to = /*#__PURE__*/function (_Ka) {
    _inherits(to, _Ka);

    var _super50 = _createSuper(to);

    function to(t, e) {
      var _this39;

      _classCallCheck(this, to);

      _this39 = _super50.call(this, t, e), _this39.type = "LineSegments";
      return _this39;
    }

    _createClass(to, [{
      key: "computeLineDistances",
      value: function computeLineDistances() {
        var t = this.geometry;
        if (t.isBufferGeometry) {
          if (null === t.index) {
            var _e140 = t.attributes.position,
                _n143 = [];

            for (var _t171 = 0, _i124 = _e140.count; _t171 < _i124; _t171 += 2) {
              Qa.fromBufferAttribute(_e140, _t171), $a.fromBufferAttribute(_e140, _t171 + 1), _n143[_t171] = 0 === _t171 ? 0 : _n143[_t171 - 1], _n143[_t171 + 1] = _n143[_t171] + Qa.distanceTo($a);
            }

            t.setAttribute("lineDistance", new Cn(_n143, 1));
          } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        } else t.isGeometry && console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
        return this;
      }
    }]);

    return to;
  }(Ka);

  to.prototype.isLineSegments = !0;

  var eo = /*#__PURE__*/function (_Ka2) {
    _inherits(eo, _Ka2);

    var _super51 = _createSuper(eo);

    function eo(t, e) {
      var _this40;

      _classCallCheck(this, eo);

      _this40 = _super51.call(this, t, e), _this40.type = "LineLoop";
      return _this40;
    }

    return _createClass(eo);
  }(Ka);

  eo.prototype.isLineLoop = !0;

  var no = /*#__PURE__*/function (_gn7) {
    _inherits(no, _gn7);

    var _super52 = _createSuper(no);

    function no(t) {
      var _this41;

      _classCallCheck(this, no);

      _this41 = _super52.call(this), _this41.type = "PointsMaterial", _this41.color = new Ft(16777215), _this41.map = null, _this41.alphaMap = null, _this41.size = 1, _this41.sizeAttenuation = !0, _this41.setValues(t);
      return _this41;
    }

    _createClass(no, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(no.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.size = t.size, this.sizeAttenuation = t.sizeAttenuation, this;
      }
    }]);

    return no;
  }(gn);

  no.prototype.isPointsMaterial = !0;
  var io = new Pe(),
      ro = new Le(),
      so = new be(),
      ao = new te();

  var oo = /*#__PURE__*/function (_nn10) {
    _inherits(oo, _nn10);

    var _super53 = _createSuper(oo);

    function oo() {
      var _this42;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Un();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new no();

      _classCallCheck(this, oo);

      _this42 = _super53.call(this), _this42.type = "Points", _this42.geometry = t, _this42.material = e, _this42.updateMorphTargets();
      return _this42;
    }

    _createClass(oo, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(oo.prototype), "copy", this).call(this, t), this.material = t.material, this.geometry = t.geometry, this;
      }
    }, {
      key: "raycast",
      value: function raycast(t, e) {
        var n = this.geometry,
            i = this.matrixWorld,
            r = t.params.Points.threshold,
            s = n.drawRange;
        if (null === n.boundingSphere && n.computeBoundingSphere(), so.copy(n.boundingSphere), so.applyMatrix4(i), so.radius += r, !1 === t.ray.intersectsSphere(so)) return;
        io.copy(i).invert(), ro.copy(t.ray).applyMatrix4(io);
        var a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
            o = a * a;

        if (n.isBufferGeometry) {
          var _r97 = n.index,
              _a39 = n.attributes.position;

          if (null !== _r97) {
            for (var _n144 = Math.max(0, s.start), _l28 = Math.min(_r97.count, s.start + s.count); _n144 < _l28; _n144++) {
              var _s43 = _r97.getX(_n144);

              ao.fromBufferAttribute(_a39, _s43), lo(ao, _s43, o, i, t, e, this);
            }
          } else {
            for (var _n145 = Math.max(0, s.start), _r98 = Math.min(_a39.count, s.start + s.count); _n145 < _r98; _n145++) {
              ao.fromBufferAttribute(_a39, _n145), lo(ao, _n145, o, i, t, e, this);
            }
          }
        } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }, {
      key: "updateMorphTargets",
      value: function updateMorphTargets() {
        var t = this.geometry;

        if (t.isBufferGeometry) {
          var _e141 = t.morphAttributes,
              _n146 = Object.keys(_e141);

          if (_n146.length > 0) {
            var _t172 = _e141[_n146[0]];

            if (void 0 !== _t172) {
              this.morphTargetInfluences = [], this.morphTargetDictionary = {};

              for (var _e142 = 0, _n147 = _t172.length; _e142 < _n147; _e142++) {
                var _n148 = _t172[_e142].name || String(_e142);

                this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n148] = _e142;
              }
            }
          }
        } else {
          var _e143 = t.morphTargets;
          void 0 !== _e143 && _e143.length > 0 && console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
        }
      }
    }]);

    return oo;
  }(nn);

  function lo(t, e, n, i, r, s, a) {
    var o = ro.distanceSqToPoint(t);

    if (o < n) {
      var _n149 = new te();

      ro.closestPointToPoint(t, _n149), _n149.applyMatrix4(i);

      var _l29 = r.ray.origin.distanceTo(_n149);

      if (_l29 < r.near || _l29 > r.far) return;
      s.push({
        distance: _l29,
        distanceToRay: Math.sqrt(o),
        point: _n149,
        index: e,
        face: null,
        object: a
      });
    }
  }

  oo.prototype.isPoints = !0;

  var co = /*#__PURE__*/function (_jt6) {
    _inherits(co, _jt6);

    var _super54 = _createSuper(co);

    function co(t, e, n, i, r, s, a, o, l) {
      var _this43;

      _classCallCheck(this, co);

      _this43 = _super54.call(this, t, e, n, i, r, s, a, o, l), _this43.minFilter = void 0 !== s ? s : g, _this43.magFilter = void 0 !== r ? r : g, _this43.generateMipmaps = !1;

      var c = _assertThisInitialized(_this43);

      "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(function e() {
        c.needsUpdate = !0, t.requestVideoFrameCallback(e);
      });
      return _this43;
    }

    _createClass(co, [{
      key: "clone",
      value: function clone() {
        return new this.constructor(this.image).copy(this);
      }
    }, {
      key: "update",
      value: function update() {
        var t = this.image;
        !1 === "requestVideoFrameCallback" in t && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
      }
    }]);

    return co;
  }(jt);

  co.prototype.isVideoTexture = !0;

  var ho = /*#__PURE__*/function (_jt7) {
    _inherits(ho, _jt7);

    var _super55 = _createSuper(ho);

    function ho(t, e, n) {
      var _this44;

      _classCallCheck(this, ho);

      _this44 = _super55.call(this, {
        width: t,
        height: e
      }), _this44.format = n, _this44.magFilter = p, _this44.minFilter = p, _this44.generateMipmaps = !1, _this44.needsUpdate = !0;
      return _this44;
    }

    return _createClass(ho);
  }(jt);

  ho.prototype.isFramebufferTexture = !0;

  var uo = /*#__PURE__*/function (_jt8) {
    _inherits(uo, _jt8);

    var _super56 = _createSuper(uo);

    function uo(t, e, n, i, r, s, a, o, l, c, h, u) {
      var _this45;

      _classCallCheck(this, uo);

      _this45 = _super56.call(this, null, s, a, o, l, c, i, r, h, u), _this45.image = {
        width: e,
        height: n
      }, _this45.mipmaps = t, _this45.flipY = !1, _this45.generateMipmaps = !1;
      return _this45;
    }

    return _createClass(uo);
  }(jt);

  uo.prototype.isCompressedTexture = !0;

  var po = /*#__PURE__*/function (_jt9) {
    _inherits(po, _jt9);

    var _super57 = _createSuper(po);

    function po(t, e, n, i, r, s, a, o, l) {
      var _this46;

      _classCallCheck(this, po);

      _this46 = _super57.call(this, t, e, n, i, r, s, a, o, l), _this46.needsUpdate = !0;
      return _this46;
    }

    return _createClass(po);
  }(jt);

  po.prototype.isCanvasTexture = !0;

  var mo = /*#__PURE__*/function (_Un3) {
    _inherits(mo, _Un3);

    var _super58 = _createSuper(mo);

    function mo() {
      var _this47;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2 * Math.PI;

      _classCallCheck(this, mo);

      _this47 = _super58.call(this), _this47.type = "CircleGeometry", _this47.parameters = {
        radius: t,
        segments: e,
        thetaStart: n,
        thetaLength: i
      }, e = Math.max(3, e);
      var r = [],
          s = [],
          a = [],
          o = [],
          l = new te(),
          c = new At();
      s.push(0, 0, 0), a.push(0, 0, 1), o.push(.5, .5);

      for (var _r99 = 0, _h17 = 3; _r99 <= e; _r99++, _h17 += 3) {
        var _u13 = n + _r99 / e * i;

        l.x = t * Math.cos(_u13), l.y = t * Math.sin(_u13), s.push(l.x, l.y, l.z), a.push(0, 0, 1), c.x = (s[_h17] / t + 1) / 2, c.y = (s[_h17 + 1] / t + 1) / 2, o.push(c.x, c.y);
      }

      for (var _t173 = 1; _t173 <= e; _t173++) {
        r.push(_t173, _t173 + 1, 0);
      }

      _this47.setIndex(r), _this47.setAttribute("position", new Cn(s, 3)), _this47.setAttribute("normal", new Cn(a, 3)), _this47.setAttribute("uv", new Cn(o, 2));
      return _this47;
    }

    _createClass(mo, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new mo(t.radius, t.segments, t.thetaStart, t.thetaLength);
      }
    }]);

    return mo;
  }(Un);

  var fo = /*#__PURE__*/function (_Un4) {
    _inherits(fo, _Un4);

    var _super59 = _createSuper(fo);

    function fo() {
      var _this48;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
      var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 2 * Math.PI;

      _classCallCheck(this, fo);

      _this48 = _super59.call(this), _this48.type = "CylinderGeometry", _this48.parameters = {
        radiusTop: t,
        radiusBottom: e,
        height: n,
        radialSegments: i,
        heightSegments: r,
        openEnded: s,
        thetaStart: a,
        thetaLength: o
      };

      var l = _assertThisInitialized(_this48);

      i = Math.floor(i), r = Math.floor(r);
      var c = [],
          h = [],
          u = [],
          d = [];
      var p = 0;
      var m = [],
          f = n / 2;
      var g = 0;

      function v(n) {
        var r = p,
            s = new At(),
            m = new te();
        var v = 0;
        var y = !0 === n ? t : e,
            x = !0 === n ? 1 : -1;

        for (var _t174 = 1; _t174 <= i; _t174++) {
          h.push(0, f * x, 0), u.push(0, x, 0), d.push(.5, .5), p++;
        }

        var _ = p;

        for (var _t175 = 0; _t175 <= i; _t175++) {
          var _e144 = _t175 / i * o + a,
              _n150 = Math.cos(_e144),
              _r100 = Math.sin(_e144);

          m.x = y * _r100, m.y = f * x, m.z = y * _n150, h.push(m.x, m.y, m.z), u.push(0, x, 0), s.x = .5 * _n150 + .5, s.y = .5 * _r100 * x + .5, d.push(s.x, s.y), p++;
        }

        for (var _t176 = 0; _t176 < i; _t176++) {
          var _e145 = r + _t176,
              _i125 = _ + _t176;

          !0 === n ? c.push(_i125, _i125 + 1, _e145) : c.push(_i125 + 1, _i125, _e145), v += 3;
        }

        l.addGroup(g, v, !0 === n ? 1 : 2), g += v;
      }

      !function () {
        var s = new te(),
            v = new te();
        var y = 0;
        var x = (e - t) / n;

        for (var _l30 = 0; _l30 <= r; _l30++) {
          var _c21 = [],
              _g4 = _l30 / r,
              _y6 = _g4 * (e - t) + t;

          for (var _t177 = 0; _t177 <= i; _t177++) {
            var _e146 = _t177 / i,
                _r101 = _e146 * o + a,
                _l31 = Math.sin(_r101),
                _m8 = Math.cos(_r101);

            v.x = _y6 * _l31, v.y = -_g4 * n + f, v.z = _y6 * _m8, h.push(v.x, v.y, v.z), s.set(_l31, x, _m8).normalize(), u.push(s.x, s.y, s.z), d.push(_e146, 1 - _g4), _c21.push(p++);
          }

          m.push(_c21);
        }

        for (var _t178 = 0; _t178 < i; _t178++) {
          for (var _e147 = 0; _e147 < r; _e147++) {
            var _n151 = m[_e147][_t178],
                _i126 = m[_e147 + 1][_t178],
                _r102 = m[_e147 + 1][_t178 + 1],
                _s44 = m[_e147][_t178 + 1];
            c.push(_n151, _i126, _s44), c.push(_i126, _r102, _s44), y += 6;
          }
        }

        l.addGroup(g, y, 0), g += y;
      }(), !1 === s && (t > 0 && v(!0), e > 0 && v(!1)), _this48.setIndex(c), _this48.setAttribute("position", new Cn(h, 3)), _this48.setAttribute("normal", new Cn(u, 3)), _this48.setAttribute("uv", new Cn(d, 2));
      return _this48;
    }

    _createClass(fo, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new fo(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
      }
    }]);

    return fo;
  }(Un);

  var go = /*#__PURE__*/function (_fo) {
    _inherits(go, _fo);

    var _super60 = _createSuper(go);

    function go() {
      var _this49;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 2 * Math.PI;

      _classCallCheck(this, go);

      _this49 = _super60.call(this, 0, t, e, n, i, r, s, a), _this49.type = "ConeGeometry", _this49.parameters = {
        radius: t,
        height: e,
        radialSegments: n,
        heightSegments: i,
        openEnded: r,
        thetaStart: s,
        thetaLength: a
      };
      return _this49;
    }

    _createClass(go, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new go(t.radius, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
      }
    }]);

    return go;
  }(fo);

  var vo = /*#__PURE__*/function (_Un5) {
    _inherits(vo, _Un5);

    var _super61 = _createSuper(vo);

    function vo() {
      var _this50;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      _classCallCheck(this, vo);

      _this50 = _super61.call(this), _this50.type = "PolyhedronGeometry", _this50.parameters = {
        vertices: t,
        indices: e,
        radius: n,
        detail: i
      };
      var r = [],
          s = [];

      function a(t, e, n, i) {
        var r = i + 1,
            s = [];

        for (var _i127 = 0; _i127 <= r; _i127++) {
          s[_i127] = [];

          var _a40 = t.clone().lerp(n, _i127 / r),
              _o24 = e.clone().lerp(n, _i127 / r),
              _l32 = r - _i127;

          for (var _t179 = 0; _t179 <= _l32; _t179++) {
            s[_i127][_t179] = 0 === _t179 && _i127 === r ? _a40 : _a40.clone().lerp(_o24, _t179 / _l32);
          }
        }

        for (var _t180 = 0; _t180 < r; _t180++) {
          for (var _e148 = 0; _e148 < 2 * (r - _t180) - 1; _e148++) {
            var _n152 = Math.floor(_e148 / 2);

            _e148 % 2 == 0 ? (o(s[_t180][_n152 + 1]), o(s[_t180 + 1][_n152]), o(s[_t180][_n152])) : (o(s[_t180][_n152 + 1]), o(s[_t180 + 1][_n152 + 1]), o(s[_t180 + 1][_n152]));
          }
        }
      }

      function o(t) {
        r.push(t.x, t.y, t.z);
      }

      function l(e, n) {
        var i = 3 * e;
        n.x = t[i + 0], n.y = t[i + 1], n.z = t[i + 2];
      }

      function c(t, e, n, i) {
        i < 0 && 1 === t.x && (s[e] = t.x - 1), 0 === n.x && 0 === n.z && (s[e] = i / 2 / Math.PI + .5);
      }

      function h(t) {
        return Math.atan2(t.z, -t.x);
      }

      !function (t) {
        var n = new te(),
            i = new te(),
            r = new te();

        for (var _s45 = 0; _s45 < e.length; _s45 += 3) {
          l(e[_s45 + 0], n), l(e[_s45 + 1], i), l(e[_s45 + 2], r), a(n, i, r, t);
        }
      }(i), function (t) {
        var e = new te();

        for (var _n153 = 0; _n153 < r.length; _n153 += 3) {
          e.x = r[_n153 + 0], e.y = r[_n153 + 1], e.z = r[_n153 + 2], e.normalize().multiplyScalar(t), r[_n153 + 0] = e.x, r[_n153 + 1] = e.y, r[_n153 + 2] = e.z;
        }
      }(n), function () {
        var t = new te();

        for (var _n154 = 0; _n154 < r.length; _n154 += 3) {
          t.x = r[_n154 + 0], t.y = r[_n154 + 1], t.z = r[_n154 + 2];

          var _i128 = h(t) / 2 / Math.PI + .5,
              _a41 = (e = t, Math.atan2(-e.y, Math.sqrt(e.x * e.x + e.z * e.z)) / Math.PI + .5);

          s.push(_i128, 1 - _a41);
        }

        var e;
        (function () {
          var t = new te(),
              e = new te(),
              n = new te(),
              i = new te(),
              a = new At(),
              o = new At(),
              l = new At();

          for (var _u14 = 0, _d14 = 0; _u14 < r.length; _u14 += 9, _d14 += 6) {
            t.set(r[_u14 + 0], r[_u14 + 1], r[_u14 + 2]), e.set(r[_u14 + 3], r[_u14 + 4], r[_u14 + 5]), n.set(r[_u14 + 6], r[_u14 + 7], r[_u14 + 8]), a.set(s[_d14 + 0], s[_d14 + 1]), o.set(s[_d14 + 2], s[_d14 + 3]), l.set(s[_d14 + 4], s[_d14 + 5]), i.copy(t).add(e).add(n).divideScalar(3);

            var _p9 = h(i);

            c(a, _d14 + 0, t, _p9), c(o, _d14 + 2, e, _p9), c(l, _d14 + 4, n, _p9);
          }
        })(), function () {
          for (var _t181 = 0; _t181 < s.length; _t181 += 6) {
            var _e149 = s[_t181 + 0],
                _n155 = s[_t181 + 2],
                _i129 = s[_t181 + 4],
                _r103 = Math.max(_e149, _n155, _i129),
                _a42 = Math.min(_e149, _n155, _i129);

            _r103 > .9 && _a42 < .1 && (_e149 < .2 && (s[_t181 + 0] += 1), _n155 < .2 && (s[_t181 + 2] += 1), _i129 < .2 && (s[_t181 + 4] += 1));
          }
        }();
      }(), _this50.setAttribute("position", new Cn(r, 3)), _this50.setAttribute("normal", new Cn(r.slice(), 3)), _this50.setAttribute("uv", new Cn(s, 2)), 0 === i ? _this50.computeVertexNormals() : _this50.normalizeNormals();
      return _this50;
    }

    _createClass(vo, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new vo(t.vertices, t.indices, t.radius, t.details);
      }
    }]);

    return vo;
  }(Un);

  var yo = /*#__PURE__*/function (_vo) {
    _inherits(yo, _vo);

    var _super62 = _createSuper(yo);

    function yo() {
      var _this51;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, yo);

      var n = (1 + Math.sqrt(5)) / 2,
          i = 1 / n;
      _this51 = _super62.call(this, [-1, -1, -1, -1, -1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1, 0, -i, -n, 0, -i, n, 0, i, -n, 0, i, n, -i, -n, 0, -i, n, 0, i, -n, 0, i, n, 0, -n, 0, -i, n, 0, -i, -n, 0, i, n, 0, i], [3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9], t, e), _this51.type = "DodecahedronGeometry", _this51.parameters = {
        radius: t,
        detail: e
      };
      return _this51;
    }

    _createClass(yo, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new yo(t.radius, t.detail);
      }
    }]);

    return yo;
  }(vo);

  var xo = new te(),
      _o = new te(),
      Mo = new te(),
      bo = new mn();

  var wo = /*#__PURE__*/function (_Un6) {
    _inherits(wo, _Un6);

    var _super63 = _createSuper(wo);

    function wo() {
      var _this52;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      _classCallCheck(this, wo);

      if (_this52 = _super63.call(this), _this52.type = "EdgesGeometry", _this52.parameters = {
        geometry: t,
        thresholdAngle: e
      }, null !== t) {
        var _n156 = 4,
            _i130 = Math.pow(10, _n156),
            _r104 = Math.cos(vt * e),
            _s46 = t.getIndex(),
            _a43 = t.getAttribute("position"),
            _o25 = _s46 ? _s46.count : _a43.count,
            _l33 = [0, 0, 0],
            _c22 = ["a", "b", "c"],
            _h18 = new Array(3),
            _u15 = {},
            _d15 = [];

        for (var _t182 = 0; _t182 < _o25; _t182 += 3) {
          _s46 ? (_l33[0] = _s46.getX(_t182), _l33[1] = _s46.getX(_t182 + 1), _l33[2] = _s46.getX(_t182 + 2)) : (_l33[0] = _t182, _l33[1] = _t182 + 1, _l33[2] = _t182 + 2);
          var _e150 = bo.a,
              _n157 = bo.b,
              _o26 = bo.c;
          if (_e150.fromBufferAttribute(_a43, _l33[0]), _n157.fromBufferAttribute(_a43, _l33[1]), _o26.fromBufferAttribute(_a43, _l33[2]), bo.getNormal(Mo), _h18[0] = "".concat(Math.round(_e150.x * _i130), ",").concat(Math.round(_e150.y * _i130), ",").concat(Math.round(_e150.z * _i130)), _h18[1] = "".concat(Math.round(_n157.x * _i130), ",").concat(Math.round(_n157.y * _i130), ",").concat(Math.round(_n157.z * _i130)), _h18[2] = "".concat(Math.round(_o26.x * _i130), ",").concat(Math.round(_o26.y * _i130), ",").concat(Math.round(_o26.z * _i130)), _h18[0] !== _h18[1] && _h18[1] !== _h18[2] && _h18[2] !== _h18[0]) for (var _t183 = 0; _t183 < 3; _t183++) {
            var _e151 = (_t183 + 1) % 3,
                _n158 = _h18[_t183],
                _i131 = _h18[_e151],
                _s47 = bo[_c22[_t183]],
                _a44 = bo[_c22[_e151]],
                _o27 = "".concat(_n158, "_").concat(_i131),
                _p10 = "".concat(_i131, "_").concat(_n158);

            _p10 in _u15 && _u15[_p10] ? (Mo.dot(_u15[_p10].normal) <= _r104 && (_d15.push(_s47.x, _s47.y, _s47.z), _d15.push(_a44.x, _a44.y, _a44.z)), _u15[_p10] = null) : _o27 in _u15 || (_u15[_o27] = {
              index0: _l33[_t183],
              index1: _l33[_e151],
              normal: Mo.clone()
            });
          }
        }

        for (var _t184 in _u15) {
          if (_u15[_t184]) {
            var _u15$_t = _u15[_t184],
                _e152 = _u15$_t.index0,
                _n159 = _u15$_t.index1;
            xo.fromBufferAttribute(_a43, _e152), _o.fromBufferAttribute(_a43, _n159), _d15.push(xo.x, xo.y, xo.z), _d15.push(_o.x, _o.y, _o.z);
          }
        }

        _this52.setAttribute("position", new Cn(_d15, 3));
      }

      return _possibleConstructorReturn(_this52);
    }

    return _createClass(wo);
  }(Un);

  var So = /*#__PURE__*/function () {
    function So() {
      _classCallCheck(this, So);

      this.type = "Curve", this.arcLengthDivisions = 200;
    }

    _createClass(So, [{
      key: "getPoint",
      value: function getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
      }
    }, {
      key: "getPointAt",
      value: function getPointAt(t, e) {
        var n = this.getUtoTmapping(t);
        return this.getPoint(n, e);
      }
    }, {
      key: "getPoints",
      value: function getPoints() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
        var e = [];

        for (var _n160 = 0; _n160 <= t; _n160++) {
          e.push(this.getPoint(_n160 / t));
        }

        return e;
      }
    }, {
      key: "getSpacedPoints",
      value: function getSpacedPoints() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
        var e = [];

        for (var _n161 = 0; _n161 <= t; _n161++) {
          e.push(this.getPointAt(_n161 / t));
        }

        return e;
      }
    }, {
      key: "getLength",
      value: function getLength() {
        var t = this.getLengths();
        return t[t.length - 1];
      }
    }, {
      key: "getLengths",
      value: function getLengths() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.arcLengthDivisions;
        if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        var e = [];
        var n,
            i = this.getPoint(0),
            r = 0;
        e.push(0);

        for (var _s48 = 1; _s48 <= t; _s48++) {
          n = this.getPoint(_s48 / t), r += n.distanceTo(i), e.push(r), i = n;
        }

        return this.cacheArcLengths = e, e;
      }
    }, {
      key: "updateArcLengths",
      value: function updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
      }
    }, {
      key: "getUtoTmapping",
      value: function getUtoTmapping(t, e) {
        var n = this.getLengths();
        var i = 0;
        var r = n.length;
        var s;
        s = e || t * n[r - 1];
        var a,
            o = 0,
            l = r - 1;

        for (; o <= l;) {
          if (i = Math.floor(o + (l - o) / 2), a = n[i] - s, a < 0) o = i + 1;else {
            if (!(a > 0)) {
              l = i;
              break;
            }

            l = i - 1;
          }
        }

        if (i = l, n[i] === s) return i / (r - 1);
        var c = n[i];
        return (i + (s - c) / (n[i + 1] - c)) / (r - 1);
      }
    }, {
      key: "getTangent",
      value: function getTangent(t, e) {
        var n = 1e-4;
        var i = t - n,
            r = t + n;
        i < 0 && (i = 0), r > 1 && (r = 1);
        var s = this.getPoint(i),
            a = this.getPoint(r),
            o = e || (s.isVector2 ? new At() : new te());
        return o.copy(a).sub(s).normalize(), o;
      }
    }, {
      key: "getTangentAt",
      value: function getTangentAt(t, e) {
        var n = this.getUtoTmapping(t);
        return this.getTangent(n, e);
      }
    }, {
      key: "computeFrenetFrames",
      value: function computeFrenetFrames(t, e) {
        var n = new te(),
            i = [],
            r = [],
            s = [],
            a = new te(),
            o = new Pe();

        for (var _e153 = 0; _e153 <= t; _e153++) {
          var _n162 = _e153 / t;

          i[_e153] = this.getTangentAt(_n162, new te());
        }

        r[0] = new te(), s[0] = new te();
        var l = Number.MAX_VALUE;
        var c = Math.abs(i[0].x),
            h = Math.abs(i[0].y),
            u = Math.abs(i[0].z);
        c <= l && (l = c, n.set(1, 0, 0)), h <= l && (l = h, n.set(0, 1, 0)), u <= l && n.set(0, 0, 1), a.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], a), s[0].crossVectors(i[0], r[0]);

        for (var _e154 = 1; _e154 <= t; _e154++) {
          if (r[_e154] = r[_e154 - 1].clone(), s[_e154] = s[_e154 - 1].clone(), a.crossVectors(i[_e154 - 1], i[_e154]), a.length() > Number.EPSILON) {
            a.normalize();

            var _t185 = Math.acos(_t(i[_e154 - 1].dot(i[_e154]), -1, 1));

            r[_e154].applyMatrix4(o.makeRotationAxis(a, _t185));
          }

          s[_e154].crossVectors(i[_e154], r[_e154]);
        }

        if (!0 === e) {
          var _e155 = Math.acos(_t(r[0].dot(r[t]), -1, 1));

          _e155 /= t, i[0].dot(a.crossVectors(r[0], r[t])) > 0 && (_e155 = -_e155);

          for (var _n163 = 1; _n163 <= t; _n163++) {
            r[_n163].applyMatrix4(o.makeRotationAxis(i[_n163], _e155 * _n163)), s[_n163].crossVectors(i[_n163], r[_n163]);
          }
        }

        return {
          tangents: i,
          normals: r,
          binormals: s
        };
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = {
          metadata: {
            version: 4.5,
            type: "Curve",
            generator: "Curve.toJSON"
          }
        };
        return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
      }
    }]);

    return So;
  }();

  var To = /*#__PURE__*/function (_So) {
    _inherits(To, _So);

    var _super64 = _createSuper(To);

    function To() {
      var _this53;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2 * Math.PI;
      var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
      var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

      _classCallCheck(this, To);

      _this53 = _super64.call(this), _this53.type = "EllipseCurve", _this53.aX = t, _this53.aY = e, _this53.xRadius = n, _this53.yRadius = i, _this53.aStartAngle = r, _this53.aEndAngle = s, _this53.aClockwise = a, _this53.aRotation = o;
      return _this53;
    }

    _createClass(To, [{
      key: "getPoint",
      value: function getPoint(t, e) {
        var n = e || new At(),
            i = 2 * Math.PI;
        var r = this.aEndAngle - this.aStartAngle;
        var s = Math.abs(r) < Number.EPSILON;

        for (; r < 0;) {
          r += i;
        }

        for (; r > i;) {
          r -= i;
        }

        r < Number.EPSILON && (r = s ? 0 : i), !0 !== this.aClockwise || s || (r === i ? r = -i : r -= i);
        var a = this.aStartAngle + t * r;
        var o = this.aX + this.xRadius * Math.cos(a),
            l = this.aY + this.yRadius * Math.sin(a);

        if (0 !== this.aRotation) {
          var _t186 = Math.cos(this.aRotation),
              _e156 = Math.sin(this.aRotation),
              _n164 = o - this.aX,
              _i132 = l - this.aY;

          o = _n164 * _t186 - _i132 * _e156 + this.aX, l = _n164 * _e156 + _i132 * _t186 + this.aY;
        }

        return n.set(o, l);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(To.prototype), "copy", this).call(this, t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(To.prototype), "toJSON", this).call(this);

        return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(To.prototype), "fromJSON", this).call(this, t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
      }
    }]);

    return To;
  }(So);

  To.prototype.isEllipseCurve = !0;

  var Eo = /*#__PURE__*/function (_To) {
    _inherits(Eo, _To);

    var _super65 = _createSuper(Eo);

    function Eo(t, e, n, i, r, s) {
      var _this54;

      _classCallCheck(this, Eo);

      _this54 = _super65.call(this, t, e, n, n, i, r, s), _this54.type = "ArcCurve";
      return _this54;
    }

    return _createClass(Eo);
  }(To);

  function Ao() {
    var t = 0,
        e = 0,
        n = 0,
        i = 0;

    function r(r, s, a, o) {
      t = r, e = a, n = -3 * r + 3 * s - 2 * a - o, i = 2 * r - 2 * s + a + o;
    }

    return {
      initCatmullRom: function initCatmullRom(t, e, n, i, s) {
        r(e, n, s * (n - t), s * (i - e));
      },
      initNonuniformCatmullRom: function initNonuniformCatmullRom(t, e, n, i, s, a, o) {
        var l = (e - t) / s - (n - t) / (s + a) + (n - e) / a,
            c = (n - e) / a - (i - e) / (a + o) + (i - n) / o;
        l *= a, c *= a, r(e, n, l, c);
      },
      calc: function calc(r) {
        var s = r * r;
        return t + e * r + n * s + i * (s * r);
      }
    };
  }

  Eo.prototype.isArcCurve = !0;
  var Ro = new te(),
      Co = new Ao(),
      Lo = new Ao(),
      Po = new Ao();

  var Do = /*#__PURE__*/function (_So2) {
    _inherits(Do, _So2);

    var _super66 = _createSuper(Do);

    function Do() {
      var _this55;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "centripetal";
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : .5;

      _classCallCheck(this, Do);

      _this55 = _super66.call(this), _this55.type = "CatmullRomCurve3", _this55.points = t, _this55.closed = e, _this55.curveType = n, _this55.tension = i;
      return _this55;
    }

    _createClass(Do, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
        var n = e,
            i = this.points,
            r = i.length,
            s = (r - (this.closed ? 0 : 1)) * t;
        var a,
            o,
            l = Math.floor(s),
            c = s - l;
        this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === c && l === r - 1 && (l = r - 2, c = 1), this.closed || l > 0 ? a = i[(l - 1) % r] : (Ro.subVectors(i[0], i[1]).add(i[0]), a = Ro);
        var h = i[l % r],
            u = i[(l + 1) % r];

        if (this.closed || l + 2 < r ? o = i[(l + 2) % r] : (Ro.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), o = Ro), "centripetal" === this.curveType || "chordal" === this.curveType) {
          var _t187 = "chordal" === this.curveType ? .5 : .25;

          var _e157 = Math.pow(a.distanceToSquared(h), _t187),
              _n165 = Math.pow(h.distanceToSquared(u), _t187),
              _i133 = Math.pow(u.distanceToSquared(o), _t187);

          _n165 < 1e-4 && (_n165 = 1), _e157 < 1e-4 && (_e157 = _n165), _i133 < 1e-4 && (_i133 = _n165), Co.initNonuniformCatmullRom(a.x, h.x, u.x, o.x, _e157, _n165, _i133), Lo.initNonuniformCatmullRom(a.y, h.y, u.y, o.y, _e157, _n165, _i133), Po.initNonuniformCatmullRom(a.z, h.z, u.z, o.z, _e157, _n165, _i133);
        } else "catmullrom" === this.curveType && (Co.initCatmullRom(a.x, h.x, u.x, o.x, this.tension), Lo.initCatmullRom(a.y, h.y, u.y, o.y, this.tension), Po.initCatmullRom(a.z, h.z, u.z, o.z, this.tension));

        return n.set(Co.calc(c), Lo.calc(c), Po.calc(c)), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        _get(_getPrototypeOf(Do.prototype), "copy", this).call(this, t), this.points = [];

        for (var _e158 = 0, _n166 = t.points.length; _e158 < _n166; _e158++) {
          var _n167 = t.points[_e158];
          this.points.push(_n167.clone());
        }

        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Do.prototype), "toJSON", this).call(this);

        t.points = [];

        for (var _e159 = 0, _n168 = this.points.length; _e159 < _n168; _e159++) {
          var _n169 = this.points[_e159];
          t.points.push(_n169.toArray());
        }

        return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        _get(_getPrototypeOf(Do.prototype), "fromJSON", this).call(this, t), this.points = [];

        for (var _e160 = 0, _n170 = t.points.length; _e160 < _n170; _e160++) {
          var _n171 = t.points[_e160];
          this.points.push(new te().fromArray(_n171));
        }

        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
      }
    }]);

    return Do;
  }(So);

  function Io(t, e, n, i, r) {
    var s = .5 * (i - e),
        a = .5 * (r - n),
        o = t * t;
    return (2 * n - 2 * i + s + a) * (t * o) + (-3 * n + 3 * i - 2 * s - a) * o + s * t + n;
  }

  function No(t, e, n, i) {
    return function (t, e) {
      var n = 1 - t;
      return n * n * e;
    }(t, e) + function (t, e) {
      return 2 * (1 - t) * t * e;
    }(t, n) + function (t, e) {
      return t * t * e;
    }(t, i);
  }

  function Bo(t, e, n, i, r) {
    return function (t, e) {
      var n = 1 - t;
      return n * n * n * e;
    }(t, e) + function (t, e) {
      var n = 1 - t;
      return 3 * n * n * t * e;
    }(t, n) + function (t, e) {
      return 3 * (1 - t) * t * t * e;
    }(t, i) + function (t, e) {
      return t * t * t * e;
    }(t, r);
  }

  Do.prototype.isCatmullRomCurve3 = !0;

  var zo = /*#__PURE__*/function (_So3) {
    _inherits(zo, _So3);

    var _super67 = _createSuper(zo);

    function zo() {
      var _this56;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new At();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new At();
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new At();

      _classCallCheck(this, zo);

      _this56 = _super67.call(this), _this56.type = "CubicBezierCurve", _this56.v0 = t, _this56.v1 = e, _this56.v2 = n, _this56.v3 = i;
      return _this56;
    }

    _createClass(zo, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();
        var n = e,
            i = this.v0,
            r = this.v1,
            s = this.v2,
            a = this.v3;
        return n.set(Bo(t, i.x, r.x, s.x, a.x), Bo(t, i.y, r.y, s.y, a.y)), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(zo.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(zo.prototype), "toJSON", this).call(this);

        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(zo.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
      }
    }]);

    return zo;
  }(So);

  zo.prototype.isCubicBezierCurve = !0;

  var Oo = /*#__PURE__*/function (_So4) {
    _inherits(Oo, _So4);

    var _super68 = _createSuper(Oo);

    function Oo() {
      var _this57;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new te();
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new te();

      _classCallCheck(this, Oo);

      _this57 = _super68.call(this), _this57.type = "CubicBezierCurve3", _this57.v0 = t, _this57.v1 = e, _this57.v2 = n, _this57.v3 = i;
      return _this57;
    }

    _createClass(Oo, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
        var n = e,
            i = this.v0,
            r = this.v1,
            s = this.v2,
            a = this.v3;
        return n.set(Bo(t, i.x, r.x, s.x, a.x), Bo(t, i.y, r.y, s.y, a.y), Bo(t, i.z, r.z, s.z, a.z)), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Oo.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Oo.prototype), "toJSON", this).call(this);

        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(Oo.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
      }
    }]);

    return Oo;
  }(So);

  Oo.prototype.isCubicBezierCurve3 = !0;

  var Uo = /*#__PURE__*/function (_So5) {
    _inherits(Uo, _So5);

    var _super69 = _createSuper(Uo);

    function Uo() {
      var _this58;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new At();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();

      _classCallCheck(this, Uo);

      _this58 = _super69.call(this), _this58.type = "LineCurve", _this58.v1 = t, _this58.v2 = e;
      return _this58;
    }

    _createClass(Uo, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();
        var n = e;
        return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
      }
    }, {
      key: "getPointAt",
      value: function getPointAt(t, e) {
        return this.getPoint(t, e);
      }
    }, {
      key: "getTangent",
      value: function getTangent(t, e) {
        var n = e || new At();
        return n.copy(this.v2).sub(this.v1).normalize(), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Uo.prototype), "copy", this).call(this, t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Uo.prototype), "toJSON", this).call(this);

        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(Uo.prototype), "fromJSON", this).call(this, t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
      }
    }]);

    return Uo;
  }(So);

  Uo.prototype.isLineCurve = !0;

  var Fo = /*#__PURE__*/function (_So6) {
    _inherits(Fo, _So6);

    var _super70 = _createSuper(Fo);

    function Fo() {
      var _this59;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();

      _classCallCheck(this, Fo);

      _this59 = _super70.call(this), _this59.type = "LineCurve3", _this59.isLineCurve3 = !0, _this59.v1 = t, _this59.v2 = e;
      return _this59;
    }

    _createClass(Fo, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
        var n = e;
        return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
      }
    }, {
      key: "getPointAt",
      value: function getPointAt(t, e) {
        return this.getPoint(t, e);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Fo.prototype), "copy", this).call(this, t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Fo.prototype), "toJSON", this).call(this);

        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(Fo.prototype), "fromJSON", this).call(this, t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
      }
    }]);

    return Fo;
  }(So);

  var Ho = /*#__PURE__*/function (_So7) {
    _inherits(Ho, _So7);

    var _super71 = _createSuper(Ho);

    function Ho() {
      var _this60;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new At();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new At();

      _classCallCheck(this, Ho);

      _this60 = _super71.call(this), _this60.type = "QuadraticBezierCurve", _this60.v0 = t, _this60.v1 = e, _this60.v2 = n;
      return _this60;
    }

    _createClass(Ho, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();
        var n = e,
            i = this.v0,
            r = this.v1,
            s = this.v2;
        return n.set(No(t, i.x, r.x, s.x), No(t, i.y, r.y, s.y)), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Ho.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Ho.prototype), "toJSON", this).call(this);

        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(Ho.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
      }
    }]);

    return Ho;
  }(So);

  Ho.prototype.isQuadraticBezierCurve = !0;

  var Go = /*#__PURE__*/function (_So8) {
    _inherits(Go, _So8);

    var _super72 = _createSuper(Go);

    function Go() {
      var _this61;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new te();

      _classCallCheck(this, Go);

      _this61 = _super72.call(this), _this61.type = "QuadraticBezierCurve3", _this61.v0 = t, _this61.v1 = e, _this61.v2 = n;
      return _this61;
    }

    _createClass(Go, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();
        var n = e,
            i = this.v0,
            r = this.v1,
            s = this.v2;
        return n.set(No(t, i.x, r.x, s.x), No(t, i.y, r.y, s.y), No(t, i.z, r.z, s.z)), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Go.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Go.prototype), "toJSON", this).call(this);

        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(Go.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
      }
    }]);

    return Go;
  }(So);

  Go.prototype.isQuadraticBezierCurve3 = !0;

  var Vo = /*#__PURE__*/function (_So9) {
    _inherits(Vo, _So9);

    var _super73 = _createSuper(Vo);

    function Vo() {
      var _this62;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      _classCallCheck(this, Vo);

      _this62 = _super73.call(this), _this62.type = "SplineCurve", _this62.points = t;
      return _this62;
    }

    _createClass(Vo, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At();
        var n = e,
            i = this.points,
            r = (i.length - 1) * t,
            s = Math.floor(r),
            a = r - s,
            o = i[0 === s ? s : s - 1],
            l = i[s],
            c = i[s > i.length - 2 ? i.length - 1 : s + 1],
            h = i[s > i.length - 3 ? i.length - 1 : s + 2];
        return n.set(Io(a, o.x, l.x, c.x, h.x), Io(a, o.y, l.y, c.y, h.y)), n;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        _get(_getPrototypeOf(Vo.prototype), "copy", this).call(this, t), this.points = [];

        for (var _e161 = 0, _n172 = t.points.length; _e161 < _n172; _e161++) {
          var _n173 = t.points[_e161];
          this.points.push(_n173.clone());
        }

        return this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Vo.prototype), "toJSON", this).call(this);

        t.points = [];

        for (var _e162 = 0, _n174 = this.points.length; _e162 < _n174; _e162++) {
          var _n175 = this.points[_e162];
          t.points.push(_n175.toArray());
        }

        return t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        _get(_getPrototypeOf(Vo.prototype), "fromJSON", this).call(this, t), this.points = [];

        for (var _e163 = 0, _n176 = t.points.length; _e163 < _n176; _e163++) {
          var _n177 = t.points[_e163];
          this.points.push(new At().fromArray(_n177));
        }

        return this;
      }
    }]);

    return Vo;
  }(So);

  Vo.prototype.isSplineCurve = !0;
  var ko = Object.freeze({
    __proto__: null,
    ArcCurve: Eo,
    CatmullRomCurve3: Do,
    CubicBezierCurve: zo,
    CubicBezierCurve3: Oo,
    EllipseCurve: To,
    LineCurve: Uo,
    LineCurve3: Fo,
    QuadraticBezierCurve: Ho,
    QuadraticBezierCurve3: Go,
    SplineCurve: Vo
  });

  var Wo = /*#__PURE__*/function (_So10) {
    _inherits(Wo, _So10);

    var _super74 = _createSuper(Wo);

    function Wo() {
      var _this63;

      _classCallCheck(this, Wo);

      _this63 = _super74.call(this), _this63.type = "CurvePath", _this63.curves = [], _this63.autoClose = !1;
      return _this63;
    }

    _createClass(Wo, [{
      key: "add",
      value: function add(t) {
        this.curves.push(t);
      }
    }, {
      key: "closePath",
      value: function closePath() {
        var t = this.curves[0].getPoint(0),
            e = this.curves[this.curves.length - 1].getPoint(1);
        t.equals(e) || this.curves.push(new Uo(e, t));
      }
    }, {
      key: "getPoint",
      value: function getPoint(t, e) {
        var n = t * this.getLength(),
            i = this.getCurveLengths();
        var r = 0;

        for (; r < i.length;) {
          if (i[r] >= n) {
            var _t188 = i[r] - n,
                _s49 = this.curves[r],
                _a45 = _s49.getLength(),
                _o28 = 0 === _a45 ? 0 : 1 - _t188 / _a45;

            return _s49.getPointAt(_o28, e);
          }

          r++;
        }

        return null;
      }
    }, {
      key: "getLength",
      value: function getLength() {
        var t = this.getCurveLengths();
        return t[t.length - 1];
      }
    }, {
      key: "updateArcLengths",
      value: function updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
      }
    }, {
      key: "getCurveLengths",
      value: function getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        var t = [];
        var e = 0;

        for (var _n178 = 0, _i134 = this.curves.length; _n178 < _i134; _n178++) {
          e += this.curves[_n178].getLength(), t.push(e);
        }

        return this.cacheLengths = t, t;
      }
    }, {
      key: "getSpacedPoints",
      value: function getSpacedPoints() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
        var e = [];

        for (var _n179 = 0; _n179 <= t; _n179++) {
          e.push(this.getPoint(_n179 / t));
        }

        return this.autoClose && e.push(e[0]), e;
      }
    }, {
      key: "getPoints",
      value: function getPoints() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
        var e = [];
        var n;

        for (var _i135 = 0, _r105 = this.curves; _i135 < _r105.length; _i135++) {
          var _s50 = _r105[_i135],
              _a46 = _s50.isEllipseCurve ? 2 * t : _s50.isLineCurve || _s50.isLineCurve3 ? 1 : _s50.isSplineCurve ? t * _s50.points.length : t,
              _o29 = _s50.getPoints(_a46);

          for (var _t189 = 0; _t189 < _o29.length; _t189++) {
            var _i136 = _o29[_t189];
            n && n.equals(_i136) || (e.push(_i136), n = _i136);
          }
        }

        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        _get(_getPrototypeOf(Wo.prototype), "copy", this).call(this, t), this.curves = [];

        for (var _e164 = 0, _n180 = t.curves.length; _e164 < _n180; _e164++) {
          var _n181 = t.curves[_e164];
          this.curves.push(_n181.clone());
        }

        return this.autoClose = t.autoClose, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Wo.prototype), "toJSON", this).call(this);

        t.autoClose = this.autoClose, t.curves = [];

        for (var _e165 = 0, _n182 = this.curves.length; _e165 < _n182; _e165++) {
          var _n183 = this.curves[_e165];
          t.curves.push(_n183.toJSON());
        }

        return t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        _get(_getPrototypeOf(Wo.prototype), "fromJSON", this).call(this, t), this.autoClose = t.autoClose, this.curves = [];

        for (var _e166 = 0, _n184 = t.curves.length; _e166 < _n184; _e166++) {
          var _n185 = t.curves[_e166];
          this.curves.push(new ko[_n185.type]().fromJSON(_n185));
        }

        return this;
      }
    }]);

    return Wo;
  }(So);

  var jo = /*#__PURE__*/function (_Wo) {
    _inherits(jo, _Wo);

    var _super75 = _createSuper(jo);

    function jo(t) {
      var _this64;

      _classCallCheck(this, jo);

      _this64 = _super75.call(this), _this64.type = "Path", _this64.currentPoint = new At(), t && _this64.setFromPoints(t);
      return _this64;
    }

    _createClass(jo, [{
      key: "setFromPoints",
      value: function setFromPoints(t) {
        this.moveTo(t[0].x, t[0].y);

        for (var _e167 = 1, _n186 = t.length; _e167 < _n186; _e167++) {
          this.lineTo(t[_e167].x, t[_e167].y);
        }

        return this;
      }
    }, {
      key: "moveTo",
      value: function moveTo(t, e) {
        return this.currentPoint.set(t, e), this;
      }
    }, {
      key: "lineTo",
      value: function lineTo(t, e) {
        var n = new Uo(this.currentPoint.clone(), new At(t, e));
        return this.curves.push(n), this.currentPoint.set(t, e), this;
      }
    }, {
      key: "quadraticCurveTo",
      value: function quadraticCurveTo(t, e, n, i) {
        var r = new Ho(this.currentPoint.clone(), new At(t, e), new At(n, i));
        return this.curves.push(r), this.currentPoint.set(n, i), this;
      }
    }, {
      key: "bezierCurveTo",
      value: function bezierCurveTo(t, e, n, i, r, s) {
        var a = new zo(this.currentPoint.clone(), new At(t, e), new At(n, i), new At(r, s));
        return this.curves.push(a), this.currentPoint.set(r, s), this;
      }
    }, {
      key: "splineThru",
      value: function splineThru(t) {
        var e = [this.currentPoint.clone()].concat(t),
            n = new Vo(e);
        return this.curves.push(n), this.currentPoint.copy(t[t.length - 1]), this;
      }
    }, {
      key: "arc",
      value: function arc(t, e, n, i, r, s) {
        var a = this.currentPoint.x,
            o = this.currentPoint.y;
        return this.absarc(t + a, e + o, n, i, r, s), this;
      }
    }, {
      key: "absarc",
      value: function absarc(t, e, n, i, r, s) {
        return this.absellipse(t, e, n, n, i, r, s), this;
      }
    }, {
      key: "ellipse",
      value: function ellipse(t, e, n, i, r, s, a, o) {
        var l = this.currentPoint.x,
            c = this.currentPoint.y;
        return this.absellipse(t + l, e + c, n, i, r, s, a, o), this;
      }
    }, {
      key: "absellipse",
      value: function absellipse(t, e, n, i, r, s, a, o) {
        var l = new To(t, e, n, i, r, s, a, o);

        if (this.curves.length > 0) {
          var _t190 = l.getPoint(0);

          _t190.equals(this.currentPoint) || this.lineTo(_t190.x, _t190.y);
        }

        this.curves.push(l);
        var c = l.getPoint(1);
        return this.currentPoint.copy(c), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(jo.prototype), "copy", this).call(this, t), this.currentPoint.copy(t.currentPoint), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(jo.prototype), "toJSON", this).call(this);

        return t.currentPoint = this.currentPoint.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(jo.prototype), "fromJSON", this).call(this, t), this.currentPoint.fromArray(t.currentPoint), this;
      }
    }]);

    return jo;
  }(Wo);

  var qo = /*#__PURE__*/function (_jo) {
    _inherits(qo, _jo);

    var _super76 = _createSuper(qo);

    function qo(t) {
      var _this65;

      _classCallCheck(this, qo);

      _this65 = _super76.call(this, t), _this65.uuid = xt(), _this65.type = "Shape", _this65.holes = [];
      return _this65;
    }

    _createClass(qo, [{
      key: "getPointsHoles",
      value: function getPointsHoles(t) {
        var e = [];

        for (var _n187 = 0, _i137 = this.holes.length; _n187 < _i137; _n187++) {
          e[_n187] = this.holes[_n187].getPoints(t);
        }

        return e;
      }
    }, {
      key: "extractPoints",
      value: function extractPoints(t) {
        return {
          shape: this.getPoints(t),
          holes: this.getPointsHoles(t)
        };
      }
    }, {
      key: "copy",
      value: function copy(t) {
        _get(_getPrototypeOf(qo.prototype), "copy", this).call(this, t), this.holes = [];

        for (var _e168 = 0, _n188 = t.holes.length; _e168 < _n188; _e168++) {
          var _n189 = t.holes[_e168];
          this.holes.push(_n189.clone());
        }

        return this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(qo.prototype), "toJSON", this).call(this);

        t.uuid = this.uuid, t.holes = [];

        for (var _e169 = 0, _n190 = this.holes.length; _e169 < _n190; _e169++) {
          var _n191 = this.holes[_e169];
          t.holes.push(_n191.toJSON());
        }

        return t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        _get(_getPrototypeOf(qo.prototype), "fromJSON", this).call(this, t), this.uuid = t.uuid, this.holes = [];

        for (var _e170 = 0, _n192 = t.holes.length; _e170 < _n192; _e170++) {
          var _n193 = t.holes[_e170];
          this.holes.push(new jo().fromJSON(_n193));
        }

        return this;
      }
    }]);

    return qo;
  }(jo);

  var Xo = function Xo(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var i = e && e.length,
        r = i ? e[0] * n : t.length;
    var s = Jo(t, 0, r, n, !0);
    var a = [];
    if (!s || s.next === s.prev) return a;
    var o, l, c, h, u, d, p;

    if (i && (s = function (t, e, n, i) {
      var r = [];
      var s, a, o, l, c;

      for (s = 0, a = e.length; s < a; s++) {
        o = e[s] * i, l = s < a - 1 ? e[s + 1] * i : t.length, c = Jo(t, o, l, i, !1), c === c.next && (c.steiner = !0), r.push(sl(c));
      }

      for (r.sort(el), s = 0; s < r.length; s++) {
        nl(r[s], n), n = Yo(n, n.next);
      }

      return n;
    }(t, e, s, n)), t.length > 80 * n) {
      o = c = t[0], l = h = t[1];

      for (var _e171 = n; _e171 < r; _e171 += n) {
        u = t[_e171], d = t[_e171 + 1], u < o && (o = u), d < l && (l = d), u > c && (c = u), d > h && (h = d);
      }

      p = Math.max(c - o, h - l), p = 0 !== p ? 1 / p : 0;
    }

    return Zo(s, a, n, o, l, p), a;
  };

  function Jo(t, e, n, i, r) {
    var s, a;
    if (r === function (t, e, n, i) {
      var r = 0;

      for (var _s51 = e, _a47 = n - i; _s51 < n; _s51 += i) {
        r += (t[_a47] - t[_s51]) * (t[_s51 + 1] + t[_a47 + 1]), _a47 = _s51;
      }

      return r;
    }(t, e, n, i) > 0) for (s = e; s < n; s += i) {
      a = fl(s, t[s], t[s + 1], a);
    } else for (s = n - i; s >= e; s -= i) {
      a = fl(s, t[s], t[s + 1], a);
    }
    return a && cl(a, a.next) && (gl(a), a = a.next), a;
  }

  function Yo(t, e) {
    if (!t) return t;
    e || (e = t);
    var n,
        i = t;

    do {
      if (n = !1, i.steiner || !cl(i, i.next) && 0 !== ll(i.prev, i, i.next)) i = i.next;else {
        if (gl(i), i = e = i.prev, i === i.next) break;
        n = !0;
      }
    } while (n || i !== e);

    return e;
  }

  function Zo(t, e, n, i, r, s, a) {
    if (!t) return;
    !a && s && function (t, e, n, i) {
      var r = t;

      do {
        null === r.z && (r.z = rl(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
      } while (r !== t);

      r.prevZ.nextZ = null, r.prevZ = null, function (t) {
        var e,
            n,
            i,
            r,
            s,
            a,
            o,
            l,
            c = 1;

        do {
          for (n = t, t = null, s = null, a = 0; n;) {
            for (a++, i = n, o = 0, e = 0; e < c && (o++, i = i.nextZ, i); e++) {
              ;
            }

            for (l = c; o > 0 || l > 0 && i;) {
              0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), s ? s.nextZ = r : t = r, r.prevZ = s, s = r;
            }

            n = i;
          }

          s.nextZ = null, c *= 2;
        } while (a > 1);
      }(r);
    }(t, i, r, s);
    var o,
        l,
        c = t;

    for (; t.prev !== t.next;) {
      if (o = t.prev, l = t.next, s ? Qo(t, i, r, s) : Ko(t)) e.push(o.i / n), e.push(t.i / n), e.push(l.i / n), gl(t), t = l.next, c = l.next;else if ((t = l) === c) {
        a ? 1 === a ? Zo(t = $o(Yo(t), e, n), e, n, i, r, s, 2) : 2 === a && tl(t, e, n, i, r, s) : Zo(Yo(t), e, n, i, r, s, 1);
        break;
      }
    }
  }

  function Ko(t) {
    var e = t.prev,
        n = t,
        i = t.next;
    if (ll(e, n, i) >= 0) return !1;
    var r = t.next.next;

    for (; r !== t.prev;) {
      if (al(e.x, e.y, n.x, n.y, i.x, i.y, r.x, r.y) && ll(r.prev, r, r.next) >= 0) return !1;
      r = r.next;
    }

    return !0;
  }

  function Qo(t, e, n, i) {
    var r = t.prev,
        s = t,
        a = t.next;
    if (ll(r, s, a) >= 0) return !1;
    var o = r.x < s.x ? r.x < a.x ? r.x : a.x : s.x < a.x ? s.x : a.x,
        l = r.y < s.y ? r.y < a.y ? r.y : a.y : s.y < a.y ? s.y : a.y,
        c = r.x > s.x ? r.x > a.x ? r.x : a.x : s.x > a.x ? s.x : a.x,
        h = r.y > s.y ? r.y > a.y ? r.y : a.y : s.y > a.y ? s.y : a.y,
        u = rl(o, l, e, n, i),
        d = rl(c, h, e, n, i);
    var p = t.prevZ,
        m = t.nextZ;

    for (; p && p.z >= u && m && m.z <= d;) {
      if (p !== t.prev && p !== t.next && al(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && ll(p.prev, p, p.next) >= 0) return !1;
      if (p = p.prevZ, m !== t.prev && m !== t.next && al(r.x, r.y, s.x, s.y, a.x, a.y, m.x, m.y) && ll(m.prev, m, m.next) >= 0) return !1;
      m = m.nextZ;
    }

    for (; p && p.z >= u;) {
      if (p !== t.prev && p !== t.next && al(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && ll(p.prev, p, p.next) >= 0) return !1;
      p = p.prevZ;
    }

    for (; m && m.z <= d;) {
      if (m !== t.prev && m !== t.next && al(r.x, r.y, s.x, s.y, a.x, a.y, m.x, m.y) && ll(m.prev, m, m.next) >= 0) return !1;
      m = m.nextZ;
    }

    return !0;
  }

  function $o(t, e, n) {
    var i = t;

    do {
      var _r106 = i.prev,
          _s52 = i.next.next;
      !cl(_r106, _s52) && hl(_r106, i, i.next, _s52) && pl(_r106, _s52) && pl(_s52, _r106) && (e.push(_r106.i / n), e.push(i.i / n), e.push(_s52.i / n), gl(i), gl(i.next), i = t = _s52), i = i.next;
    } while (i !== t);

    return Yo(i);
  }

  function tl(t, e, n, i, r, s) {
    var a = t;

    do {
      var _t191 = a.next.next;

      for (; _t191 !== a.prev;) {
        if (a.i !== _t191.i && ol(a, _t191)) {
          var _o30 = ml(a, _t191);

          return a = Yo(a, a.next), _o30 = Yo(_o30, _o30.next), Zo(a, e, n, i, r, s), void Zo(_o30, e, n, i, r, s);
        }

        _t191 = _t191.next;
      }

      a = a.next;
    } while (a !== t);
  }

  function el(t, e) {
    return t.x - e.x;
  }

  function nl(t, e) {
    if (e = function (t, e) {
      var n = e;
      var i = t.x,
          r = t.y;
      var s,
          a = -1 / 0;

      do {
        if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
          var _t192 = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);

          if (_t192 <= i && _t192 > a) {
            if (a = _t192, _t192 === i) {
              if (r === n.y) return n;
              if (r === n.next.y) return n.next;
            }

            s = n.x < n.next.x ? n : n.next;
          }
        }

        n = n.next;
      } while (n !== e);

      if (!s) return null;
      if (i === a) return s;
      var o = s,
          l = s.x,
          c = s.y;
      var h,
          u = 1 / 0;
      n = s;

      do {
        i >= n.x && n.x >= l && i !== n.x && al(r < c ? i : a, r, l, c, r < c ? a : i, r, n.x, n.y) && (h = Math.abs(r - n.y) / (i - n.x), pl(n, t) && (h < u || h === u && (n.x > s.x || n.x === s.x && il(s, n))) && (s = n, u = h)), n = n.next;
      } while (n !== o);

      return s;
    }(t, e), e) {
      var _n194 = ml(e, t);

      Yo(e, e.next), Yo(_n194, _n194.next);
    }
  }

  function il(t, e) {
    return ll(t.prev, t, e.prev) < 0 && ll(e.next, t, t.next) < 0;
  }

  function rl(t, e, n, i, r) {
    return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - n) * r) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - i) * r) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
  }

  function sl(t) {
    var e = t,
        n = t;

    do {
      (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
    } while (e !== t);

    return n;
  }

  function al(t, e, n, i, r, s, a, o) {
    return (r - a) * (e - o) - (t - a) * (s - o) >= 0 && (t - a) * (i - o) - (n - a) * (e - o) >= 0 && (n - a) * (s - o) - (r - a) * (i - o) >= 0;
  }

  function ol(t, e) {
    return t.next.i !== e.i && t.prev.i !== e.i && !function (t, e) {
      var n = t;

      do {
        if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && hl(n, n.next, t, e)) return !0;
        n = n.next;
      } while (n !== t);

      return !1;
    }(t, e) && (pl(t, e) && pl(e, t) && function (t, e) {
      var n = t,
          i = !1;
      var r = (t.x + e.x) / 2,
          s = (t.y + e.y) / 2;

      do {
        n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
      } while (n !== t);

      return i;
    }(t, e) && (ll(t.prev, t, e.prev) || ll(t, e.prev, e)) || cl(t, e) && ll(t.prev, t, t.next) > 0 && ll(e.prev, e, e.next) > 0);
  }

  function ll(t, e, n) {
    return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
  }

  function cl(t, e) {
    return t.x === e.x && t.y === e.y;
  }

  function hl(t, e, n, i) {
    var r = dl(ll(t, e, n)),
        s = dl(ll(t, e, i)),
        a = dl(ll(n, i, t)),
        o = dl(ll(n, i, e));
    return r !== s && a !== o || !(0 !== r || !ul(t, n, e)) || !(0 !== s || !ul(t, i, e)) || !(0 !== a || !ul(n, t, i)) || !(0 !== o || !ul(n, e, i));
  }

  function ul(t, e, n) {
    return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
  }

  function dl(t) {
    return t > 0 ? 1 : t < 0 ? -1 : 0;
  }

  function pl(t, e) {
    return ll(t.prev, t, t.next) < 0 ? ll(t, e, t.next) >= 0 && ll(t, t.prev, e) >= 0 : ll(t, e, t.prev) < 0 || ll(t, t.next, e) < 0;
  }

  function ml(t, e) {
    var n = new vl(t.i, t.x, t.y),
        i = new vl(e.i, e.x, e.y),
        r = t.next,
        s = e.prev;
    return t.next = e, e.prev = t, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, i.prev = s, i;
  }

  function fl(t, e, n, i) {
    var r = new vl(t, e, n);
    return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
  }

  function gl(t) {
    t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
  }

  function vl(t, e, n) {
    this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
  }

  var yl = /*#__PURE__*/function () {
    function yl() {
      _classCallCheck(this, yl);
    }

    _createClass(yl, null, [{
      key: "area",
      value: function area(t) {
        var e = t.length;
        var n = 0;

        for (var _i138 = e - 1, _r107 = 0; _r107 < e; _i138 = _r107++) {
          n += t[_i138].x * t[_r107].y - t[_r107].x * t[_i138].y;
        }

        return .5 * n;
      }
    }, {
      key: "isClockWise",
      value: function isClockWise(t) {
        return yl.area(t) < 0;
      }
    }, {
      key: "triangulateShape",
      value: function triangulateShape(t, e) {
        var n = [],
            i = [],
            r = [];
        xl(t), _l(n, t);
        var s = t.length;
        e.forEach(xl);

        for (var _t193 = 0; _t193 < e.length; _t193++) {
          i.push(s), s += e[_t193].length, _l(n, e[_t193]);
        }

        var a = Xo(n, i);

        for (var _t194 = 0; _t194 < a.length; _t194 += 3) {
          r.push(a.slice(_t194, _t194 + 3));
        }

        return r;
      }
    }]);

    return yl;
  }();

  function xl(t) {
    var e = t.length;
    e > 2 && t[e - 1].equals(t[0]) && t.pop();
  }

  function _l(t, e) {
    for (var _n195 = 0; _n195 < e.length; _n195++) {
      t.push(e[_n195].x), t.push(e[_n195].y);
    }
  }

  var Ml = /*#__PURE__*/function (_Un7) {
    _inherits(Ml, _Un7);

    var _super77 = _createSuper(Ml);

    function Ml() {
      var _this66;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new qo([new At(.5, .5), new At(-.5, .5), new At(-.5, -.5), new At(.5, -.5)]);
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Ml);

      _this66 = _super77.call(this), _this66.type = "ExtrudeGeometry", _this66.parameters = {
        shapes: t,
        options: e
      }, t = Array.isArray(t) ? t : [t];

      var n = _assertThisInitialized(_this66),
          i = [],
          r = [];

      for (var _e172 = 0, _n196 = t.length; _e172 < _n196; _e172++) {
        s(t[_e172]);
      }

      function s(t) {
        var s = [],
            a = void 0 !== e.curveSegments ? e.curveSegments : 12,
            o = void 0 !== e.steps ? e.steps : 1;
        var l = void 0 !== e.depth ? e.depth : 1,
            c = void 0 === e.bevelEnabled || e.bevelEnabled,
            h = void 0 !== e.bevelThickness ? e.bevelThickness : .2,
            u = void 0 !== e.bevelSize ? e.bevelSize : h - .1,
            d = void 0 !== e.bevelOffset ? e.bevelOffset : 0,
            p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
        var m = e.extrudePath,
            f = void 0 !== e.UVGenerator ? e.UVGenerator : bl;
        void 0 !== e.amount && (console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth."), l = e.amount);

        var g,
            v,
            y,
            x,
            _,
            M = !1;

        m && (g = m.getSpacedPoints(o), M = !0, c = !1, v = m.computeFrenetFrames(o, !1), y = new te(), x = new te(), _ = new te()), c || (p = 0, h = 0, u = 0, d = 0);
        var b = t.extractPoints(a);
        var w = b.shape;
        var S = b.holes;

        if (!yl.isClockWise(w)) {
          w = w.reverse();

          for (var _t195 = 0, _e173 = S.length; _t195 < _e173; _t195++) {
            var _e174 = S[_t195];
            yl.isClockWise(_e174) && (S[_t195] = _e174.reverse());
          }
        }

        var T = yl.triangulateShape(w, S),
            E = w;

        for (var _t196 = 0, _e175 = S.length; _t196 < _e175; _t196++) {
          var _e176 = S[_t196];
          w = w.concat(_e176);
        }

        function A(t, e, n) {
          return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), e.clone().multiplyScalar(n).add(t);
        }

        var R = w.length,
            C = T.length;

        function L(t, e, n) {
          var i, r, s;
          var a = t.x - e.x,
              o = t.y - e.y,
              l = n.x - t.x,
              c = n.y - t.y,
              h = a * a + o * o,
              u = a * c - o * l;

          if (Math.abs(u) > Number.EPSILON) {
            var _u16 = Math.sqrt(h),
                _d16 = Math.sqrt(l * l + c * c),
                _p11 = e.x - o / _u16,
                _m9 = e.y + a / _u16,
                _f6 = ((n.x - c / _d16 - _p11) * c - (n.y + l / _d16 - _m9) * l) / (a * c - o * l);

            i = _p11 + a * _f6 - t.x, r = _m9 + o * _f6 - t.y;

            var _g5 = i * i + r * r;

            if (_g5 <= 2) return new At(i, r);
            s = Math.sqrt(_g5 / 2);
          } else {
            var _t197 = !1;

            a > Number.EPSILON ? l > Number.EPSILON && (_t197 = !0) : a < -Number.EPSILON ? l < -Number.EPSILON && (_t197 = !0) : Math.sign(o) === Math.sign(c) && (_t197 = !0), _t197 ? (i = -o, r = a, s = Math.sqrt(h)) : (i = a, r = o, s = Math.sqrt(h / 2));
          }

          return new At(i / s, r / s);
        }

        var P = [];

        for (var _t198 = 0, _e177 = E.length, _n197 = _e177 - 1, _i139 = _t198 + 1; _t198 < _e177; _t198++, _n197++, _i139++) {
          _n197 === _e177 && (_n197 = 0), _i139 === _e177 && (_i139 = 0), P[_t198] = L(E[_t198], E[_n197], E[_i139]);
        }

        var D = [];
        var I,
            N = P.concat();

        for (var _t199 = 0, _e178 = S.length; _t199 < _e178; _t199++) {
          var _e179 = S[_t199];
          I = [];

          for (var _t200 = 0, _n198 = _e179.length, _i140 = _n198 - 1, _r108 = _t200 + 1; _t200 < _n198; _t200++, _i140++, _r108++) {
            _i140 === _n198 && (_i140 = 0), _r108 === _n198 && (_r108 = 0), I[_t200] = L(_e179[_t200], _e179[_i140], _e179[_r108]);
          }

          D.push(I), N = N.concat(I);
        }

        for (var _t201 = 0; _t201 < p; _t201++) {
          var _e180 = _t201 / p,
              _n199 = h * Math.cos(_e180 * Math.PI / 2),
              _i141 = u * Math.sin(_e180 * Math.PI / 2) + d;

          for (var _t202 = 0, _e181 = E.length; _t202 < _e181; _t202++) {
            var _e182 = A(E[_t202], P[_t202], _i141);

            O(_e182.x, _e182.y, -_n199);
          }

          for (var _t203 = 0, _e183 = S.length; _t203 < _e183; _t203++) {
            var _e184 = S[_t203];
            I = D[_t203];

            for (var _t204 = 0, _r109 = _e184.length; _t204 < _r109; _t204++) {
              var _r110 = A(_e184[_t204], I[_t204], _i141);

              O(_r110.x, _r110.y, -_n199);
            }
          }
        }

        var B = u + d;

        for (var _t205 = 0; _t205 < R; _t205++) {
          var _e185 = c ? A(w[_t205], N[_t205], B) : w[_t205];

          M ? (x.copy(v.normals[0]).multiplyScalar(_e185.x), y.copy(v.binormals[0]).multiplyScalar(_e185.y), _.copy(g[0]).add(x).add(y), O(_.x, _.y, _.z)) : O(_e185.x, _e185.y, 0);
        }

        for (var _t206 = 1; _t206 <= o; _t206++) {
          for (var _e186 = 0; _e186 < R; _e186++) {
            var _n200 = c ? A(w[_e186], N[_e186], B) : w[_e186];

            M ? (x.copy(v.normals[_t206]).multiplyScalar(_n200.x), y.copy(v.binormals[_t206]).multiplyScalar(_n200.y), _.copy(g[_t206]).add(x).add(y), O(_.x, _.y, _.z)) : O(_n200.x, _n200.y, l / o * _t206);
          }
        }

        for (var _t207 = p - 1; _t207 >= 0; _t207--) {
          var _e187 = _t207 / p,
              _n201 = h * Math.cos(_e187 * Math.PI / 2),
              _i142 = u * Math.sin(_e187 * Math.PI / 2) + d;

          for (var _t208 = 0, _e188 = E.length; _t208 < _e188; _t208++) {
            var _e189 = A(E[_t208], P[_t208], _i142);

            O(_e189.x, _e189.y, l + _n201);
          }

          for (var _t209 = 0, _e190 = S.length; _t209 < _e190; _t209++) {
            var _e191 = S[_t209];
            I = D[_t209];

            for (var _t210 = 0, _r111 = _e191.length; _t210 < _r111; _t210++) {
              var _r112 = A(_e191[_t210], I[_t210], _i142);

              M ? O(_r112.x, _r112.y + g[o - 1].y, g[o - 1].x + _n201) : O(_r112.x, _r112.y, l + _n201);
            }
          }
        }

        function z(t, e) {
          var n = t.length;

          for (; --n >= 0;) {
            var _i143 = n;

            var _r113 = n - 1;

            _r113 < 0 && (_r113 = t.length - 1);

            for (var _t211 = 0, _n202 = o + 2 * p; _t211 < _n202; _t211++) {
              var _n203 = R * _t211,
                  _s53 = R * (_t211 + 1);

              F(e + _i143 + _n203, e + _r113 + _n203, e + _r113 + _s53, e + _i143 + _s53);
            }
          }
        }

        function O(t, e, n) {
          s.push(t), s.push(e), s.push(n);
        }

        function U(t, e, r) {
          H(t), H(e), H(r);
          var s = i.length / 3,
              a = f.generateTopUV(n, i, s - 3, s - 2, s - 1);
          G(a[0]), G(a[1]), G(a[2]);
        }

        function F(t, e, r, s) {
          H(t), H(e), H(s), H(e), H(r), H(s);
          var a = i.length / 3,
              o = f.generateSideWallUV(n, i, a - 6, a - 3, a - 2, a - 1);
          G(o[0]), G(o[1]), G(o[3]), G(o[1]), G(o[2]), G(o[3]);
        }

        function H(t) {
          i.push(s[3 * t + 0]), i.push(s[3 * t + 1]), i.push(s[3 * t + 2]);
        }

        function G(t) {
          r.push(t.x), r.push(t.y);
        }

        !function () {
          var t = i.length / 3;

          if (c) {
            var _t212 = 0,
                _e192 = R * _t212;

            for (var _t213 = 0; _t213 < C; _t213++) {
              var _n204 = T[_t213];
              U(_n204[2] + _e192, _n204[1] + _e192, _n204[0] + _e192);
            }

            _t212 = o + 2 * p, _e192 = R * _t212;

            for (var _t214 = 0; _t214 < C; _t214++) {
              var _n205 = T[_t214];
              U(_n205[0] + _e192, _n205[1] + _e192, _n205[2] + _e192);
            }
          } else {
            for (var _t215 = 0; _t215 < C; _t215++) {
              var _e193 = T[_t215];
              U(_e193[2], _e193[1], _e193[0]);
            }

            for (var _t216 = 0; _t216 < C; _t216++) {
              var _e194 = T[_t216];
              U(_e194[0] + R * o, _e194[1] + R * o, _e194[2] + R * o);
            }
          }

          n.addGroup(t, i.length / 3 - t, 0);
        }(), function () {
          var t = i.length / 3;
          var e = 0;
          z(E, e), e += E.length;

          for (var _t217 = 0, _n206 = S.length; _t217 < _n206; _t217++) {
            var _n207 = S[_t217];
            z(_n207, e), e += _n207.length;
          }

          n.addGroup(t, i.length / 3 - t, 1);
        }();
      }

      _this66.setAttribute("position", new Cn(i, 3)), _this66.setAttribute("uv", new Cn(r, 2)), _this66.computeVertexNormals();
      return _this66;
    }

    _createClass(Ml, [{
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Ml.prototype), "toJSON", this).call(this);

        return function (t, e, n) {
          if (n.shapes = [], Array.isArray(t)) for (var _e195 = 0, _i144 = t.length; _e195 < _i144; _e195++) {
            var _i145 = t[_e195];
            n.shapes.push(_i145.uuid);
          } else n.shapes.push(t.uuid);
          void 0 !== e.extrudePath && (n.options.extrudePath = e.extrudePath.toJSON());
          return n;
        }(this.parameters.shapes, this.parameters.options, t);
      }
    }], [{
      key: "fromJSON",
      value: function fromJSON(t, e) {
        var n = [];

        for (var _i146 = 0, _r114 = t.shapes.length; _i146 < _r114; _i146++) {
          var _r115 = e[t.shapes[_i146]];
          n.push(_r115);
        }

        var i = t.options.extrudePath;
        return void 0 !== i && (t.options.extrudePath = new ko[i.type]().fromJSON(i)), new Ml(n, t.options);
      }
    }]);

    return Ml;
  }(Un);

  var bl = {
    generateTopUV: function generateTopUV(t, e, n, i, r) {
      var s = e[3 * n],
          a = e[3 * n + 1],
          o = e[3 * i],
          l = e[3 * i + 1],
          c = e[3 * r],
          h = e[3 * r + 1];
      return [new At(s, a), new At(o, l), new At(c, h)];
    },
    generateSideWallUV: function generateSideWallUV(t, e, n, i, r, s) {
      var a = e[3 * n],
          o = e[3 * n + 1],
          l = e[3 * n + 2],
          c = e[3 * i],
          h = e[3 * i + 1],
          u = e[3 * i + 2],
          d = e[3 * r],
          p = e[3 * r + 1],
          m = e[3 * r + 2],
          f = e[3 * s],
          g = e[3 * s + 1],
          v = e[3 * s + 2];
      return Math.abs(o - h) < Math.abs(a - c) ? [new At(a, 1 - l), new At(c, 1 - u), new At(d, 1 - m), new At(f, 1 - v)] : [new At(o, 1 - l), new At(h, 1 - u), new At(p, 1 - m), new At(g, 1 - v)];
    }
  };

  var wl = /*#__PURE__*/function (_vo2) {
    _inherits(wl, _vo2);

    var _super78 = _createSuper(wl);

    function wl() {
      var _this67;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, wl);

      var n = (1 + Math.sqrt(5)) / 2;
      _this67 = _super78.call(this, [-1, n, 0, 1, n, 0, -1, -n, 0, 1, -n, 0, 0, -1, n, 0, 1, n, 0, -1, -n, 0, 1, -n, n, 0, -1, n, 0, 1, -n, 0, -1, -n, 0, 1], [0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1], t, e), _this67.type = "IcosahedronGeometry", _this67.parameters = {
        radius: t,
        detail: e
      };
      return _this67;
    }

    _createClass(wl, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new wl(t.radius, t.detail);
      }
    }]);

    return wl;
  }(vo);

  var Sl = /*#__PURE__*/function (_Un8) {
    _inherits(Sl, _Un8);

    var _super79 = _createSuper(Sl);

    function Sl() {
      var _this68;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [new At(0, .5), new At(.5, 0), new At(0, -.5)];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2 * Math.PI;

      _classCallCheck(this, Sl);

      _this68 = _super79.call(this), _this68.type = "LatheGeometry", _this68.parameters = {
        points: t,
        segments: e,
        phiStart: n,
        phiLength: i
      }, e = Math.floor(e), i = _t(i, 0, 2 * Math.PI);
      var r = [],
          s = [],
          a = [],
          o = [],
          l = [],
          c = 1 / e,
          h = new te(),
          u = new At(),
          d = new te(),
          p = new te(),
          m = new te();
      var f = 0,
          g = 0;

      for (var _e196 = 0; _e196 <= t.length - 1; _e196++) {
        switch (_e196) {
          case 0:
            f = t[_e196 + 1].x - t[_e196].x, g = t[_e196 + 1].y - t[_e196].y, d.x = 1 * g, d.y = -f, d.z = 0 * g, m.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
            break;

          case t.length - 1:
            o.push(m.x, m.y, m.z);
            break;

          default:
            f = t[_e196 + 1].x - t[_e196].x, g = t[_e196 + 1].y - t[_e196].y, d.x = 1 * g, d.y = -f, d.z = 0 * g, p.copy(d), d.x += m.x, d.y += m.y, d.z += m.z, d.normalize(), o.push(d.x, d.y, d.z), m.copy(p);
        }
      }

      for (var _r116 = 0; _r116 <= e; _r116++) {
        var _d17 = n + _r116 * c * i,
            _p12 = Math.sin(_d17),
            _m10 = Math.cos(_d17);

        for (var _n208 = 0; _n208 <= t.length - 1; _n208++) {
          h.x = t[_n208].x * _p12, h.y = t[_n208].y, h.z = t[_n208].x * _m10, s.push(h.x, h.y, h.z), u.x = _r116 / e, u.y = _n208 / (t.length - 1), a.push(u.x, u.y);

          var _i147 = o[3 * _n208 + 0] * _p12,
              _c23 = o[3 * _n208 + 1],
              _d18 = o[3 * _n208 + 0] * _m10;

          l.push(_i147, _c23, _d18);
        }
      }

      for (var _n209 = 0; _n209 < e; _n209++) {
        for (var _e197 = 0; _e197 < t.length - 1; _e197++) {
          var _i148 = _e197 + _n209 * t.length,
              _s54 = _i148,
              _a48 = _i148 + t.length,
              _o31 = _i148 + t.length + 1,
              _l34 = _i148 + 1;

          r.push(_s54, _a48, _l34), r.push(_o31, _l34, _a48);
        }
      }

      _this68.setIndex(r), _this68.setAttribute("position", new Cn(s, 3)), _this68.setAttribute("uv", new Cn(a, 2)), _this68.setAttribute("normal", new Cn(l, 3));
      return _this68;
    }

    _createClass(Sl, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Sl(t.points, t.segments, t.phiStart, t.phiLength);
      }
    }]);

    return Sl;
  }(Un);

  var Tl = /*#__PURE__*/function (_vo3) {
    _inherits(Tl, _vo3);

    var _super80 = _createSuper(Tl);

    function Tl() {
      var _this69;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, Tl);

      _this69 = _super80.call(this, [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1], [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2], t, e), _this69.type = "OctahedronGeometry", _this69.parameters = {
        radius: t,
        detail: e
      };
      return _this69;
    }

    _createClass(Tl, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Tl(t.radius, t.detail);
      }
    }]);

    return Tl;
  }(vo);

  var El = /*#__PURE__*/function (_Un9) {
    _inherits(El, _Un9);

    var _super81 = _createSuper(El);

    function El() {
      var _this70;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .5;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2 * Math.PI;

      _classCallCheck(this, El);

      _this70 = _super81.call(this), _this70.type = "RingGeometry", _this70.parameters = {
        innerRadius: t,
        outerRadius: e,
        thetaSegments: n,
        phiSegments: i,
        thetaStart: r,
        thetaLength: s
      }, n = Math.max(3, n);
      var a = [],
          o = [],
          l = [],
          c = [];
      var h = t;
      var u = (e - t) / (i = Math.max(1, i)),
          d = new te(),
          p = new At();

      for (var _t218 = 0; _t218 <= i; _t218++) {
        for (var _t219 = 0; _t219 <= n; _t219++) {
          var _i149 = r + _t219 / n * s;

          d.x = h * Math.cos(_i149), d.y = h * Math.sin(_i149), o.push(d.x, d.y, d.z), l.push(0, 0, 1), p.x = (d.x / e + 1) / 2, p.y = (d.y / e + 1) / 2, c.push(p.x, p.y);
        }

        h += u;
      }

      for (var _t220 = 0; _t220 < i; _t220++) {
        var _e198 = _t220 * (n + 1);

        for (var _t221 = 0; _t221 < n; _t221++) {
          var _i150 = _t221 + _e198,
              _r117 = _i150,
              _s55 = _i150 + n + 1,
              _o32 = _i150 + n + 2,
              _l35 = _i150 + 1;

          a.push(_r117, _s55, _l35), a.push(_s55, _o32, _l35);
        }
      }

      _this70.setIndex(a), _this70.setAttribute("position", new Cn(o, 3)), _this70.setAttribute("normal", new Cn(l, 3)), _this70.setAttribute("uv", new Cn(c, 2));
      return _this70;
    }

    _createClass(El, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new El(t.innerRadius, t.outerRadius, t.thetaSegments, t.phiSegments, t.thetaStart, t.thetaLength);
      }
    }]);

    return El;
  }(Un);

  var Al = /*#__PURE__*/function (_Un10) {
    _inherits(Al, _Un10);

    var _super82 = _createSuper(Al);

    function Al() {
      var _this71;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new qo([new At(0, .5), new At(-.5, -.5), new At(.5, -.5)]);
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

      _classCallCheck(this, Al);

      _this71 = _super82.call(this), _this71.type = "ShapeGeometry", _this71.parameters = {
        shapes: t,
        curveSegments: e
      };
      var n = [],
          i = [],
          r = [],
          s = [];
      var a = 0,
          o = 0;
      if (!1 === Array.isArray(t)) l(t);else for (var _e199 = 0; _e199 < t.length; _e199++) {
        l(t[_e199]), _this71.addGroup(a, o, _e199), a += o, o = 0;
      }

      function l(t) {
        var a = i.length / 3,
            l = t.extractPoints(e);
        var c = l.shape;
        var h = l.holes;
        !1 === yl.isClockWise(c) && (c = c.reverse());

        for (var _t222 = 0, _e200 = h.length; _t222 < _e200; _t222++) {
          var _e201 = h[_t222];
          !0 === yl.isClockWise(_e201) && (h[_t222] = _e201.reverse());
        }

        var u = yl.triangulateShape(c, h);

        for (var _t223 = 0, _e202 = h.length; _t223 < _e202; _t223++) {
          var _e203 = h[_t223];
          c = c.concat(_e203);
        }

        for (var _t224 = 0, _e204 = c.length; _t224 < _e204; _t224++) {
          var _e205 = c[_t224];
          i.push(_e205.x, _e205.y, 0), r.push(0, 0, 1), s.push(_e205.x, _e205.y);
        }

        for (var _t225 = 0, _e206 = u.length; _t225 < _e206; _t225++) {
          var _e207 = u[_t225],
              _i151 = _e207[0] + a,
              _r118 = _e207[1] + a,
              _s56 = _e207[2] + a;

          n.push(_i151, _r118, _s56), o += 3;
        }
      }

      _this71.setIndex(n), _this71.setAttribute("position", new Cn(i, 3)), _this71.setAttribute("normal", new Cn(r, 3)), _this71.setAttribute("uv", new Cn(s, 2));
      return _this71;
    }

    _createClass(Al, [{
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Al.prototype), "toJSON", this).call(this);

        return function (t, e) {
          if (e.shapes = [], Array.isArray(t)) for (var _n210 = 0, _i152 = t.length; _n210 < _i152; _n210++) {
            var _i153 = t[_n210];
            e.shapes.push(_i153.uuid);
          } else e.shapes.push(t.uuid);
          return e;
        }(this.parameters.shapes, t);
      }
    }], [{
      key: "fromJSON",
      value: function fromJSON(t, e) {
        var n = [];

        for (var _i154 = 0, _r119 = t.shapes.length; _i154 < _r119; _i154++) {
          var _r120 = e[t.shapes[_i154]];
          n.push(_r120);
        }

        return new Al(n, t.curveSegments);
      }
    }]);

    return Al;
  }(Un);

  var Rl = /*#__PURE__*/function (_Un11) {
    _inherits(Rl, _Un11);

    var _super83 = _createSuper(Rl);

    function Rl() {
      var _this72;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2 * Math.PI;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Math.PI;

      _classCallCheck(this, Rl);

      _this72 = _super83.call(this), _this72.type = "SphereGeometry", _this72.parameters = {
        radius: t,
        widthSegments: e,
        heightSegments: n,
        phiStart: i,
        phiLength: r,
        thetaStart: s,
        thetaLength: a
      }, e = Math.max(3, Math.floor(e)), n = Math.max(2, Math.floor(n));
      var o = Math.min(s + a, Math.PI);
      var l = 0;
      var c = [],
          h = new te(),
          u = new te(),
          d = [],
          p = [],
          m = [],
          f = [];

      for (var _d19 = 0; _d19 <= n; _d19++) {
        var _g6 = [],
            _v6 = _d19 / n;

        var _y7 = 0;
        0 == _d19 && 0 == s ? _y7 = .5 / e : _d19 == n && o == Math.PI && (_y7 = -.5 / e);

        for (var _n211 = 0; _n211 <= e; _n211++) {
          var _o33 = _n211 / e;

          h.x = -t * Math.cos(i + _o33 * r) * Math.sin(s + _v6 * a), h.y = t * Math.cos(s + _v6 * a), h.z = t * Math.sin(i + _o33 * r) * Math.sin(s + _v6 * a), p.push(h.x, h.y, h.z), u.copy(h).normalize(), m.push(u.x, u.y, u.z), f.push(_o33 + _y7, 1 - _v6), _g6.push(l++);
        }

        c.push(_g6);
      }

      for (var _t226 = 0; _t226 < n; _t226++) {
        for (var _i155 = 0; _i155 < e; _i155++) {
          var _e208 = c[_t226][_i155 + 1],
              _r121 = c[_t226][_i155],
              _a49 = c[_t226 + 1][_i155],
              _l36 = c[_t226 + 1][_i155 + 1];
          (0 !== _t226 || s > 0) && d.push(_e208, _r121, _l36), (_t226 !== n - 1 || o < Math.PI) && d.push(_r121, _a49, _l36);
        }
      }

      _this72.setIndex(d), _this72.setAttribute("position", new Cn(p, 3)), _this72.setAttribute("normal", new Cn(m, 3)), _this72.setAttribute("uv", new Cn(f, 2));
      return _this72;
    }

    _createClass(Rl, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Rl(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
      }
    }]);

    return Rl;
  }(Un);

  var Cl = /*#__PURE__*/function (_vo4) {
    _inherits(Cl, _vo4);

    var _super84 = _createSuper(Cl);

    function Cl() {
      var _this73;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, Cl);

      _this73 = _super84.call(this, [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1], [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1], t, e), _this73.type = "TetrahedronGeometry", _this73.parameters = {
        radius: t,
        detail: e
      };
      return _this73;
    }

    _createClass(Cl, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Cl(t.radius, t.detail);
      }
    }]);

    return Cl;
  }(vo);

  var Ll = /*#__PURE__*/function (_Un12) {
    _inherits(Ll, _Un12);

    var _super85 = _createSuper(Ll);

    function Ll() {
      var _this74;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .4;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2 * Math.PI;

      _classCallCheck(this, Ll);

      _this74 = _super85.call(this), _this74.type = "TorusGeometry", _this74.parameters = {
        radius: t,
        tube: e,
        radialSegments: n,
        tubularSegments: i,
        arc: r
      }, n = Math.floor(n), i = Math.floor(i);
      var s = [],
          a = [],
          o = [],
          l = [],
          c = new te(),
          h = new te(),
          u = new te();

      for (var _s57 = 0; _s57 <= n; _s57++) {
        for (var _d20 = 0; _d20 <= i; _d20++) {
          var _p13 = _d20 / i * r,
              _m11 = _s57 / n * Math.PI * 2;

          h.x = (t + e * Math.cos(_m11)) * Math.cos(_p13), h.y = (t + e * Math.cos(_m11)) * Math.sin(_p13), h.z = e * Math.sin(_m11), a.push(h.x, h.y, h.z), c.x = t * Math.cos(_p13), c.y = t * Math.sin(_p13), u.subVectors(h, c).normalize(), o.push(u.x, u.y, u.z), l.push(_d20 / i), l.push(_s57 / n);
        }
      }

      for (var _t227 = 1; _t227 <= n; _t227++) {
        for (var _e209 = 1; _e209 <= i; _e209++) {
          var _n212 = (i + 1) * _t227 + _e209 - 1,
              _r122 = (i + 1) * (_t227 - 1) + _e209 - 1,
              _a50 = (i + 1) * (_t227 - 1) + _e209,
              _o34 = (i + 1) * _t227 + _e209;

          s.push(_n212, _r122, _o34), s.push(_r122, _a50, _o34);
        }
      }

      _this74.setIndex(s), _this74.setAttribute("position", new Cn(a, 3)), _this74.setAttribute("normal", new Cn(o, 3)), _this74.setAttribute("uv", new Cn(l, 2));
      return _this74;
    }

    _createClass(Ll, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Ll(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc);
      }
    }]);

    return Ll;
  }(Un);

  var Pl = /*#__PURE__*/function (_Un13) {
    _inherits(Pl, _Un13);

    var _super86 = _createSuper(Pl);

    function Pl() {
      var _this75;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .4;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 64;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 3;

      _classCallCheck(this, Pl);

      _this75 = _super86.call(this), _this75.type = "TorusKnotGeometry", _this75.parameters = {
        radius: t,
        tube: e,
        tubularSegments: n,
        radialSegments: i,
        p: r,
        q: s
      }, n = Math.floor(n), i = Math.floor(i);
      var a = [],
          o = [],
          l = [],
          c = [],
          h = new te(),
          u = new te(),
          d = new te(),
          p = new te(),
          m = new te(),
          f = new te(),
          g = new te();

      for (var _a51 = 0; _a51 <= n; ++_a51) {
        var _y8 = _a51 / n * r * Math.PI * 2;

        v(_y8, r, s, t, d), v(_y8 + .01, r, s, t, p), f.subVectors(p, d), g.addVectors(p, d), m.crossVectors(f, g), g.crossVectors(m, f), m.normalize(), g.normalize();

        for (var _t228 = 0; _t228 <= i; ++_t228) {
          var _r123 = _t228 / i * Math.PI * 2,
              _s58 = -e * Math.cos(_r123),
              _p14 = e * Math.sin(_r123);

          h.x = d.x + (_s58 * g.x + _p14 * m.x), h.y = d.y + (_s58 * g.y + _p14 * m.y), h.z = d.z + (_s58 * g.z + _p14 * m.z), o.push(h.x, h.y, h.z), u.subVectors(h, d).normalize(), l.push(u.x, u.y, u.z), c.push(_a51 / n), c.push(_t228 / i);
        }
      }

      for (var _t229 = 1; _t229 <= n; _t229++) {
        for (var _e210 = 1; _e210 <= i; _e210++) {
          var _n213 = (i + 1) * (_t229 - 1) + (_e210 - 1),
              _r124 = (i + 1) * _t229 + (_e210 - 1),
              _s59 = (i + 1) * _t229 + _e210,
              _o35 = (i + 1) * (_t229 - 1) + _e210;

          a.push(_n213, _r124, _o35), a.push(_r124, _s59, _o35);
        }
      }

      function v(t, e, n, i, r) {
        var s = Math.cos(t),
            a = Math.sin(t),
            o = n / e * t,
            l = Math.cos(o);
        r.x = i * (2 + l) * .5 * s, r.y = i * (2 + l) * a * .5, r.z = i * Math.sin(o) * .5;
      }

      _this75.setIndex(a), _this75.setAttribute("position", new Cn(o, 3)), _this75.setAttribute("normal", new Cn(l, 3)), _this75.setAttribute("uv", new Cn(c, 2));
      return _this75;
    }

    _createClass(Pl, null, [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Pl(t.radius, t.tube, t.tubularSegments, t.radialSegments, t.p, t.q);
      }
    }]);

    return Pl;
  }(Un);

  var Dl = /*#__PURE__*/function (_Un14) {
    _inherits(Dl, _Un14);

    var _super87 = _createSuper(Dl);

    function Dl() {
      var _this76;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Go(new te(-1, -1, 0), new te(-1, 1, 0), new te(1, 1, 0));
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

      _classCallCheck(this, Dl);

      _this76 = _super87.call(this), _this76.type = "TubeGeometry", _this76.parameters = {
        path: t,
        tubularSegments: e,
        radius: n,
        radialSegments: i,
        closed: r
      };
      var s = t.computeFrenetFrames(e, r);
      _this76.tangents = s.tangents, _this76.normals = s.normals, _this76.binormals = s.binormals;
      var a = new te(),
          o = new te(),
          l = new At();
      var c = new te();
      var h = [],
          u = [],
          d = [],
          p = [];

      function m(r) {
        c = t.getPointAt(r / e, c);
        var l = s.normals[r],
            d = s.binormals[r];

        for (var _t230 = 0; _t230 <= i; _t230++) {
          var _e211 = _t230 / i * Math.PI * 2,
              _r125 = Math.sin(_e211),
              _s60 = -Math.cos(_e211);

          o.x = _s60 * l.x + _r125 * d.x, o.y = _s60 * l.y + _r125 * d.y, o.z = _s60 * l.z + _r125 * d.z, o.normalize(), u.push(o.x, o.y, o.z), a.x = c.x + n * o.x, a.y = c.y + n * o.y, a.z = c.z + n * o.z, h.push(a.x, a.y, a.z);
        }
      }

      !function () {
        for (var _t231 = 0; _t231 < e; _t231++) {
          m(_t231);
        }

        m(!1 === r ? e : 0), function () {
          for (var _t232 = 0; _t232 <= e; _t232++) {
            for (var _n214 = 0; _n214 <= i; _n214++) {
              l.x = _t232 / e, l.y = _n214 / i, d.push(l.x, l.y);
            }
          }
        }(), function () {
          for (var _t233 = 1; _t233 <= e; _t233++) {
            for (var _e212 = 1; _e212 <= i; _e212++) {
              var _n215 = (i + 1) * (_t233 - 1) + (_e212 - 1),
                  _r126 = (i + 1) * _t233 + (_e212 - 1),
                  _s61 = (i + 1) * _t233 + _e212,
                  _a52 = (i + 1) * (_t233 - 1) + _e212;

              p.push(_n215, _r126, _a52), p.push(_r126, _s61, _a52);
            }
          }
        }();
      }(), _this76.setIndex(p), _this76.setAttribute("position", new Cn(h, 3)), _this76.setAttribute("normal", new Cn(u, 3)), _this76.setAttribute("uv", new Cn(d, 2));
      return _this76;
    }

    _createClass(Dl, [{
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Dl.prototype), "toJSON", this).call(this);

        return t.path = this.parameters.path.toJSON(), t;
      }
    }], [{
      key: "fromJSON",
      value: function fromJSON(t) {
        return new Dl(new ko[t.path.type]().fromJSON(t.path), t.tubularSegments, t.radius, t.radialSegments, t.closed);
      }
    }]);

    return Dl;
  }(Un);

  var Il = /*#__PURE__*/function (_Un15) {
    _inherits(Il, _Un15);

    var _super88 = _createSuper(Il);

    function Il() {
      var _this77;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      _classCallCheck(this, Il);

      if (_this77 = _super88.call(this), _this77.type = "WireframeGeometry", _this77.parameters = {
        geometry: t
      }, null !== t) {
        var _e213 = [],
            _n216 = new Set(),
            _i156 = new te(),
            _r127 = new te();

        if (null !== t.index) {
          var _s62 = t.attributes.position,
              _a53 = t.index;
          var _o36 = t.groups;
          0 === _o36.length && (_o36 = [{
            start: 0,
            count: _a53.count,
            materialIndex: 0
          }]);

          for (var _t234 = 0, _l37 = _o36.length; _t234 < _l37; ++_t234) {
            var _l38 = _o36[_t234],
                _c24 = _l38.start;

            for (var _t235 = _c24, _o37 = _c24 + _l38.count; _t235 < _o37; _t235 += 3) {
              for (var _o38 = 0; _o38 < 3; _o38++) {
                var _l39 = _a53.getX(_t235 + _o38),
                    _c25 = _a53.getX(_t235 + (_o38 + 1) % 3);

                _i156.fromBufferAttribute(_s62, _l39), _r127.fromBufferAttribute(_s62, _c25), !0 === Nl(_i156, _r127, _n216) && (_e213.push(_i156.x, _i156.y, _i156.z), _e213.push(_r127.x, _r127.y, _r127.z));
              }
            }
          }
        } else {
          var _s63 = t.attributes.position;

          for (var _t236 = 0, _a54 = _s63.count / 3; _t236 < _a54; _t236++) {
            for (var _a55 = 0; _a55 < 3; _a55++) {
              var _o39 = 3 * _t236 + _a55,
                  _l40 = 3 * _t236 + (_a55 + 1) % 3;

              _i156.fromBufferAttribute(_s63, _o39), _r127.fromBufferAttribute(_s63, _l40), !0 === Nl(_i156, _r127, _n216) && (_e213.push(_i156.x, _i156.y, _i156.z), _e213.push(_r127.x, _r127.y, _r127.z));
            }
          }
        }

        _this77.setAttribute("position", new Cn(_e213, 3));
      }

      return _possibleConstructorReturn(_this77);
    }

    return _createClass(Il);
  }(Un);

  function Nl(t, e, n) {
    var i = "".concat(t.x, ",").concat(t.y, ",").concat(t.z, "-").concat(e.x, ",").concat(e.y, ",").concat(e.z),
        r = "".concat(e.x, ",").concat(e.y, ",").concat(e.z, "-").concat(t.x, ",").concat(t.y, ",").concat(t.z);
    return !0 !== n.has(i) && !0 !== n.has(r) && (n.add(i), n.add(r), !0);
  }

  var Bl = Object.freeze({
    __proto__: null,
    BoxGeometry: ri,
    BoxBufferGeometry: ri,
    CircleGeometry: mo,
    CircleBufferGeometry: mo,
    ConeGeometry: go,
    ConeBufferGeometry: go,
    CylinderGeometry: fo,
    CylinderBufferGeometry: fo,
    DodecahedronGeometry: yo,
    DodecahedronBufferGeometry: yo,
    EdgesGeometry: wo,
    ExtrudeGeometry: Ml,
    ExtrudeBufferGeometry: Ml,
    IcosahedronGeometry: wl,
    IcosahedronBufferGeometry: wl,
    LatheGeometry: Sl,
    LatheBufferGeometry: Sl,
    OctahedronGeometry: Tl,
    OctahedronBufferGeometry: Tl,
    PlaneGeometry: Si,
    PlaneBufferGeometry: Si,
    PolyhedronGeometry: vo,
    PolyhedronBufferGeometry: vo,
    RingGeometry: El,
    RingBufferGeometry: El,
    ShapeGeometry: Al,
    ShapeBufferGeometry: Al,
    SphereGeometry: Rl,
    SphereBufferGeometry: Rl,
    TetrahedronGeometry: Cl,
    TetrahedronBufferGeometry: Cl,
    TorusGeometry: Ll,
    TorusBufferGeometry: Ll,
    TorusKnotGeometry: Pl,
    TorusKnotBufferGeometry: Pl,
    TubeGeometry: Dl,
    TubeBufferGeometry: Dl,
    WireframeGeometry: Il
  });

  var zl = /*#__PURE__*/function (_gn8) {
    _inherits(zl, _gn8);

    var _super89 = _createSuper(zl);

    function zl(t) {
      var _this78;

      _classCallCheck(this, zl);

      _this78 = _super89.call(this), _this78.type = "ShadowMaterial", _this78.color = new Ft(0), _this78.transparent = !0, _this78.setValues(t);
      return _this78;
    }

    _createClass(zl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(zl.prototype), "copy", this).call(this, t), this.color.copy(t.color), this;
      }
    }]);

    return zl;
  }(gn);

  zl.prototype.isShadowMaterial = !0;

  var Ol = /*#__PURE__*/function (_li) {
    _inherits(Ol, _li);

    var _super90 = _createSuper(Ol);

    function Ol(t) {
      var _this79;

      _classCallCheck(this, Ol);

      _this79 = _super90.call(this, t), _this79.type = "RawShaderMaterial";
      return _this79;
    }

    return _createClass(Ol);
  }(li);

  Ol.prototype.isRawShaderMaterial = !0;

  var Ul = /*#__PURE__*/function (_gn9) {
    _inherits(Ul, _gn9);

    var _super91 = _createSuper(Ul);

    function Ul(t) {
      var _this80;

      _classCallCheck(this, Ul);

      _this80 = _super91.call(this), _this80.defines = {
        STANDARD: ""
      }, _this80.type = "MeshStandardMaterial", _this80.color = new Ft(16777215), _this80.roughness = 1, _this80.metalness = 0, _this80.map = null, _this80.lightMap = null, _this80.lightMapIntensity = 1, _this80.aoMap = null, _this80.aoMapIntensity = 1, _this80.emissive = new Ft(0), _this80.emissiveIntensity = 1, _this80.emissiveMap = null, _this80.bumpMap = null, _this80.bumpScale = 1, _this80.normalMap = null, _this80.normalMapType = 0, _this80.normalScale = new At(1, 1), _this80.displacementMap = null, _this80.displacementScale = 1, _this80.displacementBias = 0, _this80.roughnessMap = null, _this80.metalnessMap = null, _this80.alphaMap = null, _this80.envMap = null, _this80.envMapIntensity = 1, _this80.refractionRatio = .98, _this80.wireframe = !1, _this80.wireframeLinewidth = 1, _this80.wireframeLinecap = "round", _this80.wireframeLinejoin = "round", _this80.flatShading = !1, _this80.setValues(t);
      return _this80;
    }

    _createClass(Ul, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Ul.prototype), "copy", this).call(this, t), this.defines = {
          STANDARD: ""
        }, this.color.copy(t.color), this.roughness = t.roughness, this.metalness = t.metalness, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.roughnessMap = t.roughnessMap, this.metalnessMap = t.metalnessMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapIntensity = t.envMapIntensity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this;
      }
    }]);

    return Ul;
  }(gn);

  Ul.prototype.isMeshStandardMaterial = !0;

  var Fl = /*#__PURE__*/function (_Ul) {
    _inherits(Fl, _Ul);

    var _super92 = _createSuper(Fl);

    function Fl(t) {
      var _this81;

      _classCallCheck(this, Fl);

      _this81 = _super92.call(this), _this81.defines = {
        STANDARD: "",
        PHYSICAL: ""
      }, _this81.type = "MeshPhysicalMaterial", _this81.clearcoatMap = null, _this81.clearcoatRoughness = 0, _this81.clearcoatRoughnessMap = null, _this81.clearcoatNormalScale = new At(1, 1), _this81.clearcoatNormalMap = null, _this81.ior = 1.5, Object.defineProperty(_assertThisInitialized(_this81), "reflectivity", {
        get: function get() {
          return _t(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
        },
        set: function set(t) {
          this.ior = (1 + .4 * t) / (1 - .4 * t);
        }
      }), _this81.sheenColor = new Ft(0), _this81.sheenColorMap = null, _this81.sheenRoughness = 1, _this81.sheenRoughnessMap = null, _this81.transmissionMap = null, _this81.thickness = 0, _this81.thicknessMap = null, _this81.attenuationDistance = 0, _this81.attenuationColor = new Ft(1, 1, 1), _this81.specularIntensity = 1, _this81.specularIntensityMap = null, _this81.specularColor = new Ft(1, 1, 1), _this81.specularColorMap = null, _this81._sheen = 0, _this81._clearcoat = 0, _this81._transmission = 0, _this81.setValues(t);
      return _this81;
    }

    _createClass(Fl, [{
      key: "sheen",
      get: function get() {
        return this._sheen;
      },
      set: function set(t) {
        this._sheen > 0 != t > 0 && this.version++, this._sheen = t;
      }
    }, {
      key: "clearcoat",
      get: function get() {
        return this._clearcoat;
      },
      set: function set(t) {
        this._clearcoat > 0 != t > 0 && this.version++, this._clearcoat = t;
      }
    }, {
      key: "transmission",
      get: function get() {
        return this._transmission;
      },
      set: function set(t) {
        this._transmission > 0 != t > 0 && this.version++, this._transmission = t;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Fl.prototype), "copy", this).call(this, t), this.defines = {
          STANDARD: "",
          PHYSICAL: ""
        }, this.clearcoat = t.clearcoat, this.clearcoatMap = t.clearcoatMap, this.clearcoatRoughness = t.clearcoatRoughness, this.clearcoatRoughnessMap = t.clearcoatRoughnessMap, this.clearcoatNormalMap = t.clearcoatNormalMap, this.clearcoatNormalScale.copy(t.clearcoatNormalScale), this.ior = t.ior, this.sheen = t.sheen, this.sheenColor.copy(t.sheenColor), this.sheenColorMap = t.sheenColorMap, this.sheenRoughness = t.sheenRoughness, this.sheenRoughnessMap = t.sheenRoughnessMap, this.transmission = t.transmission, this.transmissionMap = t.transmissionMap, this.thickness = t.thickness, this.thicknessMap = t.thicknessMap, this.attenuationDistance = t.attenuationDistance, this.attenuationColor.copy(t.attenuationColor), this.specularIntensity = t.specularIntensity, this.specularIntensityMap = t.specularIntensityMap, this.specularColor.copy(t.specularColor), this.specularColorMap = t.specularColorMap, this;
      }
    }]);

    return Fl;
  }(Ul);

  Fl.prototype.isMeshPhysicalMaterial = !0;

  var Hl = /*#__PURE__*/function (_gn10) {
    _inherits(Hl, _gn10);

    var _super93 = _createSuper(Hl);

    function Hl(t) {
      var _this82;

      _classCallCheck(this, Hl);

      _this82 = _super93.call(this), _this82.type = "MeshPhongMaterial", _this82.color = new Ft(16777215), _this82.specular = new Ft(1118481), _this82.shininess = 30, _this82.map = null, _this82.lightMap = null, _this82.lightMapIntensity = 1, _this82.aoMap = null, _this82.aoMapIntensity = 1, _this82.emissive = new Ft(0), _this82.emissiveIntensity = 1, _this82.emissiveMap = null, _this82.bumpMap = null, _this82.bumpScale = 1, _this82.normalMap = null, _this82.normalMapType = 0, _this82.normalScale = new At(1, 1), _this82.displacementMap = null, _this82.displacementScale = 1, _this82.displacementBias = 0, _this82.specularMap = null, _this82.alphaMap = null, _this82.envMap = null, _this82.combine = 0, _this82.reflectivity = 1, _this82.refractionRatio = .98, _this82.wireframe = !1, _this82.wireframeLinewidth = 1, _this82.wireframeLinecap = "round", _this82.wireframeLinejoin = "round", _this82.flatShading = !1, _this82.setValues(t);
      return _this82;
    }

    _createClass(Hl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Hl.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.specular.copy(t.specular), this.shininess = t.shininess, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this;
      }
    }]);

    return Hl;
  }(gn);

  Hl.prototype.isMeshPhongMaterial = !0;

  var Gl = /*#__PURE__*/function (_gn11) {
    _inherits(Gl, _gn11);

    var _super94 = _createSuper(Gl);

    function Gl(t) {
      var _this83;

      _classCallCheck(this, Gl);

      _this83 = _super94.call(this), _this83.defines = {
        TOON: ""
      }, _this83.type = "MeshToonMaterial", _this83.color = new Ft(16777215), _this83.map = null, _this83.gradientMap = null, _this83.lightMap = null, _this83.lightMapIntensity = 1, _this83.aoMap = null, _this83.aoMapIntensity = 1, _this83.emissive = new Ft(0), _this83.emissiveIntensity = 1, _this83.emissiveMap = null, _this83.bumpMap = null, _this83.bumpScale = 1, _this83.normalMap = null, _this83.normalMapType = 0, _this83.normalScale = new At(1, 1), _this83.displacementMap = null, _this83.displacementScale = 1, _this83.displacementBias = 0, _this83.alphaMap = null, _this83.wireframe = !1, _this83.wireframeLinewidth = 1, _this83.wireframeLinecap = "round", _this83.wireframeLinejoin = "round", _this83.setValues(t);
      return _this83;
    }

    _createClass(Gl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Gl.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.gradientMap = t.gradientMap, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
      }
    }]);

    return Gl;
  }(gn);

  Gl.prototype.isMeshToonMaterial = !0;

  var Vl = /*#__PURE__*/function (_gn12) {
    _inherits(Vl, _gn12);

    var _super95 = _createSuper(Vl);

    function Vl(t) {
      var _this84;

      _classCallCheck(this, Vl);

      _this84 = _super95.call(this), _this84.type = "MeshNormalMaterial", _this84.bumpMap = null, _this84.bumpScale = 1, _this84.normalMap = null, _this84.normalMapType = 0, _this84.normalScale = new At(1, 1), _this84.displacementMap = null, _this84.displacementScale = 1, _this84.displacementBias = 0, _this84.wireframe = !1, _this84.wireframeLinewidth = 1, _this84.fog = !1, _this84.flatShading = !1, _this84.setValues(t);
      return _this84;
    }

    _createClass(Vl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Vl.prototype), "copy", this).call(this, t), this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.flatShading = t.flatShading, this;
      }
    }]);

    return Vl;
  }(gn);

  Vl.prototype.isMeshNormalMaterial = !0;

  var kl = /*#__PURE__*/function (_gn13) {
    _inherits(kl, _gn13);

    var _super96 = _createSuper(kl);

    function kl(t) {
      var _this85;

      _classCallCheck(this, kl);

      _this85 = _super96.call(this), _this85.type = "MeshLambertMaterial", _this85.color = new Ft(16777215), _this85.map = null, _this85.lightMap = null, _this85.lightMapIntensity = 1, _this85.aoMap = null, _this85.aoMapIntensity = 1, _this85.emissive = new Ft(0), _this85.emissiveIntensity = 1, _this85.emissiveMap = null, _this85.specularMap = null, _this85.alphaMap = null, _this85.envMap = null, _this85.combine = 0, _this85.reflectivity = 1, _this85.refractionRatio = .98, _this85.wireframe = !1, _this85.wireframeLinewidth = 1, _this85.wireframeLinecap = "round", _this85.wireframeLinejoin = "round", _this85.setValues(t);
      return _this85;
    }

    _createClass(kl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(kl.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
      }
    }]);

    return kl;
  }(gn);

  kl.prototype.isMeshLambertMaterial = !0;

  var Wl = /*#__PURE__*/function (_gn14) {
    _inherits(Wl, _gn14);

    var _super97 = _createSuper(Wl);

    function Wl(t) {
      var _this86;

      _classCallCheck(this, Wl);

      _this86 = _super97.call(this), _this86.defines = {
        MATCAP: ""
      }, _this86.type = "MeshMatcapMaterial", _this86.color = new Ft(16777215), _this86.matcap = null, _this86.map = null, _this86.bumpMap = null, _this86.bumpScale = 1, _this86.normalMap = null, _this86.normalMapType = 0, _this86.normalScale = new At(1, 1), _this86.displacementMap = null, _this86.displacementScale = 1, _this86.displacementBias = 0, _this86.alphaMap = null, _this86.flatShading = !1, _this86.setValues(t);
      return _this86;
    }

    _createClass(Wl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Wl.prototype), "copy", this).call(this, t), this.defines = {
          MATCAP: ""
        }, this.color.copy(t.color), this.matcap = t.matcap, this.map = t.map, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.flatShading = t.flatShading, this;
      }
    }]);

    return Wl;
  }(gn);

  Wl.prototype.isMeshMatcapMaterial = !0;

  var jl = /*#__PURE__*/function (_ja) {
    _inherits(jl, _ja);

    var _super98 = _createSuper(jl);

    function jl(t) {
      var _this87;

      _classCallCheck(this, jl);

      _this87 = _super98.call(this), _this87.type = "LineDashedMaterial", _this87.scale = 1, _this87.dashSize = 3, _this87.gapSize = 1, _this87.setValues(t);
      return _this87;
    }

    _createClass(jl, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(jl.prototype), "copy", this).call(this, t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
      }
    }]);

    return jl;
  }(ja);

  jl.prototype.isLineDashedMaterial = !0;
  var ql = {
    ShadowMaterial: zl,
    SpriteMaterial: ca,
    RawShaderMaterial: Ol,
    ShaderMaterial: li,
    PointsMaterial: no,
    MeshPhysicalMaterial: Fl,
    MeshStandardMaterial: Ul,
    MeshPhongMaterial: Hl,
    MeshToonMaterial: Gl,
    MeshNormalMaterial: Vl,
    MeshLambertMaterial: kl,
    MeshDepthMaterial: Vs,
    MeshDistanceMaterial: ks,
    MeshBasicMaterial: vn,
    MeshMatcapMaterial: Wl,
    LineDashedMaterial: jl,
    LineBasicMaterial: ja,
    Material: gn
  };

  gn.fromType = function (t) {
    return new ql[t]();
  };

  var Xl = {
    arraySlice: function arraySlice(t, e, n) {
      return Xl.isTypedArray(t) ? new t.constructor(t.subarray(e, void 0 !== n ? n : t.length)) : t.slice(e, n);
    },
    convertArray: function convertArray(t, e, n) {
      return !t || !n && t.constructor === e ? t : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t) : Array.prototype.slice.call(t);
    },
    isTypedArray: function isTypedArray(t) {
      return ArrayBuffer.isView(t) && !(t instanceof DataView);
    },
    getKeyframeOrder: function getKeyframeOrder(t) {
      var e = t.length,
          n = new Array(e);

      for (var _t237 = 0; _t237 !== e; ++_t237) {
        n[_t237] = _t237;
      }

      return n.sort(function (e, n) {
        return t[e] - t[n];
      }), n;
    },
    sortedArray: function sortedArray(t, e, n) {
      var i = t.length,
          r = new t.constructor(i);

      for (var _s64 = 0, _a56 = 0; _a56 !== i; ++_s64) {
        var _i157 = n[_s64] * e;

        for (var _n217 = 0; _n217 !== e; ++_n217) {
          r[_a56++] = t[_i157 + _n217];
        }
      }

      return r;
    },
    flattenJSON: function flattenJSON(t, e, n, i) {
      var r = 1,
          s = t[0];

      for (; void 0 !== s && void 0 === s[i];) {
        s = t[r++];
      }

      if (void 0 === s) return;
      var a = s[i];
      if (void 0 !== a) if (Array.isArray(a)) do {
        a = s[i], void 0 !== a && (e.push(s.time), n.push.apply(n, a)), s = t[r++];
      } while (void 0 !== s);else if (void 0 !== a.toArray) do {
        a = s[i], void 0 !== a && (e.push(s.time), a.toArray(n, n.length)), s = t[r++];
      } while (void 0 !== s);else do {
        a = s[i], void 0 !== a && (e.push(s.time), n.push(a)), s = t[r++];
      } while (void 0 !== s);
    },
    subclip: function subclip(t, e, n, i) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
      var s = t.clone();
      s.name = e;
      var a = [];

      for (var _t238 = 0; _t238 < s.tracks.length; ++_t238) {
        var _e214 = s.tracks[_t238],
            _o40 = _e214.getValueSize(),
            _l41 = [],
            _c26 = [];

        for (var _t239 = 0; _t239 < _e214.times.length; ++_t239) {
          var _s65 = _e214.times[_t239] * r;

          if (!(_s65 < n || _s65 >= i)) {
            _l41.push(_e214.times[_t239]);

            for (var _n218 = 0; _n218 < _o40; ++_n218) {
              _c26.push(_e214.values[_t239 * _o40 + _n218]);
            }
          }
        }

        0 !== _l41.length && (_e214.times = Xl.convertArray(_l41, _e214.times.constructor), _e214.values = Xl.convertArray(_c26, _e214.values.constructor), a.push(_e214));
      }

      s.tracks = a;
      var o = 1 / 0;

      for (var _t240 = 0; _t240 < s.tracks.length; ++_t240) {
        o > s.tracks[_t240].times[0] && (o = s.tracks[_t240].times[0]);
      }

      for (var _t241 = 0; _t241 < s.tracks.length; ++_t241) {
        s.tracks[_t241].shift(-1 * o);
      }

      return s.resetDuration(), s;
    },
    makeClipAdditive: function makeClipAdditive(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
      i <= 0 && (i = 30);
      var r = n.tracks.length,
          s = e / i;

      var _loop = function _loop(_e215) {
        var i = n.tracks[_e215],
            r = i.ValueTypeName;
        if ("bool" === r || "string" === r) return "continue";
        var a = t.tracks.find(function (t) {
          return t.name === i.name && t.ValueTypeName === r;
        });
        if (void 0 === a) return "continue";
        var o = 0;
        var l = i.getValueSize();
        i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
        var c = 0;
        var h = a.getValueSize();
        a.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = h / 3);
        var u = i.times.length - 1;
        var d = void 0;

        if (s <= i.times[0]) {
          var _t242 = o,
              _e216 = l - o;

          d = Xl.arraySlice(i.values, _t242, _e216);
        } else if (s >= i.times[u]) {
          var _t243 = u * l + o,
              _e217 = _t243 + l - o;

          d = Xl.arraySlice(i.values, _t243, _e217);
        } else {
          var _t244 = i.createInterpolant(),
              _e218 = o,
              _n219 = l - o;

          _t244.evaluate(s), d = Xl.arraySlice(_t244.resultBuffer, _e218, _n219);
        }

        if ("quaternion" === r) {
          new $t().fromArray(d).normalize().conjugate().toArray(d);
        }

        var p = a.times.length;

        for (var _t245 = 0; _t245 < p; ++_t245) {
          var _e219 = _t245 * h + c;

          if ("quaternion" === r) $t.multiplyQuaternionsFlat(a.values, _e219, d, 0, a.values, _e219);else {
            var _t246 = h - 2 * c;

            for (var _n220 = 0; _n220 < _t246; ++_n220) {
              a.values[_e219 + _n220] -= d[_n220];
            }
          }
        }
      };

      for (var _e215 = 0; _e215 < r; ++_e215) {
        var _ret = _loop(_e215);

        if (_ret === "continue") continue;
      }

      return t.blendMode = at, t;
    }
  };

  var Jl = /*#__PURE__*/function () {
    function Jl(t, e, n, i) {
      _classCallCheck(this, Jl);

      this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
    }

    _createClass(Jl, [{
      key: "evaluate",
      value: function evaluate(t) {
        var e = this.parameterPositions;
        var n = this._cachedIndex,
            i = e[n],
            r = e[n - 1];

        t: {
          e: {
            var _s66;

            n: {
              i: if (!(t < i)) {
                for (var _s67 = n + 2;;) {
                  if (void 0 === i) {
                    if (t < r) break i;
                    return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, t, r);
                  }

                  if (n === _s67) break;
                  if (r = i, i = e[++n], t < i) break e;
                }

                _s66 = e.length;
                break n;
              }

              if (t >= r) break t;
              {
                var _a57 = e[1];
                t < _a57 && (n = 2, r = _a57);

                for (var _s68 = n - 2;;) {
                  if (void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, i);
                  if (n === _s68) break;
                  if (i = r, r = e[--n - 1], t >= r) break e;
                }

                _s66 = n, n = 0;
              }
            }

            for (; n < _s66;) {
              var _i158 = n + _s66 >>> 1;

              t < e[_i158] ? _s66 = _i158 : n = _i158 + 1;
            }

            if (i = e[n], r = e[n - 1], void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, i);
            if (void 0 === i) return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, r, t);
          }

          this._cachedIndex = n, this.intervalChanged_(n, r, i);
        }

        return this.interpolate_(n, r, t, i);
      }
    }, {
      key: "getSettings_",
      value: function getSettings_() {
        return this.settings || this.DefaultSettings_;
      }
    }, {
      key: "copySampleValue_",
      value: function copySampleValue_(t) {
        var e = this.resultBuffer,
            n = this.sampleValues,
            i = this.valueSize,
            r = t * i;

        for (var _t247 = 0; _t247 !== i; ++_t247) {
          e[_t247] = n[r + _t247];
        }

        return e;
      }
    }, {
      key: "interpolate_",
      value: function interpolate_() {
        throw new Error("call to abstract method");
      }
    }, {
      key: "intervalChanged_",
      value: function intervalChanged_() {}
    }]);

    return Jl;
  }();

  Jl.prototype.beforeStart_ = Jl.prototype.copySampleValue_, Jl.prototype.afterEnd_ = Jl.prototype.copySampleValue_;

  var Yl = /*#__PURE__*/function (_Jl) {
    _inherits(Yl, _Jl);

    var _super99 = _createSuper(Yl);

    function Yl(t, e, n, i) {
      var _this88;

      _classCallCheck(this, Yl);

      _this88 = _super99.call(this, t, e, n, i), _this88._weightPrev = -0, _this88._offsetPrev = -0, _this88._weightNext = -0, _this88._offsetNext = -0, _this88.DefaultSettings_ = {
        endingStart: nt,
        endingEnd: nt
      };
      return _this88;
    }

    _createClass(Yl, [{
      key: "intervalChanged_",
      value: function intervalChanged_(t, e, n) {
        var i = this.parameterPositions;
        var r = t - 2,
            s = t + 1,
            a = i[r],
            o = i[s];
        if (void 0 === a) switch (this.getSettings_().endingStart) {
          case it:
            r = t, a = 2 * e - n;
            break;

          case rt:
            r = i.length - 2, a = e + i[r] - i[r + 1];
            break;

          default:
            r = t, a = n;
        }
        if (void 0 === o) switch (this.getSettings_().endingEnd) {
          case it:
            s = t, o = 2 * n - e;
            break;

          case rt:
            s = 1, o = n + i[1] - i[0];
            break;

          default:
            s = t - 1, o = e;
        }
        var l = .5 * (n - e),
            c = this.valueSize;
        this._weightPrev = l / (e - a), this._weightNext = l / (o - n), this._offsetPrev = r * c, this._offsetNext = s * c;
      }
    }, {
      key: "interpolate_",
      value: function interpolate_(t, e, n, i) {
        var r = this.resultBuffer,
            s = this.sampleValues,
            a = this.valueSize,
            o = t * a,
            l = o - a,
            c = this._offsetPrev,
            h = this._offsetNext,
            u = this._weightPrev,
            d = this._weightNext,
            p = (n - e) / (i - e),
            m = p * p,
            f = m * p,
            g = -u * f + 2 * u * m - u * p,
            v = (1 + u) * f + (-1.5 - 2 * u) * m + (-.5 + u) * p + 1,
            y = (-1 - d) * f + (1.5 + d) * m + .5 * p,
            x = d * f - d * m;

        for (var _t248 = 0; _t248 !== a; ++_t248) {
          r[_t248] = g * s[c + _t248] + v * s[l + _t248] + y * s[o + _t248] + x * s[h + _t248];
        }

        return r;
      }
    }]);

    return Yl;
  }(Jl);

  var Zl = /*#__PURE__*/function (_Jl2) {
    _inherits(Zl, _Jl2);

    var _super100 = _createSuper(Zl);

    function Zl(t, e, n, i) {
      _classCallCheck(this, Zl);

      return _super100.call(this, t, e, n, i);
    }

    _createClass(Zl, [{
      key: "interpolate_",
      value: function interpolate_(t, e, n, i) {
        var r = this.resultBuffer,
            s = this.sampleValues,
            a = this.valueSize,
            o = t * a,
            l = o - a,
            c = (n - e) / (i - e),
            h = 1 - c;

        for (var _t249 = 0; _t249 !== a; ++_t249) {
          r[_t249] = s[l + _t249] * h + s[o + _t249] * c;
        }

        return r;
      }
    }]);

    return Zl;
  }(Jl);

  var Kl = /*#__PURE__*/function (_Jl3) {
    _inherits(Kl, _Jl3);

    var _super101 = _createSuper(Kl);

    function Kl(t, e, n, i) {
      _classCallCheck(this, Kl);

      return _super101.call(this, t, e, n, i);
    }

    _createClass(Kl, [{
      key: "interpolate_",
      value: function interpolate_(t) {
        return this.copySampleValue_(t - 1);
      }
    }]);

    return Kl;
  }(Jl);

  var Ql = /*#__PURE__*/function () {
    function Ql(t, e, n, i) {
      _classCallCheck(this, Ql);

      if (void 0 === t) throw new Error("THREE.KeyframeTrack: track name is undefined");
      if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
      this.name = t, this.times = Xl.convertArray(e, this.TimeBufferType), this.values = Xl.convertArray(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }

    _createClass(Ql, [{
      key: "InterpolantFactoryMethodDiscrete",
      value: function InterpolantFactoryMethodDiscrete(t) {
        return new Kl(this.times, this.values, this.getValueSize(), t);
      }
    }, {
      key: "InterpolantFactoryMethodLinear",
      value: function InterpolantFactoryMethodLinear(t) {
        return new Zl(this.times, this.values, this.getValueSize(), t);
      }
    }, {
      key: "InterpolantFactoryMethodSmooth",
      value: function InterpolantFactoryMethodSmooth(t) {
        return new Yl(this.times, this.values, this.getValueSize(), t);
      }
    }, {
      key: "setInterpolation",
      value: function setInterpolation(t) {
        var e;

        switch (t) {
          case $:
            e = this.InterpolantFactoryMethodDiscrete;
            break;

          case tt:
            e = this.InterpolantFactoryMethodLinear;
            break;

          case et:
            e = this.InterpolantFactoryMethodSmooth;
        }

        if (void 0 === e) {
          var _e220 = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;

          if (void 0 === this.createInterpolant) {
            if (t === this.DefaultInterpolation) throw new Error(_e220);
            this.setInterpolation(this.DefaultInterpolation);
          }

          return console.warn("THREE.KeyframeTrack:", _e220), this;
        }

        return this.createInterpolant = e, this;
      }
    }, {
      key: "getInterpolation",
      value: function getInterpolation() {
        switch (this.createInterpolant) {
          case this.InterpolantFactoryMethodDiscrete:
            return $;

          case this.InterpolantFactoryMethodLinear:
            return tt;

          case this.InterpolantFactoryMethodSmooth:
            return et;
        }
      }
    }, {
      key: "getValueSize",
      value: function getValueSize() {
        return this.values.length / this.times.length;
      }
    }, {
      key: "shift",
      value: function shift(t) {
        if (0 !== t) {
          var _e221 = this.times;

          for (var _n221 = 0, _i159 = _e221.length; _n221 !== _i159; ++_n221) {
            _e221[_n221] += t;
          }
        }

        return this;
      }
    }, {
      key: "scale",
      value: function scale(t) {
        if (1 !== t) {
          var _e222 = this.times;

          for (var _n222 = 0, _i160 = _e222.length; _n222 !== _i160; ++_n222) {
            _e222[_n222] *= t;
          }
        }

        return this;
      }
    }, {
      key: "trim",
      value: function trim(t, e) {
        var n = this.times,
            i = n.length;
        var r = 0,
            s = i - 1;

        for (; r !== i && n[r] < t;) {
          ++r;
        }

        for (; -1 !== s && n[s] > e;) {
          --s;
        }

        if (++s, 0 !== r || s !== i) {
          r >= s && (s = Math.max(s, 1), r = s - 1);

          var _t250 = this.getValueSize();

          this.times = Xl.arraySlice(n, r, s), this.values = Xl.arraySlice(this.values, r * _t250, s * _t250);
        }

        return this;
      }
    }, {
      key: "validate",
      value: function validate() {
        var t = !0;
        var e = this.getValueSize();
        e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
        var n = this.times,
            i = this.values,
            r = n.length;
        0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
        var s = null;

        for (var _e223 = 0; _e223 !== r; _e223++) {
          var _i161 = n[_e223];

          if ("number" == typeof _i161 && isNaN(_i161)) {
            console.error("THREE.KeyframeTrack: Time is not a valid number.", this, _e223, _i161), t = !1;
            break;
          }

          if (null !== s && s > _i161) {
            console.error("THREE.KeyframeTrack: Out of order keys.", this, _e223, _i161, s), t = !1;
            break;
          }

          s = _i161;
        }

        if (void 0 !== i && Xl.isTypedArray(i)) for (var _e224 = 0, _n223 = i.length; _e224 !== _n223; ++_e224) {
          var _n224 = i[_e224];

          if (isNaN(_n224)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, _e224, _n224), t = !1;
            break;
          }
        }
        return t;
      }
    }, {
      key: "optimize",
      value: function optimize() {
        var t = Xl.arraySlice(this.times),
            e = Xl.arraySlice(this.values),
            n = this.getValueSize(),
            i = this.getInterpolation() === et,
            r = t.length - 1;
        var s = 1;

        for (var _a58 = 1; _a58 < r; ++_a58) {
          var _r128 = !1;

          var _o41 = t[_a58];
          if (_o41 !== t[_a58 + 1] && (1 !== _a58 || _o41 !== t[0])) if (i) _r128 = !0;else {
            var _t251 = _a58 * n,
                _i162 = _t251 - n,
                _s69 = _t251 + n;

            for (var _a59 = 0; _a59 !== n; ++_a59) {
              var _n225 = e[_t251 + _a59];

              if (_n225 !== e[_i162 + _a59] || _n225 !== e[_s69 + _a59]) {
                _r128 = !0;
                break;
              }
            }
          }

          if (_r128) {
            if (_a58 !== s) {
              t[s] = t[_a58];

              var _i163 = _a58 * n,
                  _r129 = s * n;

              for (var _t252 = 0; _t252 !== n; ++_t252) {
                e[_r129 + _t252] = e[_i163 + _t252];
              }
            }

            ++s;
          }
        }

        if (r > 0) {
          t[s] = t[r];

          for (var _t253 = r * n, _i164 = s * n, _a60 = 0; _a60 !== n; ++_a60) {
            e[_i164 + _a60] = e[_t253 + _a60];
          }

          ++s;
        }

        return s !== t.length ? (this.times = Xl.arraySlice(t, 0, s), this.values = Xl.arraySlice(e, 0, s * n)) : (this.times = t, this.values = e), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        var t = Xl.arraySlice(this.times, 0),
            e = Xl.arraySlice(this.values, 0),
            n = new (0, this.constructor)(this.name, t, e);
        return n.createInterpolant = this.createInterpolant, n;
      }
    }], [{
      key: "toJSON",
      value: function toJSON(t) {
        var e = t.constructor;
        var n;
        if (e.toJSON !== this.toJSON) n = e.toJSON(t);else {
          n = {
            name: t.name,
            times: Xl.convertArray(t.times, Array),
            values: Xl.convertArray(t.values, Array)
          };

          var _e225 = t.getInterpolation();

          _e225 !== t.DefaultInterpolation && (n.interpolation = _e225);
        }
        return n.type = t.ValueTypeName, n;
      }
    }]);

    return Ql;
  }();

  Ql.prototype.TimeBufferType = Float32Array, Ql.prototype.ValueBufferType = Float32Array, Ql.prototype.DefaultInterpolation = tt;

  var $l = /*#__PURE__*/function (_Ql) {
    _inherits($l, _Ql);

    var _super102 = _createSuper($l);

    function $l() {
      _classCallCheck(this, $l);

      return _super102.apply(this, arguments);
    }

    return _createClass($l);
  }(Ql);

  $l.prototype.ValueTypeName = "bool", $l.prototype.ValueBufferType = Array, $l.prototype.DefaultInterpolation = $, $l.prototype.InterpolantFactoryMethodLinear = void 0, $l.prototype.InterpolantFactoryMethodSmooth = void 0;

  var tc = /*#__PURE__*/function (_Ql2) {
    _inherits(tc, _Ql2);

    var _super103 = _createSuper(tc);

    function tc() {
      _classCallCheck(this, tc);

      return _super103.apply(this, arguments);
    }

    return _createClass(tc);
  }(Ql);

  tc.prototype.ValueTypeName = "color";

  var ec = /*#__PURE__*/function (_Ql3) {
    _inherits(ec, _Ql3);

    var _super104 = _createSuper(ec);

    function ec() {
      _classCallCheck(this, ec);

      return _super104.apply(this, arguments);
    }

    return _createClass(ec);
  }(Ql);

  ec.prototype.ValueTypeName = "number";

  var nc = /*#__PURE__*/function (_Jl4) {
    _inherits(nc, _Jl4);

    var _super105 = _createSuper(nc);

    function nc(t, e, n, i) {
      _classCallCheck(this, nc);

      return _super105.call(this, t, e, n, i);
    }

    _createClass(nc, [{
      key: "interpolate_",
      value: function interpolate_(t, e, n, i) {
        var r = this.resultBuffer,
            s = this.sampleValues,
            a = this.valueSize,
            o = (n - e) / (i - e);
        var l = t * a;

        for (var _t254 = l + a; l !== _t254; l += 4) {
          $t.slerpFlat(r, 0, s, l - a, s, l, o);
        }

        return r;
      }
    }]);

    return nc;
  }(Jl);

  var ic = /*#__PURE__*/function (_Ql4) {
    _inherits(ic, _Ql4);

    var _super106 = _createSuper(ic);

    function ic() {
      _classCallCheck(this, ic);

      return _super106.apply(this, arguments);
    }

    _createClass(ic, [{
      key: "InterpolantFactoryMethodLinear",
      value: function InterpolantFactoryMethodLinear(t) {
        return new nc(this.times, this.values, this.getValueSize(), t);
      }
    }]);

    return ic;
  }(Ql);

  ic.prototype.ValueTypeName = "quaternion", ic.prototype.DefaultInterpolation = tt, ic.prototype.InterpolantFactoryMethodSmooth = void 0;

  var rc = /*#__PURE__*/function (_Ql5) {
    _inherits(rc, _Ql5);

    var _super107 = _createSuper(rc);

    function rc() {
      _classCallCheck(this, rc);

      return _super107.apply(this, arguments);
    }

    return _createClass(rc);
  }(Ql);

  rc.prototype.ValueTypeName = "string", rc.prototype.ValueBufferType = Array, rc.prototype.DefaultInterpolation = $, rc.prototype.InterpolantFactoryMethodLinear = void 0, rc.prototype.InterpolantFactoryMethodSmooth = void 0;

  var sc = /*#__PURE__*/function (_Ql6) {
    _inherits(sc, _Ql6);

    var _super108 = _createSuper(sc);

    function sc() {
      _classCallCheck(this, sc);

      return _super108.apply(this, arguments);
    }

    return _createClass(sc);
  }(Ql);

  sc.prototype.ValueTypeName = "vector";

  var ac = /*#__PURE__*/function () {
    function ac(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2500;

      _classCallCheck(this, ac);

      this.name = t, this.tracks = n, this.duration = e, this.blendMode = i, this.uuid = xt(), this.duration < 0 && this.resetDuration();
    }

    _createClass(ac, [{
      key: "resetDuration",
      value: function resetDuration() {
        var t = 0;

        for (var _e226 = 0, _n226 = this.tracks.length; _e226 !== _n226; ++_e226) {
          var _n227 = this.tracks[_e226];
          t = Math.max(t, _n227.times[_n227.times.length - 1]);
        }

        return this.duration = t, this;
      }
    }, {
      key: "trim",
      value: function trim() {
        for (var _t255 = 0; _t255 < this.tracks.length; _t255++) {
          this.tracks[_t255].trim(0, this.duration);
        }

        return this;
      }
    }, {
      key: "validate",
      value: function validate() {
        var t = !0;

        for (var _e227 = 0; _e227 < this.tracks.length; _e227++) {
          t = t && this.tracks[_e227].validate();
        }

        return t;
      }
    }, {
      key: "optimize",
      value: function optimize() {
        for (var _t256 = 0; _t256 < this.tracks.length; _t256++) {
          this.tracks[_t256].optimize();
        }

        return this;
      }
    }, {
      key: "clone",
      value: function clone() {
        var t = [];

        for (var _e228 = 0; _e228 < this.tracks.length; _e228++) {
          t.push(this.tracks[_e228].clone());
        }

        return new this.constructor(this.name, this.duration, t, this.blendMode);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return this.constructor.toJSON(this);
      }
    }], [{
      key: "parse",
      value: function parse(t) {
        var e = [],
            n = t.tracks,
            i = 1 / (t.fps || 1);

        for (var _t257 = 0, _r130 = n.length; _t257 !== _r130; ++_t257) {
          e.push(oc(n[_t257]).scale(i));
        }

        var r = new this(t.name, t.duration, e, t.blendMode);
        return r.uuid = t.uuid, r;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = [],
            n = t.tracks,
            i = {
          name: t.name,
          duration: t.duration,
          tracks: e,
          uuid: t.uuid,
          blendMode: t.blendMode
        };

        for (var _t258 = 0, _i165 = n.length; _t258 !== _i165; ++_t258) {
          e.push(Ql.toJSON(n[_t258]));
        }

        return i;
      }
    }, {
      key: "CreateFromMorphTargetSequence",
      value: function CreateFromMorphTargetSequence(t, e, n, i) {
        var r = e.length,
            s = [];

        for (var _t259 = 0; _t259 < r; _t259++) {
          var _a61 = [],
              _o42 = [];
          _a61.push((_t259 + r - 1) % r, _t259, (_t259 + 1) % r), _o42.push(0, 1, 0);

          var _l42 = Xl.getKeyframeOrder(_a61);

          _a61 = Xl.sortedArray(_a61, 1, _l42), _o42 = Xl.sortedArray(_o42, 1, _l42), i || 0 !== _a61[0] || (_a61.push(r), _o42.push(_o42[0])), s.push(new ec(".morphTargetInfluences[" + e[_t259].name + "]", _a61, _o42).scale(1 / n));
        }

        return new this(t, -1, s);
      }
    }, {
      key: "findByName",
      value: function findByName(t, e) {
        var n = t;

        if (!Array.isArray(t)) {
          var _e229 = t;
          n = _e229.geometry && _e229.geometry.animations || _e229.animations;
        }

        for (var _t260 = 0; _t260 < n.length; _t260++) {
          if (n[_t260].name === e) return n[_t260];
        }

        return null;
      }
    }, {
      key: "CreateClipsFromMorphTargetSequences",
      value: function CreateClipsFromMorphTargetSequences(t, e, n) {
        var i = {},
            r = /^([\w-]*?)([\d]+)$/;

        for (var _e230 = 0, _n228 = t.length; _e230 < _n228; _e230++) {
          var _n229 = t[_e230],
              _s70 = _n229.name.match(r);

          if (_s70 && _s70.length > 1) {
            var _t261 = _s70[1];
            var _e231 = i[_t261];
            _e231 || (i[_t261] = _e231 = []), _e231.push(_n229);
          }
        }

        var s = [];

        for (var _t262 in i) {
          s.push(this.CreateFromMorphTargetSequence(_t262, i[_t262], e, n));
        }

        return s;
      }
    }, {
      key: "parseAnimation",
      value: function parseAnimation(t, e) {
        if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;

        var n = function n(t, e, _n230, i, r) {
          if (0 !== _n230.length) {
            var _s71 = [],
                _a62 = [];
            Xl.flattenJSON(_n230, _s71, _a62, i), 0 !== _s71.length && r.push(new t(e, _s71, _a62));
          }
        },
            i = [],
            r = t.name || "default",
            s = t.fps || 30,
            a = t.blendMode;

        var o = t.length || -1;
        var l = t.hierarchy || [];

        for (var _t263 = 0; _t263 < l.length; _t263++) {
          var _r131 = l[_t263].keys;
          if (_r131 && 0 !== _r131.length) if (_r131[0].morphTargets) {
            var _t264 = {};

            var _e232 = void 0;

            for (_e232 = 0; _e232 < _r131.length; _e232++) {
              if (_r131[_e232].morphTargets) for (var _n231 = 0; _n231 < _r131[_e232].morphTargets.length; _n231++) {
                _t264[_r131[_e232].morphTargets[_n231]] = -1;
              }
            }

            for (var _n232 in _t264) {
              var _t265 = [],
                  _s72 = [];

              for (var _i166 = 0; _i166 !== _r131[_e232].morphTargets.length; ++_i166) {
                var _i167 = _r131[_e232];
                _t265.push(_i167.time), _s72.push(_i167.morphTarget === _n232 ? 1 : 0);
              }

              i.push(new ec(".morphTargetInfluence[" + _n232 + "]", _t265, _s72));
            }

            o = _t264.length * s;
          } else {
            var _s73 = ".bones[" + e[_t263].name + "]";

            n(sc, _s73 + ".position", _r131, "pos", i), n(ic, _s73 + ".quaternion", _r131, "rot", i), n(sc, _s73 + ".scale", _r131, "scl", i);
          }
        }

        if (0 === i.length) return null;
        return new this(r, o, i, a);
      }
    }]);

    return ac;
  }();

  function oc(t) {
    if (void 0 === t.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");

    var e = function (t) {
      switch (t.toLowerCase()) {
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
          return ec;

        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
          return sc;

        case "color":
          return tc;

        case "quaternion":
          return ic;

        case "bool":
        case "boolean":
          return $l;

        case "string":
          return rc;
      }

      throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t);
    }(t.type);

    if (void 0 === t.times) {
      var _e233 = [],
          _n233 = [];
      Xl.flattenJSON(t.keys, _e233, _n233, "value"), t.times = _e233, t.values = _n233;
    }

    return void 0 !== e.parse ? e.parse(t) : new e(t.name, t.times, t.values, t.interpolation);
  }

  var lc = {
    enabled: !1,
    files: {},
    add: function add(t, e) {
      !1 !== this.enabled && (this.files[t] = e);
    },
    get: function get(t) {
      if (!1 !== this.enabled) return this.files[t];
    },
    remove: function remove(t) {
      delete this.files[t];
    },
    clear: function clear() {
      this.files = {};
    }
  };

  var cc = /*#__PURE__*/_createClass(function cc(t, e, n) {
    _classCallCheck(this, cc);

    var i = this;
    var r,
        s = !1,
        a = 0,
        o = 0;
    var l = [];
    this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = n, this.itemStart = function (t) {
      o++, !1 === s && void 0 !== i.onStart && i.onStart(t, a, o), s = !0;
    }, this.itemEnd = function (t) {
      a++, void 0 !== i.onProgress && i.onProgress(t, a, o), a === o && (s = !1, void 0 !== i.onLoad && i.onLoad());
    }, this.itemError = function (t) {
      void 0 !== i.onError && i.onError(t);
    }, this.resolveURL = function (t) {
      return r ? r(t) : t;
    }, this.setURLModifier = function (t) {
      return r = t, this;
    }, this.addHandler = function (t, e) {
      return l.push(t, e), this;
    }, this.removeHandler = function (t) {
      var e = l.indexOf(t);
      return -1 !== e && l.splice(e, 2), this;
    }, this.getHandler = function (t) {
      for (var _e234 = 0, _n234 = l.length; _e234 < _n234; _e234 += 2) {
        var _n235 = l[_e234],
            _i168 = l[_e234 + 1];
        if (_n235.global && (_n235.lastIndex = 0), _n235.test(t)) return _i168;
      }

      return null;
    };
  });

  var hc = new cc();

  var uc = /*#__PURE__*/function () {
    function uc(t) {
      _classCallCheck(this, uc);

      this.manager = void 0 !== t ? t : hc, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }

    _createClass(uc, [{
      key: "load",
      value: function load() {}
    }, {
      key: "loadAsync",
      value: function loadAsync(t, e) {
        var n = this;
        return new Promise(function (i, r) {
          n.load(t, i, e, r);
        });
      }
    }, {
      key: "parse",
      value: function parse() {}
    }, {
      key: "setCrossOrigin",
      value: function setCrossOrigin(t) {
        return this.crossOrigin = t, this;
      }
    }, {
      key: "setWithCredentials",
      value: function setWithCredentials(t) {
        return this.withCredentials = t, this;
      }
    }, {
      key: "setPath",
      value: function setPath(t) {
        return this.path = t, this;
      }
    }, {
      key: "setResourcePath",
      value: function setResourcePath(t) {
        return this.resourcePath = t, this;
      }
    }, {
      key: "setRequestHeader",
      value: function setRequestHeader(t) {
        return this.requestHeader = t, this;
      }
    }]);

    return uc;
  }();

  var dc = {};

  var pc = /*#__PURE__*/function (_uc) {
    _inherits(pc, _uc);

    var _super109 = _createSuper(pc);

    function pc(t) {
      _classCallCheck(this, pc);

      return _super109.call(this, t);
    }

    _createClass(pc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var _this89 = this;

        void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
        var r = lc.get(t);
        if (void 0 !== r) return this.manager.itemStart(t), setTimeout(function () {
          e && e(r), _this89.manager.itemEnd(t);
        }, 0), r;
        if (void 0 !== dc[t]) return void dc[t].push({
          onLoad: e,
          onProgress: n,
          onError: i
        });
        dc[t] = [], dc[t].push({
          onLoad: e,
          onProgress: n,
          onError: i
        });
        var s = new Request(t, {
          headers: new Headers(this.requestHeader),
          credentials: this.withCredentials ? "include" : "same-origin"
        }),
            a = this.mimeType,
            o = this.responseType;
        fetch(s).then(function (e) {
          if (200 === e.status || 0 === e.status) {
            if (0 === e.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;

            var _n236 = dc[t],
                _i169 = e.body.getReader(),
                _r132 = e.headers.get("Content-Length"),
                _s74 = _r132 ? parseInt(_r132) : 0,
                _a63 = 0 !== _s74;

            var _o43 = 0;

            var _l43 = new ReadableStream({
              start: function start(t) {
                !function e() {
                  _i169.read().then(function (_ref3) {
                    var i = _ref3.done,
                        r = _ref3.value;
                    if (i) t.close();else {
                      _o43 += r.byteLength;

                      var _i170 = new ProgressEvent("progress", {
                        lengthComputable: _a63,
                        loaded: _o43,
                        total: _s74
                      });

                      for (var _t266 = 0, _e235 = _n236.length; _t266 < _e235; _t266++) {
                        var _e236 = _n236[_t266];
                        _e236.onProgress && _e236.onProgress(_i170);
                      }

                      t.enqueue(r), e();
                    }
                  });
                }();
              }
            });

            return new Response(_l43);
          }

          throw Error("fetch for \"".concat(e.url, "\" responded with ").concat(e.status, ": ").concat(e.statusText));
        }).then(function (t) {
          switch (o) {
            case "arraybuffer":
              return t.arrayBuffer();

            case "blob":
              return t.blob();

            case "document":
              return t.text().then(function (t) {
                return new DOMParser().parseFromString(t, a);
              });

            case "json":
              return t.json();

            default:
              if (void 0 === a) return t.text();
              {
                var _e237 = /charset="?([^;"\s]*)"?/i.exec(a),
                    _n237 = _e237 && _e237[1] ? _e237[1].toLowerCase() : void 0,
                    _i171 = new TextDecoder(_n237);

                return t.arrayBuffer().then(function (t) {
                  return _i171.decode(t);
                });
              }
          }
        }).then(function (e) {
          lc.add(t, e);
          var n = dc[t];
          delete dc[t];

          for (var _t267 = 0, _i172 = n.length; _t267 < _i172; _t267++) {
            var _i173 = n[_t267];
            _i173.onLoad && _i173.onLoad(e);
          }
        }).catch(function (e) {
          var n = dc[t];
          if (void 0 === n) throw _this89.manager.itemError(t), e;
          delete dc[t];

          for (var _t268 = 0, _i174 = n.length; _t268 < _i174; _t268++) {
            var _i175 = n[_t268];
            _i175.onError && _i175.onError(e);
          }

          _this89.manager.itemError(t);
        }).finally(function () {
          _this89.manager.itemEnd(t);
        }), this.manager.itemStart(t);
      }
    }, {
      key: "setResponseType",
      value: function setResponseType(t) {
        return this.responseType = t, this;
      }
    }, {
      key: "setMimeType",
      value: function setMimeType(t) {
        return this.mimeType = t, this;
      }
    }]);

    return pc;
  }(uc);

  var mc = /*#__PURE__*/function (_uc2) {
    _inherits(mc, _uc2);

    var _super110 = _createSuper(mc);

    function mc(t) {
      _classCallCheck(this, mc);

      return _super110.call(this, t);
    }

    _createClass(mc, [{
      key: "load",
      value: function load(t, e, n, i) {
        void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
        var r = this,
            s = lc.get(t);
        if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
          e && e(s), r.manager.itemEnd(t);
        }, 0), s;
        var a = Dt("img");

        function o() {
          c(), lc.add(t, this), e && e(this), r.manager.itemEnd(t);
        }

        function l(e) {
          c(), i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
        }

        function c() {
          a.removeEventListener("load", o, !1), a.removeEventListener("error", l, !1);
        }

        return a.addEventListener("load", o, !1), a.addEventListener("error", l, !1), "data:" !== t.slice(0, 5) && void 0 !== this.crossOrigin && (a.crossOrigin = this.crossOrigin), r.manager.itemStart(t), a.src = t, a;
      }
    }]);

    return mc;
  }(uc);

  var fc = /*#__PURE__*/function (_uc3) {
    _inherits(fc, _uc3);

    var _super111 = _createSuper(fc);

    function fc(t) {
      _classCallCheck(this, fc);

      return _super111.call(this, t);
    }

    _createClass(fc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = new pi(),
            s = new mc(this.manager);
        s.setCrossOrigin(this.crossOrigin), s.setPath(this.path);
        var a = 0;

        function o(n) {
          s.load(t[n], function (t) {
            r.images[n] = t, a++, 6 === a && (r.needsUpdate = !0, e && e(r));
          }, void 0, i);
        }

        for (var _e238 = 0; _e238 < t.length; ++_e238) {
          o(_e238);
        }

        return r;
      }
    }]);

    return fc;
  }(uc);

  var gc = /*#__PURE__*/function (_uc4) {
    _inherits(gc, _uc4);

    var _super112 = _createSuper(gc);

    function gc(t) {
      _classCallCheck(this, gc);

      return _super112.call(this, t);
    }

    _createClass(gc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = new Ba(),
            a = new pc(this.manager);
        return a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setPath(this.path), a.setWithCredentials(r.withCredentials), a.load(t, function (t) {
          var n = r.parse(t);
          n && (void 0 !== n.image ? s.image = n.image : void 0 !== n.data && (s.image.width = n.width, s.image.height = n.height, s.image.data = n.data), s.wrapS = void 0 !== n.wrapS ? n.wrapS : u, s.wrapT = void 0 !== n.wrapT ? n.wrapT : u, s.magFilter = void 0 !== n.magFilter ? n.magFilter : g, s.minFilter = void 0 !== n.minFilter ? n.minFilter : g, s.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.encoding && (s.encoding = n.encoding), void 0 !== n.flipY && (s.flipY = n.flipY), void 0 !== n.format && (s.format = n.format), void 0 !== n.type && (s.type = n.type), void 0 !== n.mipmaps && (s.mipmaps = n.mipmaps, s.minFilter = y), 1 === n.mipmapCount && (s.minFilter = g), void 0 !== n.generateMipmaps && (s.generateMipmaps = n.generateMipmaps), s.needsUpdate = !0, e && e(s, n));
        }, n, i), s;
      }
    }]);

    return gc;
  }(uc);

  var vc = /*#__PURE__*/function (_uc5) {
    _inherits(vc, _uc5);

    var _super113 = _createSuper(vc);

    function vc(t) {
      _classCallCheck(this, vc);

      return _super113.call(this, t);
    }

    _createClass(vc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = new jt(),
            s = new mc(this.manager);
        return s.setCrossOrigin(this.crossOrigin), s.setPath(this.path), s.load(t, function (t) {
          r.image = t, r.needsUpdate = !0, void 0 !== e && e(r);
        }, n, i), r;
      }
    }]);

    return vc;
  }(uc);

  var yc = /*#__PURE__*/function (_nn11) {
    _inherits(yc, _nn11);

    var _super114 = _createSuper(yc);

    function yc(t) {
      var _this90;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      _classCallCheck(this, yc);

      _this90 = _super114.call(this), _this90.type = "Light", _this90.color = new Ft(t), _this90.intensity = e;
      return _this90;
    }

    _createClass(yc, [{
      key: "dispose",
      value: function dispose() {}
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(yc.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.intensity = t.intensity, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(yc.prototype), "toJSON", this).call(this, t);

        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
      }
    }]);

    return yc;
  }(nn);

  yc.prototype.isLight = !0;

  var xc = /*#__PURE__*/function (_yc) {
    _inherits(xc, _yc);

    var _super115 = _createSuper(xc);

    function xc(t, e, n) {
      var _this91;

      _classCallCheck(this, xc);

      _this91 = _super115.call(this, t, n), _this91.type = "HemisphereLight", _this91.position.copy(nn.DefaultUp), _this91.updateMatrix(), _this91.groundColor = new Ft(e);
      return _this91;
    }

    _createClass(xc, [{
      key: "copy",
      value: function copy(t) {
        return yc.prototype.copy.call(this, t), this.groundColor.copy(t.groundColor), this;
      }
    }]);

    return xc;
  }(yc);

  xc.prototype.isHemisphereLight = !0;

  var _c = new Pe(),
      Mc = new te(),
      bc = new te();

  var wc = /*#__PURE__*/function () {
    function wc(t) {
      _classCallCheck(this, wc);

      this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new At(512, 512), this.map = null, this.mapPass = null, this.matrix = new Pe(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Mi(), this._frameExtents = new At(1, 1), this._viewportCount = 1, this._viewports = [new qt(0, 0, 1, 1)];
    }

    _createClass(wc, [{
      key: "getViewportCount",
      value: function getViewportCount() {
        return this._viewportCount;
      }
    }, {
      key: "getFrustum",
      value: function getFrustum() {
        return this._frustum;
      }
    }, {
      key: "updateMatrices",
      value: function updateMatrices(t) {
        var e = this.camera,
            n = this.matrix;
        Mc.setFromMatrixPosition(t.matrixWorld), e.position.copy(Mc), bc.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(bc), e.updateMatrixWorld(), _c.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(_c), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(e.projectionMatrix), n.multiply(e.matrixWorldInverse);
      }
    }, {
      key: "getViewport",
      value: function getViewport(t) {
        return this._viewports[t];
      }
    }, {
      key: "getFrameExtents",
      value: function getFrameExtents() {
        return this._frameExtents;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = {};
        return 0 !== this.bias && (t.bias = this.bias), 0 !== this.normalBias && (t.normalBias = this.normalBias), 1 !== this.radius && (t.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
      }
    }]);

    return wc;
  }();

  var Sc = /*#__PURE__*/function (_wc) {
    _inherits(Sc, _wc);

    var _super116 = _createSuper(Sc);

    function Sc() {
      var _this92;

      _classCallCheck(this, Sc);

      _this92 = _super116.call(this, new hi(50, 1, .5, 500)), _this92.focus = 1;
      return _this92;
    }

    _createClass(Sc, [{
      key: "updateMatrices",
      value: function updateMatrices(t) {
        var e = this.camera,
            n = 2 * yt * t.angle * this.focus,
            i = this.mapSize.width / this.mapSize.height,
            r = t.distance || e.far;
        n === e.fov && i === e.aspect && r === e.far || (e.fov = n, e.aspect = i, e.far = r, e.updateProjectionMatrix()), _get(_getPrototypeOf(Sc.prototype), "updateMatrices", this).call(this, t);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Sc.prototype), "copy", this).call(this, t), this.focus = t.focus, this;
      }
    }]);

    return Sc;
  }(wc);

  Sc.prototype.isSpotLightShadow = !0;

  var Tc = /*#__PURE__*/function (_yc2) {
    _inherits(Tc, _yc2);

    var _super117 = _createSuper(Tc);

    function Tc(t, e) {
      var _this93;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI / 3;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

      _classCallCheck(this, Tc);

      _this93 = _super117.call(this, t, e), _this93.type = "SpotLight", _this93.position.copy(nn.DefaultUp), _this93.updateMatrix(), _this93.target = new nn(), _this93.distance = n, _this93.angle = i, _this93.penumbra = r, _this93.decay = s, _this93.shadow = new Sc();
      return _this93;
    }

    _createClass(Tc, [{
      key: "power",
      get: function get() {
        return this.intensity * Math.PI;
      },
      set: function set(t) {
        this.intensity = t / Math.PI;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.shadow.dispose();
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Tc.prototype), "copy", this).call(this, t), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
      }
    }]);

    return Tc;
  }(yc);

  Tc.prototype.isSpotLight = !0;
  var Ec = new Pe(),
      Ac = new te(),
      Rc = new te();

  var Cc = /*#__PURE__*/function (_wc2) {
    _inherits(Cc, _wc2);

    var _super118 = _createSuper(Cc);

    function Cc() {
      var _this94;

      _classCallCheck(this, Cc);

      _this94 = _super118.call(this, new hi(90, 1, .5, 500)), _this94._frameExtents = new At(4, 2), _this94._viewportCount = 6, _this94._viewports = [new qt(2, 1, 1, 1), new qt(0, 1, 1, 1), new qt(3, 1, 1, 1), new qt(1, 1, 1, 1), new qt(3, 0, 1, 1), new qt(1, 0, 1, 1)], _this94._cubeDirections = [new te(1, 0, 0), new te(-1, 0, 0), new te(0, 0, 1), new te(0, 0, -1), new te(0, 1, 0), new te(0, -1, 0)], _this94._cubeUps = [new te(0, 1, 0), new te(0, 1, 0), new te(0, 1, 0), new te(0, 1, 0), new te(0, 0, 1), new te(0, 0, -1)];
      return _this94;
    }

    _createClass(Cc, [{
      key: "updateMatrices",
      value: function updateMatrices(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = this.camera,
            i = this.matrix,
            r = t.distance || n.far;
        r !== n.far && (n.far = r, n.updateProjectionMatrix()), Ac.setFromMatrixPosition(t.matrixWorld), n.position.copy(Ac), Rc.copy(n.position), Rc.add(this._cubeDirections[e]), n.up.copy(this._cubeUps[e]), n.lookAt(Rc), n.updateMatrixWorld(), i.makeTranslation(-Ac.x, -Ac.y, -Ac.z), Ec.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Ec);
      }
    }]);

    return Cc;
  }(wc);

  Cc.prototype.isPointLightShadow = !0;

  var Lc = /*#__PURE__*/function (_yc3) {
    _inherits(Lc, _yc3);

    var _super119 = _createSuper(Lc);

    function Lc(t, e) {
      var _this95;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      _classCallCheck(this, Lc);

      _this95 = _super119.call(this, t, e), _this95.type = "PointLight", _this95.distance = n, _this95.decay = i, _this95.shadow = new Cc();
      return _this95;
    }

    _createClass(Lc, [{
      key: "power",
      get: function get() {
        return 4 * this.intensity * Math.PI;
      },
      set: function set(t) {
        this.intensity = t / (4 * Math.PI);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.shadow.dispose();
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Lc.prototype), "copy", this).call(this, t), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
      }
    }]);

    return Lc;
  }(yc);

  Lc.prototype.isPointLight = !0;

  var Pc = /*#__PURE__*/function (_wc3) {
    _inherits(Pc, _wc3);

    var _super120 = _createSuper(Pc);

    function Pc() {
      _classCallCheck(this, Pc);

      return _super120.call(this, new Ni(-5, 5, 5, -5, .5, 500));
    }

    return _createClass(Pc);
  }(wc);

  Pc.prototype.isDirectionalLightShadow = !0;

  var Dc = /*#__PURE__*/function (_yc4) {
    _inherits(Dc, _yc4);

    var _super121 = _createSuper(Dc);

    function Dc(t, e) {
      var _this96;

      _classCallCheck(this, Dc);

      _this96 = _super121.call(this, t, e), _this96.type = "DirectionalLight", _this96.position.copy(nn.DefaultUp), _this96.updateMatrix(), _this96.target = new nn(), _this96.shadow = new Pc();
      return _this96;
    }

    _createClass(Dc, [{
      key: "dispose",
      value: function dispose() {
        this.shadow.dispose();
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Dc.prototype), "copy", this).call(this, t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
      }
    }]);

    return Dc;
  }(yc);

  Dc.prototype.isDirectionalLight = !0;

  var Ic = /*#__PURE__*/function (_yc5) {
    _inherits(Ic, _yc5);

    var _super122 = _createSuper(Ic);

    function Ic(t, e) {
      var _this97;

      _classCallCheck(this, Ic);

      _this97 = _super122.call(this, t, e), _this97.type = "AmbientLight";
      return _this97;
    }

    return _createClass(Ic);
  }(yc);

  Ic.prototype.isAmbientLight = !0;

  var Nc = /*#__PURE__*/function (_yc6) {
    _inherits(Nc, _yc6);

    var _super123 = _createSuper(Nc);

    function Nc(t, e) {
      var _this98;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

      _classCallCheck(this, Nc);

      _this98 = _super123.call(this, t, e), _this98.type = "RectAreaLight", _this98.width = n, _this98.height = i;
      return _this98;
    }

    _createClass(Nc, [{
      key: "power",
      get: function get() {
        return this.intensity * this.width * this.height * Math.PI;
      },
      set: function set(t) {
        this.intensity = t / (this.width * this.height * Math.PI);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Nc.prototype), "copy", this).call(this, t), this.width = t.width, this.height = t.height, this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(Nc.prototype), "toJSON", this).call(this, t);

        return e.object.width = this.width, e.object.height = this.height, e;
      }
    }]);

    return Nc;
  }(yc);

  Nc.prototype.isRectAreaLight = !0;

  var Bc = /*#__PURE__*/function () {
    function Bc() {
      _classCallCheck(this, Bc);

      this.coefficients = [];

      for (var _t269 = 0; _t269 < 9; _t269++) {
        this.coefficients.push(new te());
      }
    }

    _createClass(Bc, [{
      key: "set",
      value: function set(t) {
        for (var _e239 = 0; _e239 < 9; _e239++) {
          this.coefficients[_e239].copy(t[_e239]);
        }

        return this;
      }
    }, {
      key: "zero",
      value: function zero() {
        for (var _t270 = 0; _t270 < 9; _t270++) {
          this.coefficients[_t270].set(0, 0, 0);
        }

        return this;
      }
    }, {
      key: "getAt",
      value: function getAt(t, e) {
        var n = t.x,
            i = t.y,
            r = t.z,
            s = this.coefficients;
        return e.copy(s[0]).multiplyScalar(.282095), e.addScaledVector(s[1], .488603 * i), e.addScaledVector(s[2], .488603 * r), e.addScaledVector(s[3], .488603 * n), e.addScaledVector(s[4], n * i * 1.092548), e.addScaledVector(s[5], i * r * 1.092548), e.addScaledVector(s[6], .315392 * (3 * r * r - 1)), e.addScaledVector(s[7], n * r * 1.092548), e.addScaledVector(s[8], .546274 * (n * n - i * i)), e;
      }
    }, {
      key: "getIrradianceAt",
      value: function getIrradianceAt(t, e) {
        var n = t.x,
            i = t.y,
            r = t.z,
            s = this.coefficients;
        return e.copy(s[0]).multiplyScalar(.886227), e.addScaledVector(s[1], 1.023328 * i), e.addScaledVector(s[2], 1.023328 * r), e.addScaledVector(s[3], 1.023328 * n), e.addScaledVector(s[4], .858086 * n * i), e.addScaledVector(s[5], .858086 * i * r), e.addScaledVector(s[6], .743125 * r * r - .247708), e.addScaledVector(s[7], .858086 * n * r), e.addScaledVector(s[8], .429043 * (n * n - i * i)), e;
      }
    }, {
      key: "add",
      value: function add(t) {
        for (var _e240 = 0; _e240 < 9; _e240++) {
          this.coefficients[_e240].add(t.coefficients[_e240]);
        }

        return this;
      }
    }, {
      key: "addScaledSH",
      value: function addScaledSH(t, e) {
        for (var _n238 = 0; _n238 < 9; _n238++) {
          this.coefficients[_n238].addScaledVector(t.coefficients[_n238], e);
        }

        return this;
      }
    }, {
      key: "scale",
      value: function scale(t) {
        for (var _e241 = 0; _e241 < 9; _e241++) {
          this.coefficients[_e241].multiplyScalar(t);
        }

        return this;
      }
    }, {
      key: "lerp",
      value: function lerp(t, e) {
        for (var _n239 = 0; _n239 < 9; _n239++) {
          this.coefficients[_n239].lerp(t.coefficients[_n239], e);
        }

        return this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        for (var _e242 = 0; _e242 < 9; _e242++) {
          if (!this.coefficients[_e242].equals(t.coefficients[_e242])) return !1;
        }

        return !0;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.set(t.coefficients);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "fromArray",
      value: function fromArray(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = this.coefficients;

        for (var _i176 = 0; _i176 < 9; _i176++) {
          n[_i176].fromArray(t, e + 3 * _i176);
        }

        return this;
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = this.coefficients;

        for (var _i177 = 0; _i177 < 9; _i177++) {
          n[_i177].toArray(t, e + 3 * _i177);
        }

        return t;
      }
    }], [{
      key: "getBasisAt",
      value: function getBasisAt(t, e) {
        var n = t.x,
            i = t.y,
            r = t.z;
        e[0] = .282095, e[1] = .488603 * i, e[2] = .488603 * r, e[3] = .488603 * n, e[4] = 1.092548 * n * i, e[5] = 1.092548 * i * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * n * r, e[8] = .546274 * (n * n - i * i);
      }
    }]);

    return Bc;
  }();

  Bc.prototype.isSphericalHarmonics3 = !0;

  var zc = /*#__PURE__*/function (_yc7) {
    _inherits(zc, _yc7);

    var _super124 = _createSuper(zc);

    function zc() {
      var _this99;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Bc();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      _classCallCheck(this, zc);

      _this99 = _super124.call(this, void 0, e), _this99.sh = t;
      return _this99;
    }

    _createClass(zc, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(zc.prototype), "copy", this).call(this, t), this.sh.copy(t.sh), this;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return this.intensity = t.intensity, this.sh.fromArray(t.sh), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(zc.prototype), "toJSON", this).call(this, t);

        return e.object.sh = this.sh.toArray(), e;
      }
    }]);

    return zc;
  }(yc);

  zc.prototype.isLightProbe = !0;

  var Oc = /*#__PURE__*/function (_uc6) {
    _inherits(Oc, _uc6);

    var _super125 = _createSuper(Oc);

    function Oc(t) {
      var _this100;

      _classCallCheck(this, Oc);

      _this100 = _super125.call(this, t), _this100.textures = {};
      return _this100;
    }

    _createClass(Oc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = new pc(r.manager);
        s.setPath(r.path), s.setRequestHeader(r.requestHeader), s.setWithCredentials(r.withCredentials), s.load(t, function (n) {
          try {
            e(r.parse(JSON.parse(n)));
          } catch (e) {
            i ? i(e) : console.error(e), r.manager.itemError(t);
          }
        }, n, i);
      }
    }, {
      key: "parse",
      value: function parse(t) {
        var e = this.textures;

        function n(t) {
          return void 0 === e[t] && console.warn("THREE.MaterialLoader: Undefined texture", t), e[t];
        }

        var i = gn.fromType(t.type);
        if (void 0 !== t.uuid && (i.uuid = t.uuid), void 0 !== t.name && (i.name = t.name), void 0 !== t.color && void 0 !== i.color && i.color.setHex(t.color), void 0 !== t.roughness && (i.roughness = t.roughness), void 0 !== t.metalness && (i.metalness = t.metalness), void 0 !== t.sheen && (i.sheen = t.sheen), void 0 !== t.sheenColor && (i.sheenColor = new Ft().setHex(t.sheenColor)), void 0 !== t.sheenRoughness && (i.sheenRoughness = t.sheenRoughness), void 0 !== t.emissive && void 0 !== i.emissive && i.emissive.setHex(t.emissive), void 0 !== t.specular && void 0 !== i.specular && i.specular.setHex(t.specular), void 0 !== t.specularIntensity && (i.specularIntensity = t.specularIntensity), void 0 !== t.specularColor && void 0 !== i.specularColor && i.specularColor.setHex(t.specularColor), void 0 !== t.shininess && (i.shininess = t.shininess), void 0 !== t.clearcoat && (i.clearcoat = t.clearcoat), void 0 !== t.clearcoatRoughness && (i.clearcoatRoughness = t.clearcoatRoughness), void 0 !== t.transmission && (i.transmission = t.transmission), void 0 !== t.thickness && (i.thickness = t.thickness), void 0 !== t.attenuationDistance && (i.attenuationDistance = t.attenuationDistance), void 0 !== t.attenuationColor && void 0 !== i.attenuationColor && i.attenuationColor.setHex(t.attenuationColor), void 0 !== t.fog && (i.fog = t.fog), void 0 !== t.flatShading && (i.flatShading = t.flatShading), void 0 !== t.blending && (i.blending = t.blending), void 0 !== t.combine && (i.combine = t.combine), void 0 !== t.side && (i.side = t.side), void 0 !== t.shadowSide && (i.shadowSide = t.shadowSide), void 0 !== t.opacity && (i.opacity = t.opacity), void 0 !== t.transparent && (i.transparent = t.transparent), void 0 !== t.alphaTest && (i.alphaTest = t.alphaTest), void 0 !== t.depthTest && (i.depthTest = t.depthTest), void 0 !== t.depthWrite && (i.depthWrite = t.depthWrite), void 0 !== t.colorWrite && (i.colorWrite = t.colorWrite), void 0 !== t.stencilWrite && (i.stencilWrite = t.stencilWrite), void 0 !== t.stencilWriteMask && (i.stencilWriteMask = t.stencilWriteMask), void 0 !== t.stencilFunc && (i.stencilFunc = t.stencilFunc), void 0 !== t.stencilRef && (i.stencilRef = t.stencilRef), void 0 !== t.stencilFuncMask && (i.stencilFuncMask = t.stencilFuncMask), void 0 !== t.stencilFail && (i.stencilFail = t.stencilFail), void 0 !== t.stencilZFail && (i.stencilZFail = t.stencilZFail), void 0 !== t.stencilZPass && (i.stencilZPass = t.stencilZPass), void 0 !== t.wireframe && (i.wireframe = t.wireframe), void 0 !== t.wireframeLinewidth && (i.wireframeLinewidth = t.wireframeLinewidth), void 0 !== t.wireframeLinecap && (i.wireframeLinecap = t.wireframeLinecap), void 0 !== t.wireframeLinejoin && (i.wireframeLinejoin = t.wireframeLinejoin), void 0 !== t.rotation && (i.rotation = t.rotation), 1 !== t.linewidth && (i.linewidth = t.linewidth), void 0 !== t.dashSize && (i.dashSize = t.dashSize), void 0 !== t.gapSize && (i.gapSize = t.gapSize), void 0 !== t.scale && (i.scale = t.scale), void 0 !== t.polygonOffset && (i.polygonOffset = t.polygonOffset), void 0 !== t.polygonOffsetFactor && (i.polygonOffsetFactor = t.polygonOffsetFactor), void 0 !== t.polygonOffsetUnits && (i.polygonOffsetUnits = t.polygonOffsetUnits), void 0 !== t.dithering && (i.dithering = t.dithering), void 0 !== t.alphaToCoverage && (i.alphaToCoverage = t.alphaToCoverage), void 0 !== t.premultipliedAlpha && (i.premultipliedAlpha = t.premultipliedAlpha), void 0 !== t.visible && (i.visible = t.visible), void 0 !== t.toneMapped && (i.toneMapped = t.toneMapped), void 0 !== t.userData && (i.userData = t.userData), void 0 !== t.vertexColors && ("number" == typeof t.vertexColors ? i.vertexColors = t.vertexColors > 0 : i.vertexColors = t.vertexColors), void 0 !== t.uniforms) for (var _e243 in t.uniforms) {
          var _r133 = t.uniforms[_e243];

          switch (i.uniforms[_e243] = {}, _r133.type) {
            case "t":
              i.uniforms[_e243].value = n(_r133.value);
              break;

            case "c":
              i.uniforms[_e243].value = new Ft().setHex(_r133.value);
              break;

            case "v2":
              i.uniforms[_e243].value = new At().fromArray(_r133.value);
              break;

            case "v3":
              i.uniforms[_e243].value = new te().fromArray(_r133.value);
              break;

            case "v4":
              i.uniforms[_e243].value = new qt().fromArray(_r133.value);
              break;

            case "m3":
              i.uniforms[_e243].value = new Rt().fromArray(_r133.value);
              break;

            case "m4":
              i.uniforms[_e243].value = new Pe().fromArray(_r133.value);
              break;

            default:
              i.uniforms[_e243].value = _r133.value;
          }
        }
        if (void 0 !== t.defines && (i.defines = t.defines), void 0 !== t.vertexShader && (i.vertexShader = t.vertexShader), void 0 !== t.fragmentShader && (i.fragmentShader = t.fragmentShader), void 0 !== t.extensions) for (var _e244 in t.extensions) {
          i.extensions[_e244] = t.extensions[_e244];
        }

        if (void 0 !== t.shading && (i.flatShading = 1 === t.shading), void 0 !== t.size && (i.size = t.size), void 0 !== t.sizeAttenuation && (i.sizeAttenuation = t.sizeAttenuation), void 0 !== t.map && (i.map = n(t.map)), void 0 !== t.matcap && (i.matcap = n(t.matcap)), void 0 !== t.alphaMap && (i.alphaMap = n(t.alphaMap)), void 0 !== t.bumpMap && (i.bumpMap = n(t.bumpMap)), void 0 !== t.bumpScale && (i.bumpScale = t.bumpScale), void 0 !== t.normalMap && (i.normalMap = n(t.normalMap)), void 0 !== t.normalMapType && (i.normalMapType = t.normalMapType), void 0 !== t.normalScale) {
          var _e245 = t.normalScale;
          !1 === Array.isArray(_e245) && (_e245 = [_e245, _e245]), i.normalScale = new At().fromArray(_e245);
        }

        return void 0 !== t.displacementMap && (i.displacementMap = n(t.displacementMap)), void 0 !== t.displacementScale && (i.displacementScale = t.displacementScale), void 0 !== t.displacementBias && (i.displacementBias = t.displacementBias), void 0 !== t.roughnessMap && (i.roughnessMap = n(t.roughnessMap)), void 0 !== t.metalnessMap && (i.metalnessMap = n(t.metalnessMap)), void 0 !== t.emissiveMap && (i.emissiveMap = n(t.emissiveMap)), void 0 !== t.emissiveIntensity && (i.emissiveIntensity = t.emissiveIntensity), void 0 !== t.specularMap && (i.specularMap = n(t.specularMap)), void 0 !== t.specularIntensityMap && (i.specularIntensityMap = n(t.specularIntensityMap)), void 0 !== t.specularColorMap && (i.specularColorMap = n(t.specularColorMap)), void 0 !== t.envMap && (i.envMap = n(t.envMap)), void 0 !== t.envMapIntensity && (i.envMapIntensity = t.envMapIntensity), void 0 !== t.reflectivity && (i.reflectivity = t.reflectivity), void 0 !== t.refractionRatio && (i.refractionRatio = t.refractionRatio), void 0 !== t.lightMap && (i.lightMap = n(t.lightMap)), void 0 !== t.lightMapIntensity && (i.lightMapIntensity = t.lightMapIntensity), void 0 !== t.aoMap && (i.aoMap = n(t.aoMap)), void 0 !== t.aoMapIntensity && (i.aoMapIntensity = t.aoMapIntensity), void 0 !== t.gradientMap && (i.gradientMap = n(t.gradientMap)), void 0 !== t.clearcoatMap && (i.clearcoatMap = n(t.clearcoatMap)), void 0 !== t.clearcoatRoughnessMap && (i.clearcoatRoughnessMap = n(t.clearcoatRoughnessMap)), void 0 !== t.clearcoatNormalMap && (i.clearcoatNormalMap = n(t.clearcoatNormalMap)), void 0 !== t.clearcoatNormalScale && (i.clearcoatNormalScale = new At().fromArray(t.clearcoatNormalScale)), void 0 !== t.transmissionMap && (i.transmissionMap = n(t.transmissionMap)), void 0 !== t.thicknessMap && (i.thicknessMap = n(t.thicknessMap)), void 0 !== t.sheenColorMap && (i.sheenColorMap = n(t.sheenColorMap)), void 0 !== t.sheenRoughnessMap && (i.sheenRoughnessMap = n(t.sheenRoughnessMap)), i;
      }
    }, {
      key: "setTextures",
      value: function setTextures(t) {
        return this.textures = t, this;
      }
    }]);

    return Oc;
  }(uc);

  var Uc = /*#__PURE__*/function () {
    function Uc() {
      _classCallCheck(this, Uc);
    }

    _createClass(Uc, null, [{
      key: "decodeText",
      value: function decodeText(t) {
        if ("undefined" != typeof TextDecoder) return new TextDecoder().decode(t);
        var e = "";

        for (var _n240 = 0, _i178 = t.length; _n240 < _i178; _n240++) {
          e += String.fromCharCode(t[_n240]);
        }

        try {
          return decodeURIComponent(escape(e));
        } catch (t) {
          return e;
        }
      }
    }, {
      key: "extractUrlBase",
      value: function extractUrlBase(t) {
        var e = t.lastIndexOf("/");
        return -1 === e ? "./" : t.slice(0, e + 1);
      }
    }, {
      key: "resolveURL",
      value: function resolveURL(t, e) {
        return "string" != typeof t || "" === t ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t) || /^data:.*,.*$/i.test(t) || /^blob:.*$/i.test(t) ? t : e + t);
      }
    }]);

    return Uc;
  }();

  var Fc = /*#__PURE__*/function (_Un16) {
    _inherits(Fc, _Un16);

    var _super126 = _createSuper(Fc);

    function Fc() {
      var _this101;

      _classCallCheck(this, Fc);

      _this101 = _super126.call(this), _this101.type = "InstancedBufferGeometry", _this101.instanceCount = 1 / 0;
      return _this101;
    }

    _createClass(Fc, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Fc.prototype), "copy", this).call(this, t), this.instanceCount = t.instanceCount, this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(Fc.prototype), "toJSON", this).call(this, this);

        return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
      }
    }]);

    return Fc;
  }(Un);

  Fc.prototype.isInstancedBufferGeometry = !0;

  var Hc = /*#__PURE__*/function (_uc7) {
    _inherits(Hc, _uc7);

    var _super127 = _createSuper(Hc);

    function Hc(t) {
      _classCallCheck(this, Hc);

      return _super127.call(this, t);
    }

    _createClass(Hc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = new pc(r.manager);
        s.setPath(r.path), s.setRequestHeader(r.requestHeader), s.setWithCredentials(r.withCredentials), s.load(t, function (n) {
          try {
            e(r.parse(JSON.parse(n)));
          } catch (e) {
            i ? i(e) : console.error(e), r.manager.itemError(t);
          }
        }, n, i);
      }
    }, {
      key: "parse",
      value: function parse(t) {
        var e = {},
            n = {};

        function i(t, i) {
          if (void 0 !== e[i]) return e[i];

          var r = t.interleavedBuffers[i],
              s = function (t, e) {
            if (void 0 !== n[e]) return n[e];
            var i = t.arrayBuffers[e],
                r = new Uint32Array(i).buffer;
            return n[e] = r, r;
          }(t, r.buffer),
              a = Pt(r.type, s),
              o = new aa(a, r.stride);

          return o.uuid = r.uuid, e[i] = o, o;
        }

        var r = t.isInstancedBufferGeometry ? new Fc() : new Un(),
            s = t.data.index;

        if (void 0 !== s) {
          var _t271 = Pt(s.type, s.array);

          r.setIndex(new _n(_t271, 1));
        }

        var a = t.data.attributes;

        for (var _e246 in a) {
          var _n241 = a[_e246];

          var _s75 = void 0;

          if (_n241.isInterleavedBufferAttribute) {
            var _e247 = i(t.data, _n241.data);

            _s75 = new la(_e247, _n241.itemSize, _n241.offset, _n241.normalized);
          } else {
            var _t272 = Pt(_n241.type, _n241.array);

            _s75 = new (_n241.isInstancedBufferAttribute ? Fa : _n)(_t272, _n241.itemSize, _n241.normalized);
          }

          void 0 !== _n241.name && (_s75.name = _n241.name), void 0 !== _n241.usage && _s75.setUsage(_n241.usage), void 0 !== _n241.updateRange && (_s75.updateRange.offset = _n241.updateRange.offset, _s75.updateRange.count = _n241.updateRange.count), r.setAttribute(_e246, _s75);
        }

        var o = t.data.morphAttributes;
        if (o) for (var _e248 in o) {
          var _n242 = o[_e248],
              _s76 = [];

          for (var _e249 = 0, _r134 = _n242.length; _e249 < _r134; _e249++) {
            var _r135 = _n242[_e249];

            var _a64 = void 0;

            if (_r135.isInterleavedBufferAttribute) {
              var _e250 = i(t.data, _r135.data);

              _a64 = new la(_e250, _r135.itemSize, _r135.offset, _r135.normalized);
            } else {
              var _t273 = Pt(_r135.type, _r135.array);

              _a64 = new _n(_t273, _r135.itemSize, _r135.normalized);
            }

            void 0 !== _r135.name && (_a64.name = _r135.name), _s76.push(_a64);
          }

          r.morphAttributes[_e248] = _s76;
        }
        t.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
        var l = t.data.groups || t.data.drawcalls || t.data.offsets;
        if (void 0 !== l) for (var _t274 = 0, _e251 = l.length; _t274 !== _e251; ++_t274) {
          var _e252 = l[_t274];
          r.addGroup(_e252.start, _e252.count, _e252.materialIndex);
        }
        var c = t.data.boundingSphere;

        if (void 0 !== c) {
          var _t275 = new te();

          void 0 !== c.center && _t275.fromArray(c.center), r.boundingSphere = new be(_t275, c.radius);
        }

        return t.name && (r.name = t.name), t.userData && (r.userData = t.userData), r;
      }
    }]);

    return Hc;
  }(uc);

  var Gc = {
    UVMapping: i,
    CubeReflectionMapping: r,
    CubeRefractionMapping: s,
    EquirectangularReflectionMapping: a,
    EquirectangularRefractionMapping: o,
    CubeUVReflectionMapping: l,
    CubeUVRefractionMapping: c
  },
      Vc = {
    RepeatWrapping: h,
    ClampToEdgeWrapping: u,
    MirroredRepeatWrapping: d
  },
      kc = {
    NearestFilter: p,
    NearestMipmapNearestFilter: m,
    NearestMipmapLinearFilter: f,
    LinearFilter: g,
    LinearMipmapNearestFilter: v,
    LinearMipmapLinearFilter: y
  };

  var Wc = /*#__PURE__*/function (_uc8) {
    _inherits(Wc, _uc8);

    var _super128 = _createSuper(Wc);

    function Wc(t) {
      var _this102;

      _classCallCheck(this, Wc);

      _this102 = _super128.call(this, t), "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), _this102.options = {
        premultiplyAlpha: "none"
      };
      return _this102;
    }

    _createClass(Wc, [{
      key: "setOptions",
      value: function setOptions(t) {
        return this.options = t, this;
      }
    }, {
      key: "load",
      value: function load(t, e, n, i) {
        void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
        var r = this,
            s = lc.get(t);
        if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
          e && e(s), r.manager.itemEnd(t);
        }, 0), s;
        var a = {};
        a.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", a.headers = this.requestHeader, fetch(t, a).then(function (t) {
          return t.blob();
        }).then(function (t) {
          return createImageBitmap(t, Object.assign(r.options, {
            colorSpaceConversion: "none"
          }));
        }).then(function (n) {
          lc.add(t, n), e && e(n), r.manager.itemEnd(t);
        }).catch(function (e) {
          i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
        }), r.manager.itemStart(t);
      }
    }]);

    return Wc;
  }(uc);

  var jc;
  Wc.prototype.isImageBitmapLoader = !0;
  var qc = {
    getContext: function getContext() {
      return void 0 === jc && (jc = new (window.AudioContext || window.webkitAudioContext)()), jc;
    },
    setContext: function setContext(t) {
      jc = t;
    }
  };

  var Xc = /*#__PURE__*/function (_uc9) {
    _inherits(Xc, _uc9);

    var _super129 = _createSuper(Xc);

    function Xc(t) {
      _classCallCheck(this, Xc);

      return _super129.call(this, t);
    }

    _createClass(Xc, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = new pc(this.manager);
        s.setResponseType("arraybuffer"), s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, function (n) {
          try {
            var _t276 = n.slice(0);

            qc.getContext().decodeAudioData(_t276, function (t) {
              e(t);
            });
          } catch (e) {
            i ? i(e) : console.error(e), r.manager.itemError(t);
          }
        }, n, i);
      }
    }]);

    return Xc;
  }(uc);

  var Jc = /*#__PURE__*/function (_zc) {
    _inherits(Jc, _zc);

    var _super130 = _createSuper(Jc);

    function Jc(t, e) {
      var _this103;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      _classCallCheck(this, Jc);

      _this103 = _super130.call(this, void 0, n);
      var i = new Ft().set(t),
          r = new Ft().set(e),
          s = new te(i.r, i.g, i.b),
          a = new te(r.r, r.g, r.b),
          o = Math.sqrt(Math.PI),
          l = o * Math.sqrt(.75);
      _this103.sh.coefficients[0].copy(s).add(a).multiplyScalar(o), _this103.sh.coefficients[1].copy(s).sub(a).multiplyScalar(l);
      return _this103;
    }

    return _createClass(Jc);
  }(zc);

  Jc.prototype.isHemisphereLightProbe = !0;

  var Yc = /*#__PURE__*/function (_zc2) {
    _inherits(Yc, _zc2);

    var _super131 = _createSuper(Yc);

    function Yc(t) {
      var _this104;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      _classCallCheck(this, Yc);

      _this104 = _super131.call(this, void 0, e);
      var n = new Ft().set(t);

      _this104.sh.coefficients[0].set(n.r, n.g, n.b).multiplyScalar(2 * Math.sqrt(Math.PI));

      return _this104;
    }

    return _createClass(Yc);
  }(zc);

  Yc.prototype.isAmbientLightProbe = !0;
  var Zc = new Pe(),
      Kc = new Pe(),
      Qc = new Pe();

  var $c = /*#__PURE__*/function () {
    function $c() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;

      _classCallCheck(this, $c);

      this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }

    _createClass($c, [{
      key: "start",
      value: function start() {
        this.startTime = th(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
      }
    }, {
      key: "stop",
      value: function stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
      }
    }, {
      key: "getElapsedTime",
      value: function getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
      }
    }, {
      key: "getDelta",
      value: function getDelta() {
        var t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;

        if (this.running) {
          var _e253 = th();

          t = (_e253 - this.oldTime) / 1e3, this.oldTime = _e253, this.elapsedTime += t;
        }

        return t;
      }
    }]);

    return $c;
  }();

  function th() {
    return ("undefined" == typeof performance ? Date : performance).now();
  }

  var eh = new te(),
      nh = new $t(),
      ih = new te(),
      rh = new te();

  var sh = /*#__PURE__*/function (_nn12) {
    _inherits(sh, _nn12);

    var _super132 = _createSuper(sh);

    function sh(t) {
      var _this105;

      _classCallCheck(this, sh);

      _this105 = _super132.call(this), _this105.type = "Audio", _this105.listener = t, _this105.context = t.context, _this105.gain = _this105.context.createGain(), _this105.gain.connect(t.getInput()), _this105.autoplay = !1, _this105.buffer = null, _this105.detune = 0, _this105.loop = !1, _this105.loopStart = 0, _this105.loopEnd = 0, _this105.offset = 0, _this105.duration = void 0, _this105.playbackRate = 1, _this105.isPlaying = !1, _this105.hasPlaybackControl = !0, _this105.source = null, _this105.sourceType = "empty", _this105._startedAt = 0, _this105._progress = 0, _this105._connected = !1, _this105.filters = [];
      return _this105;
    }

    _createClass(sh, [{
      key: "getOutput",
      value: function getOutput() {
        return this.gain;
      }
    }, {
      key: "setNodeSource",
      value: function setNodeSource(t) {
        return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t, this.connect(), this;
      }
    }, {
      key: "setMediaElementSource",
      value: function setMediaElementSource(t) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t), this.connect(), this;
      }
    }, {
      key: "setMediaStreamSource",
      value: function setMediaStreamSource(t) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t), this.connect(), this;
      }
    }, {
      key: "setBuffer",
      value: function setBuffer(t) {
        return this.buffer = t, this.sourceType = "buffer", this.autoplay && this.play(), this;
      }
    }, {
      key: "play",
      value: function play() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
        if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
        this._startedAt = this.context.currentTime + t;
        var e = this.context.createBufferSource();
        return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
      }
    }, {
      key: "pause",
      value: function pause() {
        if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
        console.warn("THREE.Audio: this Audio has no playback control.");
      }
    }, {
      key: "stop",
      value: function stop() {
        if (!1 !== this.hasPlaybackControl) return this._progress = 0, this.source.stop(), this.source.onended = null, this.isPlaying = !1, this;
        console.warn("THREE.Audio: this Audio has no playback control.");
      }
    }, {
      key: "connect",
      value: function connect() {
        if (this.filters.length > 0) {
          this.source.connect(this.filters[0]);

          for (var _t277 = 1, _e254 = this.filters.length; _t277 < _e254; _t277++) {
            this.filters[_t277 - 1].connect(this.filters[_t277]);
          }

          this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());

        return this._connected = !0, this;
      }
    }, {
      key: "disconnect",
      value: function disconnect() {
        if (this.filters.length > 0) {
          this.source.disconnect(this.filters[0]);

          for (var _t278 = 1, _e255 = this.filters.length; _t278 < _e255; _t278++) {
            this.filters[_t278 - 1].disconnect(this.filters[_t278]);
          }

          this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());

        return this._connected = !1, this;
      }
    }, {
      key: "getFilters",
      value: function getFilters() {
        return this.filters;
      }
    }, {
      key: "setFilters",
      value: function setFilters(t) {
        return t || (t = []), !0 === this._connected ? (this.disconnect(), this.filters = t.slice(), this.connect()) : this.filters = t.slice(), this;
      }
    }, {
      key: "setDetune",
      value: function setDetune(t) {
        if (this.detune = t, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
      }
    }, {
      key: "getDetune",
      value: function getDetune() {
        return this.detune;
      }
    }, {
      key: "getFilter",
      value: function getFilter() {
        return this.getFilters()[0];
      }
    }, {
      key: "setFilter",
      value: function setFilter(t) {
        return this.setFilters(t ? [t] : []);
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(t) {
        if (!1 !== this.hasPlaybackControl) return this.playbackRate = t, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
        console.warn("THREE.Audio: this Audio has no playback control.");
      }
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return this.playbackRate;
      }
    }, {
      key: "onEnded",
      value: function onEnded() {
        this.isPlaying = !1;
      }
    }, {
      key: "getLoop",
      value: function getLoop() {
        return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
      }
    }, {
      key: "setLoop",
      value: function setLoop(t) {
        if (!1 !== this.hasPlaybackControl) return this.loop = t, !0 === this.isPlaying && (this.source.loop = this.loop), this;
        console.warn("THREE.Audio: this Audio has no playback control.");
      }
    }, {
      key: "setLoopStart",
      value: function setLoopStart(t) {
        return this.loopStart = t, this;
      }
    }, {
      key: "setLoopEnd",
      value: function setLoopEnd(t) {
        return this.loopEnd = t, this;
      }
    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.gain.gain.value;
      }
    }, {
      key: "setVolume",
      value: function setVolume(t) {
        return this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01), this;
      }
    }]);

    return sh;
  }(nn);

  var ah = new te(),
      oh = new $t(),
      lh = new te(),
      ch = new te();

  var hh = /*#__PURE__*/function () {
    function hh(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2048;

      _classCallCheck(this, hh);

      this.analyser = t.context.createAnalyser(), this.analyser.fftSize = e, this.data = new Uint8Array(this.analyser.frequencyBinCount), t.getOutput().connect(this.analyser);
    }

    _createClass(hh, [{
      key: "getFrequencyData",
      value: function getFrequencyData() {
        return this.analyser.getByteFrequencyData(this.data), this.data;
      }
    }, {
      key: "getAverageFrequency",
      value: function getAverageFrequency() {
        var t = 0;
        var e = this.getFrequencyData();

        for (var _n243 = 0; _n243 < e.length; _n243++) {
          t += e[_n243];
        }

        return t / e.length;
      }
    }]);

    return hh;
  }();

  var uh = /*#__PURE__*/function () {
    function uh(t, e, n) {
      _classCallCheck(this, uh);

      var i, r, s;

      switch (this.binding = t, this.valueSize = n, e) {
        case "quaternion":
          i = this._slerp, r = this._slerpAdditive, s = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
          break;

        case "string":
        case "bool":
          i = this._select, r = this._select, s = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
          break;

        default:
          i = this._lerp, r = this._lerpAdditive, s = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
      }

      this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = s, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }

    _createClass(uh, [{
      key: "accumulate",
      value: function accumulate(t, e) {
        var n = this.buffer,
            i = this.valueSize,
            r = t * i + i;
        var s = this.cumulativeWeight;

        if (0 === s) {
          for (var _t279 = 0; _t279 !== i; ++_t279) {
            n[r + _t279] = n[_t279];
          }

          s = e;
        } else {
          s += e;

          var _t280 = e / s;

          this._mixBufferRegion(n, r, 0, _t280, i);
        }

        this.cumulativeWeight = s;
      }
    }, {
      key: "accumulateAdditive",
      value: function accumulateAdditive(t) {
        var e = this.buffer,
            n = this.valueSize,
            i = n * this._addIndex;
        0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t, n), this.cumulativeWeightAdditive += t;
      }
    }, {
      key: "apply",
      value: function apply(t) {
        var e = this.valueSize,
            n = this.buffer,
            i = t * e + e,
            r = this.cumulativeWeight,
            s = this.cumulativeWeightAdditive,
            a = this.binding;

        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
          var _t281 = e * this._origIndex;

          this._mixBufferRegion(n, i, _t281, 1 - r, e);
        }

        s > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * e, 1, e);

        for (var _t282 = e, _r136 = e + e; _t282 !== _r136; ++_t282) {
          if (n[_t282] !== n[_t282 + e]) {
            a.setValue(n, i);
            break;
          }
        }
      }
    }, {
      key: "saveOriginalState",
      value: function saveOriginalState() {
        var t = this.binding,
            e = this.buffer,
            n = this.valueSize,
            i = n * this._origIndex;
        t.getValue(e, i);

        for (var _t283 = n, _r137 = i; _t283 !== _r137; ++_t283) {
          e[_t283] = e[i + _t283 % n];
        }

        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
      }
    }, {
      key: "restoreOriginalState",
      value: function restoreOriginalState() {
        var t = 3 * this.valueSize;
        this.binding.setValue(this.buffer, t);
      }
    }, {
      key: "_setAdditiveIdentityNumeric",
      value: function _setAdditiveIdentityNumeric() {
        var t = this._addIndex * this.valueSize,
            e = t + this.valueSize;

        for (var _n244 = t; _n244 < e; _n244++) {
          this.buffer[_n244] = 0;
        }
      }
    }, {
      key: "_setAdditiveIdentityQuaternion",
      value: function _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
      }
    }, {
      key: "_setAdditiveIdentityOther",
      value: function _setAdditiveIdentityOther() {
        var t = this._origIndex * this.valueSize,
            e = this._addIndex * this.valueSize;

        for (var _n245 = 0; _n245 < this.valueSize; _n245++) {
          this.buffer[e + _n245] = this.buffer[t + _n245];
        }
      }
    }, {
      key: "_select",
      value: function _select(t, e, n, i, r) {
        if (i >= .5) for (var _i179 = 0; _i179 !== r; ++_i179) {
          t[e + _i179] = t[n + _i179];
        }
      }
    }, {
      key: "_slerp",
      value: function _slerp(t, e, n, i) {
        $t.slerpFlat(t, e, t, e, t, n, i);
      }
    }, {
      key: "_slerpAdditive",
      value: function _slerpAdditive(t, e, n, i, r) {
        var s = this._workIndex * r;
        $t.multiplyQuaternionsFlat(t, s, t, e, t, n), $t.slerpFlat(t, e, t, e, t, s, i);
      }
    }, {
      key: "_lerp",
      value: function _lerp(t, e, n, i, r) {
        var s = 1 - i;

        for (var _a65 = 0; _a65 !== r; ++_a65) {
          var _r138 = e + _a65;

          t[_r138] = t[_r138] * s + t[n + _a65] * i;
        }
      }
    }, {
      key: "_lerpAdditive",
      value: function _lerpAdditive(t, e, n, i, r) {
        for (var _s77 = 0; _s77 !== r; ++_s77) {
          var _r139 = e + _s77;

          t[_r139] = t[_r139] + t[n + _s77] * i;
        }
      }
    }]);

    return uh;
  }();

  var dh = "\\[\\]\\.:\\/",
      ph = new RegExp("[\\[\\]\\.:\\/]", "g"),
      mh = "[^\\[\\]\\.:\\/]",
      fh = "[^" + dh.replace("\\.", "") + "]",
      gh = /((?:WC+[\/:])*)/.source.replace("WC", mh),
      vh = /(WCOD+)?/.source.replace("WCOD", fh),
      yh = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", mh),
      xh = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", mh),
      _h = new RegExp("^" + gh + vh + yh + xh + "$"),
      Mh = ["material", "materials", "bones"];

  var bh = /*#__PURE__*/function () {
    function bh(t, e, n) {
      _classCallCheck(this, bh);

      this.path = e, this.parsedPath = n || bh.parseTrackName(e), this.node = bh.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }

    _createClass(bh, [{
      key: "_getValue_unavailable",
      value: function _getValue_unavailable() {}
    }, {
      key: "_setValue_unavailable",
      value: function _setValue_unavailable() {}
    }, {
      key: "_getValue_direct",
      value: function _getValue_direct(t, e) {
        t[e] = this.targetObject[this.propertyName];
      }
    }, {
      key: "_getValue_array",
      value: function _getValue_array(t, e) {
        var n = this.resolvedProperty;

        for (var _i180 = 0, _r140 = n.length; _i180 !== _r140; ++_i180) {
          t[e++] = n[_i180];
        }
      }
    }, {
      key: "_getValue_arrayElement",
      value: function _getValue_arrayElement(t, e) {
        t[e] = this.resolvedProperty[this.propertyIndex];
      }
    }, {
      key: "_getValue_toArray",
      value: function _getValue_toArray(t, e) {
        this.resolvedProperty.toArray(t, e);
      }
    }, {
      key: "_setValue_direct",
      value: function _setValue_direct(t, e) {
        this.targetObject[this.propertyName] = t[e];
      }
    }, {
      key: "_setValue_direct_setNeedsUpdate",
      value: function _setValue_direct_setNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
      }
    }, {
      key: "_setValue_direct_setMatrixWorldNeedsUpdate",
      value: function _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
      }
    }, {
      key: "_setValue_array",
      value: function _setValue_array(t, e) {
        var n = this.resolvedProperty;

        for (var _i181 = 0, _r141 = n.length; _i181 !== _r141; ++_i181) {
          n[_i181] = t[e++];
        }
      }
    }, {
      key: "_setValue_array_setNeedsUpdate",
      value: function _setValue_array_setNeedsUpdate(t, e) {
        var n = this.resolvedProperty;

        for (var _i182 = 0, _r142 = n.length; _i182 !== _r142; ++_i182) {
          n[_i182] = t[e++];
        }

        this.targetObject.needsUpdate = !0;
      }
    }, {
      key: "_setValue_array_setMatrixWorldNeedsUpdate",
      value: function _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
        var n = this.resolvedProperty;

        for (var _i183 = 0, _r143 = n.length; _i183 !== _r143; ++_i183) {
          n[_i183] = t[e++];
        }

        this.targetObject.matrixWorldNeedsUpdate = !0;
      }
    }, {
      key: "_setValue_arrayElement",
      value: function _setValue_arrayElement(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e];
      }
    }, {
      key: "_setValue_arrayElement_setNeedsUpdate",
      value: function _setValue_arrayElement_setNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
      }
    }, {
      key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
      value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
      }
    }, {
      key: "_setValue_fromArray",
      value: function _setValue_fromArray(t, e) {
        this.resolvedProperty.fromArray(t, e);
      }
    }, {
      key: "_setValue_fromArray_setNeedsUpdate",
      value: function _setValue_fromArray_setNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
      }
    }, {
      key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
      value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
      }
    }, {
      key: "_getValue_unbound",
      value: function _getValue_unbound(t, e) {
        this.bind(), this.getValue(t, e);
      }
    }, {
      key: "_setValue_unbound",
      value: function _setValue_unbound(t, e) {
        this.bind(), this.setValue(t, e);
      }
    }, {
      key: "bind",
      value: function bind() {
        var t = this.node;
        var e = this.parsedPath,
            n = e.objectName,
            i = e.propertyName;
        var r = e.propertyIndex;
        if (t || (t = bh.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) return void console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");

        if (n) {
          var _i184 = e.objectIndex;

          switch (n) {
            case "materials":
              if (!t.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
              if (!t.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
              t = t.material.materials;
              break;

            case "bones":
              if (!t.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
              t = t.skeleton.bones;

              for (var _e256 = 0; _e256 < t.length; _e256++) {
                if (t[_e256].name === _i184) {
                  _i184 = _e256;
                  break;
                }
              }

              break;

            default:
              if (void 0 === t[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
              t = t[n];
          }

          if (void 0 !== _i184) {
            if (void 0 === t[_i184]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
            t = t[_i184];
          }
        }

        var s = t[i];

        if (void 0 === s) {
          var _n246 = e.nodeName;
          return void console.error("THREE.PropertyBinding: Trying to update property for track: " + _n246 + "." + i + " but it wasn't found.", t);
        }

        var a = this.Versioning.None;
        this.targetObject = t, void 0 !== t.needsUpdate ? a = this.Versioning.NeedsUpdate : void 0 !== t.matrixWorldNeedsUpdate && (a = this.Versioning.MatrixWorldNeedsUpdate);
        var o = this.BindingType.Direct;

        if (void 0 !== r) {
          if ("morphTargetInfluences" === i) {
            if (!t.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
            if (!t.geometry.isBufferGeometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
            if (!t.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
            void 0 !== t.morphTargetDictionary[r] && (r = t.morphTargetDictionary[r]);
          }

          o = this.BindingType.ArrayElement, this.resolvedProperty = s, this.propertyIndex = r;
        } else void 0 !== s.fromArray && void 0 !== s.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = s) : Array.isArray(s) ? (o = this.BindingType.EntireArray, this.resolvedProperty = s) : this.propertyName = i;

        this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][a];
      }
    }, {
      key: "unbind",
      value: function unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
      }
    }], [{
      key: "create",
      value: function create(t, e, n) {
        return t && t.isAnimationObjectGroup ? new bh.Composite(t, e, n) : new bh(t, e, n);
      }
    }, {
      key: "sanitizeNodeName",
      value: function sanitizeNodeName(t) {
        return t.replace(/\s/g, "_").replace(ph, "");
      }
    }, {
      key: "parseTrackName",
      value: function parseTrackName(t) {
        var e = _h.exec(t);

        if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
        var n = {
          nodeName: e[2],
          objectName: e[3],
          objectIndex: e[4],
          propertyName: e[5],
          propertyIndex: e[6]
        },
            i = n.nodeName && n.nodeName.lastIndexOf(".");

        if (void 0 !== i && -1 !== i) {
          var _t284 = n.nodeName.substring(i + 1);

          -1 !== Mh.indexOf(_t284) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = _t284);
        }

        if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
        return n;
      }
    }, {
      key: "findNode",
      value: function findNode(t, e) {
        if (void 0 === e || "" === e || "." === e || -1 === e || e === t.name || e === t.uuid) return t;

        if (t.skeleton) {
          var _n247 = t.skeleton.getBoneByName(e);

          if (void 0 !== _n247) return _n247;
        }

        if (t.children) {
          var _n248 = function _n248(t) {
            for (var _i186 = 0; _i186 < t.length; _i186++) {
              var _r144 = t[_i186];
              if (_r144.name === e || _r144.uuid === e) return _r144;

              var _s78 = _n248(_r144.children);

              if (_s78) return _s78;
            }

            return null;
          },
              _i185 = _n248(t.children);

          if (_i185) return _i185;
        }

        return null;
      }
    }]);

    return bh;
  }();

  bh.Composite = /*#__PURE__*/function () {
    function _class(t, e, n) {
      _classCallCheck(this, _class);

      var i = n || bh.parseTrackName(e);
      this._targetGroup = t, this._bindings = t.subscribe_(e, i);
    }

    _createClass(_class, [{
      key: "getValue",
      value: function getValue(t, e) {
        this.bind();
        var n = this._targetGroup.nCachedObjects_,
            i = this._bindings[n];
        void 0 !== i && i.getValue(t, e);
      }
    }, {
      key: "setValue",
      value: function setValue(t, e) {
        var n = this._bindings;

        for (var _i187 = this._targetGroup.nCachedObjects_, _r145 = n.length; _i187 !== _r145; ++_i187) {
          n[_i187].setValue(t, e);
        }
      }
    }, {
      key: "bind",
      value: function bind() {
        var t = this._bindings;

        for (var _e257 = this._targetGroup.nCachedObjects_, _n249 = t.length; _e257 !== _n249; ++_e257) {
          t[_e257].bind();
        }
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var t = this._bindings;

        for (var _e258 = this._targetGroup.nCachedObjects_, _n250 = t.length; _e258 !== _n250; ++_e258) {
          t[_e258].unbind();
        }
      }
    }]);

    return _class;
  }(), bh.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
  }, bh.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
  }, bh.prototype.GetterByBindingType = [bh.prototype._getValue_direct, bh.prototype._getValue_array, bh.prototype._getValue_arrayElement, bh.prototype._getValue_toArray], bh.prototype.SetterByBindingTypeAndVersioning = [[bh.prototype._setValue_direct, bh.prototype._setValue_direct_setNeedsUpdate, bh.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [bh.prototype._setValue_array, bh.prototype._setValue_array_setNeedsUpdate, bh.prototype._setValue_array_setMatrixWorldNeedsUpdate], [bh.prototype._setValue_arrayElement, bh.prototype._setValue_arrayElement_setNeedsUpdate, bh.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [bh.prototype._setValue_fromArray, bh.prototype._setValue_fromArray_setNeedsUpdate, bh.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]];

  var wh = /*#__PURE__*/function () {
    function wh() {
      _classCallCheck(this, wh);

      this.uuid = xt(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
      var t = {};
      this._indicesByUUID = t;

      for (var _e259 = 0, _n251 = arguments.length; _e259 !== _n251; ++_e259) {
        t[arguments[_e259].uuid] = _e259;
      }

      this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
      var e = this;
      this.stats = {
        objects: {
          get total() {
            return e._objects.length;
          },

          get inUse() {
            return this.total - e.nCachedObjects_;
          }

        },

        get bindingsPerObject() {
          return e._bindings.length;
        }

      };
    }

    _createClass(wh, [{
      key: "add",
      value: function add() {
        var t = this._objects,
            e = this._indicesByUUID,
            n = this._paths,
            i = this._parsedPaths,
            r = this._bindings,
            s = r.length;
        var a,
            o = t.length,
            l = this.nCachedObjects_;

        for (var _c27 = 0, _h19 = arguments.length; _c27 !== _h19; ++_c27) {
          var _h20 = arguments[_c27],
              _u17 = _h20.uuid;
          var _d21 = e[_u17];

          if (void 0 === _d21) {
            _d21 = o++, e[_u17] = _d21, t.push(_h20);

            for (var _t285 = 0, _e260 = s; _t285 !== _e260; ++_t285) {
              r[_t285].push(new bh(_h20, n[_t285], i[_t285]));
            }
          } else if (_d21 < l) {
            a = t[_d21];

            var _o44 = --l,
                _c28 = t[_o44];

            e[_c28.uuid] = _d21, t[_d21] = _c28, e[_u17] = _o44, t[_o44] = _h20;

            for (var _t286 = 0, _e261 = s; _t286 !== _e261; ++_t286) {
              var _e262 = r[_t286],
                  _s79 = _e262[_o44];
              var _a66 = _e262[_d21];
              _e262[_d21] = _s79, void 0 === _a66 && (_a66 = new bh(_h20, n[_t286], i[_t286])), _e262[_o44] = _a66;
            }
          } else t[_d21] !== a && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
        }

        this.nCachedObjects_ = l;
      }
    }, {
      key: "remove",
      value: function remove() {
        var t = this._objects,
            e = this._indicesByUUID,
            n = this._bindings,
            i = n.length;
        var r = this.nCachedObjects_;

        for (var _s80 = 0, _a67 = arguments.length; _s80 !== _a67; ++_s80) {
          var _a68 = arguments[_s80],
              _o45 = _a68.uuid,
              _l44 = e[_o45];

          if (void 0 !== _l44 && _l44 >= r) {
            var _s81 = r++,
                _c29 = t[_s81];

            e[_c29.uuid] = _l44, t[_l44] = _c29, e[_o45] = _s81, t[_s81] = _a68;

            for (var _t287 = 0, _e263 = i; _t287 !== _e263; ++_t287) {
              var _e264 = n[_t287],
                  _i188 = _e264[_s81],
                  _r146 = _e264[_l44];
              _e264[_l44] = _i188, _e264[_s81] = _r146;
            }
          }
        }

        this.nCachedObjects_ = r;
      }
    }, {
      key: "uncache",
      value: function uncache() {
        var t = this._objects,
            e = this._indicesByUUID,
            n = this._bindings,
            i = n.length;
        var r = this.nCachedObjects_,
            s = t.length;

        for (var _a69 = 0, _o46 = arguments.length; _a69 !== _o46; ++_a69) {
          var _o47 = arguments[_a69].uuid,
              _l45 = e[_o47];
          if (void 0 !== _l45) if (delete e[_o47], _l45 < r) {
            var _a70 = --r,
                _o48 = t[_a70],
                _c30 = --s,
                _h21 = t[_c30];

            e[_o48.uuid] = _l45, t[_l45] = _o48, e[_h21.uuid] = _a70, t[_a70] = _h21, t.pop();

            for (var _t288 = 0, _e265 = i; _t288 !== _e265; ++_t288) {
              var _e266 = n[_t288],
                  _i189 = _e266[_a70],
                  _r147 = _e266[_c30];
              _e266[_l45] = _i189, _e266[_a70] = _r147, _e266.pop();
            }
          } else {
            var _r148 = --s,
                _a71 = t[_r148];

            _r148 > 0 && (e[_a71.uuid] = _l45), t[_l45] = _a71, t.pop();

            for (var _t289 = 0, _e267 = i; _t289 !== _e267; ++_t289) {
              var _e268 = n[_t289];
              _e268[_l45] = _e268[_r148], _e268.pop();
            }
          }
        }

        this.nCachedObjects_ = r;
      }
    }, {
      key: "subscribe_",
      value: function subscribe_(t, e) {
        var n = this._bindingsIndicesByPath;
        var i = n[t];
        var r = this._bindings;
        if (void 0 !== i) return r[i];
        var s = this._paths,
            a = this._parsedPaths,
            o = this._objects,
            l = o.length,
            c = this.nCachedObjects_,
            h = new Array(l);
        i = r.length, n[t] = i, s.push(t), a.push(e), r.push(h);

        for (var _n252 = c, _i190 = o.length; _n252 !== _i190; ++_n252) {
          var _i191 = o[_n252];
          h[_n252] = new bh(_i191, t, e);
        }

        return h;
      }
    }, {
      key: "unsubscribe_",
      value: function unsubscribe_(t) {
        var e = this._bindingsIndicesByPath,
            n = e[t];

        if (void 0 !== n) {
          var _i192 = this._paths,
              _r149 = this._parsedPaths,
              _s82 = this._bindings,
              _a72 = _s82.length - 1,
              _o49 = _s82[_a72];

          e[t[_a72]] = n, _s82[n] = _o49, _s82.pop(), _r149[n] = _r149[_a72], _r149.pop(), _i192[n] = _i192[_a72], _i192.pop();
        }
      }
    }]);

    return wh;
  }();

  wh.prototype.isAnimationObjectGroup = !0;

  var Sh = /*#__PURE__*/function () {
    function Sh(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.blendMode;

      _classCallCheck(this, Sh);

      this._mixer = t, this._clip = e, this._localRoot = n, this.blendMode = i;
      var r = e.tracks,
          s = r.length,
          a = new Array(s),
          o = {
        endingStart: nt,
        endingEnd: nt
      };

      for (var _t290 = 0; _t290 !== s; ++_t290) {
        var _e269 = r[_t290].createInterpolant(null);

        a[_t290] = _e269, _e269.settings = o;
      }

      this._interpolantSettings = o, this._interpolants = a, this._propertyBindings = new Array(s), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = 2201, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }

    _createClass(Sh, [{
      key: "play",
      value: function play() {
        return this._mixer._activateAction(this), this;
      }
    }, {
      key: "stop",
      value: function stop() {
        return this._mixer._deactivateAction(this), this.reset();
      }
    }, {
      key: "reset",
      value: function reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
      }
    }, {
      key: "isRunning",
      value: function isRunning() {
        return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
      }
    }, {
      key: "isScheduled",
      value: function isScheduled() {
        return this._mixer._isActiveAction(this);
      }
    }, {
      key: "startAt",
      value: function startAt(t) {
        return this._startTime = t, this;
      }
    }, {
      key: "setLoop",
      value: function setLoop(t, e) {
        return this.loop = t, this.repetitions = e, this;
      }
    }, {
      key: "setEffectiveWeight",
      value: function setEffectiveWeight(t) {
        return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
      }
    }, {
      key: "getEffectiveWeight",
      value: function getEffectiveWeight() {
        return this._effectiveWeight;
      }
    }, {
      key: "fadeIn",
      value: function fadeIn(t) {
        return this._scheduleFading(t, 0, 1);
      }
    }, {
      key: "fadeOut",
      value: function fadeOut(t) {
        return this._scheduleFading(t, 1, 0);
      }
    }, {
      key: "crossFadeFrom",
      value: function crossFadeFrom(t, e, n) {
        if (t.fadeOut(e), this.fadeIn(e), n) {
          var _n253 = this._clip.duration,
              _i193 = t._clip.duration,
              _r150 = _i193 / _n253,
              _s83 = _n253 / _i193;

          t.warp(1, _r150, e), this.warp(_s83, 1, e);
        }

        return this;
      }
    }, {
      key: "crossFadeTo",
      value: function crossFadeTo(t, e, n) {
        return t.crossFadeFrom(this, e, n);
      }
    }, {
      key: "stopFading",
      value: function stopFading() {
        var t = this._weightInterpolant;
        return null !== t && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
      }
    }, {
      key: "setEffectiveTimeScale",
      value: function setEffectiveTimeScale(t) {
        return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
      }
    }, {
      key: "getEffectiveTimeScale",
      value: function getEffectiveTimeScale() {
        return this._effectiveTimeScale;
      }
    }, {
      key: "setDuration",
      value: function setDuration(t) {
        return this.timeScale = this._clip.duration / t, this.stopWarping();
      }
    }, {
      key: "syncWith",
      value: function syncWith(t) {
        return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
      }
    }, {
      key: "halt",
      value: function halt(t) {
        return this.warp(this._effectiveTimeScale, 0, t);
      }
    }, {
      key: "warp",
      value: function warp(t, e, n) {
        var i = this._mixer,
            r = i.time,
            s = this.timeScale;
        var a = this._timeScaleInterpolant;
        null === a && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
        var o = a.parameterPositions,
            l = a.sampleValues;
        return o[0] = r, o[1] = r + n, l[0] = t / s, l[1] = e / s, this;
      }
    }, {
      key: "stopWarping",
      value: function stopWarping() {
        var t = this._timeScaleInterpolant;
        return null !== t && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
      }
    }, {
      key: "getMixer",
      value: function getMixer() {
        return this._mixer;
      }
    }, {
      key: "getClip",
      value: function getClip() {
        return this._clip;
      }
    }, {
      key: "getRoot",
      value: function getRoot() {
        return this._localRoot || this._mixer._root;
      }
    }, {
      key: "_update",
      value: function _update(t, e, n, i) {
        if (!this.enabled) return void this._updateWeight(t);
        var r = this._startTime;

        if (null !== r) {
          var _i194 = (t - r) * n;

          if (_i194 < 0 || 0 === n) return;
          this._startTime = null, e = n * _i194;
        }

        e *= this._updateTimeScale(t);

        var s = this._updateTime(e),
            a = this._updateWeight(t);

        if (a > 0) {
          var _t291 = this._interpolants,
              _e270 = this._propertyBindings;
          if (this.blendMode === at) for (var _n254 = 0, _i195 = _t291.length; _n254 !== _i195; ++_n254) {
            _t291[_n254].evaluate(s), _e270[_n254].accumulateAdditive(a);
          } else for (var _n255 = 0, _r151 = _t291.length; _n255 !== _r151; ++_n255) {
            _t291[_n255].evaluate(s), _e270[_n255].accumulate(i, a);
          }
        }
      }
    }, {
      key: "_updateWeight",
      value: function _updateWeight(t) {
        var e = 0;

        if (this.enabled) {
          e = this.weight;
          var _n256 = this._weightInterpolant;

          if (null !== _n256) {
            var _i196 = _n256.evaluate(t)[0];

            e *= _i196, t > _n256.parameterPositions[1] && (this.stopFading(), 0 === _i196 && (this.enabled = !1));
          }
        }

        return this._effectiveWeight = e, e;
      }
    }, {
      key: "_updateTimeScale",
      value: function _updateTimeScale(t) {
        var e = 0;

        if (!this.paused) {
          e = this.timeScale;
          var _n257 = this._timeScaleInterpolant;

          if (null !== _n257) {
            e *= _n257.evaluate(t)[0], t > _n257.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e);
          }
        }

        return this._effectiveTimeScale = e, e;
      }
    }, {
      key: "_updateTime",
      value: function _updateTime(t) {
        var e = this._clip.duration,
            n = this.loop;
        var i = this.time + t,
            r = this._loopCount;
        var s = 2202 === n;
        if (0 === t) return -1 === r ? i : s && 1 == (1 & r) ? e - i : i;

        if (2200 === n) {
          -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));

          t: {
            if (i >= e) i = e;else {
              if (!(i < 0)) {
                this.time = i;
                break t;
              }

              i = 0;
            }
            this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
              type: "finished",
              action: this,
              direction: t < 0 ? -1 : 1
            });
          }
        } else {
          if (-1 === r && (t >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, s)) : this._setEndings(0 === this.repetitions, !0, s)), i >= e || i < 0) {
            var _n258 = Math.floor(i / e);

            i -= e * _n258, r += Math.abs(_n258);

            var _a73 = this.repetitions - r;

            if (_a73 <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
              type: "finished",
              action: this,
              direction: t > 0 ? 1 : -1
            });else {
              if (1 === _a73) {
                var _e271 = t < 0;

                this._setEndings(_e271, !_e271, s);
              } else this._setEndings(!1, !1, s);

              this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
                type: "loop",
                action: this,
                loopDelta: _n258
              });
            }
          } else this.time = i;

          if (s && 1 == (1 & r)) return e - i;
        }

        return i;
      }
    }, {
      key: "_setEndings",
      value: function _setEndings(t, e, n) {
        var i = this._interpolantSettings;
        n ? (i.endingStart = it, i.endingEnd = it) : (i.endingStart = t ? this.zeroSlopeAtStart ? it : nt : rt, i.endingEnd = e ? this.zeroSlopeAtEnd ? it : nt : rt);
      }
    }, {
      key: "_scheduleFading",
      value: function _scheduleFading(t, e, n) {
        var i = this._mixer,
            r = i.time;
        var s = this._weightInterpolant;
        null === s && (s = i._lendControlInterpolant(), this._weightInterpolant = s);
        var a = s.parameterPositions,
            o = s.sampleValues;
        return a[0] = r, o[0] = e, a[1] = r + t, o[1] = n, this;
      }
    }]);

    return Sh;
  }();

  var Th = /*#__PURE__*/function (_mt7) {
    _inherits(Th, _mt7);

    var _super133 = _createSuper(Th);

    function Th(t) {
      var _this106;

      _classCallCheck(this, Th);

      _this106 = _super133.call(this), _this106._root = t, _this106._initMemoryManager(), _this106._accuIndex = 0, _this106.time = 0, _this106.timeScale = 1;
      return _this106;
    }

    _createClass(Th, [{
      key: "_bindAction",
      value: function _bindAction(t, e) {
        var n = t._localRoot || this._root,
            i = t._clip.tracks,
            r = i.length,
            s = t._propertyBindings,
            a = t._interpolants,
            o = n.uuid,
            l = this._bindingsByRootAndName;
        var c = l[o];
        void 0 === c && (c = {}, l[o] = c);

        for (var _t292 = 0; _t292 !== r; ++_t292) {
          var _r152 = i[_t292],
              _l46 = _r152.name;
          var _h22 = c[_l46];
          if (void 0 !== _h22) ++_h22.referenceCount, s[_t292] = _h22;else {
            if (_h22 = s[_t292], void 0 !== _h22) {
              null === _h22._cacheIndex && (++_h22.referenceCount, this._addInactiveBinding(_h22, o, _l46));
              continue;
            }

            var _i197 = e && e._propertyBindings[_t292].binding.parsedPath;

            _h22 = new uh(bh.create(n, _l46, _i197), _r152.ValueTypeName, _r152.getValueSize()), ++_h22.referenceCount, this._addInactiveBinding(_h22, o, _l46), s[_t292] = _h22;
          }
          a[_t292].resultBuffer = _h22.buffer;
        }
      }
    }, {
      key: "_activateAction",
      value: function _activateAction(t) {
        if (!this._isActiveAction(t)) {
          if (null === t._cacheIndex) {
            var _e273 = (t._localRoot || this._root).uuid,
                _n259 = t._clip.uuid,
                _i198 = this._actionsByClip[_n259];
            this._bindAction(t, _i198 && _i198.knownActions[0]), this._addInactiveAction(t, _n259, _e273);
          }

          var _e272 = t._propertyBindings;

          for (var _t293 = 0, _n260 = _e272.length; _t293 !== _n260; ++_t293) {
            var _n261 = _e272[_t293];
            0 == _n261.useCount++ && (this._lendBinding(_n261), _n261.saveOriginalState());
          }

          this._lendAction(t);
        }
      }
    }, {
      key: "_deactivateAction",
      value: function _deactivateAction(t) {
        if (this._isActiveAction(t)) {
          var _e274 = t._propertyBindings;

          for (var _t294 = 0, _n262 = _e274.length; _t294 !== _n262; ++_t294) {
            var _n263 = _e274[_t294];
            0 == --_n263.useCount && (_n263.restoreOriginalState(), this._takeBackBinding(_n263));
          }

          this._takeBackAction(t);
        }
      }
    }, {
      key: "_initMemoryManager",
      value: function _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        var t = this;
        this.stats = {
          actions: {
            get total() {
              return t._actions.length;
            },

            get inUse() {
              return t._nActiveActions;
            }

          },
          bindings: {
            get total() {
              return t._bindings.length;
            },

            get inUse() {
              return t._nActiveBindings;
            }

          },
          controlInterpolants: {
            get total() {
              return t._controlInterpolants.length;
            },

            get inUse() {
              return t._nActiveControlInterpolants;
            }

          }
        };
      }
    }, {
      key: "_isActiveAction",
      value: function _isActiveAction(t) {
        var e = t._cacheIndex;
        return null !== e && e < this._nActiveActions;
      }
    }, {
      key: "_addInactiveAction",
      value: function _addInactiveAction(t, e, n) {
        var i = this._actions,
            r = this._actionsByClip;
        var s = r[e];
        if (void 0 === s) s = {
          knownActions: [t],
          actionByRoot: {}
        }, t._byClipCacheIndex = 0, r[e] = s;else {
          var _e275 = s.knownActions;
          t._byClipCacheIndex = _e275.length, _e275.push(t);
        }
        t._cacheIndex = i.length, i.push(t), s.actionByRoot[n] = t;
      }
    }, {
      key: "_removeInactiveAction",
      value: function _removeInactiveAction(t) {
        var e = this._actions,
            n = e[e.length - 1],
            i = t._cacheIndex;
        n._cacheIndex = i, e[i] = n, e.pop(), t._cacheIndex = null;
        var r = t._clip.uuid,
            s = this._actionsByClip,
            a = s[r],
            o = a.knownActions,
            l = o[o.length - 1],
            c = t._byClipCacheIndex;
        l._byClipCacheIndex = c, o[c] = l, o.pop(), t._byClipCacheIndex = null;
        delete a.actionByRoot[(t._localRoot || this._root).uuid], 0 === o.length && delete s[r], this._removeInactiveBindingsForAction(t);
      }
    }, {
      key: "_removeInactiveBindingsForAction",
      value: function _removeInactiveBindingsForAction(t) {
        var e = t._propertyBindings;

        for (var _t295 = 0, _n264 = e.length; _t295 !== _n264; ++_t295) {
          var _n265 = e[_t295];
          0 == --_n265.referenceCount && this._removeInactiveBinding(_n265);
        }
      }
    }, {
      key: "_lendAction",
      value: function _lendAction(t) {
        var e = this._actions,
            n = t._cacheIndex,
            i = this._nActiveActions++,
            r = e[i];
        t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
      }
    }, {
      key: "_takeBackAction",
      value: function _takeBackAction(t) {
        var e = this._actions,
            n = t._cacheIndex,
            i = --this._nActiveActions,
            r = e[i];
        t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
      }
    }, {
      key: "_addInactiveBinding",
      value: function _addInactiveBinding(t, e, n) {
        var i = this._bindingsByRootAndName,
            r = this._bindings;
        var s = i[e];
        void 0 === s && (s = {}, i[e] = s), s[n] = t, t._cacheIndex = r.length, r.push(t);
      }
    }, {
      key: "_removeInactiveBinding",
      value: function _removeInactiveBinding(t) {
        var e = this._bindings,
            n = t.binding,
            i = n.rootNode.uuid,
            r = n.path,
            s = this._bindingsByRootAndName,
            a = s[i],
            o = e[e.length - 1],
            l = t._cacheIndex;
        o._cacheIndex = l, e[l] = o, e.pop(), delete a[r], 0 === Object.keys(a).length && delete s[i];
      }
    }, {
      key: "_lendBinding",
      value: function _lendBinding(t) {
        var e = this._bindings,
            n = t._cacheIndex,
            i = this._nActiveBindings++,
            r = e[i];
        t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
      }
    }, {
      key: "_takeBackBinding",
      value: function _takeBackBinding(t) {
        var e = this._bindings,
            n = t._cacheIndex,
            i = --this._nActiveBindings,
            r = e[i];
        t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
      }
    }, {
      key: "_lendControlInterpolant",
      value: function _lendControlInterpolant() {
        var t = this._controlInterpolants,
            e = this._nActiveControlInterpolants++;
        var n = t[e];
        return void 0 === n && (n = new Zl(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer), n.__cacheIndex = e, t[e] = n), n;
      }
    }, {
      key: "_takeBackControlInterpolant",
      value: function _takeBackControlInterpolant(t) {
        var e = this._controlInterpolants,
            n = t.__cacheIndex,
            i = --this._nActiveControlInterpolants,
            r = e[i];
        t.__cacheIndex = i, e[i] = t, r.__cacheIndex = n, e[n] = r;
      }
    }, {
      key: "clipAction",
      value: function clipAction(t, e, n) {
        var i = e || this._root,
            r = i.uuid;
        var s = "string" == typeof t ? ac.findByName(i, t) : t;
        var a = null !== s ? s.uuid : t,
            o = this._actionsByClip[a];
        var l = null;

        if (void 0 === n && (n = null !== s ? s.blendMode : st), void 0 !== o) {
          var _t296 = o.actionByRoot[r];
          if (void 0 !== _t296 && _t296.blendMode === n) return _t296;
          l = o.knownActions[0], null === s && (s = l._clip);
        }

        if (null === s) return null;
        var c = new Sh(this, s, e, n);
        return this._bindAction(c, l), this._addInactiveAction(c, a, r), c;
      }
    }, {
      key: "existingAction",
      value: function existingAction(t, e) {
        var n = e || this._root,
            i = n.uuid,
            r = "string" == typeof t ? ac.findByName(n, t) : t,
            s = r ? r.uuid : t,
            a = this._actionsByClip[s];
        return void 0 !== a && a.actionByRoot[i] || null;
      }
    }, {
      key: "stopAllAction",
      value: function stopAllAction() {
        var t = this._actions;

        for (var _e276 = this._nActiveActions - 1; _e276 >= 0; --_e276) {
          t[_e276].stop();
        }

        return this;
      }
    }, {
      key: "update",
      value: function update(t) {
        t *= this.timeScale;
        var e = this._actions,
            n = this._nActiveActions,
            i = this.time += t,
            r = Math.sign(t),
            s = this._accuIndex ^= 1;

        for (var _a74 = 0; _a74 !== n; ++_a74) {
          e[_a74]._update(i, t, r, s);
        }

        var a = this._bindings,
            o = this._nActiveBindings;

        for (var _t297 = 0; _t297 !== o; ++_t297) {
          a[_t297].apply(s);
        }

        return this;
      }
    }, {
      key: "setTime",
      value: function setTime(t) {
        this.time = 0;

        for (var _t298 = 0; _t298 < this._actions.length; _t298++) {
          this._actions[_t298].time = 0;
        }

        return this.update(t);
      }
    }, {
      key: "getRoot",
      value: function getRoot() {
        return this._root;
      }
    }, {
      key: "uncacheClip",
      value: function uncacheClip(t) {
        var e = this._actions,
            n = t.uuid,
            i = this._actionsByClip,
            r = i[n];

        if (void 0 !== r) {
          var _t299 = r.knownActions;

          for (var _n266 = 0, _i199 = _t299.length; _n266 !== _i199; ++_n266) {
            var _i200 = _t299[_n266];

            this._deactivateAction(_i200);

            var _r153 = _i200._cacheIndex,
                _s84 = e[e.length - 1];
            _i200._cacheIndex = null, _i200._byClipCacheIndex = null, _s84._cacheIndex = _r153, e[_r153] = _s84, e.pop(), this._removeInactiveBindingsForAction(_i200);
          }

          delete i[n];
        }
      }
    }, {
      key: "uncacheRoot",
      value: function uncacheRoot(t) {
        var e = t.uuid,
            n = this._actionsByClip;

        for (var _t300 in n) {
          var _i201 = n[_t300].actionByRoot[e];
          void 0 !== _i201 && (this._deactivateAction(_i201), this._removeInactiveAction(_i201));
        }

        var i = this._bindingsByRootAndName[e];
        if (void 0 !== i) for (var _t301 in i) {
          var _e277 = i[_t301];
          _e277.restoreOriginalState(), this._removeInactiveBinding(_e277);
        }
      }
    }, {
      key: "uncacheAction",
      value: function uncacheAction(t, e) {
        var n = this.existingAction(t, e);
        null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
      }
    }]);

    return Th;
  }(mt);

  Th.prototype._controlInterpolantsResultBuffer = new Float32Array(1);

  var Eh = /*#__PURE__*/function () {
    function Eh(t) {
      _classCallCheck(this, Eh);

      "string" == typeof t && (console.warn("THREE.Uniform: Type parameter is no longer needed."), t = arguments[1]), this.value = t;
    }

    _createClass(Eh, [{
      key: "clone",
      value: function clone() {
        return new Eh(void 0 === this.value.clone ? this.value : this.value.clone());
      }
    }]);

    return Eh;
  }();

  var Ah = /*#__PURE__*/function (_aa) {
    _inherits(Ah, _aa);

    var _super134 = _createSuper(Ah);

    function Ah(t, e) {
      var _this107;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      _classCallCheck(this, Ah);

      _this107 = _super134.call(this, t, e), _this107.meshPerAttribute = n;
      return _this107;
    }

    _createClass(Ah, [{
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(Ah.prototype), "copy", this).call(this, t), this.meshPerAttribute = t.meshPerAttribute, this;
      }
    }, {
      key: "clone",
      value: function clone(t) {
        var e = _get(_getPrototypeOf(Ah.prototype), "clone", this).call(this, t);

        return e.meshPerAttribute = this.meshPerAttribute, e;
      }
    }, {
      key: "toJSON",
      value: function toJSON(t) {
        var e = _get(_getPrototypeOf(Ah.prototype), "toJSON", this).call(this, t);

        return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
      }
    }]);

    return Ah;
  }(aa);

  Ah.prototype.isInstancedInterleavedBuffer = !0;

  var Rh = /*#__PURE__*/function () {
    function Rh(t, e, n, i, r) {
      _classCallCheck(this, Rh);

      this.buffer = t, this.type = e, this.itemSize = n, this.elementSize = i, this.count = r, this.version = 0;
    }

    _createClass(Rh, [{
      key: "needsUpdate",
      set: function set(t) {
        !0 === t && this.version++;
      }
    }, {
      key: "setBuffer",
      value: function setBuffer(t) {
        return this.buffer = t, this;
      }
    }, {
      key: "setType",
      value: function setType(t, e) {
        return this.type = t, this.elementSize = e, this;
      }
    }, {
      key: "setItemSize",
      value: function setItemSize(t) {
        return this.itemSize = t, this;
      }
    }, {
      key: "setCount",
      value: function setCount(t) {
        return this.count = t, this;
      }
    }]);

    return Rh;
  }();

  Rh.prototype.isGLBufferAttribute = !0;

  function Ch(t, e) {
    return t.distance - e.distance;
  }

  function Lh(t, e, n, i) {
    if (t.layers.test(e.layers) && t.raycast(e, n), !0 === i) {
      var _i202 = t.children;

      for (var _t302 = 0, _r154 = _i202.length; _t302 < _r154; _t302++) {
        Lh(_i202[_t302], e, n, !0);
      }
    }
  }

  var Ph = new At();

  var Dh = /*#__PURE__*/function () {
    function Dh() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new At(1 / 0, 1 / 0);
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new At(-1 / 0, -1 / 0);

      _classCallCheck(this, Dh);

      this.min = t, this.max = e;
    }

    _createClass(Dh, [{
      key: "set",
      value: function set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
      }
    }, {
      key: "setFromPoints",
      value: function setFromPoints(t) {
        this.makeEmpty();

        for (var _e278 = 0, _n267 = t.length; _e278 < _n267; _e278++) {
          this.expandByPoint(t[_e278]);
        }

        return this;
      }
    }, {
      key: "setFromCenterAndSize",
      value: function setFromCenterAndSize(t, e) {
        var n = Ph.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
      }
    }, {
      key: "makeEmpty",
      value: function makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
      }
    }, {
      key: "isEmpty",
      value: function isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
      }
    }, {
      key: "getCenter",
      value: function getCenter(t) {
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
      }
    }, {
      key: "getSize",
      value: function getSize(t) {
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
      }
    }, {
      key: "expandByPoint",
      value: function expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
      }
    }, {
      key: "expandByVector",
      value: function expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
      }
    }, {
      key: "expandByScalar",
      value: function expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
      }
    }, {
      key: "containsPoint",
      value: function containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y);
      }
    }, {
      key: "containsBox",
      value: function containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
      }
    }, {
      key: "getParameter",
      value: function getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
      }
    }, {
      key: "intersectsBox",
      value: function intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y);
      }
    }, {
      key: "clampPoint",
      value: function clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
      }
    }, {
      key: "distanceToPoint",
      value: function distanceToPoint(t) {
        return Ph.copy(t).clamp(this.min, this.max).sub(t).length();
      }
    }, {
      key: "intersect",
      value: function intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this;
      }
    }, {
      key: "union",
      value: function union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
      }
    }, {
      key: "translate",
      value: function translate(t) {
        return this.min.add(t), this.max.add(t), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
      }
    }]);

    return Dh;
  }();

  Dh.prototype.isBox2 = !0;
  var Ih = new te(),
      Nh = new te();

  var Bh = /*#__PURE__*/function () {
    function Bh() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te();

      _classCallCheck(this, Bh);

      this.start = t, this.end = e;
    }

    _createClass(Bh, [{
      key: "set",
      value: function set(t, e) {
        return this.start.copy(t), this.end.copy(e), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.start.copy(t.start), this.end.copy(t.end), this;
      }
    }, {
      key: "getCenter",
      value: function getCenter(t) {
        return t.addVectors(this.start, this.end).multiplyScalar(.5);
      }
    }, {
      key: "delta",
      value: function delta(t) {
        return t.subVectors(this.end, this.start);
      }
    }, {
      key: "distanceSq",
      value: function distanceSq() {
        return this.start.distanceToSquared(this.end);
      }
    }, {
      key: "distance",
      value: function distance() {
        return this.start.distanceTo(this.end);
      }
    }, {
      key: "at",
      value: function at(t, e) {
        return this.delta(e).multiplyScalar(t).add(this.start);
      }
    }, {
      key: "closestPointToPointParameter",
      value: function closestPointToPointParameter(t, e) {
        Ih.subVectors(t, this.start), Nh.subVectors(this.end, this.start);
        var n = Nh.dot(Nh);
        var i = Nh.dot(Ih) / n;
        return e && (i = _t(i, 0, 1)), i;
      }
    }, {
      key: "closestPointToPoint",
      value: function closestPointToPoint(t, e, n) {
        var i = this.closestPointToPointParameter(t, e);
        return this.delta(n).multiplyScalar(i).add(this.start);
      }
    }, {
      key: "applyMatrix4",
      value: function applyMatrix4(t) {
        return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
      }
    }, {
      key: "equals",
      value: function equals(t) {
        return t.start.equals(this.start) && t.end.equals(this.end);
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return Bh;
  }();

  var zh = new te();
  var Oh = new te(),
      Uh = new Pe(),
      Fh = new Pe();

  var Hh = /*#__PURE__*/function (_to) {
    _inherits(Hh, _to);

    var _super135 = _createSuper(Hh);

    function Hh(t) {
      var _this108;

      _classCallCheck(this, Hh);

      var e = Gh(t),
          n = new Un(),
          i = [],
          r = [],
          s = new Ft(0, 0, 1),
          a = new Ft(0, 1, 0);

      for (var _t303 = 0; _t303 < e.length; _t303++) {
        var _n268 = e[_t303];
        _n268.parent && _n268.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(s.r, s.g, s.b), r.push(a.r, a.g, a.b));
      }

      n.setAttribute("position", new Cn(i, 3)), n.setAttribute("color", new Cn(r, 3));
      _this108 = _super135.call(this, n, new ja({
        vertexColors: !0,
        depthTest: !1,
        depthWrite: !1,
        toneMapped: !1,
        transparent: !0
      })), _this108.type = "SkeletonHelper", _this108.isSkeletonHelper = !0, _this108.root = t, _this108.bones = e, _this108.matrix = t.matrixWorld, _this108.matrixAutoUpdate = !1;
      return _this108;
    }

    _createClass(Hh, [{
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        var e = this.bones,
            n = this.geometry,
            i = n.getAttribute("position");
        Fh.copy(this.root.matrixWorld).invert();

        for (var _t304 = 0, _n269 = 0; _t304 < e.length; _t304++) {
          var _r155 = e[_t304];
          _r155.parent && _r155.parent.isBone && (Uh.multiplyMatrices(Fh, _r155.matrixWorld), Oh.setFromMatrixPosition(Uh), i.setXYZ(_n269, Oh.x, Oh.y, Oh.z), Uh.multiplyMatrices(Fh, _r155.parent.matrixWorld), Oh.setFromMatrixPosition(Uh), i.setXYZ(_n269 + 1, Oh.x, Oh.y, Oh.z), _n269 += 2);
        }

        n.getAttribute("position").needsUpdate = !0, _get(_getPrototypeOf(Hh.prototype), "updateMatrixWorld", this).call(this, t);
      }
    }]);

    return Hh;
  }(to);

  function Gh(t) {
    var e = [];
    !0 === t.isBone && e.push(t);

    for (var _n270 = 0; _n270 < t.children.length; _n270++) {
      e.push.apply(e, Gh(t.children[_n270]));
    }

    return e;
  }

  var Vh = new te(),
      kh = new Ft(),
      Wh = new Ft();

  var jh = /*#__PURE__*/function (_to2) {
    _inherits(jh, _to2);

    var _super136 = _createSuper(jh);

    function jh() {
      var _this109;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4473924;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8947848;

      _classCallCheck(this, jh);

      n = new Ft(n), i = new Ft(i);
      var r = e / 2,
          s = t / e,
          a = t / 2,
          o = [],
          l = [];

      for (var _t305 = 0, _c31 = 0, _h23 = -a; _t305 <= e; _t305++, _h23 += s) {
        o.push(-a, 0, _h23, a, 0, _h23), o.push(_h23, 0, -a, _h23, 0, a);

        var _e279 = _t305 === r ? n : i;

        _e279.toArray(l, _c31), _c31 += 3, _e279.toArray(l, _c31), _c31 += 3, _e279.toArray(l, _c31), _c31 += 3, _e279.toArray(l, _c31), _c31 += 3;
      }

      var c = new Un();
      c.setAttribute("position", new Cn(o, 3)), c.setAttribute("color", new Cn(l, 3));
      _this109 = _super136.call(this, c, new ja({
        vertexColors: !0,
        toneMapped: !1
      })), _this109.type = "GridHelper";
      return _this109;
    }

    return _createClass(jh);
  }(to);

  var qh = new te(),
      Xh = new te(),
      Jh = new te();
  var Yh = new te(),
      Zh = new ci();

  function Kh(t, e, n, i, r, s, a) {
    Yh.set(r, s, a).unproject(i);
    var o = e[t];

    if (void 0 !== o) {
      var _t306 = n.getAttribute("position");

      for (var _e280 = 0, _n271 = o.length; _e280 < _n271; _e280++) {
        _t306.setXYZ(o[_e280], Yh.x, Yh.y, Yh.z);
      }
    }
  }

  var Qh = new ie();

  var $h = /*#__PURE__*/function (_to3) {
    _inherits($h, _to3);

    var _super137 = _createSuper($h);

    function $h(t) {
      var _this110;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16776960;

      _classCallCheck(this, $h);

      var n = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
          i = new Float32Array(24),
          r = new Un();
      r.setIndex(new _n(n, 1)), r.setAttribute("position", new _n(i, 3)), _this110 = _super137.call(this, r, new ja({
        color: e,
        toneMapped: !1
      })), _this110.object = t, _this110.type = "BoxHelper", _this110.matrixAutoUpdate = !1, _this110.update();
      return _this110;
    }

    _createClass($h, [{
      key: "update",
      value: function update(t) {
        if (void 0 !== t && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && Qh.setFromObject(this.object), Qh.isEmpty()) return;
        var e = Qh.min,
            n = Qh.max,
            i = this.geometry.attributes.position,
            r = i.array;
        r[0] = n.x, r[1] = n.y, r[2] = n.z, r[3] = e.x, r[4] = n.y, r[5] = n.z, r[6] = e.x, r[7] = e.y, r[8] = n.z, r[9] = n.x, r[10] = e.y, r[11] = n.z, r[12] = n.x, r[13] = n.y, r[14] = e.z, r[15] = e.x, r[16] = n.y, r[17] = e.z, r[18] = e.x, r[19] = e.y, r[20] = e.z, r[21] = n.x, r[22] = e.y, r[23] = e.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
      }
    }, {
      key: "setFromObject",
      value: function setFromObject(t) {
        return this.object = t, this.update(), this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return to.prototype.copy.call(this, t), this.object = t.object, this;
      }
    }]);

    return $h;
  }(to);

  var tu = new te();
  var eu, nu;

  var iu = /*#__PURE__*/function (_to4) {
    _inherits(iu, _to4);

    var _super138 = _createSuper(iu);

    function iu() {
      var _this111;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _classCallCheck(this, iu);

      var e = [0, 0, 0, t, 0, 0, 0, 0, 0, 0, t, 0, 0, 0, 0, 0, 0, t],
          n = new Un();
      n.setAttribute("position", new Cn(e, 3)), n.setAttribute("color", new Cn([1, 0, 0, 1, .6, 0, 0, 1, 0, .6, 1, 0, 0, 0, 1, 0, .6, 1], 3));
      _this111 = _super138.call(this, n, new ja({
        vertexColors: !0,
        toneMapped: !1
      })), _this111.type = "AxesHelper";
      return _this111;
    }

    _createClass(iu, [{
      key: "setColors",
      value: function setColors(t, e, n) {
        var i = new Ft(),
            r = this.geometry.attributes.color.array;
        return i.set(t), i.toArray(r, 0), i.toArray(r, 3), i.set(e), i.toArray(r, 6), i.toArray(r, 9), i.set(n), i.toArray(r, 12), i.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.geometry.dispose(), this.material.dispose();
      }
    }]);

    return iu;
  }(to);

  var ru = new Float32Array(1),
      su = new Int32Array(ru.buffer);
  So.create = function (t, e) {
    return console.log("THREE.Curve.create() has been deprecated"), t.prototype = Object.create(So.prototype), t.prototype.constructor = t, t.prototype.getPoint = e, t;
  }, jo.prototype.fromPoints = function (t) {
    return console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints()."), this.setFromPoints(t);
  }, jh.prototype.setColors = function () {
    console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
  }, Hh.prototype.update = function () {
    console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
  }, uc.prototype.extractUrlBase = function (t) {
    return console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead."), Uc.extractUrlBase(t);
  }, uc.Handlers = {
    add: function add() {
      console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
    },
    get: function get() {
      console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
    }
  }, Dh.prototype.center = function (t) {
    return console.warn("THREE.Box2: .center() has been renamed to .getCenter()."), this.getCenter(t);
  }, Dh.prototype.empty = function () {
    return console.warn("THREE.Box2: .empty() has been renamed to .isEmpty()."), this.isEmpty();
  }, Dh.prototype.isIntersectionBox = function (t) {
    return console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
  }, Dh.prototype.size = function (t) {
    return console.warn("THREE.Box2: .size() has been renamed to .getSize()."), this.getSize(t);
  }, ie.prototype.center = function (t) {
    return console.warn("THREE.Box3: .center() has been renamed to .getCenter()."), this.getCenter(t);
  }, ie.prototype.empty = function () {
    return console.warn("THREE.Box3: .empty() has been renamed to .isEmpty()."), this.isEmpty();
  }, ie.prototype.isIntersectionBox = function (t) {
    return console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
  }, ie.prototype.isIntersectionSphere = function (t) {
    return console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t);
  }, ie.prototype.size = function (t) {
    return console.warn("THREE.Box3: .size() has been renamed to .getSize()."), this.getSize(t);
  }, Ge.prototype.toVector3 = function () {
    console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
  }, be.prototype.empty = function () {
    return console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty()."), this.isEmpty();
  }, Mi.prototype.setFromMatrix = function (t) {
    return console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix()."), this.setFromProjectionMatrix(t);
  }, Bh.prototype.center = function (t) {
    return console.warn("THREE.Line3: .center() has been renamed to .getCenter()."), this.getCenter(t);
  }, Rt.prototype.flattenToArrayOffset = function (t, e) {
    return console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t, e);
  }, Rt.prototype.multiplyVector3 = function (t) {
    return console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."), t.applyMatrix3(this);
  }, Rt.prototype.multiplyVector3Array = function () {
    console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
  }, Rt.prototype.applyToBufferAttribute = function (t) {
    return console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead."), t.applyMatrix3(this);
  }, Rt.prototype.applyToVector3Array = function () {
    console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
  }, Rt.prototype.getInverse = function (t) {
    return console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t).invert();
  }, Pe.prototype.extractPosition = function (t) {
    return console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."), this.copyPosition(t);
  }, Pe.prototype.flattenToArrayOffset = function (t, e) {
    return console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t, e);
  }, Pe.prototype.getPosition = function () {
    return console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."), new te().setFromMatrixColumn(this, 3);
  }, Pe.prototype.setRotationFromQuaternion = function (t) {
    return console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."), this.makeRotationFromQuaternion(t);
  }, Pe.prototype.multiplyToArray = function () {
    console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
  }, Pe.prototype.multiplyVector3 = function (t) {
    return console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
  }, Pe.prototype.multiplyVector4 = function (t) {
    return console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
  }, Pe.prototype.multiplyVector3Array = function () {
    console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
  }, Pe.prototype.rotateAxis = function (t) {
    console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."), t.transformDirection(this);
  }, Pe.prototype.crossVector = function (t) {
    return console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
  }, Pe.prototype.translate = function () {
    console.error("THREE.Matrix4: .translate() has been removed.");
  }, Pe.prototype.rotateX = function () {
    console.error("THREE.Matrix4: .rotateX() has been removed.");
  }, Pe.prototype.rotateY = function () {
    console.error("THREE.Matrix4: .rotateY() has been removed.");
  }, Pe.prototype.rotateZ = function () {
    console.error("THREE.Matrix4: .rotateZ() has been removed.");
  }, Pe.prototype.rotateByAxis = function () {
    console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
  }, Pe.prototype.applyToBufferAttribute = function (t) {
    return console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
  }, Pe.prototype.applyToVector3Array = function () {
    console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
  }, Pe.prototype.makeFrustum = function (t, e, n, i, r, s) {
    return console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."), this.makePerspective(t, e, i, n, r, s);
  }, Pe.prototype.getInverse = function (t) {
    return console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t).invert();
  }, yi.prototype.isIntersectionLine = function (t) {
    return console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."), this.intersectsLine(t);
  }, $t.prototype.multiplyVector3 = function (t) {
    return console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."), t.applyQuaternion(this);
  }, $t.prototype.inverse = function () {
    return console.warn("THREE.Quaternion: .inverse() has been renamed to invert()."), this.invert();
  }, Le.prototype.isIntersectionBox = function (t) {
    return console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
  }, Le.prototype.isIntersectionPlane = function (t) {
    return console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."), this.intersectsPlane(t);
  }, Le.prototype.isIntersectionSphere = function (t) {
    return console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t);
  }, mn.prototype.area = function () {
    return console.warn("THREE.Triangle: .area() has been renamed to .getArea()."), this.getArea();
  }, mn.prototype.barycoordFromPoint = function (t, e) {
    return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), this.getBarycoord(t, e);
  }, mn.prototype.midpoint = function (t) {
    return console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint()."), this.getMidpoint(t);
  }, mn.prototypenormal = function (t) {
    return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), this.getNormal(t);
  }, mn.prototype.plane = function (t) {
    return console.warn("THREE.Triangle: .plane() has been renamed to .getPlane()."), this.getPlane(t);
  }, mn.barycoordFromPoint = function (t, e, n, i, r) {
    return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), mn.getBarycoord(t, e, n, i, r);
  }, mn.normal = function (t, e, n, i) {
    return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), mn.getNormal(t, e, n, i);
  }, qo.prototype.extractAllPoints = function (t) {
    return console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead."), this.extractPoints(t);
  }, qo.prototype.extrude = function (t) {
    return console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."), new Ml(this, t);
  }, qo.prototype.makeGeometry = function (t) {
    return console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."), new Al(this, t);
  }, At.prototype.fromAttribute = function (t, e, n) {
    return console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
  }, At.prototype.distanceToManhattan = function (t) {
    return console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t);
  }, At.prototype.lengthManhattan = function () {
    return console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
  }, te.prototype.setEulerFromRotationMatrix = function () {
    console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
  }, te.prototype.setEulerFromQuaternion = function () {
    console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
  }, te.prototype.getPositionFromMatrix = function (t) {
    return console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."), this.setFromMatrixPosition(t);
  }, te.prototype.getScaleFromMatrix = function (t) {
    return console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."), this.setFromMatrixScale(t);
  }, te.prototype.getColumnFromMatrix = function (t, e) {
    return console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."), this.setFromMatrixColumn(e, t);
  }, te.prototype.applyProjection = function (t) {
    return console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."), this.applyMatrix4(t);
  }, te.prototype.fromAttribute = function (t, e, n) {
    return console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
  }, te.prototype.distanceToManhattan = function (t) {
    return console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t);
  }, te.prototype.lengthManhattan = function () {
    return console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
  }, qt.prototype.fromAttribute = function (t, e, n) {
    return console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
  }, qt.prototype.lengthManhattan = function () {
    return console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
  }, nn.prototype.getChildByName = function (t) {
    return console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."), this.getObjectByName(t);
  }, nn.prototype.renderDepth = function () {
    console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
  }, nn.prototype.translate = function (t, e) {
    return console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."), this.translateOnAxis(e, t);
  }, nn.prototype.getWorldRotation = function () {
    console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
  }, nn.prototype.applyMatrix = function (t) {
    return console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
  }, Object.defineProperties(nn.prototype, {
    eulerOrder: {
      get: function get() {
        return console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order;
      },
      set: function set(t) {
        console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order = t;
      }
    },
    useQuaternion: {
      get: function get() {
        console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
      },
      set: function set() {
        console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
      }
    }
  }), ni.prototype.setDrawMode = function () {
    console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
  }, Object.defineProperties(ni.prototype, {
    drawMode: {
      get: function get() {
        return console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode."), 0;
      },
      set: function set() {
        console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
      }
    }
  }), Ia.prototype.initBones = function () {
    console.error("THREE.SkinnedMesh: initBones() has been removed.");
  }, hi.prototype.setLens = function (t, e) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."), void 0 !== e && (this.filmGauge = e), this.setFocalLength(t);
  }, Object.defineProperties(yc.prototype, {
    onlyShadow: {
      set: function set() {
        console.warn("THREE.Light: .onlyShadow has been removed.");
      }
    },
    shadowCameraFov: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov."), this.shadow.camera.fov = t;
      }
    },
    shadowCameraLeft: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left."), this.shadow.camera.left = t;
      }
    },
    shadowCameraRight: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right."), this.shadow.camera.right = t;
      }
    },
    shadowCameraTop: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top."), this.shadow.camera.top = t;
      }
    },
    shadowCameraBottom: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."), this.shadow.camera.bottom = t;
      }
    },
    shadowCameraNear: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near."), this.shadow.camera.near = t;
      }
    },
    shadowCameraFar: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far."), this.shadow.camera.far = t;
      }
    },
    shadowCameraVisible: {
      set: function set() {
        console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
      }
    },
    shadowBias: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowBias is now .shadow.bias."), this.shadow.bias = t;
      }
    },
    shadowDarkness: {
      set: function set() {
        console.warn("THREE.Light: .shadowDarkness has been removed.");
      }
    },
    shadowMapWidth: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."), this.shadow.mapSize.width = t;
      }
    },
    shadowMapHeight: {
      set: function set(t) {
        console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."), this.shadow.mapSize.height = t;
      }
    }
  }), Object.defineProperties(_n.prototype, {
    length: {
      get: function get() {
        return console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead."), this.array.length;
      }
    },
    dynamic: {
      get: function get() {
        return console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), this.usage === ut;
      },
      set: function set() {
        console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), this.setUsage(ut);
      }
    }
  }), _n.prototype.setDynamic = function (t) {
    return console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t ? ut : ht), this;
  }, _n.prototype.copyIndicesArray = function () {
    console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
  }, _n.prototype.setArray = function () {
    console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
  }, Un.prototype.addIndex = function (t) {
    console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."), this.setIndex(t);
  }, Un.prototype.addAttribute = function (t, e) {
    return console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute()."), e && e.isBufferAttribute || e && e.isInterleavedBufferAttribute ? "index" === t ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), this.setIndex(e), this) : this.setAttribute(t, e) : (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), this.setAttribute(t, new _n(arguments[1], arguments[2])));
  }, Un.prototype.addDrawCall = function (t, e, n) {
    void 0 !== n && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."), console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup()."), this.addGroup(t, e);
  }, Un.prototype.clearDrawCalls = function () {
    console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."), this.clearGroups();
  }, Un.prototype.computeOffsets = function () {
    console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
  }, Un.prototype.removeAttribute = function (t) {
    return console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute()."), this.deleteAttribute(t);
  }, Un.prototype.applyMatrix = function (t) {
    return console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
  }, Object.defineProperties(Un.prototype, {
    drawcalls: {
      get: function get() {
        return console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups."), this.groups;
      }
    },
    offsets: {
      get: function get() {
        return console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups."), this.groups;
      }
    }
  }), aa.prototype.setDynamic = function (t) {
    return console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t ? ut : ht), this;
  }, aa.prototype.setArray = function () {
    console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
  }, Ml.prototype.getArrays = function () {
    console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
  }, Ml.prototype.addShapeList = function () {
    console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
  }, Ml.prototype.addShape = function () {
    console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
  }, sa.prototype.dispose = function () {
    console.error("THREE.Scene: .dispose() has been removed.");
  }, Eh.prototype.onUpdate = function () {
    return console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead."), this;
  }, Object.defineProperties(gn.prototype, {
    wrapAround: {
      get: function get() {
        console.warn("THREE.Material: .wrapAround has been removed.");
      },
      set: function set() {
        console.warn("THREE.Material: .wrapAround has been removed.");
      }
    },
    overdraw: {
      get: function get() {
        console.warn("THREE.Material: .overdraw has been removed.");
      },
      set: function set() {
        console.warn("THREE.Material: .overdraw has been removed.");
      }
    },
    wrapRGB: {
      get: function get() {
        return console.warn("THREE.Material: .wrapRGB has been removed."), new Ft();
      }
    },
    shading: {
      get: function get() {
        console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
      },
      set: function set(t) {
        console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === t;
      }
    },
    stencilMask: {
      get: function get() {
        return console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask;
      },
      set: function set(t) {
        console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask = t;
      }
    },
    vertexTangents: {
      get: function get() {
        console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
      },
      set: function set() {
        console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
      }
    }
  }), Object.defineProperties(li.prototype, {
    derivatives: {
      get: function get() {
        return console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives;
      },
      set: function set(t) {
        console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives = t;
      }
    }
  }), ea.prototype.clearTarget = function (t, e, n, i) {
    console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead."), this.setRenderTarget(t), this.clear(e, n, i);
  }, ea.prototype.animate = function (t) {
    console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop()."), this.setAnimationLoop(t);
  }, ea.prototype.getCurrentRenderTarget = function () {
    return console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."), this.getRenderTarget();
  }, ea.prototype.getMaxAnisotropy = function () {
    return console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy()."), this.capabilities.getMaxAnisotropy();
  }, ea.prototype.getPrecision = function () {
    return console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision."), this.capabilities.precision;
  }, ea.prototype.resetGLState = function () {
    return console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset()."), this.state.reset();
  }, ea.prototype.supportsFloatTextures = function () {
    return console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."), this.extensions.get("OES_texture_float");
  }, ea.prototype.supportsHalfFloatTextures = function () {
    return console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."), this.extensions.get("OES_texture_half_float");
  }, ea.prototype.supportsStandardDerivatives = function () {
    return console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."), this.extensions.get("OES_standard_derivatives");
  }, ea.prototype.supportsCompressedTextureS3TC = function () {
    return console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."), this.extensions.get("WEBGL_compressed_texture_s3tc");
  }, ea.prototype.supportsCompressedTexturePVRTC = function () {
    return console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."), this.extensions.get("WEBGL_compressed_texture_pvrtc");
  }, ea.prototype.supportsBlendMinMax = function () {
    return console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."), this.extensions.get("EXT_blend_minmax");
  }, ea.prototype.supportsVertexTextures = function () {
    return console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."), this.capabilities.vertexTextures;
  }, ea.prototype.supportsInstancedArrays = function () {
    return console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."), this.extensions.get("ANGLE_instanced_arrays");
  }, ea.prototype.enableScissorTest = function (t) {
    console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."), this.setScissorTest(t);
  }, ea.prototype.initMaterial = function () {
    console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
  }, ea.prototype.addPrePlugin = function () {
    console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
  }, ea.prototype.addPostPlugin = function () {
    console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
  }, ea.prototype.updateShadowMap = function () {
    console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
  }, ea.prototype.setFaceCulling = function () {
    console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
  }, ea.prototype.allocTextureUnit = function () {
    console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
  }, ea.prototype.setTexture = function () {
    console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
  }, ea.prototype.setTexture2D = function () {
    console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
  }, ea.prototype.setTextureCube = function () {
    console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
  }, ea.prototype.getActiveMipMapLevel = function () {
    return console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel()."), this.getActiveMipmapLevel();
  }, Object.defineProperties(ea.prototype, {
    shadowMapEnabled: {
      get: function get() {
        return this.shadowMap.enabled;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."), this.shadowMap.enabled = t;
      }
    },
    shadowMapType: {
      get: function get() {
        return this.shadowMap.type;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."), this.shadowMap.type = t;
      }
    },
    shadowMapCullFace: {
      get: function get() {
        console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
      }
    },
    context: {
      get: function get() {
        return console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead."), this.getContext();
      }
    },
    vr: {
      get: function get() {
        return console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr"), this.xr;
      }
    },
    gammaInput: {
      get: function get() {
        return console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead."), !1;
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
      }
    },
    gammaOutput: {
      get: function get() {
        return console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), !1;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), this.outputEncoding = !0 === t ? lt : ot;
      }
    },
    toneMappingWhitePoint: {
      get: function get() {
        return console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed."), 1;
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
      }
    },
    gammaFactor: {
      get: function get() {
        return console.warn("THREE.WebGLRenderer: .gammaFactor has been removed."), 2;
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
      }
    }
  }), Object.defineProperties(Ws.prototype, {
    cullFace: {
      get: function get() {
        console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
      }
    },
    renderReverseSided: {
      get: function get() {
        console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
      }
    },
    renderSingleSided: {
      get: function get() {
        console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
      },
      set: function set() {
        console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
      }
    }
  }), Object.defineProperties(Xt.prototype, {
    wrapS: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS = t;
      }
    },
    wrapT: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT = t;
      }
    },
    magFilter: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter = t;
      }
    },
    minFilter: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter = t;
      }
    },
    anisotropy: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy = t;
      }
    },
    offset: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset = t;
      }
    },
    repeat: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat = t;
      }
    },
    format: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format = t;
      }
    },
    type: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type = t;
      }
    },
    generateMipmaps: {
      get: function get() {
        return console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps;
      },
      set: function set(t) {
        console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps = t;
      }
    }
  }), sh.prototype.load = function (t) {
    console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
    var e = this;
    return new Xc().load(t, function (t) {
      e.setBuffer(t);
    }), this;
  }, hh.prototype.getData = function () {
    return console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData()."), this.getFrequencyData();
  }, di.prototype.updateCubeMap = function (t, e) {
    return console.warn("THREE.CubeCamera: .updateCubeMap() is now .update()."), this.update(t, e);
  }, di.prototype.clear = function (t, e, n, i) {
    return console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear()."), this.renderTarget.clear(t, e, n, i);
  }, Gt.crossOrigin = void 0, Gt.loadTexture = function (t, e, n, i) {
    console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
    var r = new vc();
    r.setCrossOrigin(this.crossOrigin);
    var s = r.load(t, n, void 0, i);
    return e && (s.mapping = e), s;
  }, Gt.loadTextureCube = function (t, e, n, i) {
    console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
    var r = new fc();
    r.setCrossOrigin(this.crossOrigin);
    var s = r.load(t, n, void 0, i);
    return e && (s.mapping = e), s;
  }, Gt.loadCompressedTexture = function () {
    console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
  }, Gt.loadCompressedTextureCube = function () {
    console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
  };
  var au = {
    createMultiMaterialObject: function createMultiMaterialObject() {
      console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    detach: function detach() {
      console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    },
    attach: function attach() {
      console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
    }
  };
  "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
      revision: e
    }
  })), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = e), t.ACESFilmicToneMapping = 4, t.AddEquation = n, t.AddOperation = 2, t.AdditiveAnimationBlendMode = at, t.AdditiveBlending = 2, t.AlphaFormat = 1021, t.AlwaysDepth = 1, t.AlwaysStencilFunc = 519, t.AmbientLight = Ic, t.AmbientLightProbe = Yc, t.AnimationClip = ac, t.AnimationLoader = /*#__PURE__*/function (_uc10) {
    _inherits(_class2, _uc10);

    var _super139 = _createSuper(_class2);

    function _class2(t) {
      _classCallCheck(this, _class2);

      return _super139.call(this, t);
    }

    _createClass(_class2, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = new pc(this.manager);
        s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, function (n) {
          try {
            e(r.parse(JSON.parse(n)));
          } catch (e) {
            i ? i(e) : console.error(e), r.manager.itemError(t);
          }
        }, n, i);
      }
    }, {
      key: "parse",
      value: function parse(t) {
        var e = [];

        for (var _n272 = 0; _n272 < t.length; _n272++) {
          var _i203 = ac.parse(t[_n272]);

          e.push(_i203);
        }

        return e;
      }
    }]);

    return _class2;
  }(uc), t.AnimationMixer = Th, t.AnimationObjectGroup = wh, t.AnimationUtils = Xl, t.ArcCurve = Eo, t.ArrayCamera = Js, t.ArrowHelper = /*#__PURE__*/function (_nn13) {
    _inherits(_class3, _nn13);

    var _super140 = _createSuper(_class3);

    function _class3() {
      var _this112;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new te(0, 0, 1);
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new te(0, 0, 0);
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 16776960;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : .2 * n;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : .2 * r;

      _classCallCheck(this, _class3);

      _this112 = _super140.call(this), _this112.type = "ArrowHelper", void 0 === eu && (eu = new Un(), eu.setAttribute("position", new Cn([0, 0, 0, 0, 1, 0], 3)), nu = new fo(0, .5, 1, 5, 1), nu.translate(0, -.5, 0)), _this112.position.copy(e), _this112.line = new Ka(eu, new ja({
        color: i,
        toneMapped: !1
      })), _this112.line.matrixAutoUpdate = !1, _this112.add(_this112.line), _this112.cone = new ni(nu, new vn({
        color: i,
        toneMapped: !1
      })), _this112.cone.matrixAutoUpdate = !1, _this112.add(_this112.cone), _this112.setDirection(t), _this112.setLength(n, r, s);
      return _this112;
    }

    _createClass(_class3, [{
      key: "setDirection",
      value: function setDirection(t) {
        if (t.y > .99999) this.quaternion.set(0, 0, 0, 1);else if (t.y < -.99999) this.quaternion.set(1, 0, 0, 0);else {
          tu.set(t.z, 0, -t.x).normalize();

          var _e281 = Math.acos(t.y);

          this.quaternion.setFromAxisAngle(tu, _e281);
        }
      }
    }, {
      key: "setLength",
      value: function setLength(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .2 * t;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .2 * e;
        this.line.scale.set(1, Math.max(1e-4, t - e), 1), this.line.updateMatrix(), this.cone.scale.set(n, e, n), this.cone.position.y = t, this.cone.updateMatrix();
      }
    }, {
      key: "setColor",
      value: function setColor(t) {
        this.line.material.color.set(t), this.cone.material.color.set(t);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(_class3.prototype), "copy", this).call(this, t, !1), this.line.copy(t.line), this.cone.copy(t.cone), this;
      }
    }]);

    return _class3;
  }(nn), t.Audio = sh, t.AudioAnalyser = hh, t.AudioContext = qc, t.AudioListener = /*#__PURE__*/function (_nn14) {
    _inherits(_class4, _nn14);

    var _super141 = _createSuper(_class4);

    function _class4() {
      var _this113;

      _classCallCheck(this, _class4);

      _this113 = _super141.call(this), _this113.type = "AudioListener", _this113.context = qc.getContext(), _this113.gain = _this113.context.createGain(), _this113.gain.connect(_this113.context.destination), _this113.filter = null, _this113.timeDelta = 0, _this113._clock = new $c();
      return _this113;
    }

    _createClass(_class4, [{
      key: "getInput",
      value: function getInput() {
        return this.gain;
      }
    }, {
      key: "removeFilter",
      value: function removeFilter() {
        return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
      }
    }, {
      key: "getFilter",
      value: function getFilter() {
        return this.filter;
      }
    }, {
      key: "setFilter",
      value: function setFilter(t) {
        return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = t, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
      }
    }, {
      key: "getMasterVolume",
      value: function getMasterVolume() {
        return this.gain.gain.value;
      }
    }, {
      key: "setMasterVolume",
      value: function setMasterVolume(t) {
        return this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01), this;
      }
    }, {
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        _get(_getPrototypeOf(_class4.prototype), "updateMatrixWorld", this).call(this, t);

        var e = this.context.listener,
            n = this.up;

        if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose(eh, nh, ih), rh.set(0, 0, -1).applyQuaternion(nh), e.positionX) {
          var _t307 = this.context.currentTime + this.timeDelta;

          e.positionX.linearRampToValueAtTime(eh.x, _t307), e.positionY.linearRampToValueAtTime(eh.y, _t307), e.positionZ.linearRampToValueAtTime(eh.z, _t307), e.forwardX.linearRampToValueAtTime(rh.x, _t307), e.forwardY.linearRampToValueAtTime(rh.y, _t307), e.forwardZ.linearRampToValueAtTime(rh.z, _t307), e.upX.linearRampToValueAtTime(n.x, _t307), e.upY.linearRampToValueAtTime(n.y, _t307), e.upZ.linearRampToValueAtTime(n.z, _t307);
        } else e.setPosition(eh.x, eh.y, eh.z), e.setOrientation(rh.x, rh.y, rh.z, n.x, n.y, n.z);
      }
    }]);

    return _class4;
  }(nn), t.AudioLoader = Xc, t.AxesHelper = iu, t.AxisHelper = function (t) {
    return console.warn("THREE.AxisHelper has been renamed to THREE.AxesHelper."), new iu(t);
  }, t.BackSide = 1, t.BasicDepthPacking = 3200, t.BasicShadowMap = 0, t.BinaryTextureLoader = function (t) {
    return console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader."), new gc(t);
  }, t.Bone = Na, t.BooleanKeyframeTrack = $l, t.BoundingBoxHelper = function (t, e) {
    return console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead."), new $h(t, e);
  }, t.Box2 = Dh, t.Box3 = ie, t.Box3Helper = /*#__PURE__*/function (_to5) {
    _inherits(_class5, _to5);

    var _super142 = _createSuper(_class5);

    function _class5(t) {
      var _this114;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16776960;

      _classCallCheck(this, _class5);

      var n = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
          i = new Un();
      i.setIndex(new _n(n, 1)), i.setAttribute("position", new Cn([1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1], 3)), _this114 = _super142.call(this, i, new ja({
        color: e,
        toneMapped: !1
      })), _this114.box = t, _this114.type = "Box3Helper", _this114.geometry.computeBoundingSphere();
      return _this114;
    }

    _createClass(_class5, [{
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        var e = this.box;
        e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), _get(_getPrototypeOf(_class5.prototype), "updateMatrixWorld", this).call(this, t));
      }
    }]);

    return _class5;
  }(to), t.BoxBufferGeometry = ri, t.BoxGeometry = ri, t.BoxHelper = $h, t.BufferAttribute = _n, t.BufferGeometry = Un, t.BufferGeometryLoader = Hc, t.ByteType = 1010, t.Cache = lc, t.Camera = ci, t.CameraHelper = /*#__PURE__*/function (_to6) {
    _inherits(_class6, _to6);

    var _super143 = _createSuper(_class6);

    function _class6(t) {
      var _this115;

      _classCallCheck(this, _class6);

      var e = new Un(),
          n = new ja({
        color: 16777215,
        vertexColors: !0,
        toneMapped: !1
      }),
          i = [],
          r = [],
          s = {},
          a = new Ft(16755200),
          o = new Ft(16711680),
          l = new Ft(43775),
          c = new Ft(16777215),
          h = new Ft(3355443);

      function u(t, e, n) {
        d(t, n), d(e, n);
      }

      function d(t, e) {
        i.push(0, 0, 0), r.push(e.r, e.g, e.b), void 0 === s[t] && (s[t] = []), s[t].push(i.length / 3 - 1);
      }

      u("n1", "n2", a), u("n2", "n4", a), u("n4", "n3", a), u("n3", "n1", a), u("f1", "f2", a), u("f2", "f4", a), u("f4", "f3", a), u("f3", "f1", a), u("n1", "f1", a), u("n2", "f2", a), u("n3", "f3", a), u("n4", "f4", a), u("p", "n1", o), u("p", "n2", o), u("p", "n3", o), u("p", "n4", o), u("u1", "u2", l), u("u2", "u3", l), u("u3", "u1", l), u("c", "t", c), u("p", "c", h), u("cn1", "cn2", h), u("cn3", "cn4", h), u("cf1", "cf2", h), u("cf3", "cf4", h), e.setAttribute("position", new Cn(i, 3)), e.setAttribute("color", new Cn(r, 3)), _this115 = _super143.call(this, e, n), _this115.type = "CameraHelper", _this115.camera = t, _this115.camera.updateProjectionMatrix && _this115.camera.updateProjectionMatrix(), _this115.matrix = t.matrixWorld, _this115.matrixAutoUpdate = !1, _this115.pointMap = s, _this115.update();
      return _this115;
    }

    _createClass(_class6, [{
      key: "update",
      value: function update() {
        var t = this.geometry,
            e = this.pointMap;
        Zh.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), Kh("c", e, t, Zh, 0, 0, -1), Kh("t", e, t, Zh, 0, 0, 1), Kh("n1", e, t, Zh, -1, -1, -1), Kh("n2", e, t, Zh, 1, -1, -1), Kh("n3", e, t, Zh, -1, 1, -1), Kh("n4", e, t, Zh, 1, 1, -1), Kh("f1", e, t, Zh, -1, -1, 1), Kh("f2", e, t, Zh, 1, -1, 1), Kh("f3", e, t, Zh, -1, 1, 1), Kh("f4", e, t, Zh, 1, 1, 1), Kh("u1", e, t, Zh, .7, 1.1, -1), Kh("u2", e, t, Zh, -.7, 1.1, -1), Kh("u3", e, t, Zh, 0, 2, -1), Kh("cf1", e, t, Zh, -1, 0, 1), Kh("cf2", e, t, Zh, 1, 0, 1), Kh("cf3", e, t, Zh, 0, -1, 1), Kh("cf4", e, t, Zh, 0, 1, 1), Kh("cn1", e, t, Zh, -1, 0, -1), Kh("cn2", e, t, Zh, 1, 0, -1), Kh("cn3", e, t, Zh, 0, -1, -1), Kh("cn4", e, t, Zh, 0, 1, -1), t.getAttribute("position").needsUpdate = !0;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.geometry.dispose(), this.material.dispose();
      }
    }]);

    return _class6;
  }(to), t.CanvasRenderer = function () {
    console.error("THREE.CanvasRenderer has been removed");
  }, t.CanvasTexture = po, t.CatmullRomCurve3 = Do, t.CineonToneMapping = 3, t.CircleBufferGeometry = mo, t.CircleGeometry = mo, t.ClampToEdgeWrapping = u, t.Clock = $c, t.Color = Ft, t.ColorKeyframeTrack = tc, t.CompressedTexture = uo, t.CompressedTextureLoader = /*#__PURE__*/function (_uc11) {
    _inherits(_class7, _uc11);

    var _super144 = _createSuper(_class7);

    function _class7(t) {
      _classCallCheck(this, _class7);

      return _super144.call(this, t);
    }

    _createClass(_class7, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = [],
            a = new uo(),
            o = new pc(this.manager);
        o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
        var l = 0;

        function c(c) {
          o.load(t[c], function (t) {
            var n = r.parse(t, !0);
            s[c] = {
              width: n.width,
              height: n.height,
              format: n.format,
              mipmaps: n.mipmaps
            }, l += 1, 6 === l && (1 === n.mipmapCount && (a.minFilter = g), a.image = s, a.format = n.format, a.needsUpdate = !0, e && e(a));
          }, n, i);
        }

        if (Array.isArray(t)) for (var _e282 = 0, _n273 = t.length; _e282 < _n273; ++_e282) {
          c(_e282);
        } else o.load(t, function (t) {
          var n = r.parse(t, !0);

          if (n.isCubemap) {
            var _t308 = n.mipmaps.length / n.mipmapCount;

            for (var _e283 = 0; _e283 < _t308; _e283++) {
              s[_e283] = {
                mipmaps: []
              };

              for (var _t309 = 0; _t309 < n.mipmapCount; _t309++) {
                s[_e283].mipmaps.push(n.mipmaps[_e283 * n.mipmapCount + _t309]), s[_e283].format = n.format, s[_e283].width = n.width, s[_e283].height = n.height;
              }
            }

            a.image = s;
          } else a.image.width = n.width, a.image.height = n.height, a.mipmaps = n.mipmaps;

          1 === n.mipmapCount && (a.minFilter = g), a.format = n.format, a.needsUpdate = !0, e && e(a);
        }, n, i);
        return a;
      }
    }]);

    return _class7;
  }(uc), t.ConeBufferGeometry = go, t.ConeGeometry = go, t.CubeCamera = di, t.CubeReflectionMapping = r, t.CubeRefractionMapping = s, t.CubeTexture = pi, t.CubeTextureLoader = fc, t.CubeUVReflectionMapping = l, t.CubeUVRefractionMapping = c, t.CubicBezierCurve = zo, t.CubicBezierCurve3 = Oo, t.CubicInterpolant = Yl, t.CullFaceBack = 1, t.CullFaceFront = 2, t.CullFaceFrontBack = 3, t.CullFaceNone = 0, t.Curve = So, t.CurvePath = Wo, t.CustomBlending = 5, t.CustomToneMapping = 5, t.CylinderBufferGeometry = fo, t.CylinderGeometry = fo, t.Cylindrical = /*#__PURE__*/function () {
    function _class8() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      _classCallCheck(this, _class8);

      return this.radius = t, this.theta = e, this.y = n, this;
    }

    _createClass(_class8, [{
      key: "set",
      value: function set(t, e, n) {
        return this.radius = t, this.theta = e, this.y = n, this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.radius = t.radius, this.theta = t.theta, this.y = t.y, this;
      }
    }, {
      key: "setFromVector3",
      value: function setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
      }
    }, {
      key: "setFromCartesianCoords",
      value: function setFromCartesianCoords(t, e, n) {
        return this.radius = Math.sqrt(t * t + n * n), this.theta = Math.atan2(t, n), this.y = e, this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return _class8;
  }(), t.Data3DTexture = Zt, t.DataArrayTexture = Jt, t.DataTexture = Ba, t.DataTexture2DArray = function (t, e, n, i) {
    return console.warn("THREE.DataTexture2DArray has been renamed to DataArrayTexture."), new Jt(t, e, n, i);
  }, t.DataTexture3D = function (t, e, n, i) {
    return console.warn("THREE.DataTexture3D has been renamed to Data3DTexture."), new Zt(t, e, n, i);
  }, t.DataTextureLoader = gc, t.DataUtils = /*#__PURE__*/function () {
    function _class9() {
      _classCallCheck(this, _class9);
    }

    _createClass(_class9, null, [{
      key: "toHalfFloat",
      value: function toHalfFloat(t) {
        t > 65504 && (console.warn("THREE.DataUtils.toHalfFloat(): value exceeds 65504."), t = 65504), ru[0] = t;
        var e = su[0];
        var n = e >> 16 & 32768,
            i = e >> 12 & 2047;
        var r = e >> 23 & 255;
        return r < 103 ? n : r > 142 ? (n |= 31744, n |= (255 == r ? 0 : 1) && 8388607 & e, n) : r < 113 ? (i |= 2048, n |= (i >> 114 - r) + (i >> 113 - r & 1), n) : (n |= r - 112 << 10 | i >> 1, n += 1 & i, n);
      }
    }]);

    return _class9;
  }(), t.DecrementStencilOp = 7683, t.DecrementWrapStencilOp = 34056, t.DefaultLoadingManager = hc, t.DepthFormat = E, t.DepthStencilFormat = A, t.DepthTexture = Qs, t.DirectionalLight = Dc, t.DirectionalLightHelper = /*#__PURE__*/function (_nn15) {
    _inherits(_class10, _nn15);

    var _super145 = _createSuper(_class10);

    function _class10(t, e, n) {
      var _this116;

      _classCallCheck(this, _class10);

      _this116 = _super145.call(this), _this116.light = t, _this116.light.updateMatrixWorld(), _this116.matrix = t.matrixWorld, _this116.matrixAutoUpdate = !1, _this116.color = n, void 0 === e && (e = 1);
      var i = new Un();
      i.setAttribute("position", new Cn([-e, e, 0, e, e, 0, e, -e, 0, -e, -e, 0, -e, e, 0], 3));
      var r = new ja({
        fog: !1,
        toneMapped: !1
      });
      _this116.lightPlane = new Ka(i, r), _this116.add(_this116.lightPlane), i = new Un(), i.setAttribute("position", new Cn([0, 0, 0, 0, 0, 1], 3)), _this116.targetLine = new Ka(i, r), _this116.add(_this116.targetLine), _this116.update();
      return _this116;
    }

    _createClass(_class10, [{
      key: "dispose",
      value: function dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
      }
    }, {
      key: "update",
      value: function update() {
        qh.setFromMatrixPosition(this.light.matrixWorld), Xh.setFromMatrixPosition(this.light.target.matrixWorld), Jh.subVectors(Xh, qh), this.lightPlane.lookAt(Xh), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(Xh), this.targetLine.scale.z = Jh.length();
      }
    }]);

    return _class10;
  }(nn), t.DiscreteInterpolant = Kl, t.DodecahedronBufferGeometry = yo, t.DodecahedronGeometry = yo, t.DoubleSide = 2, t.DstAlphaFactor = 206, t.DstColorFactor = 208, t.DynamicBufferAttribute = function (t, e) {
    return console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead."), new _n(t, e).setUsage(ut);
  }, t.DynamicCopyUsage = 35050, t.DynamicDrawUsage = ut, t.DynamicReadUsage = 35049, t.EdgesGeometry = wo, t.EdgesHelper = function (t, e) {
    return console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead."), new to(new wo(t.geometry), new ja({
      color: void 0 !== e ? e : 16777215
    }));
  }, t.EllipseCurve = To, t.EqualDepth = 4, t.EqualStencilFunc = 514, t.EquirectangularReflectionMapping = a, t.EquirectangularRefractionMapping = o, t.Euler = Ge, t.EventDispatcher = mt, t.ExtrudeBufferGeometry = Ml, t.ExtrudeGeometry = Ml, t.FaceColors = 1, t.FileLoader = pc, t.FlatShading = 1, t.Float16BufferAttribute = Rn, t.Float32Attribute = function (t, e) {
    return console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead."), new Cn(t, e);
  }, t.Float32BufferAttribute = Cn, t.Float64Attribute = function (t, e) {
    return console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead."), new Ln(t, e);
  }, t.Float64BufferAttribute = Ln, t.FloatType = b, t.Fog = ra, t.FogExp2 = ia, t.Font = function () {
    console.error("THREE.Font has been moved to /examples/jsm/loaders/FontLoader.js");
  }, t.FontLoader = function () {
    console.error("THREE.FontLoader has been moved to /examples/jsm/loaders/FontLoader.js");
  }, t.FramebufferTexture = ho, t.FrontSide = 0, t.Frustum = Mi, t.GLBufferAttribute = Rh, t.GLSL1 = "100", t.GLSL3 = dt, t.GreaterDepth = 6, t.GreaterEqualDepth = 5, t.GreaterEqualStencilFunc = 518, t.GreaterStencilFunc = 516, t.GridHelper = jh, t.Group = Ys, t.HalfFloatType = w, t.HemisphereLight = xc, t.HemisphereLightHelper = /*#__PURE__*/function (_nn16) {
    _inherits(_class11, _nn16);

    var _super146 = _createSuper(_class11);

    function _class11(t, e, n) {
      var _this117;

      _classCallCheck(this, _class11);

      _this117 = _super146.call(this), _this117.light = t, _this117.light.updateMatrixWorld(), _this117.matrix = t.matrixWorld, _this117.matrixAutoUpdate = !1, _this117.color = n;
      var i = new Tl(e);
      i.rotateY(.5 * Math.PI), _this117.material = new vn({
        wireframe: !0,
        fog: !1,
        toneMapped: !1
      }), void 0 === _this117.color && (_this117.material.vertexColors = !0);
      var r = i.getAttribute("position"),
          s = new Float32Array(3 * r.count);
      i.setAttribute("color", new _n(s, 3)), _this117.add(new ni(i, _this117.material)), _this117.update();
      return _this117;
    }

    _createClass(_class11, [{
      key: "dispose",
      value: function dispose() {
        this.children[0].geometry.dispose(), this.children[0].material.dispose();
      }
    }, {
      key: "update",
      value: function update() {
        var t = this.children[0];
        if (void 0 !== this.color) this.material.color.set(this.color);else {
          var _e284 = t.geometry.getAttribute("color");

          kh.copy(this.light.color), Wh.copy(this.light.groundColor);

          for (var _t310 = 0, _n274 = _e284.count; _t310 < _n274; _t310++) {
            var _i204 = _t310 < _n274 / 2 ? kh : Wh;

            _e284.setXYZ(_t310, _i204.r, _i204.g, _i204.b);
          }

          _e284.needsUpdate = !0;
        }
        t.lookAt(Vh.setFromMatrixPosition(this.light.matrixWorld).negate());
      }
    }]);

    return _class11;
  }(nn), t.HemisphereLightProbe = Jc, t.IcosahedronBufferGeometry = wl, t.IcosahedronGeometry = wl, t.ImageBitmapLoader = Wc, t.ImageLoader = mc, t.ImageUtils = Gt, t.ImmediateRenderObject = function () {
    console.error("THREE.ImmediateRenderObject has been removed.");
  }, t.IncrementStencilOp = 7682, t.IncrementWrapStencilOp = 34055, t.InstancedBufferAttribute = Fa, t.InstancedBufferGeometry = Fc, t.InstancedInterleavedBuffer = Ah, t.InstancedMesh = Wa, t.Int16Attribute = function (t, e) {
    return console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead."), new Sn(t, e);
  }, t.Int16BufferAttribute = Sn, t.Int32Attribute = function (t, e) {
    return console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead."), new En(t, e);
  }, t.Int32BufferAttribute = En, t.Int8Attribute = function (t, e) {
    return console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead."), new Mn(t, e);
  }, t.Int8BufferAttribute = Mn, t.IntType = 1013, t.InterleavedBuffer = aa, t.InterleavedBufferAttribute = la, t.Interpolant = Jl, t.InterpolateDiscrete = $, t.InterpolateLinear = tt, t.InterpolateSmooth = et, t.InvertStencilOp = 5386, t.JSONLoader = function () {
    console.error("THREE.JSONLoader has been removed.");
  }, t.KeepStencilOp = ct, t.KeyframeTrack = Ql, t.LOD = Aa, t.LatheBufferGeometry = Sl, t.LatheGeometry = Sl, t.Layers = Ve, t.LensFlare = function () {
    console.error("THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js");
  }, t.LessDepth = 2, t.LessEqualDepth = 3, t.LessEqualStencilFunc = 515, t.LessStencilFunc = 513, t.Light = yc, t.LightProbe = zc, t.Line = Ka, t.Line3 = Bh, t.LineBasicMaterial = ja, t.LineCurve = Uo, t.LineCurve3 = Fo, t.LineDashedMaterial = jl, t.LineLoop = eo, t.LinePieces = 1, t.LineSegments = to, t.LineStrip = 0, t.LinearEncoding = ot, t.LinearFilter = g, t.LinearInterpolant = Zl, t.LinearMipMapLinearFilter = 1008, t.LinearMipMapNearestFilter = 1007, t.LinearMipmapLinearFilter = y, t.LinearMipmapNearestFilter = v, t.LinearToneMapping = 1, t.Loader = uc, t.LoaderUtils = Uc, t.LoadingManager = cc, t.LoopOnce = 2200, t.LoopPingPong = 2202, t.LoopRepeat = 2201, t.LuminanceAlphaFormat = 1025, t.LuminanceFormat = 1024, t.MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
  }, t.Material = gn, t.MaterialLoader = Oc, t.Math = Et, t.MathUtils = Et, t.Matrix3 = Rt, t.Matrix4 = Pe, t.MaxEquation = 104, t.Mesh = ni, t.MeshBasicMaterial = vn, t.MeshDepthMaterial = Vs, t.MeshDistanceMaterial = ks, t.MeshFaceMaterial = function (t) {
    return console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead."), t;
  }, t.MeshLambertMaterial = kl, t.MeshMatcapMaterial = Wl, t.MeshNormalMaterial = Vl, t.MeshPhongMaterial = Hl, t.MeshPhysicalMaterial = Fl, t.MeshStandardMaterial = Ul, t.MeshToonMaterial = Gl, t.MinEquation = 103, t.MirroredRepeatWrapping = d, t.MixOperation = 1, t.MultiMaterial = function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return console.warn("THREE.MultiMaterial has been removed. Use an Array instead."), t.isMultiMaterial = !0, t.materials = t, t.clone = function () {
      return t.slice();
    }, t;
  }, t.MultiplyBlending = 4, t.MultiplyOperation = 0, t.NearestFilter = p, t.NearestMipMapLinearFilter = 1005, t.NearestMipMapNearestFilter = 1004, t.NearestMipmapLinearFilter = f, t.NearestMipmapNearestFilter = m, t.NeverDepth = 0, t.NeverStencilFunc = 512, t.NoBlending = 0, t.NoColors = 0, t.NoToneMapping = 0, t.NormalAnimationBlendMode = st, t.NormalBlending = 1, t.NotEqualDepth = 7, t.NotEqualStencilFunc = 517, t.NumberKeyframeTrack = ec, t.Object3D = nn, t.ObjectLoader = /*#__PURE__*/function (_uc12) {
    _inherits(_class12, _uc12);

    var _super147 = _createSuper(_class12);

    function _class12(t) {
      _classCallCheck(this, _class12);

      return _super147.call(this, t);
    }

    _createClass(_class12, [{
      key: "load",
      value: function load(t, e, n, i) {
        var r = this,
            s = "" === this.path ? Uc.extractUrlBase(t) : this.path;
        this.resourcePath = this.resourcePath || s;
        var a = new pc(this.manager);
        a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t, function (n) {
          var s = null;

          try {
            s = JSON.parse(n);
          } catch (e) {
            return void 0 !== i && i(e), void console.error("THREE:ObjectLoader: Can't parse " + t + ".", e.message);
          }

          var a = s.metadata;
          void 0 !== a && void 0 !== a.type && "geometry" !== a.type.toLowerCase() ? r.parse(s, e) : console.error("THREE.ObjectLoader: Can't load " + t);
        }, n, i);
      }
    }, {
      key: "loadAsync",
      value: function () {
        var _loadAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e) {
          var n, i, r, s, a;
          return _regeneratorRuntime.wrap(function _callee2$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  n = "" === this.path ? Uc.extractUrlBase(t) : this.path;
                  this.resourcePath = this.resourcePath || n;
                  i = new pc(this.manager);
                  i.setPath(this.path), i.setRequestHeader(this.requestHeader), i.setWithCredentials(this.withCredentials);
                  _context5.next = 6;
                  return i.loadAsync(t, e);

                case 6:
                  r = _context5.sent;
                  s = JSON.parse(r);
                  a = s.metadata;

                  if (!(void 0 === a || void 0 === a.type || "geometry" === a.type.toLowerCase())) {
                    _context5.next = 11;
                    break;
                  }

                  throw new Error("THREE.ObjectLoader: Can't load " + t);

                case 11:
                  _context5.next = 13;
                  return this.parseAsync(s);

                case 13:
                  return _context5.abrupt("return", _context5.sent);

                case 14:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee2, this);
        }));

        function loadAsync(_x7, _x8) {
          return _loadAsync.apply(this, arguments);
        }

        return loadAsync;
      }()
    }, {
      key: "parse",
      value: function parse(t, e) {
        var n = this.parseAnimations(t.animations),
            i = this.parseShapes(t.shapes),
            r = this.parseGeometries(t.geometries, i),
            s = this.parseImages(t.images, function () {
          void 0 !== e && e(l);
        }),
            a = this.parseTextures(t.textures, s),
            o = this.parseMaterials(t.materials, a),
            l = this.parseObject(t.object, r, o, a, n),
            c = this.parseSkeletons(t.skeletons, l);

        if (this.bindSkeletons(l, c), void 0 !== e) {
          var _t311 = !1;

          for (var _e285 in s) {
            if (s[_e285] instanceof HTMLImageElement) {
              _t311 = !0;
              break;
            }
          }

          !1 === _t311 && e(l);
        }

        return l;
      }
    }, {
      key: "parseAsync",
      value: function () {
        var _parseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
          var e, n, i, r, s, a, o, l;
          return _regeneratorRuntime.wrap(function _callee3$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  e = this.parseAnimations(t.animations);
                  n = this.parseShapes(t.shapes);
                  i = this.parseGeometries(t.geometries, n);
                  _context6.next = 5;
                  return this.parseImagesAsync(t.images);

                case 5:
                  r = _context6.sent;
                  s = this.parseTextures(t.textures, r);
                  a = this.parseMaterials(t.materials, s);
                  o = this.parseObject(t.object, i, a, s, e);
                  l = this.parseSkeletons(t.skeletons, o);
                  return _context6.abrupt("return", (this.bindSkeletons(o, l), o));

                case 11:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee3, this);
        }));

        function parseAsync(_x9) {
          return _parseAsync.apply(this, arguments);
        }

        return parseAsync;
      }()
    }, {
      key: "parseShapes",
      value: function parseShapes(t) {
        var e = {};
        if (void 0 !== t) for (var _n275 = 0, _i205 = t.length; _n275 < _i205; _n275++) {
          var _i206 = new qo().fromJSON(t[_n275]);

          e[_i206.uuid] = _i206;
        }
        return e;
      }
    }, {
      key: "parseSkeletons",
      value: function parseSkeletons(t, e) {
        var n = {},
            i = {};
        if (e.traverse(function (t) {
          t.isBone && (i[t.uuid] = t);
        }), void 0 !== t) for (var _e286 = 0, _r156 = t.length; _e286 < _r156; _e286++) {
          var _r157 = new Ua().fromJSON(t[_e286], i);

          n[_r157.uuid] = _r157;
        }
        return n;
      }
    }, {
      key: "parseGeometries",
      value: function parseGeometries(t, e) {
        var n = {};

        if (void 0 !== t) {
          var _i207 = new Hc();

          for (var _r158 = 0, _s85 = t.length; _r158 < _s85; _r158++) {
            var _s86 = void 0;

            var _a75 = t[_r158];

            switch (_a75.type) {
              case "BufferGeometry":
              case "InstancedBufferGeometry":
                _s86 = _i207.parse(_a75);
                break;

              case "Geometry":
                console.error("THREE.ObjectLoader: The legacy Geometry type is no longer supported.");
                break;

              default:
                _a75.type in Bl ? _s86 = Bl[_a75.type].fromJSON(_a75, e) : console.warn("THREE.ObjectLoader: Unsupported geometry type \"".concat(_a75.type, "\""));
            }

            _s86.uuid = _a75.uuid, void 0 !== _a75.name && (_s86.name = _a75.name), !0 === _s86.isBufferGeometry && void 0 !== _a75.userData && (_s86.userData = _a75.userData), n[_a75.uuid] = _s86;
          }
        }

        return n;
      }
    }, {
      key: "parseMaterials",
      value: function parseMaterials(t, e) {
        var n = {},
            i = {};

        if (void 0 !== t) {
          var _r159 = new Oc();

          _r159.setTextures(e);

          for (var _e287 = 0, _s87 = t.length; _e287 < _s87; _e287++) {
            var _s88 = t[_e287];

            if ("MultiMaterial" === _s88.type) {
              var _t312 = [];

              for (var _e288 = 0; _e288 < _s88.materials.length; _e288++) {
                var _i208 = _s88.materials[_e288];
                void 0 === n[_i208.uuid] && (n[_i208.uuid] = _r159.parse(_i208)), _t312.push(n[_i208.uuid]);
              }

              i[_s88.uuid] = _t312;
            } else void 0 === n[_s88.uuid] && (n[_s88.uuid] = _r159.parse(_s88)), i[_s88.uuid] = n[_s88.uuid];
          }
        }

        return i;
      }
    }, {
      key: "parseAnimations",
      value: function parseAnimations(t) {
        var e = {};
        if (void 0 !== t) for (var _n276 = 0; _n276 < t.length; _n276++) {
          var _i209 = t[_n276],
              _r160 = ac.parse(_i209);

          e[_r160.uuid] = _r160;
        }
        return e;
      }
    }, {
      key: "parseImages",
      value: function parseImages(t, e) {
        var n = this,
            i = {};
        var r;

        function s(t) {
          if ("string" == typeof t) {
            var _e289 = t;
            return function (t) {
              return n.manager.itemStart(t), r.load(t, function () {
                n.manager.itemEnd(t);
              }, void 0, function () {
                n.manager.itemError(t), n.manager.itemEnd(t);
              });
            }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(_e289) ? _e289 : n.resourcePath + _e289);
          }

          return t.data ? {
            data: Pt(t.type, t.data),
            width: t.width,
            height: t.height
          } : null;
        }

        if (void 0 !== t && t.length > 0) {
          var _n277 = new cc(e);

          r = new mc(_n277), r.setCrossOrigin(this.crossOrigin);

          for (var _e290 = 0, _n278 = t.length; _e290 < _n278; _e290++) {
            var _n279 = t[_e290],
                _r161 = _n279.url;

            if (Array.isArray(_r161)) {
              var _t313 = [];

              for (var _e291 = 0, _n280 = _r161.length; _e291 < _n280; _e291++) {
                var _n281 = s(_r161[_e291]);

                null !== _n281 && (_n281 instanceof HTMLImageElement ? _t313.push(_n281) : _t313.push(new Ba(_n281.data, _n281.width, _n281.height)));
              }

              i[_n279.uuid] = new Vt(_t313);
            } else {
              var _t314 = s(_n279.url);

              i[_n279.uuid] = new Vt(_t314);
            }
          }
        }

        return i;
      }
    }, {
      key: "parseImagesAsync",
      value: function () {
        var _parseImagesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
          var e, n, i, r, _r162, _e292, _i210, _i211, _s89, _t315, _e293, _n282, _n283, _i212, _t316;

          return _regeneratorRuntime.wrap(function _callee5$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _r162 = function _r165() {
                    _r162 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
                      var _n284, _r163;

                      return _regeneratorRuntime.wrap(function _callee4$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              if (!("string" == typeof t)) {
                                _context7.next = 5;
                                break;
                              }

                              _n284 = t, _r163 = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(_n284) ? _n284 : e.resourcePath + _n284;
                              _context7.next = 4;
                              return i.loadAsync(_r163);

                            case 4:
                              return _context7.abrupt("return", _context7.sent);

                            case 5:
                              return _context7.abrupt("return", t.data ? {
                                data: Pt(t.type, t.data),
                                width: t.width,
                                height: t.height
                              } : null);

                            case 6:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee4);
                    }));
                    return _r162.apply(this, arguments);
                  };

                  r = function _r164(_x11) {
                    return _r162.apply(this, arguments);
                  };

                  e = this, n = {};

                  if (!(void 0 !== t && t.length > 0)) {
                    _context8.next = 30;
                    break;
                  }

                  i = new mc(this.manager), i.setCrossOrigin(this.crossOrigin);
                  _e292 = 0, _i210 = t.length;

                case 6:
                  if (!(_e292 < _i210)) {
                    _context8.next = 30;
                    break;
                  }

                  _i211 = t[_e292], _s89 = _i211.url;

                  if (!Array.isArray(_s89)) {
                    _context8.next = 23;
                    break;
                  }

                  _t315 = [];
                  _e293 = 0, _n282 = _s89.length;

                case 11:
                  if (!(_e293 < _n282)) {
                    _context8.next = 20;
                    break;
                  }

                  _n283 = _s89[_e293];
                  _context8.next = 15;
                  return r(_n283);

                case 15:
                  _i212 = _context8.sent;
                  null !== _i212 && (_i212 instanceof HTMLImageElement ? _t315.push(_i212) : _t315.push(new Ba(_i212.data, _i212.width, _i212.height)));

                case 17:
                  _e293++;
                  _context8.next = 11;
                  break;

                case 20:
                  n[_i211.uuid] = new Vt(_t315);
                  _context8.next = 27;
                  break;

                case 23:
                  _context8.next = 25;
                  return r(_i211.url);

                case 25:
                  _t316 = _context8.sent;
                  n[_i211.uuid] = new Vt(_t316);

                case 27:
                  _e292++;
                  _context8.next = 6;
                  break;

                case 30:
                  return _context8.abrupt("return", n);

                case 31:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee5, this);
        }));

        function parseImagesAsync(_x10) {
          return _parseImagesAsync.apply(this, arguments);
        }

        return parseImagesAsync;
      }()
    }, {
      key: "parseTextures",
      value: function parseTextures(t, e) {
        function n(t, e) {
          return "number" == typeof t ? t : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", t), e[t]);
        }

        var i = {};
        if (void 0 !== t) for (var r = 0, _s90 = t.length; r < _s90; r++) {
          var _s91 = t[r];
          void 0 === _s91.image && console.warn('THREE.ObjectLoader: No "image" specified for', _s91.uuid), void 0 === e[_s91.image] && console.warn("THREE.ObjectLoader: Undefined image", _s91.image);
          var _a76 = e[_s91.image],
              _o50 = _a76.data;

          var _l47 = void 0;

          Array.isArray(_o50) ? (_l47 = new pi(), 6 === _o50.length && (_l47.needsUpdate = !0)) : (_l47 = _o50 && _o50.data ? new Ba() : new jt(), _o50 && (_l47.needsUpdate = !0)), _l47.source = _a76, _l47.uuid = _s91.uuid, void 0 !== _s91.name && (_l47.name = _s91.name), void 0 !== _s91.mapping && (_l47.mapping = n(_s91.mapping, Gc)), void 0 !== _s91.offset && _l47.offset.fromArray(_s91.offset), void 0 !== _s91.repeat && _l47.repeat.fromArray(_s91.repeat), void 0 !== _s91.center && _l47.center.fromArray(_s91.center), void 0 !== _s91.rotation && (_l47.rotation = _s91.rotation), void 0 !== _s91.wrap && (_l47.wrapS = n(_s91.wrap[0], Vc), _l47.wrapT = n(_s91.wrap[1], Vc)), void 0 !== _s91.format && (_l47.format = _s91.format), void 0 !== _s91.type && (_l47.type = _s91.type), void 0 !== _s91.encoding && (_l47.encoding = _s91.encoding), void 0 !== _s91.minFilter && (_l47.minFilter = n(_s91.minFilter, kc)), void 0 !== _s91.magFilter && (_l47.magFilter = n(_s91.magFilter, kc)), void 0 !== _s91.anisotropy && (_l47.anisotropy = _s91.anisotropy), void 0 !== _s91.flipY && (_l47.flipY = _s91.flipY), void 0 !== _s91.premultiplyAlpha && (_l47.premultiplyAlpha = _s91.premultiplyAlpha), void 0 !== _s91.unpackAlignment && (_l47.unpackAlignment = _s91.unpackAlignment), void 0 !== _s91.userData && (_l47.userData = _s91.userData), i[_s91.uuid] = _l47;
        }
        return i;
      }
    }, {
      key: "parseObject",
      value: function parseObject(t, e, n, i, r) {
        var s, a, o;

        function l(t) {
          return void 0 === e[t] && console.warn("THREE.ObjectLoader: Undefined geometry", t), e[t];
        }

        function c(t) {
          if (void 0 !== t) {
            if (Array.isArray(t)) {
              var _e294 = [];

              for (var _i213 = 0, _r166 = t.length; _i213 < _r166; _i213++) {
                var _r167 = t[_i213];
                void 0 === n[_r167] && console.warn("THREE.ObjectLoader: Undefined material", _r167), _e294.push(n[_r167]);
              }

              return _e294;
            }

            return void 0 === n[t] && console.warn("THREE.ObjectLoader: Undefined material", t), n[t];
          }
        }

        function h(t) {
          return void 0 === i[t] && console.warn("THREE.ObjectLoader: Undefined texture", t), i[t];
        }

        switch (t.type) {
          case "Scene":
            s = new sa(), void 0 !== t.background && (Number.isInteger(t.background) ? s.background = new Ft(t.background) : s.background = h(t.background)), void 0 !== t.environment && (s.environment = h(t.environment)), void 0 !== t.fog && ("Fog" === t.fog.type ? s.fog = new ra(t.fog.color, t.fog.near, t.fog.far) : "FogExp2" === t.fog.type && (s.fog = new ia(t.fog.color, t.fog.density)));
            break;

          case "PerspectiveCamera":
            s = new hi(t.fov, t.aspect, t.near, t.far), void 0 !== t.focus && (s.focus = t.focus), void 0 !== t.zoom && (s.zoom = t.zoom), void 0 !== t.filmGauge && (s.filmGauge = t.filmGauge), void 0 !== t.filmOffset && (s.filmOffset = t.filmOffset), void 0 !== t.view && (s.view = Object.assign({}, t.view));
            break;

          case "OrthographicCamera":
            s = new Ni(t.left, t.right, t.top, t.bottom, t.near, t.far), void 0 !== t.zoom && (s.zoom = t.zoom), void 0 !== t.view && (s.view = Object.assign({}, t.view));
            break;

          case "AmbientLight":
            s = new Ic(t.color, t.intensity);
            break;

          case "DirectionalLight":
            s = new Dc(t.color, t.intensity);
            break;

          case "PointLight":
            s = new Lc(t.color, t.intensity, t.distance, t.decay);
            break;

          case "RectAreaLight":
            s = new Nc(t.color, t.intensity, t.width, t.height);
            break;

          case "SpotLight":
            s = new Tc(t.color, t.intensity, t.distance, t.angle, t.penumbra, t.decay);
            break;

          case "HemisphereLight":
            s = new xc(t.color, t.groundColor, t.intensity);
            break;

          case "LightProbe":
            s = new zc().fromJSON(t);
            break;

          case "SkinnedMesh":
            a = l(t.geometry), o = c(t.material), s = new Ia(a, o), void 0 !== t.bindMode && (s.bindMode = t.bindMode), void 0 !== t.bindMatrix && s.bindMatrix.fromArray(t.bindMatrix), void 0 !== t.skeleton && (s.skeleton = t.skeleton);
            break;

          case "Mesh":
            a = l(t.geometry), o = c(t.material), s = new ni(a, o);
            break;

          case "InstancedMesh":
            a = l(t.geometry), o = c(t.material);
            var _e295 = t.count,
                _n285 = t.instanceMatrix,
                _i214 = t.instanceColor;
            s = new Wa(a, o, _e295), s.instanceMatrix = new Fa(new Float32Array(_n285.array), 16), void 0 !== _i214 && (s.instanceColor = new Fa(new Float32Array(_i214.array), _i214.itemSize));
            break;

          case "LOD":
            s = new Aa();
            break;

          case "Line":
            s = new Ka(l(t.geometry), c(t.material));
            break;

          case "LineLoop":
            s = new eo(l(t.geometry), c(t.material));
            break;

          case "LineSegments":
            s = new to(l(t.geometry), c(t.material));
            break;

          case "PointCloud":
          case "Points":
            s = new oo(l(t.geometry), c(t.material));
            break;

          case "Sprite":
            s = new wa(c(t.material));
            break;

          case "Group":
            s = new Ys();
            break;

          case "Bone":
            s = new Na();
            break;

          default:
            s = new nn();
        }

        if (s.uuid = t.uuid, void 0 !== t.name && (s.name = t.name), void 0 !== t.matrix ? (s.matrix.fromArray(t.matrix), void 0 !== t.matrixAutoUpdate && (s.matrixAutoUpdate = t.matrixAutoUpdate), s.matrixAutoUpdate && s.matrix.decompose(s.position, s.quaternion, s.scale)) : (void 0 !== t.position && s.position.fromArray(t.position), void 0 !== t.rotation && s.rotation.fromArray(t.rotation), void 0 !== t.quaternion && s.quaternion.fromArray(t.quaternion), void 0 !== t.scale && s.scale.fromArray(t.scale)), void 0 !== t.castShadow && (s.castShadow = t.castShadow), void 0 !== t.receiveShadow && (s.receiveShadow = t.receiveShadow), t.shadow && (void 0 !== t.shadow.bias && (s.shadow.bias = t.shadow.bias), void 0 !== t.shadow.normalBias && (s.shadow.normalBias = t.shadow.normalBias), void 0 !== t.shadow.radius && (s.shadow.radius = t.shadow.radius), void 0 !== t.shadow.mapSize && s.shadow.mapSize.fromArray(t.shadow.mapSize), void 0 !== t.shadow.camera && (s.shadow.camera = this.parseObject(t.shadow.camera))), void 0 !== t.visible && (s.visible = t.visible), void 0 !== t.frustumCulled && (s.frustumCulled = t.frustumCulled), void 0 !== t.renderOrder && (s.renderOrder = t.renderOrder), void 0 !== t.userData && (s.userData = t.userData), void 0 !== t.layers && (s.layers.mask = t.layers), void 0 !== t.children) {
          var _a77 = t.children;

          for (var _t317 = 0; _t317 < _a77.length; _t317++) {
            s.add(this.parseObject(_a77[_t317], e, n, i, r));
          }
        }

        if (void 0 !== t.animations) {
          var _e296 = t.animations;

          for (var _t318 = 0; _t318 < _e296.length; _t318++) {
            var _n286 = _e296[_t318];
            s.animations.push(r[_n286]);
          }
        }

        if ("LOD" === t.type) {
          void 0 !== t.autoUpdate && (s.autoUpdate = t.autoUpdate);
          var _e297 = t.levels;

          for (var _t319 = 0; _t319 < _e297.length; _t319++) {
            var _n287 = _e297[_t319],
                _i215 = s.getObjectByProperty("uuid", _n287.object);

            void 0 !== _i215 && s.addLevel(_i215, _n287.distance);
          }
        }

        return s;
      }
    }, {
      key: "bindSkeletons",
      value: function bindSkeletons(t, e) {
        0 !== Object.keys(e).length && t.traverse(function (t) {
          if (!0 === t.isSkinnedMesh && void 0 !== t.skeleton) {
            var _n288 = e[t.skeleton];
            void 0 === _n288 ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", t.skeleton) : t.bind(_n288, t.bindMatrix);
          }
        });
      }
    }, {
      key: "setTexturePath",
      value: function setTexturePath(t) {
        return console.warn("THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath()."), this.setResourcePath(t);
      }
    }]);

    return _class12;
  }(uc), t.ObjectSpaceNormalMap = 1, t.OctahedronBufferGeometry = Tl, t.OctahedronGeometry = Tl, t.OneFactor = 201, t.OneMinusDstAlphaFactor = 207, t.OneMinusDstColorFactor = 209, t.OneMinusSrcAlphaFactor = 205, t.OneMinusSrcColorFactor = 203, t.OrthographicCamera = Ni, t.PCFShadowMap = 1, t.PCFSoftShadowMap = 2, t.PMREMGenerator = ki, t.ParametricGeometry = function () {
    return console.error("THREE.ParametricGeometry has been moved to /examples/jsm/geometries/ParametricGeometry.js"), new Un();
  }, t.Particle = function (t) {
    return console.warn("THREE.Particle has been renamed to THREE.Sprite."), new wa(t);
  }, t.ParticleBasicMaterial = function (t) {
    return console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial."), new no(t);
  }, t.ParticleSystem = function (t, e) {
    return console.warn("THREE.ParticleSystem has been renamed to THREE.Points."), new oo(t, e);
  }, t.ParticleSystemMaterial = function (t) {
    return console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial."), new no(t);
  }, t.Path = jo, t.PerspectiveCamera = hi, t.Plane = yi, t.PlaneBufferGeometry = Si, t.PlaneGeometry = Si, t.PlaneHelper = /*#__PURE__*/function (_Ka3) {
    _inherits(_class13, _Ka3);

    var _super148 = _createSuper(_class13);

    function _class13(t) {
      var _this118;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16776960;

      _classCallCheck(this, _class13);

      var i = n,
          r = new Un();
      r.setAttribute("position", new Cn([1, -1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0], 3)), r.computeBoundingSphere(), _this118 = _super148.call(this, r, new ja({
        color: i,
        toneMapped: !1
      })), _this118.type = "PlaneHelper", _this118.plane = t, _this118.size = e;
      var s = new Un();
      s.setAttribute("position", new Cn([1, 1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, 1, -1, 1], 3)), s.computeBoundingSphere(), _this118.add(new ni(s, new vn({
        color: i,
        opacity: .2,
        transparent: !0,
        depthWrite: !1,
        toneMapped: !1
      })));
      return _this118;
    }

    _createClass(_class13, [{
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        var e = -this.plane.constant;
        Math.abs(e) < 1e-8 && (e = 1e-8), this.scale.set(.5 * this.size, .5 * this.size, e), this.children[0].material.side = e < 0 ? 1 : 0, this.lookAt(this.plane.normal), _get(_getPrototypeOf(_class13.prototype), "updateMatrixWorld", this).call(this, t);
      }
    }]);

    return _class13;
  }(Ka), t.PointCloud = function (t, e) {
    return console.warn("THREE.PointCloud has been renamed to THREE.Points."), new oo(t, e);
  }, t.PointCloudMaterial = function (t) {
    return console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial."), new no(t);
  }, t.PointLight = Lc, t.PointLightHelper = /*#__PURE__*/function (_ni3) {
    _inherits(_class14, _ni3);

    var _super149 = _createSuper(_class14);

    function _class14(t, e, n) {
      var _this119;

      _classCallCheck(this, _class14);

      _this119 = _super149.call(this, new Rl(e, 4, 2), new vn({
        wireframe: !0,
        fog: !1,
        toneMapped: !1
      })), _this119.light = t, _this119.light.updateMatrixWorld(), _this119.color = n, _this119.type = "PointLightHelper", _this119.matrix = _this119.light.matrixWorld, _this119.matrixAutoUpdate = !1, _this119.update();
      return _this119;
    }

    _createClass(_class14, [{
      key: "dispose",
      value: function dispose() {
        this.geometry.dispose(), this.material.dispose();
      }
    }, {
      key: "update",
      value: function update() {
        void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
      }
    }]);

    return _class14;
  }(ni), t.Points = oo, t.PointsMaterial = no, t.PolarGridHelper = /*#__PURE__*/function (_to7) {
    _inherits(_class15, _to7);

    var _super150 = _createSuper(_class15);

    function _class15() {
      var _this120;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 64;
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 4473924;
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 8947848;

      _classCallCheck(this, _class15);

      r = new Ft(r), s = new Ft(s);
      var a = [],
          o = [];

      for (var _n289 = 0; _n289 <= e; _n289++) {
        var _i216 = _n289 / e * (2 * Math.PI),
            _l48 = Math.sin(_i216) * t,
            _c32 = Math.cos(_i216) * t;

        a.push(0, 0, 0), a.push(_l48, 0, _c32);

        var _h24 = 1 & _n289 ? r : s;

        o.push(_h24.r, _h24.g, _h24.b), o.push(_h24.r, _h24.g, _h24.b);
      }

      for (var _e298 = 0; _e298 <= n; _e298++) {
        var _l49 = 1 & _e298 ? r : s,
            _c33 = t - t / n * _e298;

        for (var _t320 = 0; _t320 < i; _t320++) {
          var _e299 = _t320 / i * (2 * Math.PI),
              _n290 = Math.sin(_e299) * _c33,
              _r168 = Math.cos(_e299) * _c33;

          a.push(_n290, 0, _r168), o.push(_l49.r, _l49.g, _l49.b), _e299 = (_t320 + 1) / i * (2 * Math.PI), _n290 = Math.sin(_e299) * _c33, _r168 = Math.cos(_e299) * _c33, a.push(_n290, 0, _r168), o.push(_l49.r, _l49.g, _l49.b);
        }
      }

      var l = new Un();
      l.setAttribute("position", new Cn(a, 3)), l.setAttribute("color", new Cn(o, 3));
      _this120 = _super150.call(this, l, new ja({
        vertexColors: !0,
        toneMapped: !1
      })), _this120.type = "PolarGridHelper";
      return _this120;
    }

    return _createClass(_class15);
  }(to), t.PolyhedronBufferGeometry = vo, t.PolyhedronGeometry = vo, t.PositionalAudio = /*#__PURE__*/function (_sh) {
    _inherits(_class16, _sh);

    var _super151 = _createSuper(_class16);

    function _class16(t) {
      var _this121;

      _classCallCheck(this, _class16);

      _this121 = _super151.call(this, t), _this121.panner = _this121.context.createPanner(), _this121.panner.panningModel = "HRTF", _this121.panner.connect(_this121.gain);
      return _this121;
    }

    _createClass(_class16, [{
      key: "getOutput",
      value: function getOutput() {
        return this.panner;
      }
    }, {
      key: "getRefDistance",
      value: function getRefDistance() {
        return this.panner.refDistance;
      }
    }, {
      key: "setRefDistance",
      value: function setRefDistance(t) {
        return this.panner.refDistance = t, this;
      }
    }, {
      key: "getRolloffFactor",
      value: function getRolloffFactor() {
        return this.panner.rolloffFactor;
      }
    }, {
      key: "setRolloffFactor",
      value: function setRolloffFactor(t) {
        return this.panner.rolloffFactor = t, this;
      }
    }, {
      key: "getDistanceModel",
      value: function getDistanceModel() {
        return this.panner.distanceModel;
      }
    }, {
      key: "setDistanceModel",
      value: function setDistanceModel(t) {
        return this.panner.distanceModel = t, this;
      }
    }, {
      key: "getMaxDistance",
      value: function getMaxDistance() {
        return this.panner.maxDistance;
      }
    }, {
      key: "setMaxDistance",
      value: function setMaxDistance(t) {
        return this.panner.maxDistance = t, this;
      }
    }, {
      key: "setDirectionalCone",
      value: function setDirectionalCone(t, e, n) {
        return this.panner.coneInnerAngle = t, this.panner.coneOuterAngle = e, this.panner.coneOuterGain = n, this;
      }
    }, {
      key: "updateMatrixWorld",
      value: function updateMatrixWorld(t) {
        if (_get(_getPrototypeOf(_class16.prototype), "updateMatrixWorld", this).call(this, t), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
        this.matrixWorld.decompose(ah, oh, lh), ch.set(0, 0, 1).applyQuaternion(oh);
        var e = this.panner;

        if (e.positionX) {
          var _t321 = this.context.currentTime + this.listener.timeDelta;

          e.positionX.linearRampToValueAtTime(ah.x, _t321), e.positionY.linearRampToValueAtTime(ah.y, _t321), e.positionZ.linearRampToValueAtTime(ah.z, _t321), e.orientationX.linearRampToValueAtTime(ch.x, _t321), e.orientationY.linearRampToValueAtTime(ch.y, _t321), e.orientationZ.linearRampToValueAtTime(ch.z, _t321);
        } else e.setPosition(ah.x, ah.y, ah.z), e.setOrientation(ch.x, ch.y, ch.z);
      }
    }]);

    return _class16;
  }(sh), t.PropertyBinding = bh, t.PropertyMixer = uh, t.QuadraticBezierCurve = Ho, t.QuadraticBezierCurve3 = Go, t.Quaternion = $t, t.QuaternionKeyframeTrack = ic, t.QuaternionLinearInterpolant = nc, t.REVISION = e, t.RGBADepthPacking = 3201, t.RGBAFormat = T, t.RGBAIntegerFormat = 1033, t.RGBA_ASTC_10x10_Format = Y, t.RGBA_ASTC_10x5_Format = q, t.RGBA_ASTC_10x6_Format = X, t.RGBA_ASTC_10x8_Format = J, t.RGBA_ASTC_12x10_Format = Z, t.RGBA_ASTC_12x12_Format = K, t.RGBA_ASTC_4x4_Format = U, t.RGBA_ASTC_5x4_Format = F, t.RGBA_ASTC_5x5_Format = H, t.RGBA_ASTC_6x5_Format = G, t.RGBA_ASTC_6x6_Format = V, t.RGBA_ASTC_8x5_Format = k, t.RGBA_ASTC_8x6_Format = W, t.RGBA_ASTC_8x8_Format = j, t.RGBA_BPTC_Format = Q, t.RGBA_ETC2_EAC_Format = O, t.RGBA_PVRTC_2BPPV1_Format = B, t.RGBA_PVRTC_4BPPV1_Format = N, t.RGBA_S3TC_DXT1_Format = C, t.RGBA_S3TC_DXT3_Format = L, t.RGBA_S3TC_DXT5_Format = P, t.RGBFormat = 1022, t.RGB_ETC1_Format = 36196, t.RGB_ETC2_Format = z, t.RGB_PVRTC_2BPPV1_Format = I, t.RGB_PVRTC_4BPPV1_Format = D, t.RGB_S3TC_DXT1_Format = R, t.RGFormat = 1030, t.RGIntegerFormat = 1031, t.RawShaderMaterial = Ol, t.Ray = Le, t.Raycaster = /*#__PURE__*/function () {
    function _class17(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1 / 0;

      _classCallCheck(this, _class17);

      this.ray = new Le(t, e), this.near = n, this.far = i, this.camera = null, this.layers = new Ve(), this.params = {
        Mesh: {},
        Line: {
          threshold: 1
        },
        LOD: {},
        Points: {
          threshold: 1
        },
        Sprite: {}
      };
    }

    _createClass(_class17, [{
      key: "set",
      value: function set(t, e) {
        this.ray.set(t, e);
      }
    }, {
      key: "setFromCamera",
      value: function setFromCamera(t, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
      }
    }, {
      key: "intersectObject",
      value: function intersectObject(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return Lh(t, this, n, e), n.sort(Ch), n;
      }
    }, {
      key: "intersectObjects",
      value: function intersectObjects(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        for (var _i217 = 0, r = t.length; _i217 < r; _i217++) {
          Lh(t[_i217], this, n, e);
        }

        return n.sort(Ch), n;
      }
    }]);

    return _class17;
  }(), t.RectAreaLight = Nc, t.RedFormat = 1028, t.RedIntegerFormat = 1029, t.ReinhardToneMapping = 2, t.RepeatWrapping = h, t.ReplaceStencilOp = 7681, t.ReverseSubtractEquation = 102, t.RingBufferGeometry = El, t.RingGeometry = El, t.Scene = sa, t.SceneUtils = au, t.ShaderChunk = Ti, t.ShaderLib = Ai, t.ShaderMaterial = li, t.ShadowMaterial = zl, t.Shape = qo, t.ShapeBufferGeometry = Al, t.ShapeGeometry = Al, t.ShapePath = /*#__PURE__*/function () {
    function _class18() {
      _classCallCheck(this, _class18);

      this.type = "ShapePath", this.color = new Ft(), this.subPaths = [], this.currentPath = null;
    }

    _createClass(_class18, [{
      key: "moveTo",
      value: function moveTo(t, e) {
        return this.currentPath = new jo(), this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
      }
    }, {
      key: "lineTo",
      value: function lineTo(t, e) {
        return this.currentPath.lineTo(t, e), this;
      }
    }, {
      key: "quadraticCurveTo",
      value: function quadraticCurveTo(t, e, n, i) {
        return this.currentPath.quadraticCurveTo(t, e, n, i), this;
      }
    }, {
      key: "bezierCurveTo",
      value: function bezierCurveTo(t, e, n, i, r, s) {
        return this.currentPath.bezierCurveTo(t, e, n, i, r, s), this;
      }
    }, {
      key: "splineThru",
      value: function splineThru(t) {
        return this.currentPath.splineThru(t), this;
      }
    }, {
      key: "toShapes",
      value: function toShapes(t, e) {
        function n(t) {
          var e = [];

          for (var _n291 = 0, _i218 = t.length; _n291 < _i218; _n291++) {
            var _i219 = t[_n291],
                _r169 = new qo();

            _r169.curves = _i219.curves, e.push(_r169);
          }

          return e;
        }

        function i(t, e) {
          var n = e.length;
          var i = !1;

          for (var _r170 = n - 1, _s92 = 0; _s92 < n; _r170 = _s92++) {
            var _n292 = e[_r170],
                _a78 = e[_s92],
                _o51 = _a78.x - _n292.x,
                _l50 = _a78.y - _n292.y;

            if (Math.abs(_l50) > Number.EPSILON) {
              if (_l50 < 0 && (_n292 = e[_s92], _o51 = -_o51, _a78 = e[_r170], _l50 = -_l50), t.y < _n292.y || t.y > _a78.y) continue;

              if (t.y === _n292.y) {
                if (t.x === _n292.x) return !0;
              } else {
                var _e300 = _l50 * (t.x - _n292.x) - _o51 * (t.y - _n292.y);

                if (0 === _e300) return !0;
                if (_e300 < 0) continue;
                i = !i;
              }
            } else {
              if (t.y !== _n292.y) continue;
              if (_a78.x <= t.x && t.x <= _n292.x || _n292.x <= t.x && t.x <= _a78.x) return !0;
            }
          }

          return i;
        }

        var r = yl.isClockWise,
            s = this.subPaths;
        if (0 === s.length) return [];
        if (!0 === e) return n(s);
        var a, o, l;
        var c = [];
        if (1 === s.length) return o = s[0], l = new qo(), l.curves = o.curves, c.push(l), c;
        var h = !r(s[0].getPoints());
        h = t ? !h : h;
        var u = [],
            d = [];
        var p,
            m,
            f = [],
            g = 0;
        d[g] = void 0, f[g] = [];

        for (var _e301 = 0, _n293 = s.length; _e301 < _n293; _e301++) {
          o = s[_e301], p = o.getPoints(), a = r(p), a = t ? !a : a, a ? (!h && d[g] && g++, d[g] = {
            s: new qo(),
            p: p
          }, d[g].s.curves = o.curves, h && g++, f[g] = []) : f[g].push({
            h: o,
            p: p[0]
          });
        }

        if (!d[0]) return n(s);

        if (d.length > 1) {
          var _t322 = !1,
              _e302 = 0;

          for (var _t323 = 0, _e303 = d.length; _t323 < _e303; _t323++) {
            u[_t323] = [];
          }

          for (var _n294 = 0, _r171 = d.length; _n294 < _r171; _n294++) {
            var _r172 = f[_n294];

            for (var _s93 = 0; _s93 < _r172.length; _s93++) {
              var _a79 = _r172[_s93];

              var _o52 = !0;

              for (var _r173 = 0; _r173 < d.length; _r173++) {
                i(_a79.p, d[_r173].p) && (_n294 !== _r173 && _e302++, _o52 ? (_o52 = !1, u[_r173].push(_a79)) : _t322 = !0);
              }

              _o52 && u[_n294].push(_a79);
            }
          }

          _e302 > 0 && !1 === _t322 && (f = u);
        }

        for (var _t324 = 0, _e304 = d.length; _t324 < _e304; _t324++) {
          l = d[_t324].s, c.push(l), m = f[_t324];

          for (var _t325 = 0, _e305 = m.length; _t325 < _e305; _t325++) {
            l.holes.push(m[_t325].h);
          }
        }

        return c;
      }
    }]);

    return _class18;
  }(), t.ShapeUtils = yl, t.ShortType = 1011, t.Skeleton = Ua, t.SkeletonHelper = Hh, t.SkinnedMesh = Ia, t.SmoothShading = 2, t.Sphere = be, t.SphereBufferGeometry = Rl, t.SphereGeometry = Rl, t.Spherical = /*#__PURE__*/function () {
    function _class19() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      _classCallCheck(this, _class19);

      return this.radius = t, this.phi = e, this.theta = n, this;
    }

    _createClass(_class19, [{
      key: "set",
      value: function set(t, e, n) {
        return this.radius = t, this.phi = e, this.theta = n, this;
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
      }
    }, {
      key: "makeSafe",
      value: function makeSafe() {
        var t = 1e-6;
        return this.phi = Math.max(t, Math.min(Math.PI - t, this.phi)), this;
      }
    }, {
      key: "setFromVector3",
      value: function setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
      }
    }, {
      key: "setFromCartesianCoords",
      value: function setFromCartesianCoords(t, e, n) {
        return this.radius = Math.sqrt(t * t + e * e + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, n), this.phi = Math.acos(_t(e / this.radius, -1, 1))), this;
      }
    }, {
      key: "clone",
      value: function clone() {
        return new this.constructor().copy(this);
      }
    }]);

    return _class19;
  }(), t.SphericalHarmonics3 = Bc, t.SplineCurve = Vo, t.SpotLight = Tc, t.SpotLightHelper = /*#__PURE__*/function (_nn17) {
    _inherits(_class20, _nn17);

    var _super152 = _createSuper(_class20);

    function _class20(t, e) {
      var _this122;

      _classCallCheck(this, _class20);

      _this122 = _super152.call(this), _this122.light = t, _this122.light.updateMatrixWorld(), _this122.matrix = t.matrixWorld, _this122.matrixAutoUpdate = !1, _this122.color = e;
      var n = new Un(),
          i = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1];

      for (var _t326 = 0, _e306 = 1, _n295 = 32; _t326 < _n295; _t326++, _e306++) {
        var _r174 = _t326 / _n295 * Math.PI * 2,
            _s94 = _e306 / _n295 * Math.PI * 2;

        i.push(Math.cos(_r174), Math.sin(_r174), 1, Math.cos(_s94), Math.sin(_s94), 1);
      }

      n.setAttribute("position", new Cn(i, 3));
      var r = new ja({
        fog: !1,
        toneMapped: !1
      });
      _this122.cone = new to(n, r), _this122.add(_this122.cone), _this122.update();
      return _this122;
    }

    _createClass(_class20, [{
      key: "dispose",
      value: function dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
      }
    }, {
      key: "update",
      value: function update() {
        this.light.updateMatrixWorld();
        var t = this.light.distance ? this.light.distance : 1e3,
            e = t * Math.tan(this.light.angle);
        this.cone.scale.set(e, e, t), zh.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(zh), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
      }
    }]);

    return _class20;
  }(nn), t.Sprite = wa, t.SpriteMaterial = ca, t.SrcAlphaFactor = 204, t.SrcAlphaSaturateFactor = 210, t.SrcColorFactor = 202, t.StaticCopyUsage = 35046, t.StaticDrawUsage = ht, t.StaticReadUsage = 35045, t.StereoCamera = /*#__PURE__*/function () {
    function _class21() {
      _classCallCheck(this, _class21);

      this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new hi(), this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new hi(), this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
        focus: null,
        fov: null,
        aspect: null,
        near: null,
        far: null,
        zoom: null,
        eyeSep: null
      };
    }

    _createClass(_class21, [{
      key: "update",
      value: function update(t) {
        var e = this._cache;

        if (e.focus !== t.focus || e.fov !== t.fov || e.aspect !== t.aspect * this.aspect || e.near !== t.near || e.far !== t.far || e.zoom !== t.zoom || e.eyeSep !== this.eyeSep) {
          e.focus = t.focus, e.fov = t.fov, e.aspect = t.aspect * this.aspect, e.near = t.near, e.far = t.far, e.zoom = t.zoom, e.eyeSep = this.eyeSep, Qc.copy(t.projectionMatrix);

          var _n296 = e.eyeSep / 2,
              _i220 = _n296 * e.near / e.focus,
              r = e.near * Math.tan(vt * e.fov * .5) / e.zoom;

          var _s95, _a80;

          Kc.elements[12] = -_n296, Zc.elements[12] = _n296, _s95 = -r * e.aspect + _i220, _a80 = r * e.aspect + _i220, Qc.elements[0] = 2 * e.near / (_a80 - _s95), Qc.elements[8] = (_a80 + _s95) / (_a80 - _s95), this.cameraL.projectionMatrix.copy(Qc), _s95 = -r * e.aspect - _i220, _a80 = r * e.aspect - _i220, Qc.elements[0] = 2 * e.near / (_a80 - _s95), Qc.elements[8] = (_a80 + _s95) / (_a80 - _s95), this.cameraR.projectionMatrix.copy(Qc);
        }

        this.cameraL.matrixWorld.copy(t.matrixWorld).multiply(Kc), this.cameraR.matrixWorld.copy(t.matrixWorld).multiply(Zc);
      }
    }]);

    return _class21;
  }(), t.StreamCopyUsage = 35042, t.StreamDrawUsage = 35040, t.StreamReadUsage = 35041, t.StringKeyframeTrack = rc, t.SubtractEquation = 101, t.SubtractiveBlending = 3, t.TOUCH = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
  }, t.TangentSpaceNormalMap = 0, t.TetrahedronBufferGeometry = Cl, t.TetrahedronGeometry = Cl, t.TextGeometry = function () {
    return console.error("THREE.TextGeometry has been moved to /examples/jsm/geometries/TextGeometry.js"), new Un();
  }, t.Texture = jt, t.TextureLoader = vc, t.TorusBufferGeometry = Ll, t.TorusGeometry = Ll, t.TorusKnotBufferGeometry = Pl, t.TorusKnotGeometry = Pl, t.Triangle = mn, t.TriangleFanDrawMode = 2, t.TriangleStripDrawMode = 1, t.TrianglesDrawMode = 0, t.TubeBufferGeometry = Dl, t.TubeGeometry = Dl, t.UVMapping = i, t.Uint16Attribute = function (t, e) {
    return console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead."), new Tn(t, e);
  }, t.Uint16BufferAttribute = Tn, t.Uint32Attribute = function (t, e) {
    return console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead."), new An(t, e);
  }, t.Uint32BufferAttribute = An, t.Uint8Attribute = function (t, e) {
    return console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead."), new bn(t, e);
  }, t.Uint8BufferAttribute = bn, t.Uint8ClampedAttribute = function (t, e) {
    return console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead."), new wn(t, e);
  }, t.Uint8ClampedBufferAttribute = wn, t.Uniform = Eh, t.UniformsLib = Ei, t.UniformsUtils = oi, t.UnsignedByteType = x, t.UnsignedInt248Type = S, t.UnsignedIntType = M, t.UnsignedShort4444Type = 1017, t.UnsignedShort5551Type = 1018, t.UnsignedShortType = _, t.VSMShadowMap = 3, t.Vector2 = At, t.Vector3 = te, t.Vector4 = qt, t.VectorKeyframeTrack = sc, t.Vertex = function (t, e, n) {
    return console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead."), new te(t, e, n);
  }, t.VertexColors = 2, t.VideoTexture = co, t.WebGL1Renderer = na, t.WebGL3DRenderTarget = Kt, t.WebGLArrayRenderTarget = Yt, t.WebGLCubeRenderTarget = mi, t.WebGLMultipleRenderTargets = Qt, t.WebGLMultisampleRenderTarget = function (t, e, n) {
    console.error('THREE.WebGLMultisampleRenderTarget has been removed. Use a normal render target and set the "samples" property to greater 0 to enable multisampling.');
    var i = new Xt(t, e, n);
    return i.samples = 4, i;
  }, t.WebGLRenderTarget = Xt, t.WebGLRenderTargetCube = function (t, e, n) {
    return console.warn("THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options )."), new mi(t, n);
  }, t.WebGLRenderer = ea, t.WebGLUtils = Xs, t.WireframeGeometry = Il, t.WireframeHelper = function (t, e) {
    return console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead."), new to(new Il(t.geometry), new ja({
      color: void 0 !== e ? e : 16777215
    }));
  }, t.WrapAroundEnding = rt, t.XHRLoader = function (t) {
    return console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader."), new pc(t);
  }, t.ZeroCurvatureEnding = nt, t.ZeroFactor = 200, t.ZeroSlopeEnding = it, t.ZeroStencilOp = 0, t._SRGBAFormat = pt, t.sRGBEncoding = lt, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});